
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8661"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8661"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("boZNq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $e4b14ad7ed75be8c$export$2e2bcd8739ae039);
parcelRequire("9uXBG");
var $58rTl = parcelRequire("58rTl");
var $2eFsq = parcelRequire("2eFsq");
var $e4b14ad7ed75be8c$export$2e2bcd8739ae039 = /*@__PURE__*/ (0, $58rTl.defineComponent)({
    __name: 'App',
    setup (__props, { expose: __expose }) {
        __expose();
        const CHAPTER_LIST = [
            {
                name: "Intro",
                file: "intro"
            },
            {
                name: "Der Hase und das Brot",
                file: "ronny - der hase und das brot"
            },
            {
                name: "Panik im Paradies",
                file: "martin - kids panik im paradies"
            },
            {
                name: "How to: Pflege einer besonderen Pflanze",
                file: "bakty - anleitung zur pflege einer besonderen pflanze"
            },
            {
                name: "Einfache Radieschensuppe in 19 Schritten",
                file: "jenny - einfache radieschensuppe in 19 schritten"
            },
            {
                name: "Zwischenspiel",
                file: "zwischenspiel"
            },
            {
                name: "Eddie, sie alter Wuselknoedel",
                file: "melanie - eddie, sie alter wuselknoedel"
            },
            {
                name: "Bruder Innerlich",
                file: "manuel - bruder innerlich"
            },
            {
                name: "Zwischenspiel",
                file: "zwischenspiel 2"
            },
            {
                name: "Die Jagd nach dem Schnatz",
                file: "jenny - die jagd nach dem schnatz"
            },
            {
                name: "The Adventure Never Ends",
                file: "sae - the adventure never ends"
            },
            {
                name: "Outro",
                file: "outro"
            }
        ];
        const currentChapter = (0, $2eFsq.ref)(0);
        const audioElement = (0, $58rTl.useTemplateRef)("audioElement");
        const currentSrc = (0, $58rTl.computed)(()=>{
            return `./chapters/${CHAPTER_LIST[currentChapter.value].file}.mp3`;
        });
        const playing = (0, $2eFsq.ref)(false);
        const duration = (0, $2eFsq.ref)(0);
        const currentTime = (0, $2eFsq.ref)(0);
        const ended = (0, $2eFsq.ref)(false);
        const switchTrack = (index)=>{
            currentChapter.value = index;
            playing.value = false;
            audioElement.value.pause();
            audioElement.value.currentTime = 0;
            currentTime.value = 0;
            (0, $58rTl.nextTick)(()=>{
                playing.value = true;
                audioElement.value.play();
            });
        };
        (0, $58rTl.watch)(ended, (ended)=>{
            if (!ended) return;
            const nextChapter = currentChapter.value + 1;
            if (nextChapter >= CHAPTER_LIST.length) {
                playing.value = false;
                return;
            }
            switchTrack(nextChapter);
        });
        const togglePlaying = ()=>{
            playing.value = !playing.value;
            audioElement.value[playing.value ? "play" : "pause"]();
        };
        const onClick = (event)=>{
            const progressBar = event.currentTarget;
            const clickPosition = event.offsetX;
            const totalWidth = progressBar.clientWidth;
            const newTime = clickPosition / totalWidth * duration.value;
            audioElement.value.currentTime = newTime;
        };
        const formattedCurrentTime = (0, $58rTl.computed)(()=>{
            return `${Math.floor(currentTime.value / 60).toString().padStart(2, "0")}:${(Math.floor(currentTime.value) % 60).toString().padStart(2, "0")}`;
        });
        const formattedDuration = (0, $58rTl.computed)(()=>{
            return `${Math.floor(duration.value / 60).toString().padStart(2, "0")}:${(Math.floor(duration.value) % 60).toString().padStart(2, "0")}`;
        });
        (0, $58rTl.onMounted)(()=>{
            audioElement.value.addEventListener("timeupdate", ()=>{
                ended.value = false;
                currentTime.value = audioElement.value.currentTime;
            });
            audioElement.value.addEventListener("durationchange", ()=>{
                duration.value = audioElement.value.duration;
            });
            audioElement.value.addEventListener("ended", ()=>{
                ended.value = true;
            });
            audioElement.value.addEventListener("play", ()=>{
                ended.value = false;
            });
            (0, $58rTl.watch)(currentSrc, (src)=>{
                if (audioElement.value.src !== src) {
                    audioElement.value.src = src;
                    audioElement.value.load();
                }
            }, {
                immediate: true
            });
        });
        const __returned__ = {
            CHAPTER_LIST: CHAPTER_LIST,
            currentChapter: currentChapter,
            audioElement: audioElement,
            currentSrc: currentSrc,
            playing: playing,
            duration: duration,
            currentTime: currentTime,
            ended: ended,
            switchTrack: switchTrack,
            togglePlaying: togglePlaying,
            onClick: onClick,
            formattedCurrentTime: formattedCurrentTime,
            formattedDuration: formattedDuration
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});
parcelRegister("9uXBG", function(module, exports) {
$parcel$export(module.exports, "computed", () => (parcelRequire("58rTl")).computed);
$parcel$export(module.exports, "createElementBlock", () => (parcelRequire("58rTl")).createElementBlock);
$parcel$export(module.exports, "createElementVNode", () => (parcelRequire("58rTl")).createElementVNode);
$parcel$export(module.exports, "defineComponent", () => (parcelRequire("58rTl")).defineComponent);
$parcel$export(module.exports, "Fragment", () => (parcelRequire("58rTl")).Fragment);
$parcel$export(module.exports, "initCustomFormatter", () => (parcelRequire("58rTl")).initCustomFormatter);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("58rTl")).nextTick);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("Cr6yt")).normalizeClass);
$parcel$export(module.exports, "normalizeStyle", () => (parcelRequire("Cr6yt")).normalizeStyle);
$parcel$export(module.exports, "onMounted", () => (parcelRequire("58rTl")).onMounted);
$parcel$export(module.exports, "openBlock", () => (parcelRequire("58rTl")).openBlock);
$parcel$export(module.exports, "ref", () => (parcelRequire("2eFsq")).ref);
$parcel$export(module.exports, "renderList", () => (parcelRequire("58rTl")).renderList);
$parcel$export(module.exports, "useTemplateRef", () => (parcelRequire("58rTl")).useTemplateRef);
$parcel$export(module.exports, "watch", () => (parcelRequire("58rTl")).watch);
$parcel$export(module.exports, "createApp", () => (parcelRequire("dIm2H")).createApp);
$parcel$export(module.exports, "withKeys", () => (parcelRequire("dIm2H")).withKeys);
$parcel$export(module.exports, "withModifiers", () => (parcelRequire("dIm2H")).withModifiers);
$parcel$export(module.exports, "toDisplayString", () => (parcelRequire("Cr6yt")).toDisplayString);
/**
* vue v3.5.14
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $58rTl = parcelRequire("58rTl");parcelRequire("dIm2H");parcelRequire("Cr6yt");
function $6ea52715eb0fb1c6$var$initDev() {
    (0, $58rTl.initCustomFormatter)();
}
const $6ea52715eb0fb1c6$export$ef7acd7185315e22 = ()=>{};

});
parcelRegister("58rTl", function(module, exports) {

$parcel$export(module.exports, "callWithAsyncErrorHandling", () => $3bd355ce88b7fb93$export$dae85862a8d94378);
$parcel$export(module.exports, "nextTick", () => $3bd355ce88b7fb93$export$bdd553fddd433dcb);
$parcel$export(module.exports, "queuePostFlushCb", () => $3bd355ce88b7fb93$export$59536a0199721cab);
$parcel$export(module.exports, "Fragment", () => $3bd355ce88b7fb93$export$ffb0004e005737fa);
$parcel$export(module.exports, "Static", () => $3bd355ce88b7fb93$export$c1b9a1d3af45b7b6);
$parcel$export(module.exports, "useTransitionState", () => $3bd355ce88b7fb93$export$d2a0a1bc267c90f6);
$parcel$export(module.exports, "onMounted", () => $3bd355ce88b7fb93$export$6d1641039221b5cb);
$parcel$export(module.exports, "BaseTransitionPropsValidators", () => $3bd355ce88b7fb93$export$b876c99684f8cf3b);
$parcel$export(module.exports, "getCurrentInstance", () => $3bd355ce88b7fb93$export$f13e630aa3915748);
$parcel$export(module.exports, "getTransitionRawChildren", () => $3bd355ce88b7fb93$export$a67f9b1229c7c97a);
$parcel$export(module.exports, "resolveTransitionHooks", () => $3bd355ce88b7fb93$export$76ac1779589cd824);
$parcel$export(module.exports, "setTransitionHooks", () => $3bd355ce88b7fb93$export$7770a22486565649);
$parcel$export(module.exports, "BaseTransition", () => $3bd355ce88b7fb93$export$abd95b5f5e8a8837);
$parcel$export(module.exports, "defineComponent", () => $3bd355ce88b7fb93$export$afa64b67e5a01c3b);
$parcel$export(module.exports, "useTemplateRef", () => $3bd355ce88b7fb93$export$83a5dbc1f35517ca);
$parcel$export(module.exports, "createVNode", () => $3bd355ce88b7fb93$export$bf5c4cf060303d58);
$parcel$export(module.exports, "watch", () => $3bd355ce88b7fb93$export$3db5d71bdb2d5499);
$parcel$export(module.exports, "onUpdated", () => $3bd355ce88b7fb93$export$5876c47052fb88b1);
$parcel$export(module.exports, "onUnmounted", () => $3bd355ce88b7fb93$export$13348a43ccacfe58);
$parcel$export(module.exports, "onBeforeUpdate", () => $3bd355ce88b7fb93$export$ab91988a13872e4c);
$parcel$export(module.exports, "renderList", () => $3bd355ce88b7fb93$export$4bf387f59bfc6d67);
$parcel$export(module.exports, "openBlock", () => $3bd355ce88b7fb93$export$e7eaa45e502fe5cc);
$parcel$export(module.exports, "computed", () => $3bd355ce88b7fb93$export$2983e091f1a1e8e2);
$parcel$export(module.exports, "createRenderer", () => $3bd355ce88b7fb93$export$53ae2f996c64e9a);
$parcel$export(module.exports, "createHydrationRenderer", () => $3bd355ce88b7fb93$export$200524cf0d997ff0);
$parcel$export(module.exports, "createElementBlock", () => $3bd355ce88b7fb93$export$167055419fc69ec1);
$parcel$export(module.exports, "createElementVNode", () => $3bd355ce88b7fb93$export$42098e0eaa15c48e);
$parcel$export(module.exports, "isRuntimeOnly", () => $3bd355ce88b7fb93$export$c93a9c496c5211fa);
$parcel$export(module.exports, "h", () => $3bd355ce88b7fb93$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "initCustomFormatter", () => $3bd355ce88b7fb93$export$aed4979be6a60047);
$parcel$export(module.exports, "warn", () => $3bd355ce88b7fb93$export$c106dd0671a0fc2d);
$parcel$export(module.exports, "ref", () => (parcelRequire("2eFsq")).ref);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("2eFsq")).toRaw);
$parcel$export(module.exports, "camelize", () => (parcelRequire("Cr6yt")).camelize);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("Cr6yt")).normalizeClass);
$parcel$export(module.exports, "normalizeStyle", () => (parcelRequire("Cr6yt")).normalizeStyle);
/**
* @vue/runtime-core v3.5.14
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $2eFsq = parcelRequire("2eFsq");

var $Cr6yt = parcelRequire("Cr6yt");
const $3bd355ce88b7fb93$var$stack = [];
function $3bd355ce88b7fb93$var$pushWarningContext(vnode) {
    $3bd355ce88b7fb93$var$stack.push(vnode);
}
function $3bd355ce88b7fb93$var$popWarningContext() {
    $3bd355ce88b7fb93$var$stack.pop();
}
let $3bd355ce88b7fb93$var$isWarning = false;
function $3bd355ce88b7fb93$var$warn$1(msg, ...args) {
    if ($3bd355ce88b7fb93$var$isWarning) return;
    $3bd355ce88b7fb93$var$isWarning = true;
    (0, $2eFsq.pauseTracking)();
    const instance = $3bd355ce88b7fb93$var$stack.length ? $3bd355ce88b7fb93$var$stack[$3bd355ce88b7fb93$var$stack.length - 1].component : null;
    const appWarnHandler = instance && instance.appContext.config.warnHandler;
    const trace = $3bd355ce88b7fb93$var$getComponentTrace();
    if (appWarnHandler) $3bd355ce88b7fb93$export$b22fcaf88446e9bf(appWarnHandler, instance, 11, [
        // eslint-disable-next-line no-restricted-syntax
        msg + args.map((a)=>{
            var _a, _b;
            return (_b = (_a = a.toString) == null ? void 0 : _a.call(a)) != null ? _b : JSON.stringify(a);
        }).join(""),
        instance && instance.proxy,
        trace.map(({ vnode: vnode })=>`at <${$3bd355ce88b7fb93$var$formatComponentName(instance, vnode.type)}>`).join("\n"),
        trace
    ]);
    else {
        const warnArgs = [
            `[Vue warn]: ${msg}`,
            ...args
        ];
        if (trace.length && // avoid spamming console during tests
        true) warnArgs.push(`
`, ...$3bd355ce88b7fb93$var$formatTrace(trace));
        console.warn(...warnArgs);
    }
    (0, $2eFsq.resetTracking)();
    $3bd355ce88b7fb93$var$isWarning = false;
}
function $3bd355ce88b7fb93$var$getComponentTrace() {
    let currentVNode = $3bd355ce88b7fb93$var$stack[$3bd355ce88b7fb93$var$stack.length - 1];
    if (!currentVNode) return [];
    const normalizedStack = [];
    while(currentVNode){
        const last = normalizedStack[0];
        if (last && last.vnode === currentVNode) last.recurseCount++;
        else normalizedStack.push({
            vnode: currentVNode,
            recurseCount: 0
        });
        const parentInstance = currentVNode.component && currentVNode.component.parent;
        currentVNode = parentInstance && parentInstance.vnode;
    }
    return normalizedStack;
}
function $3bd355ce88b7fb93$var$formatTrace(trace) {
    const logs = [];
    trace.forEach((entry, i)=>{
        logs.push(...i === 0 ? [] : [
            `
`
        ], ...$3bd355ce88b7fb93$var$formatTraceEntry(entry));
    });
    return logs;
}
function $3bd355ce88b7fb93$var$formatTraceEntry({ vnode: vnode, recurseCount: recurseCount }) {
    const postfix = recurseCount > 0 ? `... (${recurseCount} recursive calls)` : ``;
    const isRoot = vnode.component ? vnode.component.parent == null : false;
    const open = ` at <${$3bd355ce88b7fb93$var$formatComponentName(vnode.component, vnode.type, isRoot)}`;
    const close = `>` + postfix;
    return vnode.props ? [
        open,
        ...$3bd355ce88b7fb93$var$formatProps(vnode.props),
        close
    ] : [
        open + close
    ];
}
function $3bd355ce88b7fb93$var$formatProps(props) {
    const res = [];
    const keys = Object.keys(props);
    keys.slice(0, 3).forEach((key)=>{
        res.push(...$3bd355ce88b7fb93$var$formatProp(key, props[key]));
    });
    if (keys.length > 3) res.push(` ...`);
    return res;
}
function $3bd355ce88b7fb93$var$formatProp(key, value, raw) {
    if ((0, $Cr6yt.isString)(value)) {
        value = JSON.stringify(value);
        return raw ? value : [
            `${key}=${value}`
        ];
    } else if (typeof value === "number" || typeof value === "boolean" || value == null) return raw ? value : [
        `${key}=${value}`
    ];
    else if ((0, $2eFsq.isRef)(value)) {
        value = $3bd355ce88b7fb93$var$formatProp(key, (0, $2eFsq.toRaw)(value.value), true);
        return raw ? value : [
            `${key}=Ref<`,
            value,
            `>`
        ];
    } else if ((0, $Cr6yt.isFunction)(value)) return [
        `${key}=fn${value.name ? `<${value.name}>` : ``}`
    ];
    else {
        value = (0, $2eFsq.toRaw)(value);
        return raw ? value : [
            `${key}=`,
            value
        ];
    }
}
function $3bd355ce88b7fb93$export$dfbcecb440255e4a(val, type) {
    return;
}
const $3bd355ce88b7fb93$export$10e8e1cf990558d7 = {
    "SETUP_FUNCTION": 0,
    "0": "SETUP_FUNCTION",
    "RENDER_FUNCTION": 1,
    "1": "RENDER_FUNCTION",
    "NATIVE_EVENT_HANDLER": 5,
    "5": "NATIVE_EVENT_HANDLER",
    "COMPONENT_EVENT_HANDLER": 6,
    "6": "COMPONENT_EVENT_HANDLER",
    "VNODE_HOOK": 7,
    "7": "VNODE_HOOK",
    "DIRECTIVE_HOOK": 8,
    "8": "DIRECTIVE_HOOK",
    "TRANSITION_HOOK": 9,
    "9": "TRANSITION_HOOK",
    "APP_ERROR_HANDLER": 10,
    "10": "APP_ERROR_HANDLER",
    "APP_WARN_HANDLER": 11,
    "11": "APP_WARN_HANDLER",
    "FUNCTION_REF": 12,
    "12": "FUNCTION_REF",
    "ASYNC_COMPONENT_LOADER": 13,
    "13": "ASYNC_COMPONENT_LOADER",
    "SCHEDULER": 14,
    "14": "SCHEDULER",
    "COMPONENT_UPDATE": 15,
    "15": "COMPONENT_UPDATE",
    "APP_UNMOUNT_CLEANUP": 16,
    "16": "APP_UNMOUNT_CLEANUP"
};
const $3bd355ce88b7fb93$var$ErrorTypeStrings$1 = {
    ["sp"]: "serverPrefetch hook",
    ["bc"]: "beforeCreate hook",
    ["c"]: "created hook",
    ["bm"]: "beforeMount hook",
    ["m"]: "mounted hook",
    ["bu"]: "beforeUpdate hook",
    ["u"]: "updated",
    ["bum"]: "beforeUnmount hook",
    ["um"]: "unmounted hook",
    ["a"]: "activated hook",
    ["da"]: "deactivated hook",
    ["ec"]: "errorCaptured hook",
    ["rtc"]: "renderTracked hook",
    ["rtg"]: "renderTriggered hook",
    [0]: "setup function",
    [1]: "render function",
    [2]: "watcher getter",
    [3]: "watcher callback",
    [4]: "watcher cleanup function",
    [5]: "native event handler",
    [6]: "component event handler",
    [7]: "vnode hook",
    [8]: "directive hook",
    [9]: "transition hook",
    [10]: "app errorHandler",
    [11]: "app warnHandler",
    [12]: "ref function",
    [13]: "async component loader",
    [14]: "scheduler flush",
    [15]: "component update",
    [16]: "app unmount cleanup function"
};
function $3bd355ce88b7fb93$export$b22fcaf88446e9bf(fn, instance, type, args) {
    try {
        return args ? fn(...args) : fn();
    } catch (err) {
        $3bd355ce88b7fb93$export$d3da1ecaf1206c58(err, instance, type);
    }
}
function $3bd355ce88b7fb93$export$dae85862a8d94378(fn, instance, type, args) {
    if ((0, $Cr6yt.isFunction)(fn)) {
        const res = $3bd355ce88b7fb93$export$b22fcaf88446e9bf(fn, instance, type, args);
        if (res && (0, $Cr6yt.isPromise)(res)) res.catch((err)=>{
            $3bd355ce88b7fb93$export$d3da1ecaf1206c58(err, instance, type);
        });
        return res;
    }
    if ((0, $Cr6yt.isArray)(fn)) {
        const values = [];
        for(let i = 0; i < fn.length; i++)values.push($3bd355ce88b7fb93$export$dae85862a8d94378(fn[i], instance, type, args));
        return values;
    }
}
function $3bd355ce88b7fb93$export$d3da1ecaf1206c58(err, instance, type, throwInDev = true) {
    const contextVNode = instance ? instance.vnode : null;
    const { errorHandler: errorHandler, throwUnhandledErrorInProduction: throwUnhandledErrorInProduction } = instance && instance.appContext.config || (0, $Cr6yt.EMPTY_OBJ);
    if (instance) {
        let cur = instance.parent;
        const exposedInstance = instance.proxy;
        const errorInfo = `https://vuejs.org/error-reference/#runtime-${type}`;
        while(cur){
            const errorCapturedHooks = cur.ec;
            if (errorCapturedHooks) for(let i = 0; i < errorCapturedHooks.length; i++){
                if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) return;
            }
            cur = cur.parent;
        }
        if (errorHandler) {
            (0, $2eFsq.pauseTracking)();
            $3bd355ce88b7fb93$export$b22fcaf88446e9bf(errorHandler, null, 10, [
                err,
                exposedInstance,
                errorInfo
            ]);
            (0, $2eFsq.resetTracking)();
            return;
        }
    }
    $3bd355ce88b7fb93$var$logError(err, type, contextVNode, throwInDev, throwUnhandledErrorInProduction);
}
function $3bd355ce88b7fb93$var$logError(err, type, contextVNode, throwInDev = true, throwInProd = false) {
    if (throwInProd) throw err;
    else console.error(err);
}
const $3bd355ce88b7fb93$var$queue = [];
let $3bd355ce88b7fb93$var$flushIndex = -1;
const $3bd355ce88b7fb93$var$pendingPostFlushCbs = [];
let $3bd355ce88b7fb93$var$activePostFlushCbs = null;
let $3bd355ce88b7fb93$var$postFlushIndex = 0;
const $3bd355ce88b7fb93$var$resolvedPromise = /* @__PURE__ */ Promise.resolve();
let $3bd355ce88b7fb93$var$currentFlushPromise = null;
const $3bd355ce88b7fb93$var$RECURSION_LIMIT = 100;
function $3bd355ce88b7fb93$export$bdd553fddd433dcb(fn) {
    const p = $3bd355ce88b7fb93$var$currentFlushPromise || $3bd355ce88b7fb93$var$resolvedPromise;
    return fn ? p.then(this ? fn.bind(this) : fn) : p;
}
function $3bd355ce88b7fb93$var$findInsertionIndex(id) {
    let start = $3bd355ce88b7fb93$var$flushIndex + 1;
    let end = $3bd355ce88b7fb93$var$queue.length;
    while(start < end){
        const middle = start + end >>> 1;
        const middleJob = $3bd355ce88b7fb93$var$queue[middle];
        const middleJobId = $3bd355ce88b7fb93$var$getId(middleJob);
        if (middleJobId < id || middleJobId === id && middleJob.flags & 2) start = middle + 1;
        else end = middle;
    }
    return start;
}
function $3bd355ce88b7fb93$var$queueJob(job) {
    if (!(job.flags & 1)) {
        const jobId = $3bd355ce88b7fb93$var$getId(job);
        const lastJob = $3bd355ce88b7fb93$var$queue[$3bd355ce88b7fb93$var$queue.length - 1];
        if (!lastJob || // fast path when the job id is larger than the tail
        !(job.flags & 2) && jobId >= $3bd355ce88b7fb93$var$getId(lastJob)) $3bd355ce88b7fb93$var$queue.push(job);
        else $3bd355ce88b7fb93$var$queue.splice($3bd355ce88b7fb93$var$findInsertionIndex(jobId), 0, job);
        job.flags |= 1;
        $3bd355ce88b7fb93$var$queueFlush();
    }
}
function $3bd355ce88b7fb93$var$queueFlush() {
    if (!$3bd355ce88b7fb93$var$currentFlushPromise) $3bd355ce88b7fb93$var$currentFlushPromise = $3bd355ce88b7fb93$var$resolvedPromise.then($3bd355ce88b7fb93$var$flushJobs);
}
function $3bd355ce88b7fb93$export$59536a0199721cab(cb) {
    if (!(0, $Cr6yt.isArray)(cb)) {
        if ($3bd355ce88b7fb93$var$activePostFlushCbs && cb.id === -1) $3bd355ce88b7fb93$var$activePostFlushCbs.splice($3bd355ce88b7fb93$var$postFlushIndex + 1, 0, cb);
        else if (!(cb.flags & 1)) {
            $3bd355ce88b7fb93$var$pendingPostFlushCbs.push(cb);
            cb.flags |= 1;
        }
    } else $3bd355ce88b7fb93$var$pendingPostFlushCbs.push(...cb);
    $3bd355ce88b7fb93$var$queueFlush();
}
function $3bd355ce88b7fb93$var$flushPreFlushCbs(instance, seen, i = $3bd355ce88b7fb93$var$flushIndex + 1) {
    for(; i < $3bd355ce88b7fb93$var$queue.length; i++){
        const cb = $3bd355ce88b7fb93$var$queue[i];
        if (cb && cb.flags & 2) {
            if (instance && cb.id !== instance.uid) continue;
            $3bd355ce88b7fb93$var$queue.splice(i, 1);
            i--;
            if (cb.flags & 4) cb.flags &= -2;
            cb();
            if (!(cb.flags & 4)) cb.flags &= -2;
        }
    }
}
function $3bd355ce88b7fb93$var$flushPostFlushCbs(seen) {
    if ($3bd355ce88b7fb93$var$pendingPostFlushCbs.length) {
        const deduped = [
            ...new Set($3bd355ce88b7fb93$var$pendingPostFlushCbs)
        ].sort((a, b)=>$3bd355ce88b7fb93$var$getId(a) - $3bd355ce88b7fb93$var$getId(b));
        $3bd355ce88b7fb93$var$pendingPostFlushCbs.length = 0;
        if ($3bd355ce88b7fb93$var$activePostFlushCbs) {
            $3bd355ce88b7fb93$var$activePostFlushCbs.push(...deduped);
            return;
        }
        $3bd355ce88b7fb93$var$activePostFlushCbs = deduped;
        for($3bd355ce88b7fb93$var$postFlushIndex = 0; $3bd355ce88b7fb93$var$postFlushIndex < $3bd355ce88b7fb93$var$activePostFlushCbs.length; $3bd355ce88b7fb93$var$postFlushIndex++){
            const cb = $3bd355ce88b7fb93$var$activePostFlushCbs[$3bd355ce88b7fb93$var$postFlushIndex];
            if (cb.flags & 4) cb.flags &= -2;
            if (!(cb.flags & 8)) cb();
            cb.flags &= -2;
        }
        $3bd355ce88b7fb93$var$activePostFlushCbs = null;
        $3bd355ce88b7fb93$var$postFlushIndex = 0;
    }
}
const $3bd355ce88b7fb93$var$getId = (job)=>job.id == null ? job.flags & 2 ? -1 : Infinity : job.id;
function $3bd355ce88b7fb93$var$flushJobs(seen) {
    const check = (0, $Cr6yt.NOOP);
    try {
        for($3bd355ce88b7fb93$var$flushIndex = 0; $3bd355ce88b7fb93$var$flushIndex < $3bd355ce88b7fb93$var$queue.length; $3bd355ce88b7fb93$var$flushIndex++){
            const job = $3bd355ce88b7fb93$var$queue[$3bd355ce88b7fb93$var$flushIndex];
            if (job && !(job.flags & 8)) {
                if (job.flags & 4) job.flags &= -2;
                $3bd355ce88b7fb93$export$b22fcaf88446e9bf(job, job.i, job.i ? 15 : 14);
                if (!(job.flags & 4)) job.flags &= -2;
            }
        }
    } finally{
        for(; $3bd355ce88b7fb93$var$flushIndex < $3bd355ce88b7fb93$var$queue.length; $3bd355ce88b7fb93$var$flushIndex++){
            const job = $3bd355ce88b7fb93$var$queue[$3bd355ce88b7fb93$var$flushIndex];
            if (job) job.flags &= -2;
        }
        $3bd355ce88b7fb93$var$flushIndex = -1;
        $3bd355ce88b7fb93$var$queue.length = 0;
        $3bd355ce88b7fb93$var$flushPostFlushCbs(seen);
        $3bd355ce88b7fb93$var$currentFlushPromise = null;
        if ($3bd355ce88b7fb93$var$queue.length || $3bd355ce88b7fb93$var$pendingPostFlushCbs.length) $3bd355ce88b7fb93$var$flushJobs(seen);
    }
}
function $3bd355ce88b7fb93$var$checkRecursiveUpdates(seen, fn) {
    const count = seen.get(fn) || 0;
    if (count > $3bd355ce88b7fb93$var$RECURSION_LIMIT) {
        const instance = fn.i;
        const componentName = instance && $3bd355ce88b7fb93$var$getComponentName(instance.type);
        $3bd355ce88b7fb93$export$d3da1ecaf1206c58(`Maximum recursive updates exceeded${componentName ? ` in component <${componentName}>` : ``}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`, null, 10);
        return true;
    }
    seen.set(fn, count + 1);
    return false;
}
let $3bd355ce88b7fb93$var$isHmrUpdating = false;
const $3bd355ce88b7fb93$var$hmrDirtyComponents = /* @__PURE__ */ new Map();
const $3bd355ce88b7fb93$var$map = /* @__PURE__ */ new Map();
function $3bd355ce88b7fb93$var$registerHMR(instance) {
    const id = instance.type.__hmrId;
    let record = $3bd355ce88b7fb93$var$map.get(id);
    if (!record) {
        $3bd355ce88b7fb93$var$createRecord(id, instance.type);
        record = $3bd355ce88b7fb93$var$map.get(id);
    }
    record.instances.add(instance);
}
function $3bd355ce88b7fb93$var$unregisterHMR(instance) {
    $3bd355ce88b7fb93$var$map.get(instance.type.__hmrId).instances.delete(instance);
}
function $3bd355ce88b7fb93$var$createRecord(id, initialDef) {
    if ($3bd355ce88b7fb93$var$map.has(id)) return false;
    $3bd355ce88b7fb93$var$map.set(id, {
        initialDef: $3bd355ce88b7fb93$var$normalizeClassComponent(initialDef),
        instances: /* @__PURE__ */ new Set()
    });
    return true;
}
function $3bd355ce88b7fb93$var$normalizeClassComponent(component) {
    return $3bd355ce88b7fb93$var$isClassComponent(component) ? component.__vccOpts : component;
}
function $3bd355ce88b7fb93$var$rerender(id, newRender) {
    const record = $3bd355ce88b7fb93$var$map.get(id);
    if (!record) return;
    record.initialDef.render = newRender;
    [
        ...record.instances
    ].forEach((instance)=>{
        if (newRender) {
            instance.render = newRender;
            $3bd355ce88b7fb93$var$normalizeClassComponent(instance.type).render = newRender;
        }
        instance.renderCache = [];
        $3bd355ce88b7fb93$var$isHmrUpdating = true;
        instance.update();
        $3bd355ce88b7fb93$var$isHmrUpdating = false;
    });
}
function $3bd355ce88b7fb93$var$reload(id, newComp) {
    const record = $3bd355ce88b7fb93$var$map.get(id);
    if (!record) return;
    newComp = $3bd355ce88b7fb93$var$normalizeClassComponent(newComp);
    $3bd355ce88b7fb93$var$updateComponentDef(record.initialDef, newComp);
    const instances = [
        ...record.instances
    ];
    for(let i = 0; i < instances.length; i++){
        const instance = instances[i];
        const oldComp = $3bd355ce88b7fb93$var$normalizeClassComponent(instance.type);
        let dirtyInstances = $3bd355ce88b7fb93$var$hmrDirtyComponents.get(oldComp);
        if (!dirtyInstances) {
            if (oldComp !== record.initialDef) $3bd355ce88b7fb93$var$updateComponentDef(oldComp, newComp);
            $3bd355ce88b7fb93$var$hmrDirtyComponents.set(oldComp, dirtyInstances = /* @__PURE__ */ new Set());
        }
        dirtyInstances.add(instance);
        instance.appContext.propsCache.delete(instance.type);
        instance.appContext.emitsCache.delete(instance.type);
        instance.appContext.optionsCache.delete(instance.type);
        if (instance.ceReload) {
            dirtyInstances.add(instance);
            instance.ceReload(newComp.styles);
            dirtyInstances.delete(instance);
        } else if (instance.parent) $3bd355ce88b7fb93$var$queueJob(()=>{
            $3bd355ce88b7fb93$var$isHmrUpdating = true;
            instance.parent.update();
            $3bd355ce88b7fb93$var$isHmrUpdating = false;
            dirtyInstances.delete(instance);
        });
        else if (instance.appContext.reload) instance.appContext.reload();
        else if (typeof window !== "undefined") window.location.reload();
        else console.warn("[HMR] Root or manually mounted instance modified. Full reload required.");
        if (instance.root.ce && instance !== instance.root) instance.root.ce._removeChildStyle(oldComp);
    }
    $3bd355ce88b7fb93$export$59536a0199721cab(()=>{
        $3bd355ce88b7fb93$var$hmrDirtyComponents.clear();
    });
}
function $3bd355ce88b7fb93$var$updateComponentDef(oldComp, newComp) {
    (0, $Cr6yt.extend)(oldComp, newComp);
    for(const key in oldComp)if (key !== "__file" && !(key in newComp)) delete oldComp[key];
}
function $3bd355ce88b7fb93$var$tryWrap(fn) {
    return (id, arg)=>{
        try {
            return fn(id, arg);
        } catch (e) {
            console.error(e);
            console.warn(`[HMR] Something went wrong during Vue component hot-reload. Full reload required.`);
        }
    };
}
let $3bd355ce88b7fb93$var$devtools$1;
let $3bd355ce88b7fb93$var$buffer = [];
let $3bd355ce88b7fb93$var$devtoolsNotInstalled = false;
function $3bd355ce88b7fb93$var$emit$1(event, ...args) {
    if ($3bd355ce88b7fb93$var$devtools$1) $3bd355ce88b7fb93$var$devtools$1.emit(event, ...args);
    else if (!$3bd355ce88b7fb93$var$devtoolsNotInstalled) $3bd355ce88b7fb93$var$buffer.push({
        event: event,
        args: args
    });
}
function $3bd355ce88b7fb93$var$setDevtoolsHook$1(hook, target) {
    var _a, _b;
    $3bd355ce88b7fb93$var$devtools$1 = hook;
    if ($3bd355ce88b7fb93$var$devtools$1) {
        $3bd355ce88b7fb93$var$devtools$1.enabled = true;
        $3bd355ce88b7fb93$var$buffer.forEach(({ event: event, args: args })=>$3bd355ce88b7fb93$var$devtools$1.emit(event, ...args));
        $3bd355ce88b7fb93$var$buffer = [];
    } else if (// handle late devtools injection - only do this if we are in an actual
    // browser environment to avoid the timer handle stalling test runner exit
    // (#4815)
    typeof window !== "undefined" && // some envs mock window but not fully
    window.HTMLElement && // also exclude jsdom
    // eslint-disable-next-line no-restricted-syntax
    !((_b = (_a = window.navigator) == null ? void 0 : _a.userAgent) == null ? void 0 : _b.includes("jsdom"))) {
        const replay = target.__VUE_DEVTOOLS_HOOK_REPLAY__ = target.__VUE_DEVTOOLS_HOOK_REPLAY__ || [];
        replay.push((newHook)=>{
            $3bd355ce88b7fb93$var$setDevtoolsHook$1(newHook, target);
        });
        setTimeout(()=>{
            if (!$3bd355ce88b7fb93$var$devtools$1) {
                target.__VUE_DEVTOOLS_HOOK_REPLAY__ = null;
                $3bd355ce88b7fb93$var$devtoolsNotInstalled = true;
                $3bd355ce88b7fb93$var$buffer = [];
            }
        }, 3e3);
    } else {
        $3bd355ce88b7fb93$var$devtoolsNotInstalled = true;
        $3bd355ce88b7fb93$var$buffer = [];
    }
}
function $3bd355ce88b7fb93$var$devtoolsInitApp(app, version) {
    $3bd355ce88b7fb93$var$emit$1("app:init" /* APP_INIT */ , app, version, {
        Fragment: $3bd355ce88b7fb93$export$ffb0004e005737fa,
        Text: $3bd355ce88b7fb93$export$5f1af8db9871e1d6,
        Comment: $3bd355ce88b7fb93$export$4d299b491347818a,
        Static: $3bd355ce88b7fb93$export$c1b9a1d3af45b7b6
    });
}
function $3bd355ce88b7fb93$var$devtoolsUnmountApp(app) {
    $3bd355ce88b7fb93$var$emit$1("app:unmount" /* APP_UNMOUNT */ , app);
}
const $3bd355ce88b7fb93$var$devtoolsComponentAdded = /* @__PURE__ */ $3bd355ce88b7fb93$var$createDevtoolsComponentHook("component:added" /* COMPONENT_ADDED */ );
const $3bd355ce88b7fb93$var$devtoolsComponentUpdated = /* @__PURE__ */ $3bd355ce88b7fb93$var$createDevtoolsComponentHook("component:updated" /* COMPONENT_UPDATED */ );
const $3bd355ce88b7fb93$var$_devtoolsComponentRemoved = /* @__PURE__ */ $3bd355ce88b7fb93$var$createDevtoolsComponentHook("component:removed" /* COMPONENT_REMOVED */ );
const $3bd355ce88b7fb93$var$devtoolsComponentRemoved = (component)=>{
    if ($3bd355ce88b7fb93$var$devtools$1 && typeof $3bd355ce88b7fb93$var$devtools$1.cleanupBuffer === "function" && // remove the component if it wasn't buffered
    !$3bd355ce88b7fb93$var$devtools$1.cleanupBuffer(component)) $3bd355ce88b7fb93$var$_devtoolsComponentRemoved(component);
};
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $3bd355ce88b7fb93$var$createDevtoolsComponentHook(hook) {
    return (component)=>{
        $3bd355ce88b7fb93$var$emit$1(hook, component.appContext.app, component.uid, component.parent ? component.parent.uid : void 0, component);
    };
}
const $3bd355ce88b7fb93$var$devtoolsPerfStart = /* @__PURE__ */ $3bd355ce88b7fb93$var$createDevtoolsPerformanceHook("perf:start" /* PERFORMANCE_START */ );
const $3bd355ce88b7fb93$var$devtoolsPerfEnd = /* @__PURE__ */ $3bd355ce88b7fb93$var$createDevtoolsPerformanceHook("perf:end" /* PERFORMANCE_END */ );
function $3bd355ce88b7fb93$var$createDevtoolsPerformanceHook(hook) {
    return (component, type, time)=>{
        $3bd355ce88b7fb93$var$emit$1(hook, component.appContext.app, component.uid, component, type, time);
    };
}
function $3bd355ce88b7fb93$var$devtoolsComponentEmit(component, event, params) {
    $3bd355ce88b7fb93$var$emit$1("component:emit" /* COMPONENT_EMIT */ , component.appContext.app, component, event, params);
}
let $3bd355ce88b7fb93$var$currentRenderingInstance = null;
let $3bd355ce88b7fb93$var$currentScopeId = null;
function $3bd355ce88b7fb93$var$setCurrentRenderingInstance(instance) {
    const prev = $3bd355ce88b7fb93$var$currentRenderingInstance;
    $3bd355ce88b7fb93$var$currentRenderingInstance = instance;
    $3bd355ce88b7fb93$var$currentScopeId = instance && instance.type.__scopeId || null;
    return prev;
}
function $3bd355ce88b7fb93$export$ac020265ca2cc4cd(id) {
    $3bd355ce88b7fb93$var$currentScopeId = id;
}
function $3bd355ce88b7fb93$export$f2dc6805dc11834e() {
    $3bd355ce88b7fb93$var$currentScopeId = null;
}
const $3bd355ce88b7fb93$export$15ba313e13f3dd04 = (_id)=>$3bd355ce88b7fb93$export$694b237e827a3d23;
function $3bd355ce88b7fb93$export$694b237e827a3d23(fn, ctx = $3bd355ce88b7fb93$var$currentRenderingInstance, isNonScopedSlot) {
    if (!ctx) return fn;
    if (fn._n) return fn;
    const renderFnWithContext = (...args)=>{
        if (renderFnWithContext._d) $3bd355ce88b7fb93$export$c20bee82f26f1e27(-1);
        const prevInstance = $3bd355ce88b7fb93$var$setCurrentRenderingInstance(ctx);
        let res;
        try {
            res = fn(...args);
        } finally{
            $3bd355ce88b7fb93$var$setCurrentRenderingInstance(prevInstance);
            if (renderFnWithContext._d) $3bd355ce88b7fb93$export$c20bee82f26f1e27(1);
        }
        if (__VUE_PROD_DEVTOOLS__) $3bd355ce88b7fb93$var$devtoolsComponentUpdated(ctx);
        return res;
    };
    renderFnWithContext._n = true;
    renderFnWithContext._c = true;
    renderFnWithContext._d = true;
    return renderFnWithContext;
}
function $3bd355ce88b7fb93$var$validateDirectiveName(name) {
    if ((0, $Cr6yt.isBuiltInDirective)(name)) $3bd355ce88b7fb93$var$warn$1("Do not use built-in directive ids as custom directive id: " + name);
}
function $3bd355ce88b7fb93$export$49729353e7c1e6c5(vnode, directives) {
    if ($3bd355ce88b7fb93$var$currentRenderingInstance === null) return vnode;
    const instance = $3bd355ce88b7fb93$var$getComponentPublicInstance($3bd355ce88b7fb93$var$currentRenderingInstance);
    const bindings = vnode.dirs || (vnode.dirs = []);
    for(let i = 0; i < directives.length; i++){
        let [dir, value, arg, modifiers = (0, $Cr6yt.EMPTY_OBJ)] = directives[i];
        if (dir) {
            if ((0, $Cr6yt.isFunction)(dir)) dir = {
                mounted: dir,
                updated: dir
            };
            if (dir.deep) (0, $2eFsq.traverse)(value);
            bindings.push({
                dir: dir,
                instance: instance,
                value: value,
                oldValue: void 0,
                arg: arg,
                modifiers: modifiers
            });
        }
    }
    return vnode;
}
function $3bd355ce88b7fb93$var$invokeDirectiveHook(vnode, prevVNode, instance, name) {
    const bindings = vnode.dirs;
    const oldBindings = prevVNode && prevVNode.dirs;
    for(let i = 0; i < bindings.length; i++){
        const binding = bindings[i];
        if (oldBindings) binding.oldValue = oldBindings[i].value;
        let hook = binding.dir[name];
        if (hook) {
            (0, $2eFsq.pauseTracking)();
            $3bd355ce88b7fb93$export$dae85862a8d94378(hook, instance, 8, [
                vnode.el,
                binding,
                vnode,
                prevVNode
            ]);
            (0, $2eFsq.resetTracking)();
        }
    }
}
const $3bd355ce88b7fb93$var$TeleportEndKey = Symbol("_vte");
const $3bd355ce88b7fb93$var$isTeleport = (type)=>type.__isTeleport;
const $3bd355ce88b7fb93$var$isTeleportDisabled = (props)=>props && (props.disabled || props.disabled === "");
const $3bd355ce88b7fb93$var$isTeleportDeferred = (props)=>props && (props.defer || props.defer === "");
const $3bd355ce88b7fb93$var$isTargetSVG = (target)=>typeof SVGElement !== "undefined" && target instanceof SVGElement;
const $3bd355ce88b7fb93$var$isTargetMathML = (target)=>typeof MathMLElement === "function" && target instanceof MathMLElement;
const $3bd355ce88b7fb93$var$resolveTarget = (props, select)=>{
    const targetSelector = props && props.to;
    if ((0, $Cr6yt.isString)(targetSelector)) {
        if (!select) return null;
        else {
            const target = select(targetSelector);
            return target;
        }
    } else return targetSelector;
};
const $3bd355ce88b7fb93$var$TeleportImpl = {
    name: "Teleport",
    __isTeleport: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals) {
        const { mc: mountChildren, pc: patchChildren, pbc: patchBlockChildren, o: { insert: insert, querySelector: querySelector, createText: createText, createComment: createComment } } = internals;
        const disabled = $3bd355ce88b7fb93$var$isTeleportDisabled(n2.props);
        let { shapeFlag: shapeFlag, children: children, dynamicChildren: dynamicChildren } = n2;
        if (n1 == null) {
            const placeholder = n2.el = createText("");
            const mainAnchor = n2.anchor = createText("");
            insert(placeholder, container, anchor);
            insert(mainAnchor, container, anchor);
            const mount = (container2, anchor2)=>{
                if (shapeFlag & 16) {
                    if (parentComponent && parentComponent.isCE) parentComponent.ce._teleportTarget = container2;
                    mountChildren(children, container2, anchor2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                }
            };
            const mountToTarget = ()=>{
                const target = n2.target = $3bd355ce88b7fb93$var$resolveTarget(n2.props, querySelector);
                const targetAnchor = $3bd355ce88b7fb93$var$prepareAnchor(target, n2, createText, insert);
                if (target) {
                    if (namespace !== "svg" && $3bd355ce88b7fb93$var$isTargetSVG(target)) namespace = "svg";
                    else if (namespace !== "mathml" && $3bd355ce88b7fb93$var$isTargetMathML(target)) namespace = "mathml";
                    if (!disabled) {
                        mount(target, targetAnchor);
                        $3bd355ce88b7fb93$var$updateCssVars(n2, false);
                    }
                }
            };
            if (disabled) {
                mount(container, mainAnchor);
                $3bd355ce88b7fb93$var$updateCssVars(n2, true);
            }
            if ($3bd355ce88b7fb93$var$isTeleportDeferred(n2.props)) $3bd355ce88b7fb93$var$queuePostRenderEffect(()=>{
                mountToTarget();
                n2.el.__isMounted = true;
            }, parentSuspense);
            else mountToTarget();
        } else {
            if ($3bd355ce88b7fb93$var$isTeleportDeferred(n2.props) && !n1.el.__isMounted) {
                $3bd355ce88b7fb93$var$queuePostRenderEffect(()=>{
                    $3bd355ce88b7fb93$var$TeleportImpl.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
                    delete n1.el.__isMounted;
                }, parentSuspense);
                return;
            }
            n2.el = n1.el;
            n2.targetStart = n1.targetStart;
            const mainAnchor = n2.anchor = n1.anchor;
            const target = n2.target = n1.target;
            const targetAnchor = n2.targetAnchor = n1.targetAnchor;
            const wasDisabled = $3bd355ce88b7fb93$var$isTeleportDisabled(n1.props);
            const currentContainer = wasDisabled ? container : target;
            const currentAnchor = wasDisabled ? mainAnchor : targetAnchor;
            if (namespace === "svg" || $3bd355ce88b7fb93$var$isTargetSVG(target)) namespace = "svg";
            else if (namespace === "mathml" || $3bd355ce88b7fb93$var$isTargetMathML(target)) namespace = "mathml";
            if (dynamicChildren) {
                patchBlockChildren(n1.dynamicChildren, dynamicChildren, currentContainer, parentComponent, parentSuspense, namespace, slotScopeIds);
                $3bd355ce88b7fb93$var$traverseStaticChildren(n1, n2, true);
            } else if (!optimized) patchChildren(n1, n2, currentContainer, currentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, false);
            if (disabled) {
                if (!wasDisabled) $3bd355ce88b7fb93$var$moveTeleport(n2, container, mainAnchor, internals, 1);
                else if (n2.props && n1.props && n2.props.to !== n1.props.to) n2.props.to = n1.props.to;
            } else {
                if ((n2.props && n2.props.to) !== (n1.props && n1.props.to)) {
                    const nextTarget = n2.target = $3bd355ce88b7fb93$var$resolveTarget(n2.props, querySelector);
                    if (nextTarget) $3bd355ce88b7fb93$var$moveTeleport(n2, nextTarget, null, internals, 0);
                } else if (wasDisabled) $3bd355ce88b7fb93$var$moveTeleport(n2, target, targetAnchor, internals, 1);
            }
            $3bd355ce88b7fb93$var$updateCssVars(n2, disabled);
        }
    },
    remove (vnode, parentComponent, parentSuspense, { um: unmount, o: { remove: hostRemove } }, doRemove) {
        const { shapeFlag: shapeFlag, children: children, anchor: anchor, targetStart: targetStart, targetAnchor: targetAnchor, target: target, props: props } = vnode;
        if (target) {
            hostRemove(targetStart);
            hostRemove(targetAnchor);
        }
        doRemove && hostRemove(anchor);
        if (shapeFlag & 16) {
            const shouldRemove = doRemove || !$3bd355ce88b7fb93$var$isTeleportDisabled(props);
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                unmount(child, parentComponent, parentSuspense, shouldRemove, !!child.dynamicChildren);
            }
        }
    },
    move: $3bd355ce88b7fb93$var$moveTeleport,
    hydrate: $3bd355ce88b7fb93$var$hydrateTeleport
};
function $3bd355ce88b7fb93$var$moveTeleport(vnode, container, parentAnchor, { o: { insert: insert }, m: move }, moveType = 2) {
    if (moveType === 0) insert(vnode.targetAnchor, container, parentAnchor);
    const { el: el, anchor: anchor, shapeFlag: shapeFlag, children: children, props: props } = vnode;
    const isReorder = moveType === 2;
    if (isReorder) insert(el, container, parentAnchor);
    if (!isReorder || $3bd355ce88b7fb93$var$isTeleportDisabled(props)) {
        if (shapeFlag & 16) for(let i = 0; i < children.length; i++)move(children[i], container, parentAnchor, 2);
    }
    if (isReorder) insert(anchor, container, parentAnchor);
}
function $3bd355ce88b7fb93$var$hydrateTeleport(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, { o: { nextSibling: nextSibling, parentNode: parentNode, querySelector: querySelector, insert: insert, createText: createText } }, hydrateChildren) {
    const target = vnode.target = $3bd355ce88b7fb93$var$resolveTarget(vnode.props, querySelector);
    if (target) {
        const disabled = $3bd355ce88b7fb93$var$isTeleportDisabled(vnode.props);
        const targetNode = target._lpa || target.firstChild;
        if (vnode.shapeFlag & 16) {
            if (disabled) {
                vnode.anchor = hydrateChildren(nextSibling(node), vnode, parentNode(node), parentComponent, parentSuspense, slotScopeIds, optimized);
                vnode.targetStart = targetNode;
                vnode.targetAnchor = targetNode && nextSibling(targetNode);
            } else {
                vnode.anchor = nextSibling(node);
                let targetAnchor = targetNode;
                while(targetAnchor){
                    if (targetAnchor && targetAnchor.nodeType === 8) {
                        if (targetAnchor.data === "teleport start anchor") vnode.targetStart = targetAnchor;
                        else if (targetAnchor.data === "teleport anchor") {
                            vnode.targetAnchor = targetAnchor;
                            target._lpa = vnode.targetAnchor && nextSibling(vnode.targetAnchor);
                            break;
                        }
                    }
                    targetAnchor = nextSibling(targetAnchor);
                }
                if (!vnode.targetAnchor) $3bd355ce88b7fb93$var$prepareAnchor(target, vnode, createText, insert);
                hydrateChildren(targetNode && nextSibling(targetNode), vnode, target, parentComponent, parentSuspense, slotScopeIds, optimized);
            }
        }
        $3bd355ce88b7fb93$var$updateCssVars(vnode, disabled);
    }
    return vnode.anchor && nextSibling(vnode.anchor);
}
const $3bd355ce88b7fb93$export$76d55a0304a371f4 = $3bd355ce88b7fb93$var$TeleportImpl;
function $3bd355ce88b7fb93$var$updateCssVars(vnode, isDisabled) {
    const ctx = vnode.ctx;
    if (ctx && ctx.ut) {
        let node, anchor;
        if (isDisabled) {
            node = vnode.el;
            anchor = vnode.anchor;
        } else {
            node = vnode.targetStart;
            anchor = vnode.targetAnchor;
        }
        while(node && node !== anchor){
            if (node.nodeType === 1) node.setAttribute("data-v-owner", ctx.uid);
            node = node.nextSibling;
        }
        ctx.ut();
    }
}
function $3bd355ce88b7fb93$var$prepareAnchor(target, vnode, createText, insert) {
    const targetStart = vnode.targetStart = createText("");
    const targetAnchor = vnode.targetAnchor = createText("");
    targetStart[$3bd355ce88b7fb93$var$TeleportEndKey] = targetAnchor;
    if (target) {
        insert(targetStart, target);
        insert(targetAnchor, target);
    }
    return targetAnchor;
}
const $3bd355ce88b7fb93$var$leaveCbKey = Symbol("_leaveCb");
const $3bd355ce88b7fb93$var$enterCbKey = Symbol("_enterCb");
function $3bd355ce88b7fb93$export$d2a0a1bc267c90f6() {
    const state = {
        isMounted: false,
        isLeaving: false,
        isUnmounting: false,
        leavingVNodes: /* @__PURE__ */ new Map()
    };
    $3bd355ce88b7fb93$export$6d1641039221b5cb(()=>{
        state.isMounted = true;
    });
    $3bd355ce88b7fb93$export$40c420df62d2614(()=>{
        state.isUnmounting = true;
    });
    return state;
}
const $3bd355ce88b7fb93$var$TransitionHookValidator = [
    Function,
    Array
];
const $3bd355ce88b7fb93$export$b876c99684f8cf3b = {
    mode: String,
    appear: Boolean,
    persisted: Boolean,
    // enter
    onBeforeEnter: $3bd355ce88b7fb93$var$TransitionHookValidator,
    onEnter: $3bd355ce88b7fb93$var$TransitionHookValidator,
    onAfterEnter: $3bd355ce88b7fb93$var$TransitionHookValidator,
    onEnterCancelled: $3bd355ce88b7fb93$var$TransitionHookValidator,
    // leave
    onBeforeLeave: $3bd355ce88b7fb93$var$TransitionHookValidator,
    onLeave: $3bd355ce88b7fb93$var$TransitionHookValidator,
    onAfterLeave: $3bd355ce88b7fb93$var$TransitionHookValidator,
    onLeaveCancelled: $3bd355ce88b7fb93$var$TransitionHookValidator,
    // appear
    onBeforeAppear: $3bd355ce88b7fb93$var$TransitionHookValidator,
    onAppear: $3bd355ce88b7fb93$var$TransitionHookValidator,
    onAfterAppear: $3bd355ce88b7fb93$var$TransitionHookValidator,
    onAppearCancelled: $3bd355ce88b7fb93$var$TransitionHookValidator
};
const $3bd355ce88b7fb93$var$recursiveGetSubtree = (instance)=>{
    const subTree = instance.subTree;
    return subTree.component ? $3bd355ce88b7fb93$var$recursiveGetSubtree(subTree.component) : subTree;
};
const $3bd355ce88b7fb93$var$BaseTransitionImpl = {
    name: `BaseTransition`,
    props: $3bd355ce88b7fb93$export$b876c99684f8cf3b,
    setup (props, { slots: slots }) {
        const instance = $3bd355ce88b7fb93$export$f13e630aa3915748();
        const state = $3bd355ce88b7fb93$export$d2a0a1bc267c90f6();
        return ()=>{
            const children = slots.default && $3bd355ce88b7fb93$export$a67f9b1229c7c97a(slots.default(), true);
            if (!children || !children.length) return;
            const child = $3bd355ce88b7fb93$var$findNonCommentChild(children);
            const rawProps = (0, $2eFsq.toRaw)(props);
            const { mode: mode } = rawProps;
            if (state.isLeaving) return $3bd355ce88b7fb93$var$emptyPlaceholder(child);
            const innerChild = $3bd355ce88b7fb93$var$getInnerChild$1(child);
            if (!innerChild) return $3bd355ce88b7fb93$var$emptyPlaceholder(child);
            let enterHooks = $3bd355ce88b7fb93$export$76ac1779589cd824(innerChild, rawProps, state, instance, // #11061, ensure enterHooks is fresh after clone
            (hooks)=>enterHooks = hooks);
            if (innerChild.type !== $3bd355ce88b7fb93$export$4d299b491347818a) $3bd355ce88b7fb93$export$7770a22486565649(innerChild, enterHooks);
            let oldInnerChild = instance.subTree && $3bd355ce88b7fb93$var$getInnerChild$1(instance.subTree);
            if (oldInnerChild && oldInnerChild.type !== $3bd355ce88b7fb93$export$4d299b491347818a && !$3bd355ce88b7fb93$var$isSameVNodeType(innerChild, oldInnerChild) && $3bd355ce88b7fb93$var$recursiveGetSubtree(instance).type !== $3bd355ce88b7fb93$export$4d299b491347818a) {
                let leavingHooks = $3bd355ce88b7fb93$export$76ac1779589cd824(oldInnerChild, rawProps, state, instance);
                $3bd355ce88b7fb93$export$7770a22486565649(oldInnerChild, leavingHooks);
                if (mode === "out-in" && innerChild.type !== $3bd355ce88b7fb93$export$4d299b491347818a) {
                    state.isLeaving = true;
                    leavingHooks.afterLeave = ()=>{
                        state.isLeaving = false;
                        if (!(instance.job.flags & 8)) instance.update();
                        delete leavingHooks.afterLeave;
                        oldInnerChild = void 0;
                    };
                    return $3bd355ce88b7fb93$var$emptyPlaceholder(child);
                } else if (mode === "in-out" && innerChild.type !== $3bd355ce88b7fb93$export$4d299b491347818a) leavingHooks.delayLeave = (el, earlyRemove, delayedLeave)=>{
                    const leavingVNodesCache = $3bd355ce88b7fb93$var$getLeavingNodesForType(state, oldInnerChild);
                    leavingVNodesCache[String(oldInnerChild.key)] = oldInnerChild;
                    el[$3bd355ce88b7fb93$var$leaveCbKey] = ()=>{
                        earlyRemove();
                        el[$3bd355ce88b7fb93$var$leaveCbKey] = void 0;
                        delete enterHooks.delayedLeave;
                        oldInnerChild = void 0;
                    };
                    enterHooks.delayedLeave = ()=>{
                        delayedLeave();
                        delete enterHooks.delayedLeave;
                        oldInnerChild = void 0;
                    };
                };
                else oldInnerChild = void 0;
            } else if (oldInnerChild) oldInnerChild = void 0;
            return child;
        };
    }
};
function $3bd355ce88b7fb93$var$findNonCommentChild(children) {
    let child = children[0];
    if (children.length > 1) {
        let hasFound = false;
        for (const c of children)if (c.type !== $3bd355ce88b7fb93$export$4d299b491347818a) {
            child = c;
            hasFound = true;
            break;
        }
    }
    return child;
}
const $3bd355ce88b7fb93$export$abd95b5f5e8a8837 = $3bd355ce88b7fb93$var$BaseTransitionImpl;
function $3bd355ce88b7fb93$var$getLeavingNodesForType(state, vnode) {
    const { leavingVNodes: leavingVNodes } = state;
    let leavingVNodesCache = leavingVNodes.get(vnode.type);
    if (!leavingVNodesCache) {
        leavingVNodesCache = /* @__PURE__ */ Object.create(null);
        leavingVNodes.set(vnode.type, leavingVNodesCache);
    }
    return leavingVNodesCache;
}
function $3bd355ce88b7fb93$export$76ac1779589cd824(vnode, props, state, instance, postClone) {
    const { appear: appear, mode: mode, persisted: persisted = false, onBeforeEnter: onBeforeEnter, onEnter: onEnter, onAfterEnter: onAfterEnter, onEnterCancelled: onEnterCancelled, onBeforeLeave: onBeforeLeave, onLeave: onLeave, onAfterLeave: onAfterLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear, onAppear: onAppear, onAfterAppear: onAfterAppear, onAppearCancelled: onAppearCancelled } = props;
    const key = String(vnode.key);
    const leavingVNodesCache = $3bd355ce88b7fb93$var$getLeavingNodesForType(state, vnode);
    const callHook = (hook, args)=>{
        hook && $3bd355ce88b7fb93$export$dae85862a8d94378(hook, instance, 9, args);
    };
    const callAsyncHook = (hook, args)=>{
        const done = args[1];
        callHook(hook, args);
        if ((0, $Cr6yt.isArray)(hook)) {
            if (hook.every((hook2)=>hook2.length <= 1)) done();
        } else if (hook.length <= 1) done();
    };
    const hooks = {
        mode: mode,
        persisted: persisted,
        beforeEnter (el) {
            let hook = onBeforeEnter;
            if (!state.isMounted) {
                if (appear) hook = onBeforeAppear || onBeforeEnter;
                else return;
            }
            if (el[$3bd355ce88b7fb93$var$leaveCbKey]) el[$3bd355ce88b7fb93$var$leaveCbKey](true);
            const leavingVNode = leavingVNodesCache[key];
            if (leavingVNode && $3bd355ce88b7fb93$var$isSameVNodeType(vnode, leavingVNode) && leavingVNode.el[$3bd355ce88b7fb93$var$leaveCbKey]) leavingVNode.el[$3bd355ce88b7fb93$var$leaveCbKey]();
            callHook(hook, [
                el
            ]);
        },
        enter (el) {
            let hook = onEnter;
            let afterHook = onAfterEnter;
            let cancelHook = onEnterCancelled;
            if (!state.isMounted) {
                if (appear) {
                    hook = onAppear || onEnter;
                    afterHook = onAfterAppear || onAfterEnter;
                    cancelHook = onAppearCancelled || onEnterCancelled;
                } else return;
            }
            let called = false;
            const done = el[$3bd355ce88b7fb93$var$enterCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                if (cancelled) callHook(cancelHook, [
                    el
                ]);
                else callHook(afterHook, [
                    el
                ]);
                if (hooks.delayedLeave) hooks.delayedLeave();
                el[$3bd355ce88b7fb93$var$enterCbKey] = void 0;
            };
            if (hook) callAsyncHook(hook, [
                el,
                done
            ]);
            else done();
        },
        leave (el, remove) {
            const key2 = String(vnode.key);
            if (el[$3bd355ce88b7fb93$var$enterCbKey]) el[$3bd355ce88b7fb93$var$enterCbKey](true);
            if (state.isUnmounting) return remove();
            callHook(onBeforeLeave, [
                el
            ]);
            let called = false;
            const done = el[$3bd355ce88b7fb93$var$leaveCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                remove();
                if (cancelled) callHook(onLeaveCancelled, [
                    el
                ]);
                else callHook(onAfterLeave, [
                    el
                ]);
                el[$3bd355ce88b7fb93$var$leaveCbKey] = void 0;
                if (leavingVNodesCache[key2] === vnode) delete leavingVNodesCache[key2];
            };
            leavingVNodesCache[key2] = vnode;
            if (onLeave) callAsyncHook(onLeave, [
                el,
                done
            ]);
            else done();
        },
        clone (vnode2) {
            const hooks2 = $3bd355ce88b7fb93$export$76ac1779589cd824(vnode2, props, state, instance, postClone);
            if (postClone) postClone(hooks2);
            return hooks2;
        }
    };
    return hooks;
}
function $3bd355ce88b7fb93$var$emptyPlaceholder(vnode) {
    if ($3bd355ce88b7fb93$var$isKeepAlive(vnode)) {
        vnode = $3bd355ce88b7fb93$export$ee4f9e12c0a92a1a(vnode);
        vnode.children = null;
        return vnode;
    }
}
function $3bd355ce88b7fb93$var$getInnerChild$1(vnode) {
    if (!$3bd355ce88b7fb93$var$isKeepAlive(vnode)) {
        if ($3bd355ce88b7fb93$var$isTeleport(vnode.type) && vnode.children) return $3bd355ce88b7fb93$var$findNonCommentChild(vnode.children);
        return vnode;
    }
    if (vnode.component) return vnode.component.subTree;
    const { shapeFlag: shapeFlag, children: children } = vnode;
    if (children) {
        if (shapeFlag & 16) return children[0];
        if (shapeFlag & 32 && (0, $Cr6yt.isFunction)(children.default)) return children.default();
    }
}
function $3bd355ce88b7fb93$export$7770a22486565649(vnode, hooks) {
    if (vnode.shapeFlag & 6 && vnode.component) {
        vnode.transition = hooks;
        $3bd355ce88b7fb93$export$7770a22486565649(vnode.component.subTree, hooks);
    } else if (vnode.shapeFlag & 128) {
        vnode.ssContent.transition = hooks.clone(vnode.ssContent);
        vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
    } else vnode.transition = hooks;
}
function $3bd355ce88b7fb93$export$a67f9b1229c7c97a(children, keepComment = false, parentKey) {
    let ret = [];
    let keyedFragmentCount = 0;
    for(let i = 0; i < children.length; i++){
        let child = children[i];
        const key = parentKey == null ? child.key : String(parentKey) + String(child.key != null ? child.key : i);
        if (child.type === $3bd355ce88b7fb93$export$ffb0004e005737fa) {
            if (child.patchFlag & 128) keyedFragmentCount++;
            ret = ret.concat($3bd355ce88b7fb93$export$a67f9b1229c7c97a(child.children, keepComment, key));
        } else if (keepComment || child.type !== $3bd355ce88b7fb93$export$4d299b491347818a) ret.push(key != null ? $3bd355ce88b7fb93$export$ee4f9e12c0a92a1a(child, {
            key: key
        }) : child);
    }
    if (keyedFragmentCount > 1) for(let i = 0; i < ret.length; i++)ret[i].patchFlag = -2;
    return ret;
}
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $3bd355ce88b7fb93$export$afa64b67e5a01c3b(options, extraOptions) {
    return (0, $Cr6yt.isFunction)(options) ? // #8236: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    /* @__PURE__ */ (()=>(0, $Cr6yt.extend)({
            name: options.name
        }, extraOptions, {
            setup: options
        }))() : options;
}
function $3bd355ce88b7fb93$export$f680877a34711e37() {
    const i = $3bd355ce88b7fb93$export$f13e630aa3915748();
    if (i) return (i.appContext.config.idPrefix || "v") + "-" + i.ids[0] + i.ids[1]++;
    return "";
}
function $3bd355ce88b7fb93$var$markAsyncBoundary(instance) {
    instance.ids = [
        instance.ids[0] + instance.ids[2]++ + "-",
        0,
        0
    ];
}
const $3bd355ce88b7fb93$var$knownTemplateRefs = /* @__PURE__ */ new WeakSet();
function $3bd355ce88b7fb93$export$83a5dbc1f35517ca(key) {
    const i = $3bd355ce88b7fb93$export$f13e630aa3915748();
    const r = (0, $2eFsq.shallowRef)(null);
    if (i) {
        const refs = i.refs === (0, $Cr6yt.EMPTY_OBJ) ? i.refs = {} : i.refs;
        let desc;
        Object.defineProperty(refs, key, {
            enumerable: true,
            get: ()=>r.value,
            set: (val)=>r.value = val
        });
    }
    const ret = r;
    return ret;
}
function $3bd355ce88b7fb93$var$setRef(rawRef, oldRawRef, parentSuspense, vnode, isUnmount = false) {
    if ((0, $Cr6yt.isArray)(rawRef)) {
        rawRef.forEach((r, i)=>$3bd355ce88b7fb93$var$setRef(r, oldRawRef && ((0, $Cr6yt.isArray)(oldRawRef) ? oldRawRef[i] : oldRawRef), parentSuspense, vnode, isUnmount));
        return;
    }
    if ($3bd355ce88b7fb93$var$isAsyncWrapper(vnode) && !isUnmount) {
        if (vnode.shapeFlag & 512 && vnode.type.__asyncResolved && vnode.component.subTree.component) $3bd355ce88b7fb93$var$setRef(rawRef, oldRawRef, parentSuspense, vnode.component.subTree);
        return;
    }
    const refValue = vnode.shapeFlag & 4 ? $3bd355ce88b7fb93$var$getComponentPublicInstance(vnode.component) : vnode.el;
    const value = isUnmount ? null : refValue;
    const { i: owner, r: ref } = rawRef;
    const oldRef = oldRawRef && oldRawRef.r;
    const refs = owner.refs === (0, $Cr6yt.EMPTY_OBJ) ? owner.refs = {} : owner.refs;
    const setupState = owner.setupState;
    const rawSetupState = (0, $2eFsq.toRaw)(setupState);
    const canSetSetupRef = setupState === (0, $Cr6yt.EMPTY_OBJ) ? ()=>false : (key)=>{
        return (0, $Cr6yt.hasOwn)(rawSetupState, key);
    };
    if (oldRef != null && oldRef !== ref) {
        if ((0, $Cr6yt.isString)(oldRef)) {
            refs[oldRef] = null;
            if (canSetSetupRef(oldRef)) setupState[oldRef] = null;
        } else if ((0, $2eFsq.isRef)(oldRef)) oldRef.value = null;
    }
    if ((0, $Cr6yt.isFunction)(ref)) $3bd355ce88b7fb93$export$b22fcaf88446e9bf(ref, owner, 12, [
        value,
        refs
    ]);
    else {
        const _isString = (0, $Cr6yt.isString)(ref);
        const _isRef = (0, $2eFsq.isRef)(ref);
        if (_isString || _isRef) {
            const doSet = ()=>{
                if (rawRef.f) {
                    const existing = _isString ? canSetSetupRef(ref) ? setupState[ref] : refs[ref] : ref.value;
                    if (isUnmount) (0, $Cr6yt.isArray)(existing) && (0, $Cr6yt.remove)(existing, refValue);
                    else {
                        if (!(0, $Cr6yt.isArray)(existing)) {
                            if (_isString) {
                                refs[ref] = [
                                    refValue
                                ];
                                if (canSetSetupRef(ref)) setupState[ref] = refs[ref];
                            } else {
                                ref.value = [
                                    refValue
                                ];
                                if (rawRef.k) refs[rawRef.k] = ref.value;
                            }
                        } else if (!existing.includes(refValue)) existing.push(refValue);
                    }
                } else if (_isString) {
                    refs[ref] = value;
                    if (canSetSetupRef(ref)) setupState[ref] = value;
                } else if (_isRef) {
                    ref.value = value;
                    if (rawRef.k) refs[rawRef.k] = value;
                }
            };
            if (value) {
                doSet.id = -1;
                $3bd355ce88b7fb93$var$queuePostRenderEffect(doSet, parentSuspense);
            } else doSet();
        }
    }
}
let $3bd355ce88b7fb93$var$hasLoggedMismatchError = false;
const $3bd355ce88b7fb93$var$logMismatchError = ()=>{
    if ($3bd355ce88b7fb93$var$hasLoggedMismatchError) return;
    console.error("Hydration completed but contains mismatches.");
    $3bd355ce88b7fb93$var$hasLoggedMismatchError = true;
};
const $3bd355ce88b7fb93$var$isSVGContainer = (container)=>container.namespaceURI.includes("svg") && container.tagName !== "foreignObject";
const $3bd355ce88b7fb93$var$isMathMLContainer = (container)=>container.namespaceURI.includes("MathML");
const $3bd355ce88b7fb93$var$getContainerType = (container)=>{
    if (container.nodeType !== 1) return void 0;
    if ($3bd355ce88b7fb93$var$isSVGContainer(container)) return "svg";
    if ($3bd355ce88b7fb93$var$isMathMLContainer(container)) return "mathml";
    return void 0;
};
const $3bd355ce88b7fb93$var$isComment = (node)=>node.nodeType === 8;
function $3bd355ce88b7fb93$var$createHydrationFunctions(rendererInternals) {
    const { mt: mountComponent, p: patch, o: { patchProp: patchProp, createText: createText, nextSibling: nextSibling, parentNode: parentNode, remove: remove, insert: insert, createComment: createComment } } = rendererInternals;
    const hydrate = (vnode, container)=>{
        if (!container.hasChildNodes()) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $3bd355ce88b7fb93$var$warn$1(`Attempting to hydrate existing markup but container is empty. Performing full mount instead.`);
            patch(null, vnode, container);
            $3bd355ce88b7fb93$var$flushPostFlushCbs();
            container._vnode = vnode;
            return;
        }
        hydrateNode(container.firstChild, vnode, null, null, null);
        $3bd355ce88b7fb93$var$flushPostFlushCbs();
        container._vnode = vnode;
    };
    const hydrateNode = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized = false)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const isFragmentStart = $3bd355ce88b7fb93$var$isComment(node) && node.data === "[";
        const onMismatch = ()=>handleMismatch(node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragmentStart);
        const { type: type, ref: ref, shapeFlag: shapeFlag, patchFlag: patchFlag } = vnode;
        let domType = node.nodeType;
        vnode.el = node;
        if (__VUE_PROD_DEVTOOLS__) {
            (0, $Cr6yt.def)(node, "__vnode", vnode, true);
            (0, $Cr6yt.def)(node, "__vueParentComponent", parentComponent, true);
        }
        if (patchFlag === -2) {
            optimized = false;
            vnode.dynamicChildren = null;
        }
        let nextNode = null;
        switch(type){
            case $3bd355ce88b7fb93$export$5f1af8db9871e1d6:
                if (domType !== 3) {
                    if (vnode.children === "") {
                        insert(vnode.el = createText(""), parentNode(node), node);
                        nextNode = node;
                    } else nextNode = onMismatch();
                } else {
                    if (node.data !== vnode.children) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $3bd355ce88b7fb93$var$warn$1(`Hydration text mismatch in`, node.parentNode, `
  - rendered on server: ${JSON.stringify(node.data)}
  - expected on client: ${JSON.stringify(vnode.children)}`);
                        $3bd355ce88b7fb93$var$logMismatchError();
                        node.data = vnode.children;
                    }
                    nextNode = nextSibling(node);
                }
                break;
            case $3bd355ce88b7fb93$export$4d299b491347818a:
                if (isTemplateNode(node)) {
                    nextNode = nextSibling(node);
                    replaceNode(vnode.el = node.content.firstChild, node, parentComponent);
                } else if (domType !== 8 || isFragmentStart) nextNode = onMismatch();
                else nextNode = nextSibling(node);
                break;
            case $3bd355ce88b7fb93$export$c1b9a1d3af45b7b6:
                if (isFragmentStart) {
                    node = nextSibling(node);
                    domType = node.nodeType;
                }
                if (domType === 1 || domType === 3) {
                    nextNode = node;
                    const needToAdoptContent = !vnode.children.length;
                    for(let i = 0; i < vnode.staticCount; i++){
                        if (needToAdoptContent) vnode.children += nextNode.nodeType === 1 ? nextNode.outerHTML : nextNode.data;
                        if (i === vnode.staticCount - 1) vnode.anchor = nextNode;
                        nextNode = nextSibling(nextNode);
                    }
                    return isFragmentStart ? nextSibling(nextNode) : nextNode;
                } else onMismatch();
                break;
            case $3bd355ce88b7fb93$export$ffb0004e005737fa:
                if (!isFragmentStart) nextNode = onMismatch();
                else nextNode = hydrateFragment(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) {
                    if ((domType !== 1 || vnode.type.toLowerCase() !== node.tagName.toLowerCase()) && !isTemplateNode(node)) nextNode = onMismatch();
                    else nextNode = hydrateElement(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                } else if (shapeFlag & 6) {
                    vnode.slotScopeIds = slotScopeIds;
                    const container = parentNode(node);
                    if (isFragmentStart) nextNode = locateClosingAnchor(node);
                    else if ($3bd355ce88b7fb93$var$isComment(node) && node.data === "teleport start") nextNode = locateClosingAnchor(node, node.data, "teleport end");
                    else nextNode = nextSibling(node);
                    mountComponent(vnode, container, null, parentComponent, parentSuspense, $3bd355ce88b7fb93$var$getContainerType(container), optimized);
                    if ($3bd355ce88b7fb93$var$isAsyncWrapper(vnode) && !vnode.type.__asyncResolved) {
                        let subTree;
                        if (isFragmentStart) {
                            subTree = $3bd355ce88b7fb93$export$bf5c4cf060303d58($3bd355ce88b7fb93$export$ffb0004e005737fa);
                            subTree.anchor = nextNode ? nextNode.previousSibling : container.lastChild;
                        } else subTree = node.nodeType === 3 ? $3bd355ce88b7fb93$export$22f9b5ffd89dac9("") : $3bd355ce88b7fb93$export$bf5c4cf060303d58("div");
                        subTree.el = node;
                        vnode.component.subTree = subTree;
                    }
                } else if (shapeFlag & 64) {
                    if (domType !== 8) nextNode = onMismatch();
                    else nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, rendererInternals, hydrateChildren);
                } else if (shapeFlag & 128) nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, $3bd355ce88b7fb93$var$getContainerType(parentNode(node)), slotScopeIds, optimized, rendererInternals, hydrateNode);
                else if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__) $3bd355ce88b7fb93$var$warn$1("Invalid HostVNode type:", type, `(${typeof type})`);
        }
        if (ref != null) $3bd355ce88b7fb93$var$setRef(ref, null, parentSuspense, vnode);
        return nextNode;
    };
    const hydrateElement = (el, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const { type: type, props: props, patchFlag: patchFlag, shapeFlag: shapeFlag, dirs: dirs, transition: transition } = vnode;
        const forcePatch = type === "input" || type === "option";
        if (forcePatch || patchFlag !== -1) {
            if (dirs) $3bd355ce88b7fb93$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
            let needCallTransitionHooks = false;
            if (isTemplateNode(el)) {
                needCallTransitionHooks = $3bd355ce88b7fb93$var$needTransition(null, // no need check parentSuspense in hydration
                transition) && parentComponent && parentComponent.vnode.props && parentComponent.vnode.props.appear;
                const content = el.content.firstChild;
                if (needCallTransitionHooks) transition.beforeEnter(content);
                replaceNode(content, el, parentComponent);
                vnode.el = el = content;
            }
            if (shapeFlag & 16 && // skip if element has innerHTML / textContent
            !(props && (props.innerHTML || props.textContent))) {
                let next = hydrateChildren(el.firstChild, vnode, el, parentComponent, parentSuspense, slotScopeIds, optimized);
                let hasWarned = false;
                while(next){
                    if (!$3bd355ce88b7fb93$var$isMismatchAllowed(el, 1 /* CHILDREN */ )) {
                        if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && !hasWarned) {
                            $3bd355ce88b7fb93$var$warn$1(`Hydration children mismatch on`, el, `
Server rendered element contains more child nodes than client vdom.`);
                            hasWarned = true;
                        }
                        $3bd355ce88b7fb93$var$logMismatchError();
                    }
                    const cur = next;
                    next = next.nextSibling;
                    remove(cur);
                }
            } else if (shapeFlag & 8) {
                let clientText = vnode.children;
                if (clientText[0] === "\n" && (el.tagName === "PRE" || el.tagName === "TEXTAREA")) clientText = clientText.slice(1);
                if (el.textContent !== clientText) {
                    if (!$3bd355ce88b7fb93$var$isMismatchAllowed(el, 0 /* TEXT */ )) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $3bd355ce88b7fb93$var$warn$1(`Hydration text content mismatch on`, el, `
  - rendered on server: ${el.textContent}
  - expected on client: ${vnode.children}`);
                        $3bd355ce88b7fb93$var$logMismatchError();
                    }
                    el.textContent = vnode.children;
                }
            }
            if (props) {
                if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ || forcePatch || !optimized || patchFlag & 48) {
                    const isCustomElement = el.tagName.includes("-");
                    for(const key in props){
                        if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && // #11189 skip if this node has directives that have created hooks
                        // as it could have mutated the DOM in any possible way
                        !(dirs && dirs.some((d)=>d.dir.created)) && $3bd355ce88b7fb93$var$propHasMismatch(el, key, props[key], vnode, parentComponent)) $3bd355ce88b7fb93$var$logMismatchError();
                        if (forcePatch && (key.endsWith("value") || key === "indeterminate") || (0, $Cr6yt.isOn)(key) && !(0, $Cr6yt.isReservedProp)(key) || // force hydrate v-bind with .prop modifiers
                        key[0] === "." || isCustomElement) patchProp(el, key, null, props[key], void 0, parentComponent);
                    }
                } else if (props.onClick) patchProp(el, "onClick", null, props.onClick, void 0, parentComponent);
                else if (patchFlag & 4 && (0, $2eFsq.isReactive)(props.style)) for(const key in props.style)props.style[key];
            }
            let vnodeHooks;
            if (vnodeHooks = props && props.onVnodeBeforeMount) $3bd355ce88b7fb93$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
            if (dirs) $3bd355ce88b7fb93$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
            if ((vnodeHooks = props && props.onVnodeMounted) || dirs || needCallTransitionHooks) $3bd355ce88b7fb93$var$queueEffectWithSuspense(()=>{
                vnodeHooks && $3bd355ce88b7fb93$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
                needCallTransitionHooks && transition.enter(el);
                dirs && $3bd355ce88b7fb93$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
            }, parentSuspense);
        }
        return el.nextSibling;
    };
    const hydrateChildren = (node, parentVNode, container, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!parentVNode.dynamicChildren;
        const children = parentVNode.children;
        const l = children.length;
        let hasWarned = false;
        for(let i = 0; i < l; i++){
            const vnode = optimized ? children[i] : children[i] = $3bd355ce88b7fb93$var$normalizeVNode(children[i]);
            const isText = vnode.type === $3bd355ce88b7fb93$export$5f1af8db9871e1d6;
            if (node) {
                if (isText && !optimized) {
                    if (i + 1 < l && $3bd355ce88b7fb93$var$normalizeVNode(children[i + 1]).type === $3bd355ce88b7fb93$export$5f1af8db9871e1d6) {
                        insert(createText(node.data.slice(vnode.children.length)), container, nextSibling(node));
                        node.data = vnode.children;
                    }
                }
                node = hydrateNode(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
            } else if (isText && !vnode.children) insert(vnode.el = createText(""), container);
            else {
                if (!$3bd355ce88b7fb93$var$isMismatchAllowed(container, 1 /* CHILDREN */ )) {
                    if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && !hasWarned) {
                        $3bd355ce88b7fb93$var$warn$1(`Hydration children mismatch on`, container, `
Server rendered element contains fewer child nodes than client vdom.`);
                        hasWarned = true;
                    }
                    $3bd355ce88b7fb93$var$logMismatchError();
                }
                patch(null, vnode, container, null, parentComponent, parentSuspense, $3bd355ce88b7fb93$var$getContainerType(container), slotScopeIds);
            }
        }
        return node;
    };
    const hydrateFragment = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        const { slotScopeIds: fragmentSlotScopeIds } = vnode;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        const container = parentNode(node);
        const next = hydrateChildren(nextSibling(node), vnode, container, parentComponent, parentSuspense, slotScopeIds, optimized);
        if (next && $3bd355ce88b7fb93$var$isComment(next) && next.data === "]") return nextSibling(vnode.anchor = next);
        else {
            $3bd355ce88b7fb93$var$logMismatchError();
            insert(vnode.anchor = createComment(`]`), container, next);
            return next;
        }
    };
    const handleMismatch = (node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragment)=>{
        if (!$3bd355ce88b7fb93$var$isMismatchAllowed(node.parentElement, 1 /* CHILDREN */ )) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $3bd355ce88b7fb93$var$warn$1(`Hydration node mismatch:
- rendered on server:`, node, node.nodeType === 3 ? `(text)` : $3bd355ce88b7fb93$var$isComment(node) && node.data === "[" ? `(start of fragment)` : ``, `
- expected on client:`, vnode.type);
            $3bd355ce88b7fb93$var$logMismatchError();
        }
        vnode.el = null;
        if (isFragment) {
            const end = locateClosingAnchor(node);
            while(true){
                const next2 = nextSibling(node);
                if (next2 && next2 !== end) remove(next2);
                else break;
            }
        }
        const next = nextSibling(node);
        const container = parentNode(node);
        remove(node);
        patch(null, vnode, container, next, parentComponent, parentSuspense, $3bd355ce88b7fb93$var$getContainerType(container), slotScopeIds);
        if (parentComponent) {
            parentComponent.vnode.el = vnode.el;
            $3bd355ce88b7fb93$var$updateHOCHostEl(parentComponent, vnode.el);
        }
        return next;
    };
    const locateClosingAnchor = (node, open = "[", close = "]")=>{
        let match = 0;
        while(node){
            node = nextSibling(node);
            if (node && $3bd355ce88b7fb93$var$isComment(node)) {
                if (node.data === open) match++;
                if (node.data === close) {
                    if (match === 0) return nextSibling(node);
                    else match--;
                }
            }
        }
        return node;
    };
    const replaceNode = (newNode, oldNode, parentComponent)=>{
        const parentNode2 = oldNode.parentNode;
        if (parentNode2) parentNode2.replaceChild(newNode, oldNode);
        let parent = parentComponent;
        while(parent){
            if (parent.vnode.el === oldNode) parent.vnode.el = parent.subTree.el = newNode;
            parent = parent.parent;
        }
    };
    const isTemplateNode = (node)=>{
        return node.nodeType === 1 && node.tagName === "TEMPLATE";
    };
    return [
        hydrate,
        hydrateNode
    ];
}
function $3bd355ce88b7fb93$var$propHasMismatch(el, key, clientValue, vnode, instance) {
    let mismatchType;
    let mismatchKey;
    let actual;
    let expected;
    if (key === "class") {
        actual = el.getAttribute("class");
        expected = (0, $Cr6yt.normalizeClass)(clientValue);
        if (!$3bd355ce88b7fb93$var$isSetEqual($3bd355ce88b7fb93$var$toClassSet(actual || ""), $3bd355ce88b7fb93$var$toClassSet(expected))) {
            mismatchType = 2 /* CLASS */ ;
            mismatchKey = `class`;
        }
    } else if (key === "style") {
        actual = el.getAttribute("style") || "";
        expected = (0, $Cr6yt.isString)(clientValue) ? clientValue : (0, $Cr6yt.stringifyStyle)((0, $Cr6yt.normalizeStyle)(clientValue));
        const actualMap = $3bd355ce88b7fb93$var$toStyleMap(actual);
        const expectedMap = $3bd355ce88b7fb93$var$toStyleMap(expected);
        if (vnode.dirs) {
            for (const { dir: dir, value: value } of vnode.dirs)if (dir.name === "show" && !value) expectedMap.set("display", "none");
        }
        if (instance) $3bd355ce88b7fb93$var$resolveCssVars(instance, vnode, expectedMap);
        if (!$3bd355ce88b7fb93$var$isMapEqual(actualMap, expectedMap)) {
            mismatchType = 3 /* STYLE */ ;
            mismatchKey = "style";
        }
    } else if (el instanceof SVGElement && (0, $Cr6yt.isKnownSvgAttr)(key) || el instanceof HTMLElement && ((0, $Cr6yt.isBooleanAttr)(key) || (0, $Cr6yt.isKnownHtmlAttr)(key))) {
        if ((0, $Cr6yt.isBooleanAttr)(key)) {
            actual = el.hasAttribute(key);
            expected = (0, $Cr6yt.includeBooleanAttr)(clientValue);
        } else if (clientValue == null) {
            actual = el.hasAttribute(key);
            expected = false;
        } else {
            if (el.hasAttribute(key)) actual = el.getAttribute(key);
            else if (key === "value" && el.tagName === "TEXTAREA") actual = el.value;
            else actual = false;
            expected = (0, $Cr6yt.isRenderableAttrValue)(clientValue) ? String(clientValue) : false;
        }
        if (actual !== expected) {
            mismatchType = 4 /* ATTRIBUTE */ ;
            mismatchKey = key;
        }
    }
    if (mismatchType != null && !$3bd355ce88b7fb93$var$isMismatchAllowed(el, mismatchType)) {
        const format = (v1)=>v1 === false ? `(not rendered)` : `${mismatchKey}="${v1}"`;
        const preSegment = `Hydration ${$3bd355ce88b7fb93$var$MismatchTypeString[mismatchType]} mismatch on`;
        const postSegment = `
  - rendered on server: ${format(actual)}
  - expected on client: ${format(expected)}
  Note: this mismatch is check-only. The DOM will not be rectified in production due to performance overhead.
  You should fix the source of the mismatch.`;
        $3bd355ce88b7fb93$var$warn$1(preSegment, el, postSegment);
        return true;
    }
    return false;
}
function $3bd355ce88b7fb93$var$toClassSet(str) {
    return new Set(str.trim().split(/\s+/));
}
function $3bd355ce88b7fb93$var$isSetEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const s of a){
        if (!b.has(s)) return false;
    }
    return true;
}
function $3bd355ce88b7fb93$var$toStyleMap(str) {
    const styleMap = /* @__PURE__ */ new Map();
    for (const item of str.split(";")){
        let [key, value] = item.split(":");
        key = key.trim();
        value = value && value.trim();
        if (key && value) styleMap.set(key, value);
    }
    return styleMap;
}
function $3bd355ce88b7fb93$var$isMapEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const [key, value] of a){
        if (value !== b.get(key)) return false;
    }
    return true;
}
function $3bd355ce88b7fb93$var$resolveCssVars(instance, vnode, expectedMap) {
    const root = instance.subTree;
    if (instance.getCssVars && (vnode === root || root && root.type === $3bd355ce88b7fb93$export$ffb0004e005737fa && root.children.includes(vnode))) {
        const cssVars = instance.getCssVars();
        for(const key in cssVars)expectedMap.set(`--${(0, $Cr6yt.getEscapedCssVarName)(key, false)}`, String(cssVars[key]));
    }
    if (vnode === root && instance.parent) $3bd355ce88b7fb93$var$resolveCssVars(instance.parent, instance.vnode, expectedMap);
}
const $3bd355ce88b7fb93$var$allowMismatchAttr = "data-allow-mismatch";
const $3bd355ce88b7fb93$var$MismatchTypeString = {
    [0 /* TEXT */ ]: "text",
    [1 /* CHILDREN */ ]: "children",
    [2 /* CLASS */ ]: "class",
    [3 /* STYLE */ ]: "style",
    [4 /* ATTRIBUTE */ ]: "attribute"
};
function $3bd355ce88b7fb93$var$isMismatchAllowed(el, allowedType) {
    if (allowedType === 0 /* TEXT */  || allowedType === 1 /* CHILDREN */ ) while(el && !el.hasAttribute($3bd355ce88b7fb93$var$allowMismatchAttr))el = el.parentElement;
    const allowedAttr = el && el.getAttribute($3bd355ce88b7fb93$var$allowMismatchAttr);
    if (allowedAttr == null) return false;
    else if (allowedAttr === "") return true;
    else {
        const list = allowedAttr.split(",");
        if (allowedType === 0 /* TEXT */  && list.includes("children")) return true;
        return allowedAttr.split(",").includes($3bd355ce88b7fb93$var$MismatchTypeString[allowedType]);
    }
}
const $3bd355ce88b7fb93$var$requestIdleCallback = (0, $Cr6yt.getGlobalThis)().requestIdleCallback || ((cb)=>setTimeout(cb, 1));
const $3bd355ce88b7fb93$var$cancelIdleCallback = (0, $Cr6yt.getGlobalThis)().cancelIdleCallback || ((id)=>clearTimeout(id));
const $3bd355ce88b7fb93$export$8bfca283fd254627 = (timeout = 1e4)=>(hydrate)=>{
        const id = $3bd355ce88b7fb93$var$requestIdleCallback(hydrate, {
            timeout: timeout
        });
        return ()=>$3bd355ce88b7fb93$var$cancelIdleCallback(id);
    };
function $3bd355ce88b7fb93$var$elementIsVisibleInViewport(el) {
    const { top: top, left: left, bottom: bottom, right: right } = el.getBoundingClientRect();
    const { innerHeight: innerHeight, innerWidth: innerWidth } = window;
    return (top > 0 && top < innerHeight || bottom > 0 && bottom < innerHeight) && (left > 0 && left < innerWidth || right > 0 && right < innerWidth);
}
const $3bd355ce88b7fb93$export$2b04cd335e660930 = (opts)=>(hydrate, forEach)=>{
        const ob = new IntersectionObserver((entries)=>{
            for (const e of entries){
                if (!e.isIntersecting) continue;
                ob.disconnect();
                hydrate();
                break;
            }
        }, opts);
        forEach((el)=>{
            if (!(el instanceof Element)) return;
            if ($3bd355ce88b7fb93$var$elementIsVisibleInViewport(el)) {
                hydrate();
                ob.disconnect();
                return false;
            }
            ob.observe(el);
        });
        return ()=>ob.disconnect();
    };
const $3bd355ce88b7fb93$export$804dbb6002787b74 = (query)=>(hydrate)=>{
        if (query) {
            const mql = matchMedia(query);
            if (mql.matches) hydrate();
            else {
                mql.addEventListener("change", hydrate, {
                    once: true
                });
                return ()=>mql.removeEventListener("change", hydrate);
            }
        }
    };
const $3bd355ce88b7fb93$export$288f5a9b4248e114 = (interactions = [])=>(hydrate, forEach)=>{
        if ((0, $Cr6yt.isString)(interactions)) interactions = [
            interactions
        ];
        let hasHydrated = false;
        const doHydrate = (e)=>{
            if (!hasHydrated) {
                hasHydrated = true;
                teardown();
                hydrate();
                e.target.dispatchEvent(new e.constructor(e.type, e));
            }
        };
        const teardown = ()=>{
            forEach((el)=>{
                for (const i of interactions)el.removeEventListener(i, doHydrate);
            });
        };
        forEach((el)=>{
            for (const i of interactions)el.addEventListener(i, doHydrate, {
                once: true
            });
        });
        return teardown;
    };
function $3bd355ce88b7fb93$var$forEachElement(node, cb) {
    if ($3bd355ce88b7fb93$var$isComment(node) && node.data === "[") {
        let depth = 1;
        let next = node.nextSibling;
        while(next){
            if (next.nodeType === 1) {
                const result = cb(next);
                if (result === false) break;
            } else if ($3bd355ce88b7fb93$var$isComment(next)) {
                if (next.data === "]") {
                    if (--depth === 0) break;
                } else if (next.data === "[") depth++;
            }
            next = next.nextSibling;
        }
    } else cb(node);
}
const $3bd355ce88b7fb93$var$isAsyncWrapper = (i)=>!!i.type.__asyncLoader;
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $3bd355ce88b7fb93$export$d75d499b4c16cf21(source) {
    if ((0, $Cr6yt.isFunction)(source)) source = {
        loader: source
    };
    const { loader: loader, loadingComponent: loadingComponent, errorComponent: errorComponent, delay: delay = 200, hydrate: hydrateStrategy, timeout: timeout, suspensible: // undefined = never times out
    suspensible = true, onError: userOnError } = source;
    let pendingRequest = null;
    let resolvedComp;
    let retries = 0;
    const retry = ()=>{
        retries++;
        pendingRequest = null;
        return load();
    };
    const load = ()=>{
        let thisRequest;
        return pendingRequest || (thisRequest = pendingRequest = loader().catch((err)=>{
            err = err instanceof Error ? err : new Error(String(err));
            if (userOnError) return new Promise((resolve, reject)=>{
                const userRetry = ()=>resolve(retry());
                const userFail = ()=>reject(err);
                userOnError(err, userRetry, userFail, retries + 1);
            });
            else throw err;
        }).then((comp)=>{
            if (thisRequest !== pendingRequest && pendingRequest) return pendingRequest;
            if (comp && (comp.__esModule || comp[Symbol.toStringTag] === "Module")) comp = comp.default;
            resolvedComp = comp;
            return comp;
        }));
    };
    return $3bd355ce88b7fb93$export$afa64b67e5a01c3b({
        name: "AsyncComponentWrapper",
        __asyncLoader: load,
        __asyncHydrate (el, instance, hydrate) {
            const doHydrate = hydrateStrategy ? ()=>{
                const teardown = hydrateStrategy(hydrate, (cb)=>$3bd355ce88b7fb93$var$forEachElement(el, cb));
                if (teardown) (instance.bum || (instance.bum = [])).push(teardown);
            } : hydrate;
            if (resolvedComp) doHydrate();
            else load().then(()=>!instance.isUnmounted && doHydrate());
        },
        get __asyncResolved () {
            return resolvedComp;
        },
        setup () {
            const instance = $3bd355ce88b7fb93$var$currentInstance;
            $3bd355ce88b7fb93$var$markAsyncBoundary(instance);
            if (resolvedComp) return ()=>$3bd355ce88b7fb93$var$createInnerComp(resolvedComp, instance);
            const onError = (err)=>{
                pendingRequest = null;
                $3bd355ce88b7fb93$export$d3da1ecaf1206c58(err, instance, 13, !errorComponent);
            };
            if (suspensible && instance.suspense || $3bd355ce88b7fb93$var$isInSSRComponentSetup) return load().then((comp)=>{
                return ()=>$3bd355ce88b7fb93$var$createInnerComp(comp, instance);
            }).catch((err)=>{
                onError(err);
                return ()=>errorComponent ? $3bd355ce88b7fb93$export$bf5c4cf060303d58(errorComponent, {
                        error: err
                    }) : null;
            });
            const loaded = (0, $2eFsq.ref)(false);
            const error = (0, $2eFsq.ref)();
            const delayed = (0, $2eFsq.ref)(!!delay);
            if (delay) setTimeout(()=>{
                delayed.value = false;
            }, delay);
            if (timeout != null) setTimeout(()=>{
                if (!loaded.value && !error.value) {
                    const err = new Error(`Async component timed out after ${timeout}ms.`);
                    onError(err);
                    error.value = err;
                }
            }, timeout);
            load().then(()=>{
                loaded.value = true;
                if (instance.parent && $3bd355ce88b7fb93$var$isKeepAlive(instance.parent.vnode)) instance.parent.update();
            }).catch((err)=>{
                onError(err);
                error.value = err;
            });
            return ()=>{
                if (loaded.value && resolvedComp) return $3bd355ce88b7fb93$var$createInnerComp(resolvedComp, instance);
                else if (error.value && errorComponent) return $3bd355ce88b7fb93$export$bf5c4cf060303d58(errorComponent, {
                    error: error.value
                });
                else if (loadingComponent && !delayed.value) return $3bd355ce88b7fb93$export$bf5c4cf060303d58(loadingComponent);
            };
        }
    });
}
function $3bd355ce88b7fb93$var$createInnerComp(comp, parent) {
    const { ref: ref2, props: props, children: children, ce: ce } = parent.vnode;
    const vnode = $3bd355ce88b7fb93$export$bf5c4cf060303d58(comp, props, children);
    vnode.ref = ref2;
    vnode.ce = ce;
    delete parent.vnode.ce;
    return vnode;
}
const $3bd355ce88b7fb93$var$isKeepAlive = (vnode)=>vnode.type.__isKeepAlive;
const $3bd355ce88b7fb93$var$KeepAliveImpl = {
    name: `KeepAlive`,
    // Marker for special handling inside the renderer. We are not using a ===
    // check directly on KeepAlive in the renderer, because importing it directly
    // would prevent it from being tree-shaken.
    __isKeepAlive: true,
    props: {
        include: [
            String,
            RegExp,
            Array
        ],
        exclude: [
            String,
            RegExp,
            Array
        ],
        max: [
            String,
            Number
        ]
    },
    setup (props, { slots: slots }) {
        const instance = $3bd355ce88b7fb93$export$f13e630aa3915748();
        const sharedContext = instance.ctx;
        if (!sharedContext.renderer) return ()=>{
            const children = slots.default && slots.default();
            return children && children.length === 1 ? children[0] : children;
        };
        const cache = /* @__PURE__ */ new Map();
        const keys = /* @__PURE__ */ new Set();
        let current = null;
        if (__VUE_PROD_DEVTOOLS__) instance.__v_cache = cache;
        const parentSuspense = instance.suspense;
        const { renderer: { p: patch, m: move, um: _unmount, o: { createElement: createElement } } } = sharedContext;
        const storageContainer = createElement("div");
        sharedContext.activate = (vnode, container, anchor, namespace, optimized)=>{
            const instance2 = vnode.component;
            move(vnode, container, anchor, 0, parentSuspense);
            patch(instance2.vnode, vnode, container, anchor, instance2, parentSuspense, namespace, vnode.slotScopeIds, optimized);
            $3bd355ce88b7fb93$var$queuePostRenderEffect(()=>{
                instance2.isDeactivated = false;
                if (instance2.a) (0, $Cr6yt.invokeArrayFns)(instance2.a);
                const vnodeHook = vnode.props && vnode.props.onVnodeMounted;
                if (vnodeHook) $3bd355ce88b7fb93$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $3bd355ce88b7fb93$var$devtoolsComponentAdded(instance2);
        };
        sharedContext.deactivate = (vnode)=>{
            const instance2 = vnode.component;
            $3bd355ce88b7fb93$var$invalidateMount(instance2.m);
            $3bd355ce88b7fb93$var$invalidateMount(instance2.a);
            move(vnode, storageContainer, null, 1, parentSuspense);
            $3bd355ce88b7fb93$var$queuePostRenderEffect(()=>{
                if (instance2.da) (0, $Cr6yt.invokeArrayFns)(instance2.da);
                const vnodeHook = vnode.props && vnode.props.onVnodeUnmounted;
                if (vnodeHook) $3bd355ce88b7fb93$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
                instance2.isDeactivated = true;
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $3bd355ce88b7fb93$var$devtoolsComponentAdded(instance2);
        };
        function unmount(vnode) {
            $3bd355ce88b7fb93$var$resetShapeFlag(vnode);
            _unmount(vnode, instance, parentSuspense, true);
        }
        function pruneCache(filter) {
            cache.forEach((vnode, key)=>{
                const name = $3bd355ce88b7fb93$var$getComponentName(vnode.type);
                if (name && !filter(name)) pruneCacheEntry(key);
            });
        }
        function pruneCacheEntry(key) {
            const cached = cache.get(key);
            if (cached && (!current || !$3bd355ce88b7fb93$var$isSameVNodeType(cached, current))) unmount(cached);
            else if (current) $3bd355ce88b7fb93$var$resetShapeFlag(current);
            cache.delete(key);
            keys.delete(key);
        }
        $3bd355ce88b7fb93$export$3db5d71bdb2d5499(()=>[
                props.include,
                props.exclude
            ], ([include, exclude])=>{
            include && pruneCache((name)=>$3bd355ce88b7fb93$var$matches(include, name));
            exclude && pruneCache((name)=>!$3bd355ce88b7fb93$var$matches(exclude, name));
        }, // prune post-render after `current` has been updated
        {
            flush: "post",
            deep: true
        });
        let pendingCacheKey = null;
        const cacheSubtree = ()=>{
            if (pendingCacheKey != null) {
                if ($3bd355ce88b7fb93$var$isSuspense(instance.subTree.type)) $3bd355ce88b7fb93$var$queuePostRenderEffect(()=>{
                    cache.set(pendingCacheKey, $3bd355ce88b7fb93$var$getInnerChild(instance.subTree));
                }, instance.subTree.suspense);
                else cache.set(pendingCacheKey, $3bd355ce88b7fb93$var$getInnerChild(instance.subTree));
            }
        };
        $3bd355ce88b7fb93$export$6d1641039221b5cb(cacheSubtree);
        $3bd355ce88b7fb93$export$5876c47052fb88b1(cacheSubtree);
        $3bd355ce88b7fb93$export$40c420df62d2614(()=>{
            cache.forEach((cached)=>{
                const { subTree: subTree, suspense: suspense } = instance;
                const vnode = $3bd355ce88b7fb93$var$getInnerChild(subTree);
                if (cached.type === vnode.type && cached.key === vnode.key) {
                    $3bd355ce88b7fb93$var$resetShapeFlag(vnode);
                    const da = vnode.component.da;
                    da && $3bd355ce88b7fb93$var$queuePostRenderEffect(da, suspense);
                    return;
                }
                unmount(cached);
            });
        });
        return ()=>{
            pendingCacheKey = null;
            if (!slots.default) return current = null;
            const children = slots.default();
            const rawVNode = children[0];
            if (children.length > 1) {
                current = null;
                return children;
            } else if (!$3bd355ce88b7fb93$export$3868d13f8734ae81(rawVNode) || !(rawVNode.shapeFlag & 4) && !(rawVNode.shapeFlag & 128)) {
                current = null;
                return rawVNode;
            }
            let vnode = $3bd355ce88b7fb93$var$getInnerChild(rawVNode);
            if (vnode.type === $3bd355ce88b7fb93$export$4d299b491347818a) {
                current = null;
                return vnode;
            }
            const comp = vnode.type;
            const name = $3bd355ce88b7fb93$var$getComponentName($3bd355ce88b7fb93$var$isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : comp);
            const { include: include, exclude: exclude, max: max } = props;
            if (include && (!name || !$3bd355ce88b7fb93$var$matches(include, name)) || exclude && name && $3bd355ce88b7fb93$var$matches(exclude, name)) {
                vnode.shapeFlag &= -257;
                current = vnode;
                return rawVNode;
            }
            const key = vnode.key == null ? comp : vnode.key;
            const cachedVNode = cache.get(key);
            if (vnode.el) {
                vnode = $3bd355ce88b7fb93$export$ee4f9e12c0a92a1a(vnode);
                if (rawVNode.shapeFlag & 128) rawVNode.ssContent = vnode;
            }
            pendingCacheKey = key;
            if (cachedVNode) {
                vnode.el = cachedVNode.el;
                vnode.component = cachedVNode.component;
                if (vnode.transition) $3bd355ce88b7fb93$export$7770a22486565649(vnode, vnode.transition);
                vnode.shapeFlag |= 512;
                keys.delete(key);
                keys.add(key);
            } else {
                keys.add(key);
                if (max && keys.size > parseInt(max, 10)) pruneCacheEntry(keys.values().next().value);
            }
            vnode.shapeFlag |= 256;
            current = vnode;
            return $3bd355ce88b7fb93$var$isSuspense(rawVNode.type) ? rawVNode : vnode;
        };
    }
};
const $3bd355ce88b7fb93$export$70eb8a58709972df = $3bd355ce88b7fb93$var$KeepAliveImpl;
function $3bd355ce88b7fb93$var$matches(pattern, name) {
    if ((0, $Cr6yt.isArray)(pattern)) return pattern.some((p)=>$3bd355ce88b7fb93$var$matches(p, name));
    else if ((0, $Cr6yt.isString)(pattern)) return pattern.split(",").includes(name);
    else if ((0, $Cr6yt.isRegExp)(pattern)) {
        pattern.lastIndex = 0;
        return pattern.test(name);
    }
    return false;
}
function $3bd355ce88b7fb93$export$ba52d824b95a2154(hook, target) {
    $3bd355ce88b7fb93$var$registerKeepAliveHook(hook, "a", target);
}
function $3bd355ce88b7fb93$export$bf1440eeaf5fa709(hook, target) {
    $3bd355ce88b7fb93$var$registerKeepAliveHook(hook, "da", target);
}
function $3bd355ce88b7fb93$var$registerKeepAliveHook(hook, type, target = $3bd355ce88b7fb93$var$currentInstance) {
    const wrappedHook = hook.__wdc || (hook.__wdc = ()=>{
        let current = target;
        while(current){
            if (current.isDeactivated) return;
            current = current.parent;
        }
        return hook();
    });
    $3bd355ce88b7fb93$var$injectHook(type, wrappedHook, target);
    if (target) {
        let current = target.parent;
        while(current && current.parent){
            if ($3bd355ce88b7fb93$var$isKeepAlive(current.parent.vnode)) $3bd355ce88b7fb93$var$injectToKeepAliveRoot(wrappedHook, type, target, current);
            current = current.parent;
        }
    }
}
function $3bd355ce88b7fb93$var$injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
    const injected = $3bd355ce88b7fb93$var$injectHook(type, hook, keepAliveRoot, true);
    $3bd355ce88b7fb93$export$13348a43ccacfe58(()=>{
        (0, $Cr6yt.remove)(keepAliveRoot[type], injected);
    }, target);
}
function $3bd355ce88b7fb93$var$resetShapeFlag(vnode) {
    vnode.shapeFlag &= -257;
    vnode.shapeFlag &= -513;
}
function $3bd355ce88b7fb93$var$getInnerChild(vnode) {
    return vnode.shapeFlag & 128 ? vnode.ssContent : vnode;
}
function $3bd355ce88b7fb93$var$injectHook(type, hook, target = $3bd355ce88b7fb93$var$currentInstance, prepend = false) {
    if (target) {
        const hooks = target[type] || (target[type] = []);
        const wrappedHook = hook.__weh || (hook.__weh = (...args)=>{
            (0, $2eFsq.pauseTracking)();
            const reset = $3bd355ce88b7fb93$var$setCurrentInstance(target);
            const res = $3bd355ce88b7fb93$export$dae85862a8d94378(hook, target, type, args);
            reset();
            (0, $2eFsq.resetTracking)();
            return res;
        });
        if (prepend) hooks.unshift(wrappedHook);
        else hooks.push(wrappedHook);
        return wrappedHook;
    }
}
const $3bd355ce88b7fb93$var$createHook = (lifecycle)=>(hook, target = $3bd355ce88b7fb93$var$currentInstance)=>{
        if (!$3bd355ce88b7fb93$var$isInSSRComponentSetup || lifecycle === "sp") $3bd355ce88b7fb93$var$injectHook(lifecycle, (...args)=>hook(...args), target);
    };
const $3bd355ce88b7fb93$export$23b7aeb0d671f804 = $3bd355ce88b7fb93$var$createHook("bm");
const $3bd355ce88b7fb93$export$6d1641039221b5cb = $3bd355ce88b7fb93$var$createHook("m");
const $3bd355ce88b7fb93$export$ab91988a13872e4c = $3bd355ce88b7fb93$var$createHook("bu");
const $3bd355ce88b7fb93$export$5876c47052fb88b1 = $3bd355ce88b7fb93$var$createHook("u");
const $3bd355ce88b7fb93$export$40c420df62d2614 = $3bd355ce88b7fb93$var$createHook("bum");
const $3bd355ce88b7fb93$export$13348a43ccacfe58 = $3bd355ce88b7fb93$var$createHook("um");
const $3bd355ce88b7fb93$export$ebf0c601f267bceb = $3bd355ce88b7fb93$var$createHook("sp");
const $3bd355ce88b7fb93$export$898295a813d662eb = $3bd355ce88b7fb93$var$createHook("rtg");
const $3bd355ce88b7fb93$export$2b41f4235363e921 = $3bd355ce88b7fb93$var$createHook("rtc");
function $3bd355ce88b7fb93$export$6a3a15856e50ad19(hook, target = $3bd355ce88b7fb93$var$currentInstance) {
    $3bd355ce88b7fb93$var$injectHook("ec", hook, target);
}
const $3bd355ce88b7fb93$var$COMPONENTS = "components";
const $3bd355ce88b7fb93$var$DIRECTIVES = "directives";
function $3bd355ce88b7fb93$export$681d65eec9d1d1e8(name, maybeSelfReference) {
    return $3bd355ce88b7fb93$var$resolveAsset($3bd355ce88b7fb93$var$COMPONENTS, name, true, maybeSelfReference) || name;
}
const $3bd355ce88b7fb93$var$NULL_DYNAMIC_COMPONENT = Symbol.for("v-ndc");
function $3bd355ce88b7fb93$export$b44c564a05ca975(component) {
    if ((0, $Cr6yt.isString)(component)) return $3bd355ce88b7fb93$var$resolveAsset($3bd355ce88b7fb93$var$COMPONENTS, component, false) || component;
    else return component || $3bd355ce88b7fb93$var$NULL_DYNAMIC_COMPONENT;
}
function $3bd355ce88b7fb93$export$a1989e995cd481be(name) {
    return $3bd355ce88b7fb93$var$resolveAsset($3bd355ce88b7fb93$var$DIRECTIVES, name);
}
function $3bd355ce88b7fb93$var$resolveAsset(type, name, warnMissing = true, maybeSelfReference = false) {
    const instance = $3bd355ce88b7fb93$var$currentRenderingInstance || $3bd355ce88b7fb93$var$currentInstance;
    if (instance) {
        const Component = instance.type;
        if (type === $3bd355ce88b7fb93$var$COMPONENTS) {
            const selfName = $3bd355ce88b7fb93$var$getComponentName(Component, false);
            if (selfName && (selfName === name || selfName === (0, $Cr6yt.camelize)(name) || selfName === (0, $Cr6yt.capitalize)((0, $Cr6yt.camelize)(name)))) return Component;
        }
        const res = // local registration
        // check instance[type] first which is resolved for options API
        $3bd355ce88b7fb93$var$resolve(instance[type] || Component[type], name) || // global registration
        $3bd355ce88b7fb93$var$resolve(instance.appContext[type], name);
        if (!res && maybeSelfReference) return Component;
        return res;
    }
}
function $3bd355ce88b7fb93$var$resolve(registry, name) {
    return registry && (registry[name] || registry[(0, $Cr6yt.camelize)(name)] || registry[(0, $Cr6yt.capitalize)((0, $Cr6yt.camelize)(name))]);
}
function $3bd355ce88b7fb93$export$4bf387f59bfc6d67(source, renderItem, cache, index) {
    let ret;
    const cached = cache && cache[index];
    const sourceIsArray = (0, $Cr6yt.isArray)(source);
    if (sourceIsArray || (0, $Cr6yt.isString)(source)) {
        const sourceIsReactiveArray = sourceIsArray && (0, $2eFsq.isReactive)(source);
        let needsWrap = false;
        let isReadonlySource = false;
        if (sourceIsReactiveArray) {
            needsWrap = !(0, $2eFsq.isShallow)(source);
            isReadonlySource = (0, $2eFsq.isReadonly)(source);
            source = (0, $2eFsq.shallowReadArray)(source);
        }
        ret = new Array(source.length);
        for(let i = 0, l = source.length; i < l; i++)ret[i] = renderItem(needsWrap ? isReadonlySource ? (0, $2eFsq.toReadonly)((0, $2eFsq.toReactive)(source[i])) : (0, $2eFsq.toReactive)(source[i]) : source[i], i, void 0, cached && cached[i]);
    } else if (typeof source === "number") {
        ret = new Array(source);
        for(let i = 0; i < source; i++)ret[i] = renderItem(i + 1, i, void 0, cached && cached[i]);
    } else if ((0, $Cr6yt.isObject)(source)) {
        if (source[Symbol.iterator]) ret = Array.from(source, (item, i)=>renderItem(item, i, void 0, cached && cached[i]));
        else {
            const keys = Object.keys(source);
            ret = new Array(keys.length);
            for(let i = 0, l = keys.length; i < l; i++){
                const key = keys[i];
                ret[i] = renderItem(source[key], key, i, cached && cached[i]);
            }
        }
    } else ret = [];
    if (cache) cache[index] = ret;
    return ret;
}
function $3bd355ce88b7fb93$export$85738f8fcd0a5430(slots, dynamicSlots) {
    for(let i = 0; i < dynamicSlots.length; i++){
        const slot = dynamicSlots[i];
        if ((0, $Cr6yt.isArray)(slot)) for(let j = 0; j < slot.length; j++)slots[slot[j].name] = slot[j].fn;
        else if (slot) slots[slot.name] = slot.key ? (...args)=>{
            const res = slot.fn(...args);
            if (res) res.key = slot.key;
            return res;
        } : slot.fn;
    }
    return slots;
}
function $3bd355ce88b7fb93$export$4abee4c34694ada1(slots, name, props = {}, fallback, noSlotted) {
    if ($3bd355ce88b7fb93$var$currentRenderingInstance.ce || $3bd355ce88b7fb93$var$currentRenderingInstance.parent && $3bd355ce88b7fb93$var$isAsyncWrapper($3bd355ce88b7fb93$var$currentRenderingInstance.parent) && $3bd355ce88b7fb93$var$currentRenderingInstance.parent.ce) {
        if (name !== "default") props.name = name;
        return $3bd355ce88b7fb93$export$e7eaa45e502fe5cc(), $3bd355ce88b7fb93$export$9f2dfe8048dfb22b($3bd355ce88b7fb93$export$ffb0004e005737fa, null, [
            $3bd355ce88b7fb93$export$bf5c4cf060303d58("slot", props, fallback && fallback())
        ], 64);
    }
    let slot = slots[name];
    if (slot && slot._c) slot._d = false;
    $3bd355ce88b7fb93$export$e7eaa45e502fe5cc();
    const validSlotContent = slot && $3bd355ce88b7fb93$var$ensureValidVNode(slot(props));
    const slotKey = props.key || // slot content array of a dynamic conditional slot may have a branch
    // key attached in the `createSlots` helper, respect that
    validSlotContent && validSlotContent.key;
    const rendered = $3bd355ce88b7fb93$export$9f2dfe8048dfb22b($3bd355ce88b7fb93$export$ffb0004e005737fa, {
        key: (slotKey && !(0, $Cr6yt.isSymbol)(slotKey) ? slotKey : `_${name}`) + // #7256 force differentiate fallback content from actual content
        (!validSlotContent && fallback ? "_fb" : "")
    }, validSlotContent || (fallback ? fallback() : []), validSlotContent && slots._ === 1 ? 64 : -2);
    if (!noSlotted && rendered.scopeId) rendered.slotScopeIds = [
        rendered.scopeId + "-s"
    ];
    if (slot && slot._c) slot._d = true;
    return rendered;
}
function $3bd355ce88b7fb93$var$ensureValidVNode(vnodes) {
    return vnodes.some((child)=>{
        if (!$3bd355ce88b7fb93$export$3868d13f8734ae81(child)) return true;
        if (child.type === $3bd355ce88b7fb93$export$4d299b491347818a) return false;
        if (child.type === $3bd355ce88b7fb93$export$ffb0004e005737fa && !$3bd355ce88b7fb93$var$ensureValidVNode(child.children)) return false;
        return true;
    }) ? vnodes : null;
}
function $3bd355ce88b7fb93$export$2fb94ff667a6a1a(obj, preserveCaseIfNecessary) {
    const ret = {};
    for(const key in obj)ret[preserveCaseIfNecessary && /[A-Z]/.test(key) ? `on:${key}` : (0, $Cr6yt.toHandlerKey)(key)] = obj[key];
    return ret;
}
const $3bd355ce88b7fb93$var$getPublicInstance = (i)=>{
    if (!i) return null;
    if ($3bd355ce88b7fb93$var$isStatefulComponent(i)) return $3bd355ce88b7fb93$var$getComponentPublicInstance(i);
    return $3bd355ce88b7fb93$var$getPublicInstance(i.parent);
};
const $3bd355ce88b7fb93$var$publicPropertiesMap = // Move PURE marker to new line to workaround compiler discarding it
// due to type annotation
/* @__PURE__ */ (0, $Cr6yt.extend)(/* @__PURE__ */ Object.create(null), {
    $: (i)=>i,
    $el: (i)=>i.vnode.el,
    $data: (i)=>i.data,
    $props: (i)=>(0, i.props),
    $attrs: (i)=>(0, i.attrs),
    $slots: (i)=>(0, i.slots),
    $refs: (i)=>(0, i.refs),
    $parent: (i)=>$3bd355ce88b7fb93$var$getPublicInstance(i.parent),
    $root: (i)=>$3bd355ce88b7fb93$var$getPublicInstance(i.root),
    $host: (i)=>i.ce,
    $emit: (i)=>i.emit,
    $options: (i)=>__VUE_OPTIONS_API__ ? $3bd355ce88b7fb93$var$resolveMergedOptions(i) : i.type,
    $forceUpdate: (i)=>i.f || (i.f = ()=>{
            $3bd355ce88b7fb93$var$queueJob(i.update);
        }),
    $nextTick: (i)=>i.n || (i.n = $3bd355ce88b7fb93$export$bdd553fddd433dcb.bind(i.proxy)),
    $watch: (i)=>__VUE_OPTIONS_API__ ? $3bd355ce88b7fb93$var$instanceWatch.bind(i) : (0, $Cr6yt.NOOP)
});
const $3bd355ce88b7fb93$var$isReservedPrefix = (key)=>key === "_" || key === "$";
const $3bd355ce88b7fb93$var$hasSetupBinding = (state, key)=>state !== (0, $Cr6yt.EMPTY_OBJ) && !state.__isScriptSetup && (0, $Cr6yt.hasOwn)(state, key);
const $3bd355ce88b7fb93$var$PublicInstanceProxyHandlers = {
    get ({ _: instance }, key) {
        if (key === "__v_skip") return true;
        const { ctx: ctx, setupState: setupState, data: data, props: props, accessCache: accessCache, type: type, appContext: appContext } = instance;
        let normalizedProps;
        if (key[0] !== "$") {
            const n = accessCache[key];
            if (n !== void 0) switch(n){
                case 1 /* SETUP */ :
                    return setupState[key];
                case 2 /* DATA */ :
                    return data[key];
                case 4 /* CONTEXT */ :
                    return ctx[key];
                case 3 /* PROPS */ :
                    return props[key];
            }
            else if ($3bd355ce88b7fb93$var$hasSetupBinding(setupState, key)) {
                accessCache[key] = 1 /* SETUP */ ;
                return setupState[key];
            } else if (data !== (0, $Cr6yt.EMPTY_OBJ) && (0, $Cr6yt.hasOwn)(data, key)) {
                accessCache[key] = 2 /* DATA */ ;
                return data[key];
            } else if (// only cache other properties when instance has declared (thus stable)
            // props
            (normalizedProps = instance.propsOptions[0]) && (0, $Cr6yt.hasOwn)(normalizedProps, key)) {
                accessCache[key] = 3 /* PROPS */ ;
                return props[key];
            } else if (ctx !== (0, $Cr6yt.EMPTY_OBJ) && (0, $Cr6yt.hasOwn)(ctx, key)) {
                accessCache[key] = 4 /* CONTEXT */ ;
                return ctx[key];
            } else if (!__VUE_OPTIONS_API__ || $3bd355ce88b7fb93$var$shouldCacheAccess) accessCache[key] = 0 /* OTHER */ ;
        }
        const publicGetter = $3bd355ce88b7fb93$var$publicPropertiesMap[key];
        let cssModule, globalProperties;
        if (publicGetter) {
            if (key === "$attrs") (0, $2eFsq.track)(instance.attrs, "get", "");
            return publicGetter(instance);
        } else if (// css module (injected by vue-loader)
        (cssModule = type.__cssModules) && (cssModule = cssModule[key])) return cssModule;
        else if (ctx !== (0, $Cr6yt.EMPTY_OBJ) && (0, $Cr6yt.hasOwn)(ctx, key)) {
            accessCache[key] = 4 /* CONTEXT */ ;
            return ctx[key];
        } else if (// global properties
        globalProperties = appContext.config.globalProperties, (0, $Cr6yt.hasOwn)(globalProperties, key)) return globalProperties[key];
    },
    set ({ _: instance }, key, value) {
        const { data: data, setupState: setupState, ctx: ctx } = instance;
        if ($3bd355ce88b7fb93$var$hasSetupBinding(setupState, key)) {
            setupState[key] = value;
            return true;
        } else {
            if (data !== (0, $Cr6yt.EMPTY_OBJ) && (0, $Cr6yt.hasOwn)(data, key)) {
                data[key] = value;
                return true;
            } else if ((0, $Cr6yt.hasOwn)(instance.props, key)) return false;
        }
        if (key[0] === "$" && key.slice(1) in instance) return false;
        else ctx[key] = value;
        return true;
    },
    has ({ _: { data: data, setupState: setupState, accessCache: accessCache, ctx: ctx, appContext: appContext, propsOptions: propsOptions } }, key) {
        let normalizedProps;
        return !!accessCache[key] || data !== (0, $Cr6yt.EMPTY_OBJ) && (0, $Cr6yt.hasOwn)(data, key) || $3bd355ce88b7fb93$var$hasSetupBinding(setupState, key) || (normalizedProps = propsOptions[0]) && (0, $Cr6yt.hasOwn)(normalizedProps, key) || (0, $Cr6yt.hasOwn)(ctx, key) || (0, $Cr6yt.hasOwn)($3bd355ce88b7fb93$var$publicPropertiesMap, key) || (0, $Cr6yt.hasOwn)(appContext.config.globalProperties, key);
    },
    defineProperty (target, key, descriptor) {
        if (descriptor.get != null) target._.accessCache[key] = 0;
        else if ((0, $Cr6yt.hasOwn)(descriptor, "value")) this.set(target, key, descriptor.value, null);
        return Reflect.defineProperty(target, key, descriptor);
    }
};
var $3bd355ce88b7fb93$var$target;
const $3bd355ce88b7fb93$var$RuntimeCompiledPublicInstanceProxyHandlers = /* @__PURE__ */ (0, $Cr6yt.extend)({}, $3bd355ce88b7fb93$var$PublicInstanceProxyHandlers, {
    get (target, key) {
        if (key === Symbol.unscopables) return;
        return $3bd355ce88b7fb93$var$PublicInstanceProxyHandlers.get(target, key, target);
    },
    has (_, key) {
        const has = key[0] !== "_" && !(0, $Cr6yt.isGloballyAllowed)(key);
        return has;
    }
});
function $3bd355ce88b7fb93$var$createDevRenderContext(instance) {
    const target = {};
    Object.defineProperty(target, `_`, {
        configurable: true,
        enumerable: false,
        get: ()=>instance
    });
    Object.keys($3bd355ce88b7fb93$var$publicPropertiesMap).forEach((key)=>{
        Object.defineProperty(target, key, {
            configurable: true,
            enumerable: false,
            get: ()=>$3bd355ce88b7fb93$var$publicPropertiesMap[key](instance),
            // intercepted by the proxy so no need for implementation,
            // but needed to prevent set errors
            set: (0, $Cr6yt.NOOP)
        });
    });
    return target;
}
function $3bd355ce88b7fb93$var$exposePropsOnRenderContext(instance) {
    const { ctx: ctx, propsOptions: [propsOptions] } = instance;
    if (propsOptions) Object.keys(propsOptions).forEach((key)=>{
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>instance.props[key],
            set: (0, $Cr6yt.NOOP)
        });
    });
}
function $3bd355ce88b7fb93$var$exposeSetupStateOnRenderContext(instance) {
    const { ctx: ctx, setupState: setupState } = instance;
    Object.keys((0, $2eFsq.toRaw)(setupState)).forEach((key)=>{
        if (!setupState.__isScriptSetup) {
            if ($3bd355ce88b7fb93$var$isReservedPrefix(key[0])) {
                $3bd355ce88b7fb93$var$warn$1(`setup() return property ${JSON.stringify(key)} should not start with "$" or "_" which are reserved prefixes for Vue internals.`);
                return;
            }
            Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: ()=>setupState[key],
                set: (0, $Cr6yt.NOOP)
            });
        }
    });
}
const $3bd355ce88b7fb93$var$warnRuntimeUsage = (method)=>$3bd355ce88b7fb93$var$warn$1(`${method}() is a compiler-hint helper that is only usable inside <script setup> of a single file component. Its arguments should be compiled away and passing it at runtime has no effect.`);
function $3bd355ce88b7fb93$export$80b33eababae110e() {
    return null;
}
function $3bd355ce88b7fb93$export$51ecece22fc17ddc() {
    return null;
}
function $3bd355ce88b7fb93$export$da25b65ca24b518a(exposed) {}
function $3bd355ce88b7fb93$export$77e79129327f3d0d(options) {}
function $3bd355ce88b7fb93$export$1b3acd4bb805b712() {
    return null;
}
function $3bd355ce88b7fb93$export$acd55aa037e791bb() {}
function $3bd355ce88b7fb93$export$4df9c0969a9e0160(props, defaults) {
    return null;
}
function $3bd355ce88b7fb93$export$9203a8e84125433c() {
    return $3bd355ce88b7fb93$var$getContext().slots;
}
function $3bd355ce88b7fb93$export$75e29435042cd2ea() {
    return $3bd355ce88b7fb93$var$getContext().attrs;
}
function $3bd355ce88b7fb93$var$getContext() {
    const i = $3bd355ce88b7fb93$export$f13e630aa3915748();
    return i.setupContext || (i.setupContext = $3bd355ce88b7fb93$var$createSetupContext(i));
}
function $3bd355ce88b7fb93$var$normalizePropsOrEmits(props) {
    return (0, $Cr6yt.isArray)(props) ? props.reduce((normalized, p)=>(normalized[p] = null, normalized), {}) : props;
}
function $3bd355ce88b7fb93$export$ec60f47d4a8a2e7f(raw, defaults) {
    const props = $3bd355ce88b7fb93$var$normalizePropsOrEmits(raw);
    for(const key in defaults){
        if (key.startsWith("__skip")) continue;
        let opt = props[key];
        if (opt) {
            if ((0, $Cr6yt.isArray)(opt) || (0, $Cr6yt.isFunction)(opt)) opt = props[key] = {
                type: opt,
                default: defaults[key]
            };
            else opt.default = defaults[key];
        } else if (opt === null) opt = props[key] = {
            default: defaults[key]
        };
        if (opt && defaults[`__skip_${key}`]) opt.skipFactory = true;
    }
    return props;
}
function $3bd355ce88b7fb93$export$ad4f724f587e6828(a, b) {
    if (!a || !b) return a || b;
    if ((0, $Cr6yt.isArray)(a) && (0, $Cr6yt.isArray)(b)) return a.concat(b);
    return (0, $Cr6yt.extend)({}, $3bd355ce88b7fb93$var$normalizePropsOrEmits(a), $3bd355ce88b7fb93$var$normalizePropsOrEmits(b));
}
function $3bd355ce88b7fb93$export$7c343e855c563faa(props, excludedKeys) {
    const ret = {};
    for(const key in props)if (!excludedKeys.includes(key)) Object.defineProperty(ret, key, {
        enumerable: true,
        get: ()=>props[key]
    });
    return ret;
}
function $3bd355ce88b7fb93$export$d6d6f7369f1fb104(getAwaitable) {
    const ctx = $3bd355ce88b7fb93$export$f13e630aa3915748();
    let awaitable = getAwaitable();
    $3bd355ce88b7fb93$var$unsetCurrentInstance();
    if ((0, $Cr6yt.isPromise)(awaitable)) awaitable = awaitable.catch((e)=>{
        $3bd355ce88b7fb93$var$setCurrentInstance(ctx);
        throw e;
    });
    return [
        awaitable,
        ()=>$3bd355ce88b7fb93$var$setCurrentInstance(ctx)
    ];
}
function $3bd355ce88b7fb93$var$createDuplicateChecker() {
    const cache = /* @__PURE__ */ Object.create(null);
    return (type, key)=>{
        if (cache[key]) $3bd355ce88b7fb93$var$warn$1(`${type} property "${key}" is already defined in ${cache[key]}.`);
        else cache[key] = type;
    };
}
let $3bd355ce88b7fb93$var$shouldCacheAccess = true;
function $3bd355ce88b7fb93$var$applyOptions(instance) {
    const options = $3bd355ce88b7fb93$var$resolveMergedOptions(instance);
    const publicThis = instance.proxy;
    const ctx = instance.ctx;
    $3bd355ce88b7fb93$var$shouldCacheAccess = false;
    if (options.beforeCreate) $3bd355ce88b7fb93$var$callHook(options.beforeCreate, instance, "bc");
    const { // state
    data: dataOptions, computed: computedOptions, methods: methods, watch: watchOptions, provide: provideOptions, inject: injectOptions, created: // lifecycle
    created, beforeMount: beforeMount, mounted: mounted, beforeUpdate: beforeUpdate, updated: updated, activated: activated, deactivated: deactivated, beforeDestroy: beforeDestroy, beforeUnmount: beforeUnmount, destroyed: destroyed, unmounted: unmounted, render: render, renderTracked: renderTracked, renderTriggered: renderTriggered, errorCaptured: errorCaptured, serverPrefetch: serverPrefetch, expose: // public API
    expose, inheritAttrs: inheritAttrs, components: // assets
    components, directives: directives, filters: filters } = options;
    const checkDuplicateProperties = null;
    if (injectOptions) $3bd355ce88b7fb93$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties);
    if (methods) for(const key in methods){
        const methodHandler = methods[key];
        if ((0, $Cr6yt.isFunction)(methodHandler)) ctx[key] = methodHandler.bind(publicThis);
    }
    if (dataOptions) {
        const data = dataOptions.call(publicThis, publicThis);
        if (!(0, $Cr6yt.isObject)(data)) ;
        else instance.data = (0, $2eFsq.reactive)(data);
    }
    $3bd355ce88b7fb93$var$shouldCacheAccess = true;
    if (computedOptions) for(const key in computedOptions){
        const opt = computedOptions[key];
        const get = (0, $Cr6yt.isFunction)(opt) ? opt.bind(publicThis, publicThis) : (0, $Cr6yt.isFunction)(opt.get) ? opt.get.bind(publicThis, publicThis) : (0, $Cr6yt.NOOP);
        const set = !(0, $Cr6yt.isFunction)(opt) && (0, $Cr6yt.isFunction)(opt.set) ? opt.set.bind(publicThis) : (0, $Cr6yt.NOOP);
        const c = $3bd355ce88b7fb93$export$2983e091f1a1e8e2({
            get: get,
            set: set
        });
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>c.value,
            set: (v1)=>c.value = v1
        });
    }
    if (watchOptions) for(const key in watchOptions)$3bd355ce88b7fb93$var$createWatcher(watchOptions[key], ctx, publicThis, key);
    if (provideOptions) {
        const provides = (0, $Cr6yt.isFunction)(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
        Reflect.ownKeys(provides).forEach((key)=>{
            $3bd355ce88b7fb93$export$abe1e183e22e10ad(key, provides[key]);
        });
    }
    if (created) $3bd355ce88b7fb93$var$callHook(created, instance, "c");
    function registerLifecycleHook(register, hook) {
        if ((0, $Cr6yt.isArray)(hook)) hook.forEach((_hook)=>register(_hook.bind(publicThis)));
        else if (hook) register(hook.bind(publicThis));
    }
    registerLifecycleHook($3bd355ce88b7fb93$export$23b7aeb0d671f804, beforeMount);
    registerLifecycleHook($3bd355ce88b7fb93$export$6d1641039221b5cb, mounted);
    registerLifecycleHook($3bd355ce88b7fb93$export$ab91988a13872e4c, beforeUpdate);
    registerLifecycleHook($3bd355ce88b7fb93$export$5876c47052fb88b1, updated);
    registerLifecycleHook($3bd355ce88b7fb93$export$ba52d824b95a2154, activated);
    registerLifecycleHook($3bd355ce88b7fb93$export$bf1440eeaf5fa709, deactivated);
    registerLifecycleHook($3bd355ce88b7fb93$export$6a3a15856e50ad19, errorCaptured);
    registerLifecycleHook($3bd355ce88b7fb93$export$2b41f4235363e921, renderTracked);
    registerLifecycleHook($3bd355ce88b7fb93$export$898295a813d662eb, renderTriggered);
    registerLifecycleHook($3bd355ce88b7fb93$export$40c420df62d2614, beforeUnmount);
    registerLifecycleHook($3bd355ce88b7fb93$export$13348a43ccacfe58, unmounted);
    registerLifecycleHook($3bd355ce88b7fb93$export$ebf0c601f267bceb, serverPrefetch);
    if ((0, $Cr6yt.isArray)(expose)) {
        if (expose.length) {
            const exposed = instance.exposed || (instance.exposed = {});
            expose.forEach((key)=>{
                Object.defineProperty(exposed, key, {
                    get: ()=>publicThis[key],
                    set: (val)=>publicThis[key] = val
                });
            });
        } else if (!instance.exposed) instance.exposed = {};
    }
    if (render && instance.render === (0, $Cr6yt.NOOP)) instance.render = render;
    if (inheritAttrs != null) instance.inheritAttrs = inheritAttrs;
    if (components) instance.components = components;
    if (directives) instance.directives = directives;
    if (serverPrefetch) $3bd355ce88b7fb93$var$markAsyncBoundary(instance);
}
function $3bd355ce88b7fb93$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties = (0, $Cr6yt.NOOP)) {
    if ((0, $Cr6yt.isArray)(injectOptions)) injectOptions = $3bd355ce88b7fb93$var$normalizeInject(injectOptions);
    for(const key in injectOptions){
        const opt = injectOptions[key];
        let injected;
        if ((0, $Cr6yt.isObject)(opt)) {
            if ("default" in opt) injected = $3bd355ce88b7fb93$export$a976684a0efeb93f(opt.from || key, opt.default, true);
            else injected = $3bd355ce88b7fb93$export$a976684a0efeb93f(opt.from || key);
        } else injected = $3bd355ce88b7fb93$export$a976684a0efeb93f(opt);
        if ((0, $2eFsq.isRef)(injected)) Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>injected.value,
            set: (v1)=>injected.value = v1
        });
        else ctx[key] = injected;
    }
}
function $3bd355ce88b7fb93$var$callHook(hook, instance, type) {
    $3bd355ce88b7fb93$export$dae85862a8d94378((0, $Cr6yt.isArray)(hook) ? hook.map((h)=>h.bind(instance.proxy)) : hook.bind(instance.proxy), instance, type);
}
function $3bd355ce88b7fb93$var$createWatcher(raw, ctx, publicThis, key) {
    let getter = key.includes(".") ? $3bd355ce88b7fb93$var$createPathGetter(publicThis, key) : ()=>publicThis[key];
    if ((0, $Cr6yt.isString)(raw)) {
        const handler = ctx[raw];
        if ((0, $Cr6yt.isFunction)(handler)) $3bd355ce88b7fb93$export$3db5d71bdb2d5499(getter, handler);
    } else if ((0, $Cr6yt.isFunction)(raw)) $3bd355ce88b7fb93$export$3db5d71bdb2d5499(getter, raw.bind(publicThis));
    else if ((0, $Cr6yt.isObject)(raw)) {
        if ((0, $Cr6yt.isArray)(raw)) raw.forEach((r)=>$3bd355ce88b7fb93$var$createWatcher(r, ctx, publicThis, key));
        else {
            const handler = (0, $Cr6yt.isFunction)(raw.handler) ? raw.handler.bind(publicThis) : ctx[raw.handler];
            if ((0, $Cr6yt.isFunction)(handler)) $3bd355ce88b7fb93$export$3db5d71bdb2d5499(getter, handler, raw);
        }
    } else ;
}
function $3bd355ce88b7fb93$var$resolveMergedOptions(instance) {
    const base = instance.type;
    const { mixins: mixins, extends: extendsOptions } = base;
    const { mixins: globalMixins, optionsCache: cache, config: { optionMergeStrategies: optionMergeStrategies } } = instance.appContext;
    const cached = cache.get(base);
    let resolved;
    if (cached) resolved = cached;
    else if (!globalMixins.length && !mixins && !extendsOptions) resolved = base;
    else {
        resolved = {};
        if (globalMixins.length) globalMixins.forEach((m)=>$3bd355ce88b7fb93$var$mergeOptions(resolved, m, optionMergeStrategies, true));
        $3bd355ce88b7fb93$var$mergeOptions(resolved, base, optionMergeStrategies);
    }
    if ((0, $Cr6yt.isObject)(base)) cache.set(base, resolved);
    return resolved;
}
function $3bd355ce88b7fb93$var$mergeOptions(to, from, strats, asMixin = false) {
    const { mixins: mixins, extends: extendsOptions } = from;
    if (extendsOptions) $3bd355ce88b7fb93$var$mergeOptions(to, extendsOptions, strats, true);
    if (mixins) mixins.forEach((m)=>$3bd355ce88b7fb93$var$mergeOptions(to, m, strats, true));
    for(const key in from){
        if (asMixin && key === "expose") ;
        else {
            const strat = $3bd355ce88b7fb93$var$internalOptionMergeStrats[key] || strats && strats[key];
            to[key] = strat ? strat(to[key], from[key]) : from[key];
        }
    }
    return to;
}
const $3bd355ce88b7fb93$var$internalOptionMergeStrats = {
    data: $3bd355ce88b7fb93$var$mergeDataFn,
    props: $3bd355ce88b7fb93$var$mergeEmitsOrPropsOptions,
    emits: $3bd355ce88b7fb93$var$mergeEmitsOrPropsOptions,
    // objects
    methods: $3bd355ce88b7fb93$var$mergeObjectOptions,
    computed: $3bd355ce88b7fb93$var$mergeObjectOptions,
    // lifecycle
    beforeCreate: $3bd355ce88b7fb93$var$mergeAsArray,
    created: $3bd355ce88b7fb93$var$mergeAsArray,
    beforeMount: $3bd355ce88b7fb93$var$mergeAsArray,
    mounted: $3bd355ce88b7fb93$var$mergeAsArray,
    beforeUpdate: $3bd355ce88b7fb93$var$mergeAsArray,
    updated: $3bd355ce88b7fb93$var$mergeAsArray,
    beforeDestroy: $3bd355ce88b7fb93$var$mergeAsArray,
    beforeUnmount: $3bd355ce88b7fb93$var$mergeAsArray,
    destroyed: $3bd355ce88b7fb93$var$mergeAsArray,
    unmounted: $3bd355ce88b7fb93$var$mergeAsArray,
    activated: $3bd355ce88b7fb93$var$mergeAsArray,
    deactivated: $3bd355ce88b7fb93$var$mergeAsArray,
    errorCaptured: $3bd355ce88b7fb93$var$mergeAsArray,
    serverPrefetch: $3bd355ce88b7fb93$var$mergeAsArray,
    // assets
    components: $3bd355ce88b7fb93$var$mergeObjectOptions,
    directives: $3bd355ce88b7fb93$var$mergeObjectOptions,
    // watch
    watch: $3bd355ce88b7fb93$var$mergeWatchOptions,
    // provide / inject
    provide: $3bd355ce88b7fb93$var$mergeDataFn,
    inject: $3bd355ce88b7fb93$var$mergeInject
};
function $3bd355ce88b7fb93$var$mergeDataFn(to, from) {
    if (!from) return to;
    if (!to) return from;
    return function mergedDataFn() {
        return (0, $Cr6yt.extend)((0, $Cr6yt.isFunction)(to) ? to.call(this, this) : to, (0, $Cr6yt.isFunction)(from) ? from.call(this, this) : from);
    };
}
function $3bd355ce88b7fb93$var$mergeInject(to, from) {
    return $3bd355ce88b7fb93$var$mergeObjectOptions($3bd355ce88b7fb93$var$normalizeInject(to), $3bd355ce88b7fb93$var$normalizeInject(from));
}
function $3bd355ce88b7fb93$var$normalizeInject(raw) {
    if ((0, $Cr6yt.isArray)(raw)) {
        const res = {};
        for(let i = 0; i < raw.length; i++)res[raw[i]] = raw[i];
        return res;
    }
    return raw;
}
function $3bd355ce88b7fb93$var$mergeAsArray(to, from) {
    return to ? [
        ...new Set([].concat(to, from))
    ] : from;
}
function $3bd355ce88b7fb93$var$mergeObjectOptions(to, from) {
    return to ? (0, $Cr6yt.extend)(/* @__PURE__ */ Object.create(null), to, from) : from;
}
function $3bd355ce88b7fb93$var$mergeEmitsOrPropsOptions(to, from) {
    if (to) {
        if ((0, $Cr6yt.isArray)(to) && (0, $Cr6yt.isArray)(from)) return [
            .../* @__PURE__ */ new Set([
                ...to,
                ...from
            ])
        ];
        return (0, $Cr6yt.extend)(/* @__PURE__ */ Object.create(null), $3bd355ce88b7fb93$var$normalizePropsOrEmits(to), $3bd355ce88b7fb93$var$normalizePropsOrEmits(from != null ? from : {}));
    } else return from;
}
function $3bd355ce88b7fb93$var$mergeWatchOptions(to, from) {
    if (!to) return from;
    if (!from) return to;
    const merged = (0, $Cr6yt.extend)(/* @__PURE__ */ Object.create(null), to);
    for(const key in from)merged[key] = $3bd355ce88b7fb93$var$mergeAsArray(to[key], from[key]);
    return merged;
}
function $3bd355ce88b7fb93$var$createAppContext() {
    return {
        app: null,
        config: {
            isNativeTag: (0, $Cr6yt.NO),
            performance: false,
            globalProperties: {},
            optionMergeStrategies: {},
            errorHandler: void 0,
            warnHandler: void 0,
            compilerOptions: {}
        },
        mixins: [],
        components: {},
        directives: {},
        provides: /* @__PURE__ */ Object.create(null),
        optionsCache: /* @__PURE__ */ new WeakMap(),
        propsCache: /* @__PURE__ */ new WeakMap(),
        emitsCache: /* @__PURE__ */ new WeakMap()
    };
}
let $3bd355ce88b7fb93$var$uid$1 = 0;
function $3bd355ce88b7fb93$var$createAppAPI(render, hydrate) {
    return function createApp(rootComponent, rootProps = null) {
        if (!(0, $Cr6yt.isFunction)(rootComponent)) rootComponent = (0, $Cr6yt.extend)({}, rootComponent);
        if (rootProps != null && !(0, $Cr6yt.isObject)(rootProps)) rootProps = null;
        const context = $3bd355ce88b7fb93$var$createAppContext();
        const installedPlugins = /* @__PURE__ */ new WeakSet();
        const pluginCleanupFns = [];
        let isMounted = false;
        const app = context.app = {
            _uid: $3bd355ce88b7fb93$var$uid$1++,
            _component: rootComponent,
            _props: rootProps,
            _container: null,
            _context: context,
            _instance: null,
            version: $3bd355ce88b7fb93$export$83d89fbfd8236492,
            get config () {
                return context.config;
            },
            set config (v){},
            use (plugin, ...options) {
                if (installedPlugins.has(plugin)) ;
                else if (plugin && (0, $Cr6yt.isFunction)(plugin.install)) {
                    installedPlugins.add(plugin);
                    plugin.install(app, ...options);
                } else if ((0, $Cr6yt.isFunction)(plugin)) {
                    installedPlugins.add(plugin);
                    plugin(app, ...options);
                }
                return app;
            },
            mixin (mixin) {
                if (__VUE_OPTIONS_API__) {
                    if (!context.mixins.includes(mixin)) context.mixins.push(mixin);
                }
                return app;
            },
            component (name, component) {
                if (!component) return context.components[name];
                context.components[name] = component;
                return app;
            },
            directive (name, directive) {
                if (!directive) return context.directives[name];
                context.directives[name] = directive;
                return app;
            },
            mount (rootContainer, isHydrate, namespace) {
                if (!isMounted) {
                    const vnode = app._ceVNode || $3bd355ce88b7fb93$export$bf5c4cf060303d58(rootComponent, rootProps);
                    vnode.appContext = context;
                    if (namespace === true) namespace = "svg";
                    else if (namespace === false) namespace = void 0;
                    if (isHydrate && hydrate) hydrate(vnode, rootContainer);
                    else render(vnode, rootContainer, namespace);
                    isMounted = true;
                    app._container = rootContainer;
                    rootContainer.__vue_app__ = app;
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = vnode.component;
                        $3bd355ce88b7fb93$var$devtoolsInitApp(app, $3bd355ce88b7fb93$export$83d89fbfd8236492);
                    }
                    return $3bd355ce88b7fb93$var$getComponentPublicInstance(vnode.component);
                }
            },
            onUnmount (cleanupFn) {
                pluginCleanupFns.push(cleanupFn);
            },
            unmount () {
                if (isMounted) {
                    $3bd355ce88b7fb93$export$dae85862a8d94378(pluginCleanupFns, app._instance, 16);
                    render(null, app._container);
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = null;
                        $3bd355ce88b7fb93$var$devtoolsUnmountApp(app);
                    }
                    delete app._container.__vue_app__;
                }
            },
            provide (key, value) {
                context.provides[key] = value;
                return app;
            },
            runWithContext (fn) {
                const lastApp = $3bd355ce88b7fb93$var$currentApp;
                $3bd355ce88b7fb93$var$currentApp = app;
                try {
                    return fn();
                } finally{
                    $3bd355ce88b7fb93$var$currentApp = lastApp;
                }
            }
        };
        return app;
    };
}
let $3bd355ce88b7fb93$var$currentApp = null;
function $3bd355ce88b7fb93$export$abe1e183e22e10ad(key, value) {
    if (!$3bd355ce88b7fb93$var$currentInstance) ;
    else {
        let provides = $3bd355ce88b7fb93$var$currentInstance.provides;
        const parentProvides = $3bd355ce88b7fb93$var$currentInstance.parent && $3bd355ce88b7fb93$var$currentInstance.parent.provides;
        if (parentProvides === provides) provides = $3bd355ce88b7fb93$var$currentInstance.provides = Object.create(parentProvides);
        provides[key] = value;
    }
}
function $3bd355ce88b7fb93$export$a976684a0efeb93f(key, defaultValue, treatDefaultAsFactory = false) {
    const instance = $3bd355ce88b7fb93$var$currentInstance || $3bd355ce88b7fb93$var$currentRenderingInstance;
    if (instance || $3bd355ce88b7fb93$var$currentApp) {
        const provides = $3bd355ce88b7fb93$var$currentApp ? $3bd355ce88b7fb93$var$currentApp._context.provides : instance ? instance.parent == null ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides : void 0;
        if (provides && key in provides) return provides[key];
        else if (arguments.length > 1) return treatDefaultAsFactory && (0, $Cr6yt.isFunction)(defaultValue) ? defaultValue.call(instance && instance.proxy) : defaultValue;
    }
}
function $3bd355ce88b7fb93$export$caf6761f24fc571a() {
    return !!($3bd355ce88b7fb93$var$currentInstance || $3bd355ce88b7fb93$var$currentRenderingInstance || $3bd355ce88b7fb93$var$currentApp);
}
const $3bd355ce88b7fb93$var$internalObjectProto = {};
const $3bd355ce88b7fb93$var$createInternalObject = ()=>Object.create($3bd355ce88b7fb93$var$internalObjectProto);
const $3bd355ce88b7fb93$var$isInternalObject = (obj)=>Object.getPrototypeOf(obj) === $3bd355ce88b7fb93$var$internalObjectProto;
function $3bd355ce88b7fb93$var$initProps(instance, rawProps, isStateful, isSSR = false) {
    const props = {};
    const attrs = $3bd355ce88b7fb93$var$createInternalObject();
    instance.propsDefaults = /* @__PURE__ */ Object.create(null);
    $3bd355ce88b7fb93$var$setFullProps(instance, rawProps, props, attrs);
    for(const key in instance.propsOptions[0])if (!(key in props)) props[key] = void 0;
    if (isStateful) instance.props = isSSR ? props : (0, $2eFsq.shallowReactive)(props);
    else if (!instance.type.props) instance.props = attrs;
    else instance.props = props;
    instance.attrs = attrs;
}
function $3bd355ce88b7fb93$var$isInHmrContext(instance) {
    while(instance){
        if (instance.type.__hmrId) return true;
        instance = instance.parent;
    }
}
function $3bd355ce88b7fb93$var$updateProps(instance, rawProps, rawPrevProps, optimized) {
    const { props: props, attrs: attrs, vnode: { patchFlag: patchFlag } } = instance;
    const rawCurrentProps = (0, $2eFsq.toRaw)(props);
    const [options] = instance.propsOptions;
    let hasAttrsChanged = false;
    if (// always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (optimized || patchFlag > 0) && !(patchFlag & 16)) {
        if (patchFlag & 8) {
            const propsToUpdate = instance.vnode.dynamicProps;
            for(let i = 0; i < propsToUpdate.length; i++){
                let key = propsToUpdate[i];
                if ($3bd355ce88b7fb93$var$isEmitListener(instance.emitsOptions, key)) continue;
                const value = rawProps[key];
                if (options) {
                    if ((0, $Cr6yt.hasOwn)(attrs, key)) {
                        if (value !== attrs[key]) {
                            attrs[key] = value;
                            hasAttrsChanged = true;
                        }
                    } else {
                        const camelizedKey = (0, $Cr6yt.camelize)(key);
                        props[camelizedKey] = $3bd355ce88b7fb93$var$resolvePropValue(options, rawCurrentProps, camelizedKey, value, instance, false);
                    }
                } else if (value !== attrs[key]) {
                    attrs[key] = value;
                    hasAttrsChanged = true;
                }
            }
        }
    } else {
        if ($3bd355ce88b7fb93$var$setFullProps(instance, rawProps, props, attrs)) hasAttrsChanged = true;
        let kebabKey;
        for(const key in rawCurrentProps)if (!rawProps || // for camelCase
        !(0, $Cr6yt.hasOwn)(rawProps, key) && // it's possible the original props was passed in as kebab-case
        // and converted to camelCase (#955)
        ((kebabKey = (0, $Cr6yt.hyphenate)(key)) === key || !(0, $Cr6yt.hasOwn)(rawProps, kebabKey))) {
            if (options) {
                if (rawPrevProps && // for camelCase
                (rawPrevProps[key] !== void 0 || // for kebab-case
                rawPrevProps[kebabKey] !== void 0)) props[key] = $3bd355ce88b7fb93$var$resolvePropValue(options, rawCurrentProps, key, void 0, instance, true);
            } else delete props[key];
        }
        if (attrs !== rawCurrentProps) {
            for(const key in attrs)if (!rawProps || !(0, $Cr6yt.hasOwn)(rawProps, key) && true) {
                delete attrs[key];
                hasAttrsChanged = true;
            }
        }
    }
    if (hasAttrsChanged) (0, $2eFsq.trigger)(instance.attrs, "set", "");
}
function $3bd355ce88b7fb93$var$setFullProps(instance, rawProps, props, attrs) {
    const [options, needCastKeys] = instance.propsOptions;
    let hasAttrsChanged = false;
    let rawCastValues;
    if (rawProps) for(let key in rawProps){
        if ((0, $Cr6yt.isReservedProp)(key)) continue;
        const value = rawProps[key];
        let camelKey;
        if (options && (0, $Cr6yt.hasOwn)(options, camelKey = (0, $Cr6yt.camelize)(key))) {
            if (!needCastKeys || !needCastKeys.includes(camelKey)) props[camelKey] = value;
            else (rawCastValues || (rawCastValues = {}))[camelKey] = value;
        } else if (!$3bd355ce88b7fb93$var$isEmitListener(instance.emitsOptions, key)) {
            if (!(key in attrs) || value !== attrs[key]) {
                attrs[key] = value;
                hasAttrsChanged = true;
            }
        }
    }
    if (needCastKeys) {
        const rawCurrentProps = (0, $2eFsq.toRaw)(props);
        const castValues = rawCastValues || (0, $Cr6yt.EMPTY_OBJ);
        for(let i = 0; i < needCastKeys.length; i++){
            const key = needCastKeys[i];
            props[key] = $3bd355ce88b7fb93$var$resolvePropValue(options, rawCurrentProps, key, castValues[key], instance, !(0, $Cr6yt.hasOwn)(castValues, key));
        }
    }
    return hasAttrsChanged;
}
function $3bd355ce88b7fb93$var$resolvePropValue(options, props, key, value, instance, isAbsent) {
    const opt = options[key];
    if (opt != null) {
        const hasDefault = (0, $Cr6yt.hasOwn)(opt, "default");
        if (hasDefault && value === void 0) {
            const defaultValue = opt.default;
            if (opt.type !== Function && !opt.skipFactory && (0, $Cr6yt.isFunction)(defaultValue)) {
                const { propsDefaults: propsDefaults } = instance;
                if (key in propsDefaults) value = propsDefaults[key];
                else {
                    const reset = $3bd355ce88b7fb93$var$setCurrentInstance(instance);
                    value = propsDefaults[key] = defaultValue.call(null, props);
                    reset();
                }
            } else value = defaultValue;
            if (instance.ce) instance.ce._setProp(key, value);
        }
        if (opt[0 /* shouldCast */ ]) {
            if (isAbsent && !hasDefault) value = false;
            else if (opt[1 /* shouldCastTrue */ ] && (value === "" || value === (0, $Cr6yt.hyphenate)(key))) value = true;
        }
    }
    return value;
}
const $3bd355ce88b7fb93$var$mixinPropsCache = /* @__PURE__ */ new WeakMap();
function $3bd355ce88b7fb93$var$normalizePropsOptions(comp, appContext, asMixin = false) {
    const cache = __VUE_OPTIONS_API__ && asMixin ? $3bd355ce88b7fb93$var$mixinPropsCache : appContext.propsCache;
    const cached = cache.get(comp);
    if (cached) return cached;
    const raw = comp.props;
    const normalized = {};
    const needCastKeys = [];
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $Cr6yt.isFunction)(comp)) {
        const extendProps = (raw2)=>{
            hasExtends = true;
            const [props, keys] = $3bd355ce88b7fb93$var$normalizePropsOptions(raw2, appContext, true);
            (0, $Cr6yt.extend)(normalized, props);
            if (keys) needCastKeys.push(...keys);
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendProps);
        if (comp.extends) extendProps(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendProps);
    }
    if (!raw && !hasExtends) {
        if ((0, $Cr6yt.isObject)(comp)) cache.set(comp, (0, $Cr6yt.EMPTY_ARR));
        return 0, $Cr6yt.EMPTY_ARR;
    }
    if ((0, $Cr6yt.isArray)(raw)) for(let i = 0; i < raw.length; i++){
        const normalizedKey = (0, $Cr6yt.camelize)(raw[i]);
        if ($3bd355ce88b7fb93$var$validatePropName(normalizedKey)) normalized[normalizedKey] = (0, $Cr6yt.EMPTY_OBJ);
    }
    else if (raw) for(const key in raw){
        const normalizedKey = (0, $Cr6yt.camelize)(key);
        if ($3bd355ce88b7fb93$var$validatePropName(normalizedKey)) {
            const opt = raw[key];
            const prop = normalized[normalizedKey] = (0, $Cr6yt.isArray)(opt) || (0, $Cr6yt.isFunction)(opt) ? {
                type: opt
            } : (0, $Cr6yt.extend)({}, opt);
            const propType = prop.type;
            let shouldCast = false;
            let shouldCastTrue = true;
            if ((0, $Cr6yt.isArray)(propType)) for(let index = 0; index < propType.length; ++index){
                const type = propType[index];
                const typeName = (0, $Cr6yt.isFunction)(type) && type.name;
                if (typeName === "Boolean") {
                    shouldCast = true;
                    break;
                } else if (typeName === "String") shouldCastTrue = false;
            }
            else shouldCast = (0, $Cr6yt.isFunction)(propType) && propType.name === "Boolean";
            prop[0 /* shouldCast */ ] = shouldCast;
            prop[1 /* shouldCastTrue */ ] = shouldCastTrue;
            if (shouldCast || (0, $Cr6yt.hasOwn)(prop, "default")) needCastKeys.push(normalizedKey);
        }
    }
    const res = [
        normalized,
        needCastKeys
    ];
    if ((0, $Cr6yt.isObject)(comp)) cache.set(comp, res);
    return res;
}
function $3bd355ce88b7fb93$var$validatePropName(key) {
    if (key[0] !== "$" && !(0, $Cr6yt.isReservedProp)(key)) return true;
    return false;
}
function $3bd355ce88b7fb93$var$getType(ctor) {
    if (ctor === null) return "null";
    if (typeof ctor === "function") return ctor.name || "";
    else if (typeof ctor === "object") {
        const name = ctor.constructor && ctor.constructor.name;
        return name || "";
    }
    return "";
}
function $3bd355ce88b7fb93$var$validateProps(rawProps, props, instance) {
    const resolvedValues = (0, $2eFsq.toRaw)(props);
    const options = instance.propsOptions[0];
    const camelizePropsKey = Object.keys(rawProps).map((key)=>(0, $Cr6yt.camelize)(key));
    for(const key in options){
        let opt = options[key];
        if (opt == null) continue;
        $3bd355ce88b7fb93$var$validateProp(key, resolvedValues[key], opt, resolvedValues, !camelizePropsKey.includes(key));
    }
}
function $3bd355ce88b7fb93$var$validateProp(name, value, prop, props, isAbsent) {
    const { type: type, required: required, validator: validator, skipCheck: skipCheck } = prop;
    if (required && isAbsent) {
        $3bd355ce88b7fb93$var$warn$1('Missing required prop: "' + name + '"');
        return;
    }
    if (value == null && !required) return;
    if (type != null && type !== true && !skipCheck) {
        let isValid = false;
        const types = (0, $Cr6yt.isArray)(type) ? type : [
            type
        ];
        const expectedTypes = [];
        for(let i = 0; i < types.length && !isValid; i++){
            const { valid: valid, expectedType: expectedType } = $3bd355ce88b7fb93$var$assertType(value, types[i]);
            expectedTypes.push(expectedType || "");
            isValid = valid;
        }
        if (!isValid) {
            $3bd355ce88b7fb93$var$warn$1($3bd355ce88b7fb93$var$getInvalidTypeMessage(name, value, expectedTypes));
            return;
        }
    }
    if (validator && !validator(value, props)) $3bd355ce88b7fb93$var$warn$1('Invalid prop: custom validator check failed for prop "' + name + '".');
}
const $3bd355ce88b7fb93$var$isSimpleType = /* @__PURE__ */ (0, $Cr6yt.makeMap)("String,Number,Boolean,Function,Symbol,BigInt");
function $3bd355ce88b7fb93$var$assertType(value, type) {
    let valid;
    const expectedType = $3bd355ce88b7fb93$var$getType(type);
    if (expectedType === "null") valid = value === null;
    else if ($3bd355ce88b7fb93$var$isSimpleType(expectedType)) {
        const t = typeof value;
        valid = t === expectedType.toLowerCase();
        if (!valid && t === "object") valid = value instanceof type;
    } else if (expectedType === "Object") valid = (0, $Cr6yt.isObject)(value);
    else if (expectedType === "Array") valid = (0, $Cr6yt.isArray)(value);
    else valid = value instanceof type;
    return {
        valid: valid,
        expectedType: expectedType
    };
}
function $3bd355ce88b7fb93$var$getInvalidTypeMessage(name, value, expectedTypes) {
    if (expectedTypes.length === 0) return `Prop type [] for prop "${name}" won't match anything. Did you mean to use type Array instead?`;
    let message = `Invalid prop: type check failed for prop "${name}". Expected ${expectedTypes.map((0, $Cr6yt.capitalize)).join(" | ")}`;
    const expectedType = expectedTypes[0];
    const receivedType = (0, $Cr6yt.toRawType)(value);
    const expectedValue = $3bd355ce88b7fb93$var$styleValue(value, expectedType);
    const receivedValue = $3bd355ce88b7fb93$var$styleValue(value, receivedType);
    if (expectedTypes.length === 1 && $3bd355ce88b7fb93$var$isExplicable(expectedType) && !$3bd355ce88b7fb93$var$isBoolean(expectedType, receivedType)) message += ` with value ${expectedValue}`;
    message += `, got ${receivedType} `;
    if ($3bd355ce88b7fb93$var$isExplicable(receivedType)) message += `with value ${receivedValue}.`;
    return message;
}
function $3bd355ce88b7fb93$var$styleValue(value, type) {
    if (type === "String") return `"${value}"`;
    else if (type === "Number") return `${Number(value)}`;
    else return `${value}`;
}
function $3bd355ce88b7fb93$var$isExplicable(type) {
    const explicitTypes = [
        "string",
        "number",
        "boolean"
    ];
    return explicitTypes.some((elem)=>type.toLowerCase() === elem);
}
function $3bd355ce88b7fb93$var$isBoolean(...args) {
    return args.some((elem)=>elem.toLowerCase() === "boolean");
}
const $3bd355ce88b7fb93$var$isInternalKey = (key)=>key[0] === "_" || key === "$stable";
const $3bd355ce88b7fb93$var$normalizeSlotValue = (value)=>(0, $Cr6yt.isArray)(value) ? value.map($3bd355ce88b7fb93$var$normalizeVNode) : [
        $3bd355ce88b7fb93$var$normalizeVNode(value)
    ];
const $3bd355ce88b7fb93$var$normalizeSlot = (key, rawSlot, ctx)=>{
    if (rawSlot._n) return rawSlot;
    const normalized = $3bd355ce88b7fb93$export$694b237e827a3d23((...args)=>{
        return $3bd355ce88b7fb93$var$normalizeSlotValue(rawSlot(...args));
    }, ctx);
    normalized._c = false;
    return normalized;
};
const $3bd355ce88b7fb93$var$normalizeObjectSlots = (rawSlots, slots, instance)=>{
    const ctx = rawSlots._ctx;
    for(const key in rawSlots){
        if ($3bd355ce88b7fb93$var$isInternalKey(key)) continue;
        const value = rawSlots[key];
        if ((0, $Cr6yt.isFunction)(value)) slots[key] = $3bd355ce88b7fb93$var$normalizeSlot(key, value, ctx);
        else if (value != null) {
            const normalized = $3bd355ce88b7fb93$var$normalizeSlotValue(value);
            slots[key] = ()=>normalized;
        }
    }
};
const $3bd355ce88b7fb93$var$normalizeVNodeSlots = (instance, children)=>{
    const normalized = $3bd355ce88b7fb93$var$normalizeSlotValue(children);
    instance.slots.default = ()=>normalized;
};
const $3bd355ce88b7fb93$var$assignSlots = (slots, children, optimized)=>{
    for(const key in children)if (optimized || !$3bd355ce88b7fb93$var$isInternalKey(key)) slots[key] = children[key];
};
const $3bd355ce88b7fb93$var$initSlots = (instance, children, optimized)=>{
    const slots = instance.slots = $3bd355ce88b7fb93$var$createInternalObject();
    if (instance.vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            $3bd355ce88b7fb93$var$assignSlots(slots, children, optimized);
            if (optimized) (0, $Cr6yt.def)(slots, "_", type, true);
        } else $3bd355ce88b7fb93$var$normalizeObjectSlots(children, slots);
    } else if (children) $3bd355ce88b7fb93$var$normalizeVNodeSlots(instance, children);
};
const $3bd355ce88b7fb93$var$updateSlots = (instance, children, optimized)=>{
    const { vnode: vnode, slots: slots } = instance;
    let needDeletionCheck = true;
    let deletionComparisonTarget = (0, $Cr6yt.EMPTY_OBJ);
    if (vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            if (optimized && type === 1) needDeletionCheck = false;
            else $3bd355ce88b7fb93$var$assignSlots(slots, children, optimized);
        } else {
            needDeletionCheck = !children.$stable;
            $3bd355ce88b7fb93$var$normalizeObjectSlots(children, slots);
        }
        deletionComparisonTarget = children;
    } else if (children) {
        $3bd355ce88b7fb93$var$normalizeVNodeSlots(instance, children);
        deletionComparisonTarget = {
            default: 1
        };
    }
    if (needDeletionCheck) {
        for(const key in slots)if (!$3bd355ce88b7fb93$var$isInternalKey(key) && deletionComparisonTarget[key] == null) delete slots[key];
    }
};
let $3bd355ce88b7fb93$var$supported;
let $3bd355ce88b7fb93$var$perf;
function $3bd355ce88b7fb93$var$startMeasure(instance, type) {
    if (instance.appContext.config.performance && $3bd355ce88b7fb93$var$isSupported()) $3bd355ce88b7fb93$var$perf.mark(`vue-${type}-${instance.uid}`);
    if (__VUE_PROD_DEVTOOLS__) $3bd355ce88b7fb93$var$devtoolsPerfStart(instance, type, $3bd355ce88b7fb93$var$isSupported() ? $3bd355ce88b7fb93$var$perf.now() : Date.now());
}
function $3bd355ce88b7fb93$var$endMeasure(instance, type) {
    if (instance.appContext.config.performance && $3bd355ce88b7fb93$var$isSupported()) {
        const startTag = `vue-${type}-${instance.uid}`;
        const endTag = startTag + `:end`;
        $3bd355ce88b7fb93$var$perf.mark(endTag);
        $3bd355ce88b7fb93$var$perf.measure(`<${$3bd355ce88b7fb93$var$formatComponentName(instance, instance.type)}> ${type}`, startTag, endTag);
        $3bd355ce88b7fb93$var$perf.clearMarks(startTag);
        $3bd355ce88b7fb93$var$perf.clearMarks(endTag);
    }
    if (__VUE_PROD_DEVTOOLS__) $3bd355ce88b7fb93$var$devtoolsPerfEnd(instance, type, $3bd355ce88b7fb93$var$isSupported() ? $3bd355ce88b7fb93$var$perf.now() : Date.now());
}
function $3bd355ce88b7fb93$var$isSupported() {
    if ($3bd355ce88b7fb93$var$supported !== void 0) return $3bd355ce88b7fb93$var$supported;
    if (typeof window !== "undefined" && window.performance) {
        $3bd355ce88b7fb93$var$supported = true;
        $3bd355ce88b7fb93$var$perf = window.performance;
    } else $3bd355ce88b7fb93$var$supported = false;
    return $3bd355ce88b7fb93$var$supported;
}
function $3bd355ce88b7fb93$var$initFeatureFlags() {
    const needWarn = [];
    if (typeof __VUE_OPTIONS_API__ !== "boolean") (0, $Cr6yt.getGlobalThis)().__VUE_OPTIONS_API__ = true;
    if (typeof __VUE_PROD_DEVTOOLS__ !== "boolean") (0, $Cr6yt.getGlobalThis)().__VUE_PROD_DEVTOOLS__ = false;
    if (typeof __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ !== "boolean") (0, $Cr6yt.getGlobalThis)().__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;
}
const $3bd355ce88b7fb93$var$queuePostRenderEffect = $3bd355ce88b7fb93$var$queueEffectWithSuspense;
function $3bd355ce88b7fb93$export$53ae2f996c64e9a(options) {
    return $3bd355ce88b7fb93$var$baseCreateRenderer(options);
}
function $3bd355ce88b7fb93$export$200524cf0d997ff0(options) {
    return $3bd355ce88b7fb93$var$baseCreateRenderer(options, $3bd355ce88b7fb93$var$createHydrationFunctions);
}
function $3bd355ce88b7fb93$var$baseCreateRenderer(options, createHydrationFns) {
    $3bd355ce88b7fb93$var$initFeatureFlags();
    const target = (0, $Cr6yt.getGlobalThis)();
    target.__VUE__ = true;
    if (__VUE_PROD_DEVTOOLS__) $3bd355ce88b7fb93$var$setDevtoolsHook$1(target.__VUE_DEVTOOLS_GLOBAL_HOOK__, target);
    const { insert: hostInsert, remove: hostRemove, patchProp: hostPatchProp, createElement: hostCreateElement, createText: hostCreateText, createComment: hostCreateComment, setText: hostSetText, setElementText: hostSetElementText, parentNode: hostParentNode, nextSibling: hostNextSibling, setScopeId: hostSetScopeId = (0, $Cr6yt.NOOP), insertStaticContent: hostInsertStaticContent } = options;
    const patch = (n1, n2, container, anchor = null, parentComponent = null, parentSuspense = null, namespace, slotScopeIds = null, optimized = !!n2.dynamicChildren)=>{
        if (n1 === n2) return;
        if (n1 && !$3bd355ce88b7fb93$var$isSameVNodeType(n1, n2)) {
            anchor = getNextHostNode(n1);
            unmount(n1, parentComponent, parentSuspense, true);
            n1 = null;
        }
        if (n2.patchFlag === -2) {
            optimized = false;
            n2.dynamicChildren = null;
        }
        const { type: type, ref: ref, shapeFlag: shapeFlag } = n2;
        switch(type){
            case $3bd355ce88b7fb93$export$5f1af8db9871e1d6:
                processText(n1, n2, container, anchor);
                break;
            case $3bd355ce88b7fb93$export$4d299b491347818a:
                processCommentNode(n1, n2, container, anchor);
                break;
            case $3bd355ce88b7fb93$export$c1b9a1d3af45b7b6:
                if (n1 == null) mountStaticNode(n2, container, anchor, namespace);
                break;
            case $3bd355ce88b7fb93$export$ffb0004e005737fa:
                processFragment(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) processElement(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 6) processComponent(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 64) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
                else if (shapeFlag & 128) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
        }
        if (ref != null && parentComponent) $3bd355ce88b7fb93$var$setRef(ref, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
    };
    const processText = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateText(n2.children), container, anchor);
        else {
            const el = n2.el = n1.el;
            if (n2.children !== n1.children) hostSetText(el, n2.children);
        }
    };
    const processCommentNode = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateComment(n2.children || ""), container, anchor);
        else n2.el = n1.el;
    };
    const mountStaticNode = (n2, container, anchor, namespace)=>{
        [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace, n2.el, n2.anchor);
    };
    const patchStaticNode = (n1, n2, container, namespace)=>{
        if (n2.children !== n1.children) {
            const anchor = hostNextSibling(n1.anchor);
            removeStaticNode(n1);
            [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace);
        } else {
            n2.el = n1.el;
            n2.anchor = n1.anchor;
        }
    };
    const moveStaticNode = ({ el: el, anchor: anchor }, container, nextSibling)=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostInsert(el, container, nextSibling);
            el = next;
        }
        hostInsert(anchor, container, nextSibling);
    };
    const removeStaticNode = ({ el: el, anchor: anchor })=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostRemove(el);
            el = next;
        }
        hostRemove(anchor);
    };
    const processElement = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        if (n2.type === "svg") namespace = "svg";
        else if (n2.type === "math") namespace = "mathml";
        if (n1 == null) mountElement(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        else patchElement(n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    const mountElement = (vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let el;
        let vnodeHook;
        const { props: props, shapeFlag: shapeFlag, transition: transition, dirs: dirs } = vnode;
        el = vnode.el = hostCreateElement(vnode.type, namespace, props && props.is, props);
        if (shapeFlag & 8) hostSetElementText(el, vnode.children);
        else if (shapeFlag & 16) mountChildren(vnode.children, el, null, parentComponent, parentSuspense, $3bd355ce88b7fb93$var$resolveChildrenNamespace(vnode, namespace), slotScopeIds, optimized);
        if (dirs) $3bd355ce88b7fb93$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
        setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
        if (props) {
            for(const key in props)if (key !== "value" && !(0, $Cr6yt.isReservedProp)(key)) hostPatchProp(el, key, null, props[key], namespace, parentComponent);
            if ("value" in props) hostPatchProp(el, "value", null, props.value, namespace);
            if (vnodeHook = props.onVnodeBeforeMount) $3bd355ce88b7fb93$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        }
        if (__VUE_PROD_DEVTOOLS__) {
            (0, $Cr6yt.def)(el, "__vnode", vnode, true);
            (0, $Cr6yt.def)(el, "__vueParentComponent", parentComponent, true);
        }
        if (dirs) $3bd355ce88b7fb93$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
        const needCallTransitionHooks = $3bd355ce88b7fb93$var$needTransition(parentSuspense, transition);
        if (needCallTransitionHooks) transition.beforeEnter(el);
        hostInsert(el, container, anchor);
        if ((vnodeHook = props && props.onVnodeMounted) || needCallTransitionHooks || dirs) $3bd355ce88b7fb93$var$queuePostRenderEffect(()=>{
            vnodeHook && $3bd355ce88b7fb93$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            needCallTransitionHooks && transition.enter(el);
            dirs && $3bd355ce88b7fb93$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
        }, parentSuspense);
    };
    const setScopeId = (el, vnode, scopeId, slotScopeIds, parentComponent)=>{
        if (scopeId) hostSetScopeId(el, scopeId);
        if (slotScopeIds) for(let i = 0; i < slotScopeIds.length; i++)hostSetScopeId(el, slotScopeIds[i]);
        if (parentComponent) {
            let subTree = parentComponent.subTree;
            if (vnode === subTree || $3bd355ce88b7fb93$var$isSuspense(subTree.type) && (subTree.ssContent === vnode || subTree.ssFallback === vnode)) {
                const parentVNode = parentComponent.vnode;
                setScopeId(el, parentVNode, parentVNode.scopeId, parentVNode.slotScopeIds, parentComponent.parent);
            }
        }
    };
    const mountChildren = (children, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, start = 0)=>{
        for(let i = start; i < children.length; i++){
            const child = children[i] = optimized ? $3bd355ce88b7fb93$var$cloneIfMounted(children[i]) : $3bd355ce88b7fb93$var$normalizeVNode(children[i]);
            patch(null, child, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchElement = (n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const el = n2.el = n1.el;
        if (__VUE_PROD_DEVTOOLS__) el.__vnode = n2;
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, dirs: dirs } = n2;
        patchFlag |= n1.patchFlag & 16;
        const oldProps = n1.props || (0, $Cr6yt.EMPTY_OBJ);
        const newProps = n2.props || (0, $Cr6yt.EMPTY_OBJ);
        let vnodeHook;
        parentComponent && $3bd355ce88b7fb93$var$toggleRecurse(parentComponent, false);
        if (vnodeHook = newProps.onVnodeBeforeUpdate) $3bd355ce88b7fb93$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
        if (dirs) $3bd355ce88b7fb93$var$invokeDirectiveHook(n2, n1, parentComponent, "beforeUpdate");
        parentComponent && $3bd355ce88b7fb93$var$toggleRecurse(parentComponent, true);
        if (oldProps.innerHTML && newProps.innerHTML == null || oldProps.textContent && newProps.textContent == null) hostSetElementText(el, "");
        if (dynamicChildren) patchBlockChildren(n1.dynamicChildren, dynamicChildren, el, parentComponent, parentSuspense, $3bd355ce88b7fb93$var$resolveChildrenNamespace(n2, namespace), slotScopeIds);
        else if (!optimized) patchChildren(n1, n2, el, null, parentComponent, parentSuspense, $3bd355ce88b7fb93$var$resolveChildrenNamespace(n2, namespace), slotScopeIds, false);
        if (patchFlag > 0) {
            if (patchFlag & 16) patchProps(el, oldProps, newProps, parentComponent, namespace);
            else {
                if (patchFlag & 2) {
                    if (oldProps.class !== newProps.class) hostPatchProp(el, "class", null, newProps.class, namespace);
                }
                if (patchFlag & 4) hostPatchProp(el, "style", oldProps.style, newProps.style, namespace);
                if (patchFlag & 8) {
                    const propsToUpdate = n2.dynamicProps;
                    for(let i = 0; i < propsToUpdate.length; i++){
                        const key = propsToUpdate[i];
                        const prev = oldProps[key];
                        const next = newProps[key];
                        if (next !== prev || key === "value") hostPatchProp(el, key, prev, next, namespace, parentComponent);
                    }
                }
            }
            if (patchFlag & 1) {
                if (n1.children !== n2.children) hostSetElementText(el, n2.children);
            }
        } else if (!optimized && dynamicChildren == null) patchProps(el, oldProps, newProps, parentComponent, namespace);
        if ((vnodeHook = newProps.onVnodeUpdated) || dirs) $3bd355ce88b7fb93$var$queuePostRenderEffect(()=>{
            vnodeHook && $3bd355ce88b7fb93$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
            dirs && $3bd355ce88b7fb93$var$invokeDirectiveHook(n2, n1, parentComponent, "updated");
        }, parentSuspense);
    };
    const patchBlockChildren = (oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, namespace, slotScopeIds)=>{
        for(let i = 0; i < newChildren.length; i++){
            const oldVNode = oldChildren[i];
            const newVNode = newChildren[i];
            const container = // oldVNode may be an errored async setup() component inside Suspense
            // which will not have a mounted element
            oldVNode.el && // - In the case of a Fragment, we need to provide the actual parent
            // of the Fragment itself so it can move its children.
            (oldVNode.type === $3bd355ce88b7fb93$export$ffb0004e005737fa || // - In the case of different nodes, there is going to be a replacement
            // which also requires the correct parent container
            !$3bd355ce88b7fb93$var$isSameVNodeType(oldVNode, newVNode) || // - In the case of a component, it could contain anything.
            oldVNode.shapeFlag & 70) ? hostParentNode(oldVNode.el) : // In other cases, the parent container is not actually used so we
            // just pass the block element here to avoid a DOM parentNode call.
            fallbackContainer;
            patch(oldVNode, newVNode, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, true);
        }
    };
    const patchProps = (el, oldProps, newProps, parentComponent, namespace)=>{
        if (oldProps !== newProps) {
            if (oldProps !== (0, $Cr6yt.EMPTY_OBJ)) {
                for(const key in oldProps)if (!(0, $Cr6yt.isReservedProp)(key) && !(key in newProps)) hostPatchProp(el, key, oldProps[key], null, namespace, parentComponent);
            }
            for(const key in newProps){
                if ((0, $Cr6yt.isReservedProp)(key)) continue;
                const next = newProps[key];
                const prev = oldProps[key];
                if (next !== prev && key !== "value") hostPatchProp(el, key, prev, next, namespace, parentComponent);
            }
            if ("value" in newProps) hostPatchProp(el, "value", oldProps.value, newProps.value, namespace);
        }
    };
    const processFragment = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText("");
        const fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText("");
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, slotScopeIds: fragmentSlotScopeIds } = n2;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        if (n1 == null) {
            hostInsert(fragmentStartAnchor, container, anchor);
            hostInsert(fragmentEndAnchor, container, anchor);
            mountChildren(// #10007
            // such fragment like `<></>` will be compiled into
            // a fragment which doesn't have a children.
            // In this case fallback to an empty array
            n2.children || [], container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        } else if (patchFlag > 0 && patchFlag & 64 && dynamicChildren && // #2715 the previous fragment could've been a BAILed one as a result
        // of renderSlot() with no valid children
        n1.dynamicChildren) {
            patchBlockChildren(n1.dynamicChildren, dynamicChildren, container, parentComponent, parentSuspense, namespace, slotScopeIds);
            if (// #2080 if the stable fragment has a key, it's a <template v-for> that may
            //  get moved around. Make sure all root level vnodes inherit el.
            // #2134 or if it's a component root, it may also get moved around
            // as the component is being moved.
            n2.key != null || parentComponent && n2 === parentComponent.subTree) $3bd355ce88b7fb93$var$traverseStaticChildren(n1, n2, true);
        } else patchChildren(n1, n2, container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    const processComponent = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        n2.slotScopeIds = slotScopeIds;
        if (n1 == null) {
            if (n2.shapeFlag & 512) parentComponent.ctx.activate(n2, container, anchor, namespace, optimized);
            else mountComponent(n2, container, anchor, parentComponent, parentSuspense, namespace, optimized);
        } else updateComponent(n1, n2, optimized);
    };
    const mountComponent = (initialVNode, container, anchor, parentComponent, parentSuspense, namespace, optimized)=>{
        const instance = initialVNode.component = $3bd355ce88b7fb93$var$createComponentInstance(initialVNode, parentComponent, parentSuspense);
        if ($3bd355ce88b7fb93$var$isKeepAlive(initialVNode)) instance.ctx.renderer = internals;
        $3bd355ce88b7fb93$var$setupComponent(instance, false, optimized);
        if (instance.asyncDep) {
            parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect, optimized);
            if (!initialVNode.el) {
                const placeholder = instance.subTree = $3bd355ce88b7fb93$export$bf5c4cf060303d58($3bd355ce88b7fb93$export$4d299b491347818a);
                processCommentNode(null, placeholder, container, anchor);
            }
        } else setupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, namespace, optimized);
    };
    const updateComponent = (n1, n2, optimized)=>{
        const instance = n2.component = n1.component;
        if ($3bd355ce88b7fb93$var$shouldUpdateComponent(n1, n2, optimized)) {
            if (instance.asyncDep && !instance.asyncResolved) {
                updateComponentPreRender(instance, n2, optimized);
                return;
            } else {
                instance.next = n2;
                instance.update();
            }
        } else {
            n2.el = n1.el;
            instance.vnode = n2;
        }
    };
    const setupRenderEffect = (instance, initialVNode, container, anchor, parentSuspense, namespace, optimized)=>{
        const componentUpdateFn = ()=>{
            if (!instance.isMounted) {
                let vnodeHook;
                const { el: el, props: props } = initialVNode;
                const { bm: bm, m: m, parent: parent, root: root, type: type } = instance;
                const isAsyncWrapperVNode = $3bd355ce88b7fb93$var$isAsyncWrapper(initialVNode);
                $3bd355ce88b7fb93$var$toggleRecurse(instance, false);
                if (bm) (0, $Cr6yt.invokeArrayFns)(bm);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeBeforeMount)) $3bd355ce88b7fb93$var$invokeVNodeHook(vnodeHook, parent, initialVNode);
                $3bd355ce88b7fb93$var$toggleRecurse(instance, true);
                if (el && hydrateNode) {
                    const hydrateSubTree = ()=>{
                        instance.subTree = $3bd355ce88b7fb93$var$renderComponentRoot(instance);
                        hydrateNode(el, instance.subTree, instance, parentSuspense, null);
                    };
                    if (isAsyncWrapperVNode && type.__asyncHydrate) type.__asyncHydrate(el, instance, hydrateSubTree);
                    else hydrateSubTree();
                } else {
                    if (root.ce) root.ce._injectChildStyle(type);
                    const subTree = instance.subTree = $3bd355ce88b7fb93$var$renderComponentRoot(instance);
                    patch(null, subTree, container, anchor, instance, parentSuspense, namespace);
                    initialVNode.el = subTree.el;
                }
                if (m) $3bd355ce88b7fb93$var$queuePostRenderEffect(m, parentSuspense);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeMounted)) {
                    const scopedInitialVNode = initialVNode;
                    $3bd355ce88b7fb93$var$queuePostRenderEffect(()=>$3bd355ce88b7fb93$var$invokeVNodeHook(vnodeHook, parent, scopedInitialVNode), parentSuspense);
                }
                if (initialVNode.shapeFlag & 256 || parent && $3bd355ce88b7fb93$var$isAsyncWrapper(parent.vnode) && parent.vnode.shapeFlag & 256) instance.a && $3bd355ce88b7fb93$var$queuePostRenderEffect(instance.a, parentSuspense);
                instance.isMounted = true;
                if (__VUE_PROD_DEVTOOLS__) $3bd355ce88b7fb93$var$devtoolsComponentAdded(instance);
                initialVNode = container = anchor = null;
            } else {
                let { next: next, bu: bu, u: u, parent: parent, vnode: vnode } = instance;
                {
                    const nonHydratedAsyncRoot = $3bd355ce88b7fb93$var$locateNonHydratedAsyncRoot(instance);
                    if (nonHydratedAsyncRoot) {
                        if (next) {
                            next.el = vnode.el;
                            updateComponentPreRender(instance, next, optimized);
                        }
                        nonHydratedAsyncRoot.asyncDep.then(()=>{
                            if (!instance.isUnmounted) componentUpdateFn();
                        });
                        return;
                    }
                }
                let originNext = next;
                let vnodeHook;
                $3bd355ce88b7fb93$var$toggleRecurse(instance, false);
                if (next) {
                    next.el = vnode.el;
                    updateComponentPreRender(instance, next, optimized);
                } else next = vnode;
                if (bu) (0, $Cr6yt.invokeArrayFns)(bu);
                if (vnodeHook = next.props && next.props.onVnodeBeforeUpdate) $3bd355ce88b7fb93$var$invokeVNodeHook(vnodeHook, parent, next, vnode);
                $3bd355ce88b7fb93$var$toggleRecurse(instance, true);
                const nextTree = $3bd355ce88b7fb93$var$renderComponentRoot(instance);
                const prevTree = instance.subTree;
                instance.subTree = nextTree;
                patch(prevTree, nextTree, // parent may have changed if it's in a teleport
                hostParentNode(prevTree.el), // anchor may have changed if it's in a fragment
                getNextHostNode(prevTree), instance, parentSuspense, namespace);
                next.el = nextTree.el;
                if (originNext === null) $3bd355ce88b7fb93$var$updateHOCHostEl(instance, nextTree.el);
                if (u) $3bd355ce88b7fb93$var$queuePostRenderEffect(u, parentSuspense);
                if (vnodeHook = next.props && next.props.onVnodeUpdated) $3bd355ce88b7fb93$var$queuePostRenderEffect(()=>$3bd355ce88b7fb93$var$invokeVNodeHook(vnodeHook, parent, next, vnode), parentSuspense);
                if (__VUE_PROD_DEVTOOLS__) $3bd355ce88b7fb93$var$devtoolsComponentUpdated(instance);
            }
        };
        instance.scope.on();
        const effect = instance.effect = new (0, $2eFsq.ReactiveEffect)(componentUpdateFn);
        instance.scope.off();
        const update = instance.update = effect.run.bind(effect);
        const job = instance.job = effect.runIfDirty.bind(effect);
        job.i = instance;
        job.id = instance.uid;
        effect.scheduler = ()=>$3bd355ce88b7fb93$var$queueJob(job);
        $3bd355ce88b7fb93$var$toggleRecurse(instance, true);
        var e, e1;
        update();
    };
    const updateComponentPreRender = (instance, nextVNode, optimized)=>{
        nextVNode.component = instance;
        const prevProps = instance.vnode.props;
        instance.vnode = nextVNode;
        instance.next = null;
        $3bd355ce88b7fb93$var$updateProps(instance, nextVNode.props, prevProps, optimized);
        $3bd355ce88b7fb93$var$updateSlots(instance, nextVNode.children, optimized);
        (0, $2eFsq.pauseTracking)();
        $3bd355ce88b7fb93$var$flushPreFlushCbs(instance);
        (0, $2eFsq.resetTracking)();
    };
    const patchChildren = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized = false)=>{
        const c1 = n1 && n1.children;
        const prevShapeFlag = n1 ? n1.shapeFlag : 0;
        const c2 = n2.children;
        const { patchFlag: patchFlag, shapeFlag: shapeFlag } = n2;
        if (patchFlag > 0) {
            if (patchFlag & 128) {
                patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            } else if (patchFlag & 256) {
                patchUnkeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            }
        }
        if (shapeFlag & 8) {
            if (prevShapeFlag & 16) unmountChildren(c1, parentComponent, parentSuspense);
            if (c2 !== c1) hostSetElementText(container, c2);
        } else if (prevShapeFlag & 16) {
            if (shapeFlag & 16) patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else unmountChildren(c1, parentComponent, parentSuspense, true);
        } else {
            if (prevShapeFlag & 8) hostSetElementText(container, "");
            if (shapeFlag & 16) mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchUnkeyedChildren = (c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        c1 = c1 || (0, $Cr6yt.EMPTY_ARR);
        c2 = c2 || (0, $Cr6yt.EMPTY_ARR);
        const oldLength = c1.length;
        const newLength = c2.length;
        const commonLength = Math.min(oldLength, newLength);
        let i;
        for(i = 0; i < commonLength; i++){
            const nextChild = c2[i] = optimized ? $3bd355ce88b7fb93$var$cloneIfMounted(c2[i]) : $3bd355ce88b7fb93$var$normalizeVNode(c2[i]);
            patch(c1[i], nextChild, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
        if (oldLength > newLength) unmountChildren(c1, parentComponent, parentSuspense, true, false, commonLength);
        else mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, commonLength);
    };
    const patchKeyedChildren = (c1, c2, container, parentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let i = 0;
        const l2 = c2.length;
        let e1 = c1.length - 1;
        let e2 = l2 - 1;
        while(i <= e1 && i <= e2){
            const n1 = c1[i];
            const n2 = c2[i] = optimized ? $3bd355ce88b7fb93$var$cloneIfMounted(c2[i]) : $3bd355ce88b7fb93$var$normalizeVNode(c2[i]);
            if ($3bd355ce88b7fb93$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            i++;
        }
        while(i <= e1 && i <= e2){
            const n1 = c1[e1];
            const n2 = c2[e2] = optimized ? $3bd355ce88b7fb93$var$cloneIfMounted(c2[e2]) : $3bd355ce88b7fb93$var$normalizeVNode(c2[e2]);
            if ($3bd355ce88b7fb93$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            e1--;
            e2--;
        }
        if (i > e1) {
            if (i <= e2) {
                const nextPos = e2 + 1;
                const anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
                while(i <= e2){
                    patch(null, c2[i] = optimized ? $3bd355ce88b7fb93$var$cloneIfMounted(c2[i]) : $3bd355ce88b7fb93$var$normalizeVNode(c2[i]), container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    i++;
                }
            }
        } else if (i > e2) while(i <= e1){
            unmount(c1[i], parentComponent, parentSuspense, true);
            i++;
        }
        else {
            const s1 = i;
            const s2 = i;
            const keyToNewIndexMap = /* @__PURE__ */ new Map();
            for(i = s2; i <= e2; i++){
                const nextChild = c2[i] = optimized ? $3bd355ce88b7fb93$var$cloneIfMounted(c2[i]) : $3bd355ce88b7fb93$var$normalizeVNode(c2[i]);
                if (nextChild.key != null) keyToNewIndexMap.set(nextChild.key, i);
            }
            let j;
            let patched = 0;
            const toBePatched = e2 - s2 + 1;
            let moved = false;
            let maxNewIndexSoFar = 0;
            const newIndexToOldIndexMap = new Array(toBePatched);
            for(i = 0; i < toBePatched; i++)newIndexToOldIndexMap[i] = 0;
            for(i = s1; i <= e1; i++){
                const prevChild = c1[i];
                if (patched >= toBePatched) {
                    unmount(prevChild, parentComponent, parentSuspense, true);
                    continue;
                }
                let newIndex;
                if (prevChild.key != null) newIndex = keyToNewIndexMap.get(prevChild.key);
                else {
                    for(j = s2; j <= e2; j++)if (newIndexToOldIndexMap[j - s2] === 0 && $3bd355ce88b7fb93$var$isSameVNodeType(prevChild, c2[j])) {
                        newIndex = j;
                        break;
                    }
                }
                if (newIndex === void 0) unmount(prevChild, parentComponent, parentSuspense, true);
                else {
                    newIndexToOldIndexMap[newIndex - s2] = i + 1;
                    if (newIndex >= maxNewIndexSoFar) maxNewIndexSoFar = newIndex;
                    else moved = true;
                    patch(prevChild, c2[newIndex], container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    patched++;
                }
            }
            const increasingNewIndexSequence = moved ? $3bd355ce88b7fb93$var$getSequence(newIndexToOldIndexMap) : (0, $Cr6yt.EMPTY_ARR);
            j = increasingNewIndexSequence.length - 1;
            for(i = toBePatched - 1; i >= 0; i--){
                const nextIndex = s2 + i;
                const nextChild = c2[nextIndex];
                const anchor = nextIndex + 1 < l2 ? c2[nextIndex + 1].el : parentAnchor;
                if (newIndexToOldIndexMap[i] === 0) patch(null, nextChild, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (moved) {
                    if (j < 0 || i !== increasingNewIndexSequence[j]) move(nextChild, container, anchor, 2);
                    else j--;
                }
            }
        }
    };
    const move = (vnode, container, anchor, moveType, parentSuspense = null)=>{
        const { el: el, type: type, transition: transition, children: children, shapeFlag: shapeFlag } = vnode;
        if (shapeFlag & 6) {
            move(vnode.component.subTree, container, anchor, moveType);
            return;
        }
        if (shapeFlag & 128) {
            vnode.suspense.move(container, anchor, moveType);
            return;
        }
        if (shapeFlag & 64) {
            type.move(vnode, container, anchor, internals);
            return;
        }
        if (type === $3bd355ce88b7fb93$export$ffb0004e005737fa) {
            hostInsert(el, container, anchor);
            for(let i = 0; i < children.length; i++)move(children[i], container, anchor, moveType);
            hostInsert(vnode.anchor, container, anchor);
            return;
        }
        if (type === $3bd355ce88b7fb93$export$c1b9a1d3af45b7b6) {
            moveStaticNode(vnode, container, anchor);
            return;
        }
        const needTransition2 = moveType !== 2 && shapeFlag & 1 && transition;
        if (needTransition2) {
            if (moveType === 0) {
                transition.beforeEnter(el);
                hostInsert(el, container, anchor);
                $3bd355ce88b7fb93$var$queuePostRenderEffect(()=>transition.enter(el), parentSuspense);
            } else {
                const { leave: leave, delayLeave: delayLeave, afterLeave: afterLeave } = transition;
                const remove2 = ()=>{
                    if (vnode.ctx.isUnmounted) hostRemove(el);
                    else hostInsert(el, container, anchor);
                };
                const performLeave = ()=>{
                    leave(el, ()=>{
                        remove2();
                        afterLeave && afterLeave();
                    });
                };
                if (delayLeave) delayLeave(el, remove2, performLeave);
                else performLeave();
            }
        } else hostInsert(el, container, anchor);
    };
    const unmount = (vnode, parentComponent, parentSuspense, doRemove = false, optimized = false)=>{
        const { type: type, props: props, ref: ref, children: children, dynamicChildren: dynamicChildren, shapeFlag: shapeFlag, patchFlag: patchFlag, dirs: dirs, cacheIndex: cacheIndex } = vnode;
        if (patchFlag === -2) optimized = false;
        if (ref != null) {
            (0, $2eFsq.pauseTracking)();
            $3bd355ce88b7fb93$var$setRef(ref, null, parentSuspense, vnode, true);
            (0, $2eFsq.resetTracking)();
        }
        if (cacheIndex != null) parentComponent.renderCache[cacheIndex] = void 0;
        if (shapeFlag & 256) {
            parentComponent.ctx.deactivate(vnode);
            return;
        }
        const shouldInvokeDirs = shapeFlag & 1 && dirs;
        const shouldInvokeVnodeHook = !$3bd355ce88b7fb93$var$isAsyncWrapper(vnode);
        let vnodeHook;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) $3bd355ce88b7fb93$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        if (shapeFlag & 6) unmountComponent(vnode.component, parentSuspense, doRemove);
        else {
            if (shapeFlag & 128) {
                vnode.suspense.unmount(parentSuspense, doRemove);
                return;
            }
            if (shouldInvokeDirs) $3bd355ce88b7fb93$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeUnmount");
            if (shapeFlag & 64) vnode.type.remove(vnode, parentComponent, parentSuspense, internals, doRemove);
            else if (dynamicChildren && // #5154
            // when v-once is used inside a block, setBlockTracking(-1) marks the
            // parent block with hasOnce: true
            // so that it doesn't take the fast path during unmount - otherwise
            // components nested in v-once are never unmounted.
            !dynamicChildren.hasOnce && // #1153: fast path should not be taken for non-stable (v-for) fragments
            (type !== $3bd355ce88b7fb93$export$ffb0004e005737fa || patchFlag > 0 && patchFlag & 64)) unmountChildren(dynamicChildren, parentComponent, parentSuspense, false, true);
            else if (type === $3bd355ce88b7fb93$export$ffb0004e005737fa && patchFlag & 384 || !optimized && shapeFlag & 16) unmountChildren(children, parentComponent, parentSuspense);
            if (doRemove) remove(vnode);
        }
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs) $3bd355ce88b7fb93$var$queuePostRenderEffect(()=>{
            vnodeHook && $3bd355ce88b7fb93$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            shouldInvokeDirs && $3bd355ce88b7fb93$var$invokeDirectiveHook(vnode, null, parentComponent, "unmounted");
        }, parentSuspense);
    };
    const remove = (vnode)=>{
        const { type: type, el: el, anchor: anchor, transition: transition } = vnode;
        if (type === $3bd355ce88b7fb93$export$ffb0004e005737fa) {
            var child;
            removeFragment(el, anchor);
            return;
        }
        if (type === $3bd355ce88b7fb93$export$c1b9a1d3af45b7b6) {
            removeStaticNode(vnode);
            return;
        }
        const performRemove = ()=>{
            hostRemove(el);
            if (transition && !transition.persisted && transition.afterLeave) transition.afterLeave();
        };
        if (vnode.shapeFlag & 1 && transition && !transition.persisted) {
            const { leave: leave, delayLeave: delayLeave } = transition;
            const performLeave = ()=>leave(el, performRemove);
            if (delayLeave) delayLeave(vnode.el, performRemove, performLeave);
            else performLeave();
        } else performRemove();
    };
    const removeFragment = (cur, end)=>{
        let next;
        while(cur !== end){
            next = hostNextSibling(cur);
            hostRemove(cur);
            cur = next;
        }
        hostRemove(end);
    };
    const unmountComponent = (instance, parentSuspense, doRemove)=>{
        const { bum: bum, scope: scope, job: job, subTree: subTree, um: um, m: m, a: a, parent: parent, slots: { __: slotCacheKeys } } = instance;
        $3bd355ce88b7fb93$var$invalidateMount(m);
        $3bd355ce88b7fb93$var$invalidateMount(a);
        if (bum) (0, $Cr6yt.invokeArrayFns)(bum);
        if (parent && (0, $Cr6yt.isArray)(slotCacheKeys)) slotCacheKeys.forEach((v1)=>{
            parent.renderCache[v1] = void 0;
        });
        scope.stop();
        if (job) {
            job.flags |= 8;
            unmount(subTree, instance, parentSuspense, doRemove);
        }
        if (um) $3bd355ce88b7fb93$var$queuePostRenderEffect(um, parentSuspense);
        $3bd355ce88b7fb93$var$queuePostRenderEffect(()=>{
            instance.isUnmounted = true;
        }, parentSuspense);
        if (parentSuspense && parentSuspense.pendingBranch && !parentSuspense.isUnmounted && instance.asyncDep && !instance.asyncResolved && instance.suspenseId === parentSuspense.pendingId) {
            parentSuspense.deps--;
            if (parentSuspense.deps === 0) parentSuspense.resolve();
        }
        if (__VUE_PROD_DEVTOOLS__) $3bd355ce88b7fb93$var$devtoolsComponentRemoved(instance);
    };
    const unmountChildren = (children, parentComponent, parentSuspense, doRemove = false, optimized = false, start = 0)=>{
        for(let i = start; i < children.length; i++)unmount(children[i], parentComponent, parentSuspense, doRemove, optimized);
    };
    const getNextHostNode = (vnode)=>{
        if (vnode.shapeFlag & 6) return getNextHostNode(vnode.component.subTree);
        if (vnode.shapeFlag & 128) return vnode.suspense.next();
        const el = hostNextSibling(vnode.anchor || vnode.el);
        const teleportEnd = el && el[$3bd355ce88b7fb93$var$TeleportEndKey];
        return teleportEnd ? hostNextSibling(teleportEnd) : el;
    };
    let isFlushing = false;
    const render = (vnode, container, namespace)=>{
        if (vnode == null) {
            if (container._vnode) unmount(container._vnode, null, null, true);
        } else patch(container._vnode || null, vnode, container, null, null, null, namespace);
        container._vnode = vnode;
        if (!isFlushing) {
            isFlushing = true;
            $3bd355ce88b7fb93$var$flushPreFlushCbs();
            $3bd355ce88b7fb93$var$flushPostFlushCbs();
            isFlushing = false;
        }
    };
    const internals = {
        p: patch,
        um: unmount,
        m: move,
        r: remove,
        mt: mountComponent,
        mc: mountChildren,
        pc: patchChildren,
        pbc: patchBlockChildren,
        n: getNextHostNode,
        o: options
    };
    let hydrate;
    let hydrateNode;
    if (createHydrationFns) [hydrate, hydrateNode] = createHydrationFns(internals);
    return {
        render: render,
        hydrate: hydrate,
        createApp: $3bd355ce88b7fb93$var$createAppAPI(render, hydrate)
    };
}
function $3bd355ce88b7fb93$var$resolveChildrenNamespace({ type: type, props: props }, currentNamespace) {
    return currentNamespace === "svg" && type === "foreignObject" || currentNamespace === "mathml" && type === "annotation-xml" && props && props.encoding && props.encoding.includes("html") ? void 0 : currentNamespace;
}
function $3bd355ce88b7fb93$var$toggleRecurse({ effect: effect, job: job }, allowed) {
    if (allowed) {
        effect.flags |= 32;
        job.flags |= 4;
    } else {
        effect.flags &= -33;
        job.flags &= -5;
    }
}
function $3bd355ce88b7fb93$var$needTransition(parentSuspense, transition) {
    return (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition && !transition.persisted;
}
function $3bd355ce88b7fb93$var$traverseStaticChildren(n1, n2, shallow = false) {
    const ch1 = n1.children;
    const ch2 = n2.children;
    if ((0, $Cr6yt.isArray)(ch1) && (0, $Cr6yt.isArray)(ch2)) for(let i = 0; i < ch1.length; i++){
        const c1 = ch1[i];
        let c2 = ch2[i];
        if (c2.shapeFlag & 1 && !c2.dynamicChildren) {
            if (c2.patchFlag <= 0 || c2.patchFlag === 32) {
                c2 = ch2[i] = $3bd355ce88b7fb93$var$cloneIfMounted(ch2[i]);
                c2.el = c1.el;
            }
            if (!shallow && c2.patchFlag !== -2) $3bd355ce88b7fb93$var$traverseStaticChildren(c1, c2);
        }
        if (c2.type === $3bd355ce88b7fb93$export$5f1af8db9871e1d6) c2.el = c1.el;
        if (c2.type === $3bd355ce88b7fb93$export$4d299b491347818a && !c2.el) c2.el = c1.el;
    }
}
function $3bd355ce88b7fb93$var$getSequence(arr) {
    const p = arr.slice();
    const result = [
        0
    ];
    let i, j, u, v1, c;
    const len = arr.length;
    for(i = 0; i < len; i++){
        const arrI = arr[i];
        if (arrI !== 0) {
            j = result[result.length - 1];
            if (arr[j] < arrI) {
                p[i] = j;
                result.push(i);
                continue;
            }
            u = 0;
            v1 = result.length - 1;
            while(u < v1){
                c = u + v1 >> 1;
                if (arr[result[c]] < arrI) u = c + 1;
                else v1 = c;
            }
            if (arrI < arr[result[u]]) {
                if (u > 0) p[i] = result[u - 1];
                result[u] = i;
            }
        }
    }
    u = result.length;
    v1 = result[u - 1];
    while(u-- > 0){
        result[u] = v1;
        v1 = p[v1];
    }
    return result;
}
function $3bd355ce88b7fb93$var$locateNonHydratedAsyncRoot(instance) {
    const subComponent = instance.subTree.component;
    if (subComponent) {
        if (subComponent.asyncDep && !subComponent.asyncResolved) return subComponent;
        else return $3bd355ce88b7fb93$var$locateNonHydratedAsyncRoot(subComponent);
    }
}
function $3bd355ce88b7fb93$var$invalidateMount(hooks) {
    if (hooks) for(let i = 0; i < hooks.length; i++)hooks[i].flags |= 8;
}
const $3bd355ce88b7fb93$export$f2549a27e18acf2d = Symbol.for("v-scx");
const $3bd355ce88b7fb93$export$6b1c54dc4befcda = ()=>{
    {
        const ctx = $3bd355ce88b7fb93$export$a976684a0efeb93f($3bd355ce88b7fb93$export$f2549a27e18acf2d);
        ctx;
        return ctx;
    }
};
function $3bd355ce88b7fb93$export$ede35fc0e5500309(effect, options) {
    return $3bd355ce88b7fb93$var$doWatch(effect, null, options);
}
function $3bd355ce88b7fb93$export$b7f27ea67102d543(effect, options) {
    return $3bd355ce88b7fb93$var$doWatch(effect, null, {
        flush: "post"
    });
}
function $3bd355ce88b7fb93$export$2035654f31b0e555(effect, options) {
    return $3bd355ce88b7fb93$var$doWatch(effect, null, {
        flush: "sync"
    });
}
function $3bd355ce88b7fb93$export$3db5d71bdb2d5499(source, cb, options) {
    return $3bd355ce88b7fb93$var$doWatch(source, cb, options);
}
function $3bd355ce88b7fb93$var$doWatch(source, cb, options = (0, $Cr6yt.EMPTY_OBJ)) {
    const { immediate: immediate, deep: deep, flush: flush, once: once } = options;
    const baseWatchOptions = (0, $Cr6yt.extend)({}, options);
    const runsImmediately = cb && immediate || !cb && flush !== "post";
    let ssrCleanup;
    if ($3bd355ce88b7fb93$var$isInSSRComponentSetup) {
        if (flush === "sync") {
            const ctx = $3bd355ce88b7fb93$export$6b1c54dc4befcda();
            ssrCleanup = ctx.__watcherHandles || (ctx.__watcherHandles = []);
        } else if (!runsImmediately) {
            const watchStopHandle = ()=>{};
            watchStopHandle.stop = (0, $Cr6yt.NOOP);
            watchStopHandle.resume = (0, $Cr6yt.NOOP);
            watchStopHandle.pause = (0, $Cr6yt.NOOP);
            return watchStopHandle;
        }
    }
    const instance = $3bd355ce88b7fb93$var$currentInstance;
    baseWatchOptions.call = (fn, type, args)=>$3bd355ce88b7fb93$export$dae85862a8d94378(fn, instance, type, args);
    let isPre = false;
    if (flush === "post") baseWatchOptions.scheduler = (job)=>{
        $3bd355ce88b7fb93$var$queuePostRenderEffect(job, instance && instance.suspense);
    };
    else if (flush !== "sync") {
        isPre = true;
        baseWatchOptions.scheduler = (job, isFirstRun)=>{
            if (isFirstRun) job();
            else $3bd355ce88b7fb93$var$queueJob(job);
        };
    }
    baseWatchOptions.augmentJob = (job)=>{
        if (cb) job.flags |= 4;
        if (isPre) {
            job.flags |= 2;
            if (instance) {
                job.id = instance.uid;
                job.i = instance;
            }
        }
    };
    const watchHandle = (0, $2eFsq.watch)(source, cb, baseWatchOptions);
    if ($3bd355ce88b7fb93$var$isInSSRComponentSetup) {
        if (ssrCleanup) ssrCleanup.push(watchHandle);
        else if (runsImmediately) watchHandle();
    }
    return watchHandle;
}
function $3bd355ce88b7fb93$var$instanceWatch(source, value, options) {
    const publicThis = this.proxy;
    const getter = (0, $Cr6yt.isString)(source) ? source.includes(".") ? $3bd355ce88b7fb93$var$createPathGetter(publicThis, source) : ()=>publicThis[source] : source.bind(publicThis, publicThis);
    let cb;
    if ((0, $Cr6yt.isFunction)(value)) cb = value;
    else {
        cb = value.handler;
        options = value;
    }
    const reset = $3bd355ce88b7fb93$var$setCurrentInstance(this);
    const res = $3bd355ce88b7fb93$var$doWatch(getter, cb.bind(publicThis), options);
    reset();
    return res;
}
function $3bd355ce88b7fb93$var$createPathGetter(ctx, path) {
    const segments = path.split(".");
    return ()=>{
        let cur = ctx;
        for(let i = 0; i < segments.length && cur; i++)cur = cur[segments[i]];
        return cur;
    };
}
function $3bd355ce88b7fb93$export$fb78bd113157f1a1(props, name, options = (0, $Cr6yt.EMPTY_OBJ)) {
    const i = $3bd355ce88b7fb93$export$f13e630aa3915748();
    const camelizedName = (0, $Cr6yt.camelize)(name);
    const hyphenatedName = (0, $Cr6yt.hyphenate)(name);
    const modifiers = $3bd355ce88b7fb93$var$getModelModifiers(props, camelizedName);
    const res = (0, $2eFsq.customRef)((track, trigger)=>{
        let localValue;
        let prevSetValue = (0, $Cr6yt.EMPTY_OBJ);
        let prevEmittedValue;
        $3bd355ce88b7fb93$export$2035654f31b0e555(()=>{
            const propValue = props[camelizedName];
            if ((0, $Cr6yt.hasChanged)(localValue, propValue)) {
                localValue = propValue;
                trigger();
            }
        });
        return {
            get () {
                track();
                return options.get ? options.get(localValue) : localValue;
            },
            set (value) {
                const emittedValue = options.set ? options.set(value) : value;
                if (!(0, $Cr6yt.hasChanged)(emittedValue, localValue) && !(prevSetValue !== (0, $Cr6yt.EMPTY_OBJ) && (0, $Cr6yt.hasChanged)(value, prevSetValue))) return;
                const rawProps = i.vnode.props;
                if (!(rawProps && // check if parent has passed v-model
                (name in rawProps || camelizedName in rawProps || hyphenatedName in rawProps) && (`onUpdate:${name}` in rawProps || `onUpdate:${camelizedName}` in rawProps || `onUpdate:${hyphenatedName}` in rawProps))) {
                    localValue = value;
                    trigger();
                }
                i.emit(`update:${name}`, emittedValue);
                if ((0, $Cr6yt.hasChanged)(value, emittedValue) && (0, $Cr6yt.hasChanged)(value, prevSetValue) && !(0, $Cr6yt.hasChanged)(emittedValue, prevEmittedValue)) trigger();
                prevSetValue = value;
                prevEmittedValue = emittedValue;
            }
        };
    });
    res[Symbol.iterator] = ()=>{
        let i2 = 0;
        return {
            next () {
                if (i2 < 2) return {
                    value: i2++ ? modifiers || (0, $Cr6yt.EMPTY_OBJ) : res,
                    done: false
                };
                else return {
                    done: true
                };
            }
        };
    };
    return res;
}
const $3bd355ce88b7fb93$var$getModelModifiers = (props, modelName)=>{
    return modelName === "modelValue" || modelName === "model-value" ? props.modelModifiers : props[`${modelName}Modifiers`] || props[`${(0, $Cr6yt.camelize)(modelName)}Modifiers`] || props[`${(0, $Cr6yt.hyphenate)(modelName)}Modifiers`];
};
function $3bd355ce88b7fb93$var$emit(instance, event, ...rawArgs) {
    if (instance.isUnmounted) return;
    const props = instance.vnode.props || (0, $Cr6yt.EMPTY_OBJ);
    let args = rawArgs;
    const isModelListener = event.startsWith("update:");
    const modifiers = isModelListener && $3bd355ce88b7fb93$var$getModelModifiers(props, event.slice(7));
    if (modifiers) {
        if (modifiers.trim) args = rawArgs.map((a)=>(0, $Cr6yt.isString)(a) ? a.trim() : a);
        if (modifiers.number) args = rawArgs.map((0, $Cr6yt.looseToNumber));
    }
    if (__VUE_PROD_DEVTOOLS__) $3bd355ce88b7fb93$var$devtoolsComponentEmit(instance, event, args);
    let handlerName;
    let handler = props[handlerName = (0, $Cr6yt.toHandlerKey)(event)] || // also try camelCase event handler (#2249)
    props[handlerName = (0, $Cr6yt.toHandlerKey)((0, $Cr6yt.camelize)(event))];
    if (!handler && isModelListener) handler = props[handlerName = (0, $Cr6yt.toHandlerKey)((0, $Cr6yt.hyphenate)(event))];
    if (handler) $3bd355ce88b7fb93$export$dae85862a8d94378(handler, instance, 6, args);
    const onceHandler = props[handlerName + `Once`];
    if (onceHandler) {
        if (!instance.emitted) instance.emitted = {};
        else if (instance.emitted[handlerName]) return;
        instance.emitted[handlerName] = true;
        $3bd355ce88b7fb93$export$dae85862a8d94378(onceHandler, instance, 6, args);
    }
}
function $3bd355ce88b7fb93$var$normalizeEmitsOptions(comp, appContext, asMixin = false) {
    const cache = appContext.emitsCache;
    const cached = cache.get(comp);
    if (cached !== void 0) return cached;
    const raw = comp.emits;
    let normalized = {};
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $Cr6yt.isFunction)(comp)) {
        const extendEmits = (raw2)=>{
            const normalizedFromExtend = $3bd355ce88b7fb93$var$normalizeEmitsOptions(raw2, appContext, true);
            if (normalizedFromExtend) {
                hasExtends = true;
                (0, $Cr6yt.extend)(normalized, normalizedFromExtend);
            }
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendEmits);
        if (comp.extends) extendEmits(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendEmits);
    }
    if (!raw && !hasExtends) {
        if ((0, $Cr6yt.isObject)(comp)) cache.set(comp, null);
        return null;
    }
    if ((0, $Cr6yt.isArray)(raw)) raw.forEach((key)=>normalized[key] = null);
    else (0, $Cr6yt.extend)(normalized, raw);
    if ((0, $Cr6yt.isObject)(comp)) cache.set(comp, normalized);
    return normalized;
}
function $3bd355ce88b7fb93$var$isEmitListener(options, key) {
    if (!options || !(0, $Cr6yt.isOn)(key)) return false;
    key = key.slice(2).replace(/Once$/, "");
    return (0, $Cr6yt.hasOwn)(options, key[0].toLowerCase() + key.slice(1)) || (0, $Cr6yt.hasOwn)(options, (0, $Cr6yt.hyphenate)(key)) || (0, $Cr6yt.hasOwn)(options, key);
}
let $3bd355ce88b7fb93$var$accessedAttrs = false;
function $3bd355ce88b7fb93$var$markAttrsAccessed() {
    $3bd355ce88b7fb93$var$accessedAttrs = true;
}
function $3bd355ce88b7fb93$var$renderComponentRoot(instance) {
    const { type: Component, vnode: vnode, proxy: proxy, withProxy: withProxy, propsOptions: [propsOptions], slots: slots, attrs: attrs, emit: emit, render: render, renderCache: renderCache, props: props, data: data, setupState: setupState, ctx: ctx, inheritAttrs: inheritAttrs } = instance;
    const prev = $3bd355ce88b7fb93$var$setCurrentRenderingInstance(instance);
    let result;
    let fallthroughAttrs;
    try {
        if (vnode.shapeFlag & 4) {
            const proxyToUse = withProxy || proxy;
            const thisProxy = proxyToUse;
            result = $3bd355ce88b7fb93$var$normalizeVNode(render.call(thisProxy, proxyToUse, renderCache, props, setupState, data, ctx));
            fallthroughAttrs = attrs;
        } else {
            const render2 = Component;
            result = $3bd355ce88b7fb93$var$normalizeVNode(render2.length > 1 ? render2(props, {
                attrs: attrs,
                slots: slots,
                emit: emit
            }) : render2(props, null));
            fallthroughAttrs = Component.props ? attrs : $3bd355ce88b7fb93$var$getFunctionalFallthrough(attrs);
        }
    } catch (err) {
        $3bd355ce88b7fb93$var$blockStack.length = 0;
        $3bd355ce88b7fb93$export$d3da1ecaf1206c58(err, instance, 1);
        result = $3bd355ce88b7fb93$export$bf5c4cf060303d58($3bd355ce88b7fb93$export$4d299b491347818a);
    }
    let root = result;
    let setRoot = void 0;
    if (fallthroughAttrs && inheritAttrs !== false) {
        const keys = Object.keys(fallthroughAttrs);
        const { shapeFlag: shapeFlag } = root;
        if (keys.length) {
            if (shapeFlag & 7) {
                if (propsOptions && keys.some((0, $Cr6yt.isModelListener))) fallthroughAttrs = $3bd355ce88b7fb93$var$filterModelListeners(fallthroughAttrs, propsOptions);
                root = $3bd355ce88b7fb93$export$ee4f9e12c0a92a1a(root, fallthroughAttrs, false, true);
            }
        }
    }
    if (vnode.dirs) {
        root = $3bd355ce88b7fb93$export$ee4f9e12c0a92a1a(root, null, false, true);
        root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
    }
    if (vnode.transition) $3bd355ce88b7fb93$export$7770a22486565649(root, vnode.transition);
    result = root;
    $3bd355ce88b7fb93$var$setCurrentRenderingInstance(prev);
    return result;
}
const $3bd355ce88b7fb93$var$getChildRoot = (vnode)=>{
    const rawChildren = vnode.children;
    const dynamicChildren = vnode.dynamicChildren;
    const childRoot = $3bd355ce88b7fb93$var$filterSingleRoot(rawChildren, false);
    if (!childRoot) return [
        vnode,
        void 0
    ];
    const index = rawChildren.indexOf(childRoot);
    const dynamicIndex = dynamicChildren ? dynamicChildren.indexOf(childRoot) : -1;
    const setRoot = (updatedRoot)=>{
        rawChildren[index] = updatedRoot;
        if (dynamicChildren) {
            if (dynamicIndex > -1) dynamicChildren[dynamicIndex] = updatedRoot;
            else if (updatedRoot.patchFlag > 0) vnode.dynamicChildren = [
                ...dynamicChildren,
                updatedRoot
            ];
        }
    };
    return [
        $3bd355ce88b7fb93$var$normalizeVNode(childRoot),
        setRoot
    ];
};
function $3bd355ce88b7fb93$var$filterSingleRoot(children, recurse = true) {
    let singleRoot;
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if ($3bd355ce88b7fb93$export$3868d13f8734ae81(child)) {
            if (child.type !== $3bd355ce88b7fb93$export$4d299b491347818a || child.children === "v-if") {
                if (singleRoot) return;
                else singleRoot = child;
            }
        } else return;
    }
    return singleRoot;
}
const $3bd355ce88b7fb93$var$getFunctionalFallthrough = (attrs)=>{
    let res;
    for(const key in attrs)if (key === "class" || key === "style" || (0, $Cr6yt.isOn)(key)) (res || (res = {}))[key] = attrs[key];
    return res;
};
const $3bd355ce88b7fb93$var$filterModelListeners = (attrs, props)=>{
    const res = {};
    for(const key in attrs)if (!(0, $Cr6yt.isModelListener)(key) || !(key.slice(9) in props)) res[key] = attrs[key];
    return res;
};
const $3bd355ce88b7fb93$var$isElementRoot = (vnode)=>{
    return vnode.shapeFlag & 7 || vnode.type === $3bd355ce88b7fb93$export$4d299b491347818a;
};
function $3bd355ce88b7fb93$var$shouldUpdateComponent(prevVNode, nextVNode, optimized) {
    const { props: prevProps, children: prevChildren, component: component } = prevVNode;
    const { props: nextProps, children: nextChildren, patchFlag: patchFlag } = nextVNode;
    const emits = component.emitsOptions;
    if (nextVNode.dirs || nextVNode.transition) return true;
    if (optimized && patchFlag >= 0) {
        if (patchFlag & 1024) return true;
        if (patchFlag & 16) {
            if (!prevProps) return !!nextProps;
            return $3bd355ce88b7fb93$var$hasPropsChanged(prevProps, nextProps, emits);
        } else if (patchFlag & 8) {
            const dynamicProps = nextVNode.dynamicProps;
            for(let i = 0; i < dynamicProps.length; i++){
                const key = dynamicProps[i];
                if (nextProps[key] !== prevProps[key] && !$3bd355ce88b7fb93$var$isEmitListener(emits, key)) return true;
            }
        }
    } else {
        if (prevChildren || nextChildren) {
            if (!nextChildren || !nextChildren.$stable) return true;
        }
        if (prevProps === nextProps) return false;
        if (!prevProps) return !!nextProps;
        if (!nextProps) return true;
        return $3bd355ce88b7fb93$var$hasPropsChanged(prevProps, nextProps, emits);
    }
    return false;
}
function $3bd355ce88b7fb93$var$hasPropsChanged(prevProps, nextProps, emitsOptions) {
    const nextKeys = Object.keys(nextProps);
    if (nextKeys.length !== Object.keys(prevProps).length) return true;
    for(let i = 0; i < nextKeys.length; i++){
        const key = nextKeys[i];
        if (nextProps[key] !== prevProps[key] && !$3bd355ce88b7fb93$var$isEmitListener(emitsOptions, key)) return true;
    }
    return false;
}
function $3bd355ce88b7fb93$var$updateHOCHostEl({ vnode: vnode, parent: parent }, el) {
    while(parent){
        const root = parent.subTree;
        if (root.suspense && root.suspense.activeBranch === vnode) root.el = vnode.el;
        if (root === vnode) {
            (vnode = parent.vnode).el = el;
            parent = parent.parent;
        } else break;
    }
}
const $3bd355ce88b7fb93$var$isSuspense = (type)=>type.__isSuspense;
let $3bd355ce88b7fb93$var$suspenseId = 0;
const $3bd355ce88b7fb93$var$SuspenseImpl = {
    name: "Suspense",
    // In order to make Suspense tree-shakable, we need to avoid importing it
    // directly in the renderer. The renderer checks for the __isSuspense flag
    // on a vnode's type and calls the `process` method, passing in renderer
    // internals.
    __isSuspense: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
        if (n1 == null) $3bd355ce88b7fb93$var$mountSuspense(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals);
        else {
            if (parentSuspense && parentSuspense.deps > 0 && !n1.suspense.isInFallback) {
                n2.suspense = n1.suspense;
                n2.suspense.vnode = n2;
                n2.el = n1.el;
                return;
            }
            $3bd355ce88b7fb93$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, rendererInternals);
        }
    },
    hydrate: $3bd355ce88b7fb93$var$hydrateSuspense,
    normalize: $3bd355ce88b7fb93$var$normalizeSuspenseChildren
};
const $3bd355ce88b7fb93$export$74bf444e3cd11ea5 = $3bd355ce88b7fb93$var$SuspenseImpl;
function $3bd355ce88b7fb93$var$triggerEvent(vnode, name) {
    const eventListener = vnode.props && vnode.props[name];
    if ((0, $Cr6yt.isFunction)(eventListener)) eventListener();
}
function $3bd355ce88b7fb93$var$mountSuspense(vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
    const { p: patch, o: { createElement: createElement } } = rendererInternals;
    const hiddenContainer = createElement("div");
    const suspense = vnode.suspense = $3bd355ce88b7fb93$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals);
    patch(null, suspense.pendingBranch = vnode.ssContent, hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds);
    if (suspense.deps > 0) {
        $3bd355ce88b7fb93$var$triggerEvent(vnode, "onPending");
        $3bd355ce88b7fb93$var$triggerEvent(vnode, "onFallback");
        patch(null, vnode.ssFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
        namespace, slotScopeIds);
        $3bd355ce88b7fb93$var$setActiveBranch(suspense, vnode.ssFallback);
    } else suspense.resolve(false, true);
}
function $3bd355ce88b7fb93$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, { p: patch, um: unmount, o: { createElement: createElement } }) {
    const suspense = n2.suspense = n1.suspense;
    suspense.vnode = n2;
    n2.el = n1.el;
    const newBranch = n2.ssContent;
    const newFallback = n2.ssFallback;
    const { activeBranch: activeBranch, pendingBranch: pendingBranch, isInFallback: isInFallback, isHydrating: isHydrating } = suspense;
    if (pendingBranch) {
        suspense.pendingBranch = newBranch;
        if ($3bd355ce88b7fb93$var$isSameVNodeType(newBranch, pendingBranch)) {
            patch(pendingBranch, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
            if (suspense.deps <= 0) suspense.resolve();
            else if (isInFallback) {
                if (!isHydrating) {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $3bd355ce88b7fb93$var$setActiveBranch(suspense, newFallback);
                }
            }
        } else {
            suspense.pendingId = $3bd355ce88b7fb93$var$suspenseId++;
            if (isHydrating) {
                suspense.isHydrating = false;
                suspense.activeBranch = pendingBranch;
            } else unmount(pendingBranch, parentComponent, suspense);
            suspense.deps = 0;
            suspense.effects.length = 0;
            suspense.hiddenContainer = createElement("div");
            if (isInFallback) {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
                else {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $3bd355ce88b7fb93$var$setActiveBranch(suspense, newFallback);
                }
            } else if (activeBranch && $3bd355ce88b7fb93$var$isSameVNodeType(newBranch, activeBranch)) {
                patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
                suspense.resolve(true);
            } else {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
            }
        }
    } else if (activeBranch && $3bd355ce88b7fb93$var$isSameVNodeType(newBranch, activeBranch)) {
        patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
        $3bd355ce88b7fb93$var$setActiveBranch(suspense, newBranch);
    } else {
        $3bd355ce88b7fb93$var$triggerEvent(n2, "onPending");
        suspense.pendingBranch = newBranch;
        if (newBranch.shapeFlag & 512) suspense.pendingId = newBranch.component.suspenseId;
        else suspense.pendingId = $3bd355ce88b7fb93$var$suspenseId++;
        patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
        if (suspense.deps <= 0) suspense.resolve();
        else {
            const { timeout: timeout, pendingId: pendingId } = suspense;
            if (timeout > 0) setTimeout(()=>{
                if (suspense.pendingId === pendingId) suspense.fallback(newFallback);
            }, timeout);
            else if (timeout === 0) suspense.fallback(newFallback);
        }
    }
}
let $3bd355ce88b7fb93$var$hasWarned = false;
function $3bd355ce88b7fb93$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals, isHydrating = false) {
    const { p: patch, m: move, um: unmount, n: next, o: { parentNode: parentNode, remove: remove } } = rendererInternals;
    let parentSuspenseId;
    const isSuspensible = $3bd355ce88b7fb93$var$isVNodeSuspensible(vnode);
    if (isSuspensible) {
        if (parentSuspense && parentSuspense.pendingBranch) {
            parentSuspenseId = parentSuspense.pendingId;
            parentSuspense.deps++;
        }
    }
    const timeout = vnode.props ? (0, $Cr6yt.toNumber)(vnode.props.timeout) : void 0;
    const initialAnchor = anchor;
    const suspense = {
        vnode: vnode,
        parent: parentSuspense,
        parentComponent: parentComponent,
        namespace: namespace,
        container: container,
        hiddenContainer: hiddenContainer,
        deps: 0,
        pendingId: $3bd355ce88b7fb93$var$suspenseId++,
        timeout: typeof timeout === "number" ? timeout : -1,
        activeBranch: null,
        pendingBranch: null,
        isInFallback: !isHydrating,
        isHydrating: isHydrating,
        isUnmounted: false,
        effects: [],
        resolve (resume = false, sync = false) {
            const { vnode: vnode2, activeBranch: activeBranch, pendingBranch: pendingBranch, pendingId: pendingId, effects: effects, parentComponent: parentComponent2, container: container2 } = suspense;
            let delayEnter = false;
            if (suspense.isHydrating) suspense.isHydrating = false;
            else if (!resume) {
                delayEnter = activeBranch && pendingBranch.transition && pendingBranch.transition.mode === "out-in";
                if (delayEnter) activeBranch.transition.afterLeave = ()=>{
                    if (pendingId === suspense.pendingId) {
                        move(pendingBranch, container2, anchor === initialAnchor ? next(activeBranch) : anchor, 0);
                        $3bd355ce88b7fb93$export$59536a0199721cab(effects);
                    }
                };
                if (activeBranch) {
                    if (parentNode(activeBranch.el) === container2) anchor = next(activeBranch);
                    unmount(activeBranch, parentComponent2, suspense, true);
                }
                if (!delayEnter) move(pendingBranch, container2, anchor, 0);
            }
            $3bd355ce88b7fb93$var$setActiveBranch(suspense, pendingBranch);
            suspense.pendingBranch = null;
            suspense.isInFallback = false;
            let parent = suspense.parent;
            let hasUnresolvedAncestor = false;
            while(parent){
                if (parent.pendingBranch) {
                    parent.effects.push(...effects);
                    hasUnresolvedAncestor = true;
                    break;
                }
                parent = parent.parent;
            }
            if (!hasUnresolvedAncestor && !delayEnter) $3bd355ce88b7fb93$export$59536a0199721cab(effects);
            suspense.effects = [];
            if (isSuspensible) {
                if (parentSuspense && parentSuspense.pendingBranch && parentSuspenseId === parentSuspense.pendingId) {
                    parentSuspense.deps--;
                    if (parentSuspense.deps === 0 && !sync) parentSuspense.resolve();
                }
            }
            $3bd355ce88b7fb93$var$triggerEvent(vnode2, "onResolve");
        },
        fallback (fallbackVNode) {
            if (!suspense.pendingBranch) return;
            const { vnode: vnode2, activeBranch: activeBranch, parentComponent: parentComponent2, container: container2, namespace: namespace2 } = suspense;
            $3bd355ce88b7fb93$var$triggerEvent(vnode2, "onFallback");
            const anchor2 = next(activeBranch);
            const mountFallback = ()=>{
                if (!suspense.isInFallback) return;
                patch(null, fallbackVNode, container2, anchor2, parentComponent2, null, // fallback tree will not have suspense context
                namespace2, slotScopeIds, optimized);
                $3bd355ce88b7fb93$var$setActiveBranch(suspense, fallbackVNode);
            };
            const delayEnter = fallbackVNode.transition && fallbackVNode.transition.mode === "out-in";
            if (delayEnter) activeBranch.transition.afterLeave = mountFallback;
            suspense.isInFallback = true;
            unmount(activeBranch, parentComponent2, null, // no suspense so unmount hooks fire now
            true);
            if (!delayEnter) mountFallback();
        },
        move (container2, anchor2, type) {
            suspense.activeBranch && move(suspense.activeBranch, container2, anchor2, type);
            suspense.container = container2;
        },
        next () {
            return suspense.activeBranch && next(suspense.activeBranch);
        },
        registerDep (instance, setupRenderEffect, optimized2) {
            const isInPendingSuspense = !!suspense.pendingBranch;
            if (isInPendingSuspense) suspense.deps++;
            const hydratedEl = instance.vnode.el;
            instance.asyncDep.catch((err)=>{
                $3bd355ce88b7fb93$export$d3da1ecaf1206c58(err, instance, 0);
            }).then((asyncSetupResult)=>{
                if (instance.isUnmounted || suspense.isUnmounted || suspense.pendingId !== instance.suspenseId) return;
                instance.asyncResolved = true;
                const { vnode: vnode2 } = instance;
                $3bd355ce88b7fb93$var$handleSetupResult(instance, asyncSetupResult, false);
                if (hydratedEl) vnode2.el = hydratedEl;
                const placeholder = !hydratedEl && instance.subTree.el;
                setupRenderEffect(instance, vnode2, // component may have been moved before resolve.
                // if this is not a hydration, instance.subTree will be the comment
                // placeholder.
                parentNode(hydratedEl || instance.subTree.el), // anchor will not be used if this is hydration, so only need to
                // consider the comment placeholder case.
                hydratedEl ? null : next(instance.subTree), suspense, namespace, optimized2);
                if (placeholder) remove(placeholder);
                $3bd355ce88b7fb93$var$updateHOCHostEl(instance, vnode2.el);
                if (isInPendingSuspense && --suspense.deps === 0) suspense.resolve();
            });
        },
        unmount (parentSuspense2, doRemove) {
            suspense.isUnmounted = true;
            if (suspense.activeBranch) unmount(suspense.activeBranch, parentComponent, parentSuspense2, doRemove);
            if (suspense.pendingBranch) unmount(suspense.pendingBranch, parentComponent, parentSuspense2, doRemove);
        }
    };
    return suspense;
}
function $3bd355ce88b7fb93$var$hydrateSuspense(node, vnode, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals, hydrateNode) {
    const suspense = vnode.suspense = $3bd355ce88b7fb93$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, node.parentNode, // eslint-disable-next-line no-restricted-globals
    document.createElement("div"), null, namespace, slotScopeIds, optimized, rendererInternals, true);
    const result = hydrateNode(node, suspense.pendingBranch = vnode.ssContent, parentComponent, suspense, slotScopeIds, optimized);
    if (suspense.deps === 0) suspense.resolve(false, true);
    return result;
}
function $3bd355ce88b7fb93$var$normalizeSuspenseChildren(vnode) {
    const { shapeFlag: shapeFlag, children: children } = vnode;
    const isSlotChildren = shapeFlag & 32;
    vnode.ssContent = $3bd355ce88b7fb93$var$normalizeSuspenseSlot(isSlotChildren ? children.default : children);
    vnode.ssFallback = isSlotChildren ? $3bd355ce88b7fb93$var$normalizeSuspenseSlot(children.fallback) : $3bd355ce88b7fb93$export$bf5c4cf060303d58($3bd355ce88b7fb93$export$4d299b491347818a);
}
function $3bd355ce88b7fb93$var$normalizeSuspenseSlot(s) {
    let block;
    if ((0, $Cr6yt.isFunction)(s)) {
        const trackBlock = $3bd355ce88b7fb93$var$isBlockTreeEnabled && s._c;
        if (trackBlock) {
            s._d = false;
            $3bd355ce88b7fb93$export$e7eaa45e502fe5cc();
        }
        s = s();
        if (trackBlock) {
            s._d = true;
            block = $3bd355ce88b7fb93$var$currentBlock;
            $3bd355ce88b7fb93$var$closeBlock();
        }
    }
    if ((0, $Cr6yt.isArray)(s)) {
        const singleChild = $3bd355ce88b7fb93$var$filterSingleRoot(s);
        s = singleChild;
    }
    s = $3bd355ce88b7fb93$var$normalizeVNode(s);
    if (block && !s.dynamicChildren) s.dynamicChildren = block.filter((c)=>c !== s);
    return s;
}
function $3bd355ce88b7fb93$var$queueEffectWithSuspense(fn, suspense) {
    if (suspense && suspense.pendingBranch) {
        if ((0, $Cr6yt.isArray)(fn)) suspense.effects.push(...fn);
        else suspense.effects.push(fn);
    } else $3bd355ce88b7fb93$export$59536a0199721cab(fn);
}
function $3bd355ce88b7fb93$var$setActiveBranch(suspense, branch) {
    suspense.activeBranch = branch;
    const { vnode: vnode, parentComponent: parentComponent } = suspense;
    let el = branch.el;
    while(!el && branch.component){
        branch = branch.component.subTree;
        el = branch.el;
    }
    vnode.el = el;
    if (parentComponent && parentComponent.subTree === vnode) {
        parentComponent.vnode.el = el;
        $3bd355ce88b7fb93$var$updateHOCHostEl(parentComponent, el);
    }
}
function $3bd355ce88b7fb93$var$isVNodeSuspensible(vnode) {
    const suspensible = vnode.props && vnode.props.suspensible;
    return suspensible != null && suspensible !== false;
}
const $3bd355ce88b7fb93$export$ffb0004e005737fa = Symbol.for("v-fgt");
const $3bd355ce88b7fb93$export$5f1af8db9871e1d6 = Symbol.for("v-txt");
const $3bd355ce88b7fb93$export$4d299b491347818a = Symbol.for("v-cmt");
const $3bd355ce88b7fb93$export$c1b9a1d3af45b7b6 = Symbol.for("v-stc");
const $3bd355ce88b7fb93$var$blockStack = [];
let $3bd355ce88b7fb93$var$currentBlock = null;
function $3bd355ce88b7fb93$export$e7eaa45e502fe5cc(disableTracking = false) {
    $3bd355ce88b7fb93$var$blockStack.push($3bd355ce88b7fb93$var$currentBlock = disableTracking ? null : []);
}
function $3bd355ce88b7fb93$var$closeBlock() {
    $3bd355ce88b7fb93$var$blockStack.pop();
    $3bd355ce88b7fb93$var$currentBlock = $3bd355ce88b7fb93$var$blockStack[$3bd355ce88b7fb93$var$blockStack.length - 1] || null;
}
let $3bd355ce88b7fb93$var$isBlockTreeEnabled = 1;
function $3bd355ce88b7fb93$export$c20bee82f26f1e27(value, inVOnce = false) {
    $3bd355ce88b7fb93$var$isBlockTreeEnabled += value;
    if (value < 0 && $3bd355ce88b7fb93$var$currentBlock && inVOnce) $3bd355ce88b7fb93$var$currentBlock.hasOnce = true;
}
function $3bd355ce88b7fb93$var$setupBlock(vnode) {
    vnode.dynamicChildren = $3bd355ce88b7fb93$var$isBlockTreeEnabled > 0 ? $3bd355ce88b7fb93$var$currentBlock || (0, $Cr6yt.EMPTY_ARR) : null;
    $3bd355ce88b7fb93$var$closeBlock();
    if ($3bd355ce88b7fb93$var$isBlockTreeEnabled > 0 && $3bd355ce88b7fb93$var$currentBlock) $3bd355ce88b7fb93$var$currentBlock.push(vnode);
    return vnode;
}
function $3bd355ce88b7fb93$export$167055419fc69ec1(type, props, children, patchFlag, dynamicProps, shapeFlag) {
    return $3bd355ce88b7fb93$var$setupBlock($3bd355ce88b7fb93$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, true));
}
function $3bd355ce88b7fb93$export$9f2dfe8048dfb22b(type, props, children, patchFlag, dynamicProps) {
    return $3bd355ce88b7fb93$var$setupBlock($3bd355ce88b7fb93$export$bf5c4cf060303d58(type, props, children, patchFlag, dynamicProps, true));
}
function $3bd355ce88b7fb93$export$3868d13f8734ae81(value) {
    return value ? value.__v_isVNode === true : false;
}
function $3bd355ce88b7fb93$var$isSameVNodeType(n1, n2) {
    return n1.type === n2.type && n1.key === n2.key;
}
let $3bd355ce88b7fb93$var$vnodeArgsTransformer;
function $3bd355ce88b7fb93$export$83beccd3afeeb809(transformer) {
    $3bd355ce88b7fb93$var$vnodeArgsTransformer = transformer;
}
const $3bd355ce88b7fb93$var$createVNodeWithArgsTransform = (...args)=>{
    return $3bd355ce88b7fb93$var$_createVNode(...$3bd355ce88b7fb93$var$vnodeArgsTransformer ? $3bd355ce88b7fb93$var$vnodeArgsTransformer(args, $3bd355ce88b7fb93$var$currentRenderingInstance) : args);
};
const $3bd355ce88b7fb93$var$normalizeKey = ({ key: key })=>key != null ? key : null;
const $3bd355ce88b7fb93$var$normalizeRef = ({ ref: ref, ref_key: ref_key, ref_for: ref_for })=>{
    if (typeof ref === "number") ref = "" + ref;
    return ref != null ? (0, $Cr6yt.isString)(ref) || (0, $2eFsq.isRef)(ref) || (0, $Cr6yt.isFunction)(ref) ? {
        i: $3bd355ce88b7fb93$var$currentRenderingInstance,
        r: ref,
        k: ref_key,
        f: !!ref_for
    } : ref : null;
};
function $3bd355ce88b7fb93$export$42098e0eaa15c48e(type, props = null, children = null, patchFlag = 0, dynamicProps = null, shapeFlag = type === $3bd355ce88b7fb93$export$ffb0004e005737fa ? 0 : 1, isBlockNode = false, needFullChildrenNormalization = false) {
    const vnode = {
        __v_isVNode: true,
        __v_skip: true,
        type: type,
        props: props,
        key: props && $3bd355ce88b7fb93$var$normalizeKey(props),
        ref: props && $3bd355ce88b7fb93$var$normalizeRef(props),
        scopeId: $3bd355ce88b7fb93$var$currentScopeId,
        slotScopeIds: null,
        children: children,
        component: null,
        suspense: null,
        ssContent: null,
        ssFallback: null,
        dirs: null,
        transition: null,
        el: null,
        anchor: null,
        target: null,
        targetStart: null,
        targetAnchor: null,
        staticCount: 0,
        shapeFlag: shapeFlag,
        patchFlag: patchFlag,
        dynamicProps: dynamicProps,
        dynamicChildren: null,
        appContext: null,
        ctx: $3bd355ce88b7fb93$var$currentRenderingInstance
    };
    if (needFullChildrenNormalization) {
        $3bd355ce88b7fb93$var$normalizeChildren(vnode, children);
        if (shapeFlag & 128) type.normalize(vnode);
    } else if (children) vnode.shapeFlag |= (0, $Cr6yt.isString)(children) ? 8 : 16;
    if ($3bd355ce88b7fb93$var$isBlockTreeEnabled > 0 && // avoid a block node from tracking itself
    !isBlockNode && // has current parent block
    $3bd355ce88b7fb93$var$currentBlock && // presence of a patch flag indicates this node needs patching on updates.
    // component nodes also should always be patched, because even if the
    // component doesn't need to update, it needs to persist the instance on to
    // the next vnode so that it can be properly unmounted later.
    (vnode.patchFlag > 0 || shapeFlag & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
    // vnode should not be considered dynamic due to handler caching.
    vnode.patchFlag !== 32) $3bd355ce88b7fb93$var$currentBlock.push(vnode);
    return vnode;
}
const $3bd355ce88b7fb93$export$bf5c4cf060303d58 = $3bd355ce88b7fb93$var$_createVNode;
function $3bd355ce88b7fb93$var$_createVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, isBlockNode = false) {
    if (!type || type === $3bd355ce88b7fb93$var$NULL_DYNAMIC_COMPONENT) type = $3bd355ce88b7fb93$export$4d299b491347818a;
    if ($3bd355ce88b7fb93$export$3868d13f8734ae81(type)) {
        const cloned = $3bd355ce88b7fb93$export$ee4f9e12c0a92a1a(type, props, true);
        if (children) $3bd355ce88b7fb93$var$normalizeChildren(cloned, children);
        if ($3bd355ce88b7fb93$var$isBlockTreeEnabled > 0 && !isBlockNode && $3bd355ce88b7fb93$var$currentBlock) {
            if (cloned.shapeFlag & 6) $3bd355ce88b7fb93$var$currentBlock[$3bd355ce88b7fb93$var$currentBlock.indexOf(type)] = cloned;
            else $3bd355ce88b7fb93$var$currentBlock.push(cloned);
        }
        cloned.patchFlag = -2;
        return cloned;
    }
    if ($3bd355ce88b7fb93$var$isClassComponent(type)) type = type.__vccOpts;
    if (props) {
        props = $3bd355ce88b7fb93$export$1f1be0e0e384d7d2(props);
        let { class: klass, style: style } = props;
        if (klass && !(0, $Cr6yt.isString)(klass)) props.class = (0, $Cr6yt.normalizeClass)(klass);
        if ((0, $Cr6yt.isObject)(style)) {
            if ((0, $2eFsq.isProxy)(style) && !(0, $Cr6yt.isArray)(style)) style = (0, $Cr6yt.extend)({}, style);
            props.style = (0, $Cr6yt.normalizeStyle)(style);
        }
    }
    const shapeFlag = (0, $Cr6yt.isString)(type) ? 1 : $3bd355ce88b7fb93$var$isSuspense(type) ? 128 : $3bd355ce88b7fb93$var$isTeleport(type) ? 64 : (0, $Cr6yt.isObject)(type) ? 4 : (0, $Cr6yt.isFunction)(type) ? 2 : 0;
    return $3bd355ce88b7fb93$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, isBlockNode, true);
}
function $3bd355ce88b7fb93$export$1f1be0e0e384d7d2(props) {
    if (!props) return null;
    return (0, $2eFsq.isProxy)(props) || $3bd355ce88b7fb93$var$isInternalObject(props) ? (0, $Cr6yt.extend)({}, props) : props;
}
function $3bd355ce88b7fb93$export$ee4f9e12c0a92a1a(vnode, extraProps, mergeRef = false, cloneTransition = false) {
    const { props: props, ref: ref, patchFlag: patchFlag, children: children, transition: transition } = vnode;
    const mergedProps = extraProps ? $3bd355ce88b7fb93$export$9d1611c77c2fe928(props || {}, extraProps) : props;
    const cloned = {
        __v_isVNode: true,
        __v_skip: true,
        type: vnode.type,
        props: mergedProps,
        key: mergedProps && $3bd355ce88b7fb93$var$normalizeKey(mergedProps),
        ref: extraProps && extraProps.ref ? // #2078 in the case of <component :is="vnode" ref="extra"/>
        // if the vnode itself already has a ref, cloneVNode will need to merge
        // the refs so the single vnode can be set on multiple refs
        mergeRef && ref ? (0, $Cr6yt.isArray)(ref) ? ref.concat($3bd355ce88b7fb93$var$normalizeRef(extraProps)) : [
            ref,
            $3bd355ce88b7fb93$var$normalizeRef(extraProps)
        ] : $3bd355ce88b7fb93$var$normalizeRef(extraProps) : ref,
        scopeId: vnode.scopeId,
        slotScopeIds: vnode.slotScopeIds,
        children: children,
        target: vnode.target,
        targetStart: vnode.targetStart,
        targetAnchor: vnode.targetAnchor,
        staticCount: vnode.staticCount,
        shapeFlag: vnode.shapeFlag,
        // if the vnode is cloned with extra props, we can no longer assume its
        // existing patch flag to be reliable and need to add the FULL_PROPS flag.
        // note: preserve flag for fragments since they use the flag for children
        // fast paths only.
        patchFlag: extraProps && vnode.type !== $3bd355ce88b7fb93$export$ffb0004e005737fa ? patchFlag === -1 ? 16 : patchFlag | 16 : patchFlag,
        dynamicProps: vnode.dynamicProps,
        dynamicChildren: vnode.dynamicChildren,
        appContext: vnode.appContext,
        dirs: vnode.dirs,
        transition: transition,
        // These should technically only be non-null on mounted VNodes. However,
        // they *should* be copied for kept-alive vnodes. So we just always copy
        // them since them being non-null during a mount doesn't affect the logic as
        // they will simply be overwritten.
        component: vnode.component,
        suspense: vnode.suspense,
        ssContent: vnode.ssContent && $3bd355ce88b7fb93$export$ee4f9e12c0a92a1a(vnode.ssContent),
        ssFallback: vnode.ssFallback && $3bd355ce88b7fb93$export$ee4f9e12c0a92a1a(vnode.ssFallback),
        el: vnode.el,
        anchor: vnode.anchor,
        ctx: vnode.ctx,
        ce: vnode.ce
    };
    if (transition && cloneTransition) $3bd355ce88b7fb93$export$7770a22486565649(cloned, transition.clone(cloned));
    return cloned;
}
function $3bd355ce88b7fb93$var$deepCloneVNode(vnode) {
    const cloned = $3bd355ce88b7fb93$export$ee4f9e12c0a92a1a(vnode);
    if ((0, $Cr6yt.isArray)(vnode.children)) cloned.children = vnode.children.map($3bd355ce88b7fb93$var$deepCloneVNode);
    return cloned;
}
function $3bd355ce88b7fb93$export$22f9b5ffd89dac9(text = " ", flag = 0) {
    return $3bd355ce88b7fb93$export$bf5c4cf060303d58($3bd355ce88b7fb93$export$5f1af8db9871e1d6, null, text, flag);
}
function $3bd355ce88b7fb93$export$33a9f6dd2840e6bb(content, numberOfNodes) {
    const vnode = $3bd355ce88b7fb93$export$bf5c4cf060303d58($3bd355ce88b7fb93$export$c1b9a1d3af45b7b6, null, content);
    vnode.staticCount = numberOfNodes;
    return vnode;
}
function $3bd355ce88b7fb93$export$49553837c7236d3c(text = "", asBlock = false) {
    return asBlock ? ($3bd355ce88b7fb93$export$e7eaa45e502fe5cc(), $3bd355ce88b7fb93$export$9f2dfe8048dfb22b($3bd355ce88b7fb93$export$4d299b491347818a, null, text)) : $3bd355ce88b7fb93$export$bf5c4cf060303d58($3bd355ce88b7fb93$export$4d299b491347818a, null, text);
}
function $3bd355ce88b7fb93$var$normalizeVNode(child) {
    if (child == null || typeof child === "boolean") return $3bd355ce88b7fb93$export$bf5c4cf060303d58($3bd355ce88b7fb93$export$4d299b491347818a);
    else if ((0, $Cr6yt.isArray)(child)) return $3bd355ce88b7fb93$export$bf5c4cf060303d58($3bd355ce88b7fb93$export$ffb0004e005737fa, null, // #3666, avoid reference pollution when reusing vnode
    child.slice());
    else if ($3bd355ce88b7fb93$export$3868d13f8734ae81(child)) return $3bd355ce88b7fb93$var$cloneIfMounted(child);
    else return $3bd355ce88b7fb93$export$bf5c4cf060303d58($3bd355ce88b7fb93$export$5f1af8db9871e1d6, null, String(child));
}
function $3bd355ce88b7fb93$var$cloneIfMounted(child) {
    return child.el === null && child.patchFlag !== -1 || child.memo ? child : $3bd355ce88b7fb93$export$ee4f9e12c0a92a1a(child);
}
function $3bd355ce88b7fb93$var$normalizeChildren(vnode, children) {
    let type = 0;
    const { shapeFlag: shapeFlag } = vnode;
    if (children == null) children = null;
    else if ((0, $Cr6yt.isArray)(children)) type = 16;
    else if (typeof children === "object") {
        if (shapeFlag & 65) {
            const slot = children.default;
            if (slot) {
                slot._c && (slot._d = false);
                $3bd355ce88b7fb93$var$normalizeChildren(vnode, slot());
                slot._c && (slot._d = true);
            }
            return;
        } else {
            type = 32;
            const slotFlag = children._;
            if (!slotFlag && !$3bd355ce88b7fb93$var$isInternalObject(children)) children._ctx = $3bd355ce88b7fb93$var$currentRenderingInstance;
            else if (slotFlag === 3 && $3bd355ce88b7fb93$var$currentRenderingInstance) {
                if ($3bd355ce88b7fb93$var$currentRenderingInstance.slots._ === 1) children._ = 1;
                else {
                    children._ = 2;
                    vnode.patchFlag |= 1024;
                }
            }
        }
    } else if ((0, $Cr6yt.isFunction)(children)) {
        children = {
            default: children,
            _ctx: $3bd355ce88b7fb93$var$currentRenderingInstance
        };
        type = 32;
    } else {
        children = String(children);
        if (shapeFlag & 64) {
            type = 16;
            children = [
                $3bd355ce88b7fb93$export$22f9b5ffd89dac9(children)
            ];
        } else type = 8;
    }
    vnode.children = children;
    vnode.shapeFlag |= type;
}
function $3bd355ce88b7fb93$export$9d1611c77c2fe928(...args) {
    const ret = {};
    for(let i = 0; i < args.length; i++){
        const toMerge = args[i];
        for(const key in toMerge){
            if (key === "class") {
                if (ret.class !== toMerge.class) ret.class = (0, $Cr6yt.normalizeClass)([
                    ret.class,
                    toMerge.class
                ]);
            } else if (key === "style") ret.style = (0, $Cr6yt.normalizeStyle)([
                ret.style,
                toMerge.style
            ]);
            else if ((0, $Cr6yt.isOn)(key)) {
                const existing = ret[key];
                const incoming = toMerge[key];
                if (incoming && existing !== incoming && !((0, $Cr6yt.isArray)(existing) && existing.includes(incoming))) ret[key] = existing ? [].concat(existing, incoming) : incoming;
            } else if (key !== "") ret[key] = toMerge[key];
        }
    }
    return ret;
}
function $3bd355ce88b7fb93$var$invokeVNodeHook(hook, instance, vnode, prevVNode = null) {
    $3bd355ce88b7fb93$export$dae85862a8d94378(hook, instance, 7, [
        vnode,
        prevVNode
    ]);
}
const $3bd355ce88b7fb93$var$emptyAppContext = $3bd355ce88b7fb93$var$createAppContext();
let $3bd355ce88b7fb93$var$uid = 0;
function $3bd355ce88b7fb93$var$createComponentInstance(vnode, parent, suspense) {
    const type = vnode.type;
    const appContext = (parent ? parent.appContext : vnode.appContext) || $3bd355ce88b7fb93$var$emptyAppContext;
    const instance = {
        uid: $3bd355ce88b7fb93$var$uid++,
        vnode: vnode,
        type: type,
        parent: parent,
        appContext: appContext,
        root: null,
        // to be immediately set
        next: null,
        subTree: null,
        // will be set synchronously right after creation
        effect: null,
        update: null,
        // will be set synchronously right after creation
        job: null,
        scope: new (0, $2eFsq.EffectScope)(true),
        render: null,
        proxy: null,
        exposed: null,
        exposeProxy: null,
        withProxy: null,
        provides: parent ? parent.provides : Object.create(appContext.provides),
        ids: parent ? parent.ids : [
            "",
            0,
            0
        ],
        accessCache: null,
        renderCache: [],
        // local resolved assets
        components: null,
        directives: null,
        // resolved props and emits options
        propsOptions: $3bd355ce88b7fb93$var$normalizePropsOptions(type, appContext),
        emitsOptions: $3bd355ce88b7fb93$var$normalizeEmitsOptions(type, appContext),
        // emit
        emit: null,
        // to be set immediately
        emitted: null,
        // props default value
        propsDefaults: (0, $Cr6yt.EMPTY_OBJ),
        // inheritAttrs
        inheritAttrs: type.inheritAttrs,
        // state
        ctx: (0, $Cr6yt.EMPTY_OBJ),
        data: (0, $Cr6yt.EMPTY_OBJ),
        props: (0, $Cr6yt.EMPTY_OBJ),
        attrs: (0, $Cr6yt.EMPTY_OBJ),
        slots: (0, $Cr6yt.EMPTY_OBJ),
        refs: (0, $Cr6yt.EMPTY_OBJ),
        setupState: (0, $Cr6yt.EMPTY_OBJ),
        setupContext: null,
        suspense: // suspense related
        suspense,
        suspenseId: suspense ? suspense.pendingId : 0,
        asyncDep: null,
        asyncResolved: false,
        // lifecycle hooks
        // not using enums here because it results in computed properties
        isMounted: false,
        isUnmounted: false,
        isDeactivated: false,
        bc: null,
        c: null,
        bm: null,
        m: null,
        bu: null,
        u: null,
        um: null,
        bum: null,
        da: null,
        a: null,
        rtg: null,
        rtc: null,
        ec: null,
        sp: null
    };
    instance.ctx = {
        _: instance
    };
    instance.root = parent ? parent.root : instance;
    instance.emit = $3bd355ce88b7fb93$var$emit.bind(null, instance);
    if (vnode.ce) vnode.ce(instance);
    return instance;
}
let $3bd355ce88b7fb93$var$currentInstance = null;
const $3bd355ce88b7fb93$export$f13e630aa3915748 = ()=>$3bd355ce88b7fb93$var$currentInstance || $3bd355ce88b7fb93$var$currentRenderingInstance;
let $3bd355ce88b7fb93$var$internalSetCurrentInstance;
let $3bd355ce88b7fb93$var$setInSSRSetupState;
{
    const g = (0, $Cr6yt.getGlobalThis)();
    const registerGlobalSetter = (key, setter)=>{
        let setters;
        if (!(setters = g[key])) setters = g[key] = [];
        setters.push(setter);
        return (v1)=>{
            if (setters.length > 1) setters.forEach((set)=>set(v1));
            else setters[0](v1);
        };
    };
    $3bd355ce88b7fb93$var$internalSetCurrentInstance = registerGlobalSetter(`__VUE_INSTANCE_SETTERS__`, (v1)=>$3bd355ce88b7fb93$var$currentInstance = v1);
    $3bd355ce88b7fb93$var$setInSSRSetupState = registerGlobalSetter(`__VUE_SSR_SETTERS__`, (v1)=>$3bd355ce88b7fb93$var$isInSSRComponentSetup = v1);
}const $3bd355ce88b7fb93$var$setCurrentInstance = (instance)=>{
    const prev = $3bd355ce88b7fb93$var$currentInstance;
    $3bd355ce88b7fb93$var$internalSetCurrentInstance(instance);
    instance.scope.on();
    return ()=>{
        instance.scope.off();
        $3bd355ce88b7fb93$var$internalSetCurrentInstance(prev);
    };
};
const $3bd355ce88b7fb93$var$unsetCurrentInstance = ()=>{
    $3bd355ce88b7fb93$var$currentInstance && $3bd355ce88b7fb93$var$currentInstance.scope.off();
    $3bd355ce88b7fb93$var$internalSetCurrentInstance(null);
};
const $3bd355ce88b7fb93$var$isBuiltInTag = /* @__PURE__ */ (0, $Cr6yt.makeMap)("slot,component");
function $3bd355ce88b7fb93$var$validateComponentName(name, { isNativeTag: isNativeTag }) {
    if ($3bd355ce88b7fb93$var$isBuiltInTag(name) || isNativeTag(name)) $3bd355ce88b7fb93$var$warn$1("Do not use built-in or reserved HTML elements as component id: " + name);
}
function $3bd355ce88b7fb93$var$isStatefulComponent(instance) {
    return instance.vnode.shapeFlag & 4;
}
let $3bd355ce88b7fb93$var$isInSSRComponentSetup = false;
function $3bd355ce88b7fb93$var$setupComponent(instance, isSSR = false, optimized = false) {
    isSSR && $3bd355ce88b7fb93$var$setInSSRSetupState(isSSR);
    const { props: props, children: children } = instance.vnode;
    const isStateful = $3bd355ce88b7fb93$var$isStatefulComponent(instance);
    $3bd355ce88b7fb93$var$initProps(instance, props, isStateful, isSSR);
    $3bd355ce88b7fb93$var$initSlots(instance, children, optimized || isSSR);
    const setupResult = isStateful ? $3bd355ce88b7fb93$var$setupStatefulComponent(instance, isSSR) : void 0;
    isSSR && $3bd355ce88b7fb93$var$setInSSRSetupState(false);
    return setupResult;
}
function $3bd355ce88b7fb93$var$setupStatefulComponent(instance, isSSR) {
    var _a;
    const Component = instance.type;
    instance.accessCache = /* @__PURE__ */ Object.create(null);
    instance.proxy = new Proxy(instance.ctx, $3bd355ce88b7fb93$var$PublicInstanceProxyHandlers);
    const { setup: setup } = Component;
    if (setup) {
        (0, $2eFsq.pauseTracking)();
        const setupContext = instance.setupContext = setup.length > 1 ? $3bd355ce88b7fb93$var$createSetupContext(instance) : null;
        const reset = $3bd355ce88b7fb93$var$setCurrentInstance(instance);
        const setupResult = $3bd355ce88b7fb93$export$b22fcaf88446e9bf(setup, instance, 0, [
            (0, instance.props),
            setupContext
        ]);
        const isAsyncSetup = (0, $Cr6yt.isPromise)(setupResult);
        (0, $2eFsq.resetTracking)();
        reset();
        if ((isAsyncSetup || instance.sp) && !$3bd355ce88b7fb93$var$isAsyncWrapper(instance)) $3bd355ce88b7fb93$var$markAsyncBoundary(instance);
        if (isAsyncSetup) {
            setupResult.then($3bd355ce88b7fb93$var$unsetCurrentInstance, $3bd355ce88b7fb93$var$unsetCurrentInstance);
            if (isSSR) return setupResult.then((resolvedResult)=>{
                $3bd355ce88b7fb93$var$handleSetupResult(instance, resolvedResult, isSSR);
            }).catch((e)=>{
                $3bd355ce88b7fb93$export$d3da1ecaf1206c58(e, instance, 0);
            });
            else instance.asyncDep = setupResult;
        } else $3bd355ce88b7fb93$var$handleSetupResult(instance, setupResult, isSSR);
    } else $3bd355ce88b7fb93$var$finishComponentSetup(instance, isSSR);
}
function $3bd355ce88b7fb93$var$handleSetupResult(instance, setupResult, isSSR) {
    if ((0, $Cr6yt.isFunction)(setupResult)) {
        if (instance.type.__ssrInlineRender) instance.ssrRender = setupResult;
        else instance.render = setupResult;
    } else if ((0, $Cr6yt.isObject)(setupResult)) {
        if (__VUE_PROD_DEVTOOLS__) instance.devtoolsRawSetupState = setupResult;
        instance.setupState = (0, $2eFsq.proxyRefs)(setupResult);
    }
    $3bd355ce88b7fb93$var$finishComponentSetup(instance, isSSR);
}
let $3bd355ce88b7fb93$var$compile;
let $3bd355ce88b7fb93$var$installWithProxy;
function $3bd355ce88b7fb93$export$667bb5a67822b941(_compile) {
    $3bd355ce88b7fb93$var$compile = _compile;
    $3bd355ce88b7fb93$var$installWithProxy = (i)=>{
        if (i.render._rc) i.withProxy = new Proxy(i.ctx, $3bd355ce88b7fb93$var$RuntimeCompiledPublicInstanceProxyHandlers);
    };
}
const $3bd355ce88b7fb93$export$c93a9c496c5211fa = ()=>!$3bd355ce88b7fb93$var$compile;
function $3bd355ce88b7fb93$var$finishComponentSetup(instance, isSSR, skipOptions) {
    const Component = instance.type;
    if (!instance.render) {
        if (!isSSR && $3bd355ce88b7fb93$var$compile && !Component.render) {
            const template = Component.template || __VUE_OPTIONS_API__ && $3bd355ce88b7fb93$var$resolveMergedOptions(instance).template;
            if (template) {
                const { isCustomElement: isCustomElement, compilerOptions: compilerOptions } = instance.appContext.config;
                const { delimiters: delimiters, compilerOptions: componentCompilerOptions } = Component;
                const finalCompilerOptions = (0, $Cr6yt.extend)((0, $Cr6yt.extend)({
                    isCustomElement: isCustomElement,
                    delimiters: delimiters
                }, compilerOptions), componentCompilerOptions);
                Component.render = $3bd355ce88b7fb93$var$compile(template, finalCompilerOptions);
            }
        }
        instance.render = Component.render || (0, $Cr6yt.NOOP);
        if ($3bd355ce88b7fb93$var$installWithProxy) $3bd355ce88b7fb93$var$installWithProxy(instance);
    }
    if (__VUE_OPTIONS_API__ && true) {
        const reset = $3bd355ce88b7fb93$var$setCurrentInstance(instance);
        (0, $2eFsq.pauseTracking)();
        try {
            $3bd355ce88b7fb93$var$applyOptions(instance);
        } finally{
            (0, $2eFsq.resetTracking)();
            reset();
        }
    }
}
const $3bd355ce88b7fb93$var$attrsProxyHandlers = {
    get (target, key) {
        (0, $2eFsq.track)(target, "get", "");
        return target[key];
    }
};
function $3bd355ce88b7fb93$var$getSlotsProxy(instance) {
    return new Proxy(instance.slots, {
        get (target, key) {
            (0, $2eFsq.track)(instance, "get", "$slots");
            return target[key];
        }
    });
}
function $3bd355ce88b7fb93$var$createSetupContext(instance) {
    const expose = (exposed)=>{
        instance.exposed = exposed || {};
    };
    var event, args;
    return {
        attrs: new Proxy(instance.attrs, $3bd355ce88b7fb93$var$attrsProxyHandlers),
        slots: instance.slots,
        emit: instance.emit,
        expose: expose
    };
}
function $3bd355ce88b7fb93$var$getComponentPublicInstance(instance) {
    if (instance.exposed) return instance.exposeProxy || (instance.exposeProxy = new Proxy((0, $2eFsq.proxyRefs)((0, $2eFsq.markRaw)(instance.exposed)), {
        get (target, key) {
            if (key in target) return target[key];
            else if (key in $3bd355ce88b7fb93$var$publicPropertiesMap) return $3bd355ce88b7fb93$var$publicPropertiesMap[key](instance);
        },
        has (target, key) {
            return key in target || key in $3bd355ce88b7fb93$var$publicPropertiesMap;
        }
    }));
    else return instance.proxy;
}
const $3bd355ce88b7fb93$var$classifyRE = /(?:^|[-_])(\w)/g;
const $3bd355ce88b7fb93$var$classify = (str)=>str.replace($3bd355ce88b7fb93$var$classifyRE, (c)=>c.toUpperCase()).replace(/[-_]/g, "");
function $3bd355ce88b7fb93$var$getComponentName(Component, includeInferred = true) {
    return (0, $Cr6yt.isFunction)(Component) ? Component.displayName || Component.name : Component.name || includeInferred && Component.__name;
}
function $3bd355ce88b7fb93$var$formatComponentName(instance, Component, isRoot = false) {
    let name = $3bd355ce88b7fb93$var$getComponentName(Component);
    if (!name && Component.__file) {
        const match = Component.__file.match(/([^/\\]+)\.\w+$/);
        if (match) name = match[1];
    }
    if (!name && instance && instance.parent) {
        const inferFromRegistry = (registry)=>{
            for(const key in registry){
                if (registry[key] === Component) return key;
            }
        };
        name = inferFromRegistry(instance.components || instance.parent.type.components) || inferFromRegistry(instance.appContext.components);
    }
    return name ? $3bd355ce88b7fb93$var$classify(name) : isRoot ? `App` : `Anonymous`;
}
function $3bd355ce88b7fb93$var$isClassComponent(value) {
    return (0, $Cr6yt.isFunction)(value) && "__vccOpts" in value;
}
const $3bd355ce88b7fb93$export$2983e091f1a1e8e2 = (getterOrOptions, debugOptions)=>{
    const c = (0, $2eFsq.computed)(getterOrOptions, debugOptions, $3bd355ce88b7fb93$var$isInSSRComponentSetup);
    return c;
};
function $3bd355ce88b7fb93$export$dda1d9f60106f0e9(type, propsOrChildren, children) {
    const l = arguments.length;
    if (l === 2) {
        if ((0, $Cr6yt.isObject)(propsOrChildren) && !(0, $Cr6yt.isArray)(propsOrChildren)) {
            if ($3bd355ce88b7fb93$export$3868d13f8734ae81(propsOrChildren)) return $3bd355ce88b7fb93$export$bf5c4cf060303d58(type, null, [
                propsOrChildren
            ]);
            return $3bd355ce88b7fb93$export$bf5c4cf060303d58(type, propsOrChildren);
        } else return $3bd355ce88b7fb93$export$bf5c4cf060303d58(type, null, propsOrChildren);
    } else {
        if (l > 3) children = Array.prototype.slice.call(arguments, 2);
        else if (l === 3 && $3bd355ce88b7fb93$export$3868d13f8734ae81(children)) children = [
            children
        ];
        return $3bd355ce88b7fb93$export$bf5c4cf060303d58(type, propsOrChildren, children);
    }
}
function $3bd355ce88b7fb93$export$aed4979be6a60047() {
    return;
    function formatInstance(instance) {
        const blocks = [];
        if (instance.type.props && instance.props) blocks.push(createInstanceBlock("props", (0, $2eFsq.toRaw)(instance.props)));
        if (instance.setupState !== (0, $Cr6yt.EMPTY_OBJ)) blocks.push(createInstanceBlock("setup", instance.setupState));
        if (instance.data !== (0, $Cr6yt.EMPTY_OBJ)) blocks.push(createInstanceBlock("data", (0, $2eFsq.toRaw)(instance.data)));
        const computed = extractKeys(instance, "computed");
        if (computed) blocks.push(createInstanceBlock("computed", computed));
        const injected = extractKeys(instance, "inject");
        if (injected) blocks.push(createInstanceBlock("injected", injected));
        blocks.push([
            "div",
            {},
            [
                "span",
                {
                    style: keywordStyle.style + ";opacity:0.66"
                },
                "$ (internal): "
            ],
            [
                "object",
                {
                    object: instance
                }
            ]
        ]);
        return blocks;
    }
    function createInstanceBlock(type, target) {
        target = (0, $Cr6yt.extend)({}, target);
        if (!Object.keys(target).length) return [
            "span",
            {}
        ];
        return [
            "div",
            {
                style: "line-height:1.25em;margin-bottom:0.6em"
            },
            [
                "div",
                {
                    style: "color:#476582"
                },
                type
            ],
            [
                "div",
                {
                    style: "padding-left:1.25em"
                },
                ...Object.keys(target).map((key)=>{
                    return [
                        "div",
                        {},
                        [
                            "span",
                            keywordStyle,
                            key + ": "
                        ],
                        formatValue(target[key], false)
                    ];
                })
            ]
        ];
    }
    function formatValue(v1, asRaw = true) {
        if (typeof v1 === "number") return [
            "span",
            numberStyle,
            v1
        ];
        else if (typeof v1 === "string") return [
            "span",
            stringStyle,
            JSON.stringify(v1)
        ];
        else if (typeof v1 === "boolean") return [
            "span",
            keywordStyle,
            v1
        ];
        else if ((0, $Cr6yt.isObject)(v1)) return [
            "object",
            {
                object: asRaw ? (0, $2eFsq.toRaw)(v1) : v1
            }
        ];
        else return [
            "span",
            stringStyle,
            String(v1)
        ];
    }
    function extractKeys(instance, type) {
        const Comp = instance.type;
        if ((0, $Cr6yt.isFunction)(Comp)) return;
        const extracted = {};
        for(const key in instance.ctx)if (isKeyOfType(Comp, key, type)) extracted[key] = instance.ctx[key];
        return extracted;
    }
    function isKeyOfType(Comp, key, type) {
        const opts = Comp[type];
        if ((0, $Cr6yt.isArray)(opts) && opts.includes(key) || (0, $Cr6yt.isObject)(opts) && key in opts) return true;
        if (Comp.extends && isKeyOfType(Comp.extends, key, type)) return true;
        if (Comp.mixins && Comp.mixins.some((m)=>isKeyOfType(m, key, type))) return true;
    }
    function genRefFlag(v1) {
        if ((0, $2eFsq.isShallow)(v1)) return `ShallowRef`;
        if (v1.effect) return `ComputedRef`;
        return `Ref`;
    }
}
function $3bd355ce88b7fb93$export$2a6d714a4d738ae(memo, render, cache, index) {
    const cached = cache[index];
    if (cached && $3bd355ce88b7fb93$export$bf525184d622787c(cached, memo)) return cached;
    const ret = render();
    ret.memo = memo.slice();
    ret.cacheIndex = index;
    return cache[index] = ret;
}
function $3bd355ce88b7fb93$export$bf525184d622787c(cached, memo) {
    const prev = cached.memo;
    if (prev.length != memo.length) return false;
    for(let i = 0; i < prev.length; i++){
        if ((0, $Cr6yt.hasChanged)(prev[i], memo[i])) return false;
    }
    if ($3bd355ce88b7fb93$var$isBlockTreeEnabled > 0 && $3bd355ce88b7fb93$var$currentBlock) $3bd355ce88b7fb93$var$currentBlock.push(cached);
    return true;
}
const $3bd355ce88b7fb93$export$83d89fbfd8236492 = "3.5.14";
const $3bd355ce88b7fb93$export$c106dd0671a0fc2d = (0, $Cr6yt.NOOP);
const $3bd355ce88b7fb93$export$795e0ad4a0e2ed30 = $3bd355ce88b7fb93$var$ErrorTypeStrings$1;
const $3bd355ce88b7fb93$export$6922d3b3a607469e = $3bd355ce88b7fb93$var$devtools$1;
const $3bd355ce88b7fb93$export$b0c258b32c26c785 = $3bd355ce88b7fb93$var$setDevtoolsHook$1;
const $3bd355ce88b7fb93$var$_ssrUtils = {
    createComponentInstance: $3bd355ce88b7fb93$var$createComponentInstance,
    setupComponent: $3bd355ce88b7fb93$var$setupComponent,
    renderComponentRoot: $3bd355ce88b7fb93$var$renderComponentRoot,
    setCurrentRenderingInstance: $3bd355ce88b7fb93$var$setCurrentRenderingInstance,
    isVNode: $3bd355ce88b7fb93$export$3868d13f8734ae81,
    normalizeVNode: $3bd355ce88b7fb93$var$normalizeVNode,
    getComponentPublicInstance: $3bd355ce88b7fb93$var$getComponentPublicInstance,
    ensureValidVNode: $3bd355ce88b7fb93$var$ensureValidVNode,
    pushWarningContext: $3bd355ce88b7fb93$var$pushWarningContext,
    popWarningContext: $3bd355ce88b7fb93$var$popWarningContext
};
const $3bd355ce88b7fb93$export$a9679033567b336d = $3bd355ce88b7fb93$var$_ssrUtils;
const $3bd355ce88b7fb93$export$83cf26e06ea620e1 = null;
const $3bd355ce88b7fb93$export$dc678eddf276286e = null;
const $3bd355ce88b7fb93$export$22072a82865312f6 = null;

});
parcelRegister("2eFsq", function(module, exports) {

$parcel$export(module.exports, "EffectScope", () => $1a0d0c254c7e05ef$export$1168ed9dbc71ddbd);
$parcel$export(module.exports, "ReactiveEffect", () => $1a0d0c254c7e05ef$export$28352bb4dd362521);
$parcel$export(module.exports, "pauseTracking", () => $1a0d0c254c7e05ef$export$938a971395fef855);
$parcel$export(module.exports, "resetTracking", () => $1a0d0c254c7e05ef$export$c39176b1babaa8b8);
$parcel$export(module.exports, "track", () => $1a0d0c254c7e05ef$export$6b2a7d5132615086);
$parcel$export(module.exports, "trigger", () => $1a0d0c254c7e05ef$export$e614dc9140f7ae71);
$parcel$export(module.exports, "toRaw", () => $1a0d0c254c7e05ef$export$ab18938b9fc5f28e);
$parcel$export(module.exports, "isShallow", () => $1a0d0c254c7e05ef$export$7f3fe6025abfa26e);
$parcel$export(module.exports, "toReactive", () => $1a0d0c254c7e05ef$export$45c769cf449a508c);
$parcel$export(module.exports, "shallowReadArray", () => $1a0d0c254c7e05ef$export$5eb48af14254449e);
$parcel$export(module.exports, "isProxy", () => $1a0d0c254c7e05ef$export$5f3ca29d057519b3);
$parcel$export(module.exports, "isRef", () => $1a0d0c254c7e05ef$export$4f9f5282de18fc69);
$parcel$export(module.exports, "reactive", () => $1a0d0c254c7e05ef$export$90a44edba14e47be);
$parcel$export(module.exports, "isReadonly", () => $1a0d0c254c7e05ef$export$92d09b48637741e7);
$parcel$export(module.exports, "toReadonly", () => $1a0d0c254c7e05ef$export$4a78e7a2a4fb689f);
$parcel$export(module.exports, "shallowReactive", () => $1a0d0c254c7e05ef$export$8d81cefd22d22260);
$parcel$export(module.exports, "isReactive", () => $1a0d0c254c7e05ef$export$352205f445242f02);
$parcel$export(module.exports, "markRaw", () => $1a0d0c254c7e05ef$export$995ab8b13ad7a9d0);
$parcel$export(module.exports, "ref", () => $1a0d0c254c7e05ef$export$eff4d24c3ff7876e);
$parcel$export(module.exports, "shallowRef", () => $1a0d0c254c7e05ef$export$9b7bc5fe3b17c8b3);
$parcel$export(module.exports, "unref", () => $1a0d0c254c7e05ef$export$a239a76781616204);
$parcel$export(module.exports, "proxyRefs", () => $1a0d0c254c7e05ef$export$f353fd1b97db3fa0);
$parcel$export(module.exports, "customRef", () => $1a0d0c254c7e05ef$export$a20c2dd6199824cb);
$parcel$export(module.exports, "computed", () => $1a0d0c254c7e05ef$export$2983e091f1a1e8e2);
$parcel$export(module.exports, "watch", () => $1a0d0c254c7e05ef$export$3db5d71bdb2d5499);
$parcel$export(module.exports, "traverse", () => $1a0d0c254c7e05ef$export$df3f009e3d155b20);
/**
* @vue/reactivity v3.5.14
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $Cr6yt = parcelRequire("Cr6yt");
function $1a0d0c254c7e05ef$var$warn(msg, ...args) {
    console.warn(`[Vue warn] ${msg}`, ...args);
}
let $1a0d0c254c7e05ef$var$activeEffectScope;
class $1a0d0c254c7e05ef$export$1168ed9dbc71ddbd {
    constructor(detached = false){
        this.detached = detached;
        /**
     * @internal
     */ this._active = true;
        /**
     * @internal track `on` calls, allow `on` call multiple times
     */ this._on = 0;
        /**
     * @internal
     */ this.effects = [];
        /**
     * @internal
     */ this.cleanups = [];
        this._isPaused = false;
        this.parent = $1a0d0c254c7e05ef$var$activeEffectScope;
        if (!detached && $1a0d0c254c7e05ef$var$activeEffectScope) this.index = ($1a0d0c254c7e05ef$var$activeEffectScope.scopes || ($1a0d0c254c7e05ef$var$activeEffectScope.scopes = [])).push(this) - 1;
    }
    get active() {
        return this._active;
    }
    pause() {
        if (this._active) {
            this._isPaused = true;
            let i, l;
            if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].pause();
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].pause();
        }
    }
    /**
   * Resumes the effect scope, including all child scopes and effects.
   */ resume() {
        if (this._active) {
            if (this._isPaused) {
                this._isPaused = false;
                let i, l;
                if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].resume();
                for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].resume();
            }
        }
    }
    run(fn) {
        if (this._active) {
            const currentEffectScope = $1a0d0c254c7e05ef$var$activeEffectScope;
            try {
                $1a0d0c254c7e05ef$var$activeEffectScope = this;
                return fn();
            } finally{
                $1a0d0c254c7e05ef$var$activeEffectScope = currentEffectScope;
            }
        }
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ on() {
        if (++this._on === 1) {
            this.prevScope = $1a0d0c254c7e05ef$var$activeEffectScope;
            $1a0d0c254c7e05ef$var$activeEffectScope = this;
        }
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ off() {
        if (this._on > 0 && --this._on === 0) {
            $1a0d0c254c7e05ef$var$activeEffectScope = this.prevScope;
            this.prevScope = void 0;
        }
    }
    stop(fromParent) {
        if (this._active) {
            this._active = false;
            let i, l;
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].stop();
            this.effects.length = 0;
            for(i = 0, l = this.cleanups.length; i < l; i++)this.cleanups[i]();
            this.cleanups.length = 0;
            if (this.scopes) {
                for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].stop(true);
                this.scopes.length = 0;
            }
            if (!this.detached && this.parent && !fromParent) {
                const last = this.parent.scopes.pop();
                if (last && last !== this) {
                    this.parent.scopes[this.index] = last;
                    last.index = this.index;
                }
            }
            this.parent = void 0;
        }
    }
}
function $1a0d0c254c7e05ef$export$7056603ea81600be(detached) {
    return new $1a0d0c254c7e05ef$export$1168ed9dbc71ddbd(detached);
}
function $1a0d0c254c7e05ef$export$c7be4b0125a10cba() {
    return $1a0d0c254c7e05ef$var$activeEffectScope;
}
function $1a0d0c254c7e05ef$export$a780418acd4762da(fn, failSilently = false) {
    if ($1a0d0c254c7e05ef$var$activeEffectScope) $1a0d0c254c7e05ef$var$activeEffectScope.cleanups.push(fn);
}
let $1a0d0c254c7e05ef$var$activeSub;
const $1a0d0c254c7e05ef$export$37ee493b2f34ee54 = {
    "ACTIVE": 1,
    "1": "ACTIVE",
    "RUNNING": 2,
    "2": "RUNNING",
    "TRACKING": 4,
    "4": "TRACKING",
    "NOTIFIED": 8,
    "8": "NOTIFIED",
    "DIRTY": 16,
    "16": "DIRTY",
    "ALLOW_RECURSE": 32,
    "32": "ALLOW_RECURSE",
    "PAUSED": 64,
    "64": "PAUSED",
    "EVALUATED": 128,
    "128": "EVALUATED"
};
const $1a0d0c254c7e05ef$var$pausedQueueEffects = /* @__PURE__ */ new WeakSet();
class $1a0d0c254c7e05ef$export$28352bb4dd362521 {
    constructor(fn){
        this.fn = fn;
        /**
     * @internal
     */ this.deps = void 0;
        /**
     * @internal
     */ this.depsTail = void 0;
        /**
     * @internal
     */ this.flags = 5;
        /**
     * @internal
     */ this.next = void 0;
        /**
     * @internal
     */ this.cleanup = void 0;
        this.scheduler = void 0;
        if ($1a0d0c254c7e05ef$var$activeEffectScope && $1a0d0c254c7e05ef$var$activeEffectScope.active) $1a0d0c254c7e05ef$var$activeEffectScope.effects.push(this);
    }
    pause() {
        this.flags |= 64;
    }
    resume() {
        if (this.flags & 64) {
            this.flags &= -65;
            if ($1a0d0c254c7e05ef$var$pausedQueueEffects.has(this)) {
                $1a0d0c254c7e05ef$var$pausedQueueEffects.delete(this);
                this.trigger();
            }
        }
    }
    /**
   * @internal
   */ notify() {
        if (this.flags & 2 && !(this.flags & 32)) return;
        if (!(this.flags & 8)) $1a0d0c254c7e05ef$var$batch(this);
    }
    run() {
        if (!(this.flags & 1)) return this.fn();
        this.flags |= 2;
        $1a0d0c254c7e05ef$var$cleanupEffect(this);
        $1a0d0c254c7e05ef$var$prepareDeps(this);
        const prevEffect = $1a0d0c254c7e05ef$var$activeSub;
        const prevShouldTrack = $1a0d0c254c7e05ef$var$shouldTrack;
        $1a0d0c254c7e05ef$var$activeSub = this;
        $1a0d0c254c7e05ef$var$shouldTrack = true;
        try {
            return this.fn();
        } finally{
            $1a0d0c254c7e05ef$var$cleanupDeps(this);
            $1a0d0c254c7e05ef$var$activeSub = prevEffect;
            $1a0d0c254c7e05ef$var$shouldTrack = prevShouldTrack;
            this.flags &= -3;
        }
    }
    stop() {
        if (this.flags & 1) {
            for(let link = this.deps; link; link = link.nextDep)$1a0d0c254c7e05ef$var$removeSub(link);
            this.deps = this.depsTail = void 0;
            $1a0d0c254c7e05ef$var$cleanupEffect(this);
            this.onStop && this.onStop();
            this.flags &= -2;
        }
    }
    trigger() {
        if (this.flags & 64) $1a0d0c254c7e05ef$var$pausedQueueEffects.add(this);
        else if (this.scheduler) this.scheduler();
        else this.runIfDirty();
    }
    /**
   * @internal
   */ runIfDirty() {
        if ($1a0d0c254c7e05ef$var$isDirty(this)) this.run();
    }
    get dirty() {
        return $1a0d0c254c7e05ef$var$isDirty(this);
    }
}
let $1a0d0c254c7e05ef$var$batchDepth = 0;
let $1a0d0c254c7e05ef$var$batchedSub;
let $1a0d0c254c7e05ef$var$batchedComputed;
function $1a0d0c254c7e05ef$var$batch(sub, isComputed = false) {
    sub.flags |= 8;
    if (isComputed) {
        sub.next = $1a0d0c254c7e05ef$var$batchedComputed;
        $1a0d0c254c7e05ef$var$batchedComputed = sub;
        return;
    }
    sub.next = $1a0d0c254c7e05ef$var$batchedSub;
    $1a0d0c254c7e05ef$var$batchedSub = sub;
}
function $1a0d0c254c7e05ef$var$startBatch() {
    $1a0d0c254c7e05ef$var$batchDepth++;
}
function $1a0d0c254c7e05ef$var$endBatch() {
    if (--$1a0d0c254c7e05ef$var$batchDepth > 0) return;
    if ($1a0d0c254c7e05ef$var$batchedComputed) {
        let e = $1a0d0c254c7e05ef$var$batchedComputed;
        $1a0d0c254c7e05ef$var$batchedComputed = void 0;
        while(e){
            const next = e.next;
            e.next = void 0;
            e.flags &= -9;
            e = next;
        }
    }
    let error;
    while($1a0d0c254c7e05ef$var$batchedSub){
        let e = $1a0d0c254c7e05ef$var$batchedSub;
        $1a0d0c254c7e05ef$var$batchedSub = void 0;
        while(e){
            const next = e.next;
            e.next = void 0;
            e.flags &= -9;
            if (e.flags & 1) try {
                e.trigger();
            } catch (err) {
                if (!error) error = err;
            }
            e = next;
        }
    }
    if (error) throw error;
}
function $1a0d0c254c7e05ef$var$prepareDeps(sub) {
    for(let link = sub.deps; link; link = link.nextDep){
        link.version = -1;
        link.prevActiveLink = link.dep.activeLink;
        link.dep.activeLink = link;
    }
}
function $1a0d0c254c7e05ef$var$cleanupDeps(sub) {
    let head;
    let tail = sub.depsTail;
    let link = tail;
    while(link){
        const prev = link.prevDep;
        if (link.version === -1) {
            if (link === tail) tail = prev;
            $1a0d0c254c7e05ef$var$removeSub(link);
            $1a0d0c254c7e05ef$var$removeDep(link);
        } else head = link;
        link.dep.activeLink = link.prevActiveLink;
        link.prevActiveLink = void 0;
        link = prev;
    }
    sub.deps = head;
    sub.depsTail = tail;
}
function $1a0d0c254c7e05ef$var$isDirty(sub) {
    for(let link = sub.deps; link; link = link.nextDep){
        if (link.dep.version !== link.version || link.dep.computed && ($1a0d0c254c7e05ef$var$refreshComputed(link.dep.computed) || link.dep.version !== link.version)) return true;
    }
    if (sub._dirty) return true;
    return false;
}
function $1a0d0c254c7e05ef$var$refreshComputed(computed) {
    if (computed.flags & 4 && !(computed.flags & 16)) return;
    computed.flags &= -17;
    if (computed.globalVersion === $1a0d0c254c7e05ef$var$globalVersion) return;
    computed.globalVersion = $1a0d0c254c7e05ef$var$globalVersion;
    if (!computed.isSSR && computed.flags & 128 && (!computed.deps && !computed._dirty || !$1a0d0c254c7e05ef$var$isDirty(computed))) return;
    computed.flags |= 2;
    const dep = computed.dep;
    const prevSub = $1a0d0c254c7e05ef$var$activeSub;
    const prevShouldTrack = $1a0d0c254c7e05ef$var$shouldTrack;
    $1a0d0c254c7e05ef$var$activeSub = computed;
    $1a0d0c254c7e05ef$var$shouldTrack = true;
    try {
        $1a0d0c254c7e05ef$var$prepareDeps(computed);
        const value = computed.fn(computed._value);
        if (dep.version === 0 || (0, $Cr6yt.hasChanged)(value, computed._value)) {
            computed.flags |= 128;
            computed._value = value;
            dep.version++;
        }
    } catch (err) {
        dep.version++;
        throw err;
    } finally{
        $1a0d0c254c7e05ef$var$activeSub = prevSub;
        $1a0d0c254c7e05ef$var$shouldTrack = prevShouldTrack;
        $1a0d0c254c7e05ef$var$cleanupDeps(computed);
        computed.flags &= -3;
    }
}
function $1a0d0c254c7e05ef$var$removeSub(link, soft = false) {
    const { dep: dep, prevSub: prevSub, nextSub: nextSub } = link;
    if (prevSub) {
        prevSub.nextSub = nextSub;
        link.prevSub = void 0;
    }
    if (nextSub) {
        nextSub.prevSub = prevSub;
        link.nextSub = void 0;
    }
    if (dep.subs === link) {
        dep.subs = prevSub;
        if (!prevSub && dep.computed) {
            dep.computed.flags &= -5;
            for(let l = dep.computed.deps; l; l = l.nextDep)$1a0d0c254c7e05ef$var$removeSub(l, true);
        }
    }
    if (!soft && !--dep.sc && dep.map) dep.map.delete(dep.key);
}
function $1a0d0c254c7e05ef$var$removeDep(link) {
    const { prevDep: prevDep, nextDep: nextDep } = link;
    if (prevDep) {
        prevDep.nextDep = nextDep;
        link.prevDep = void 0;
    }
    if (nextDep) {
        nextDep.prevDep = prevDep;
        link.nextDep = void 0;
    }
}
function $1a0d0c254c7e05ef$export$dc573d8a6576cdb3(fn, options) {
    if (fn.effect instanceof $1a0d0c254c7e05ef$export$28352bb4dd362521) fn = fn.effect.fn;
    const e = new $1a0d0c254c7e05ef$export$28352bb4dd362521(fn);
    if (options) (0, $Cr6yt.extend)(e, options);
    try {
        e.run();
    } catch (err) {
        e.stop();
        throw err;
    }
    const runner = e.run.bind(e);
    runner.effect = e;
    return runner;
}
function $1a0d0c254c7e05ef$export$fa6813432f753b0d(runner) {
    runner.effect.stop();
}
let $1a0d0c254c7e05ef$var$shouldTrack = true;
const $1a0d0c254c7e05ef$var$trackStack = [];
function $1a0d0c254c7e05ef$export$938a971395fef855() {
    $1a0d0c254c7e05ef$var$trackStack.push($1a0d0c254c7e05ef$var$shouldTrack);
    $1a0d0c254c7e05ef$var$shouldTrack = false;
}
function $1a0d0c254c7e05ef$export$1f8ffc6fd33b1d16() {
    $1a0d0c254c7e05ef$var$trackStack.push($1a0d0c254c7e05ef$var$shouldTrack);
    $1a0d0c254c7e05ef$var$shouldTrack = true;
}
function $1a0d0c254c7e05ef$export$c39176b1babaa8b8() {
    const last = $1a0d0c254c7e05ef$var$trackStack.pop();
    $1a0d0c254c7e05ef$var$shouldTrack = last === void 0 ? true : last;
}
function $1a0d0c254c7e05ef$export$92b6a62b33d94031(fn, failSilently = false) {
    if ($1a0d0c254c7e05ef$var$activeSub instanceof $1a0d0c254c7e05ef$export$28352bb4dd362521) $1a0d0c254c7e05ef$var$activeSub.cleanup = fn;
}
function $1a0d0c254c7e05ef$var$cleanupEffect(e) {
    const { cleanup: cleanup } = e;
    e.cleanup = void 0;
    if (cleanup) {
        const prevSub = $1a0d0c254c7e05ef$var$activeSub;
        $1a0d0c254c7e05ef$var$activeSub = void 0;
        try {
            cleanup();
        } finally{
            $1a0d0c254c7e05ef$var$activeSub = prevSub;
        }
    }
}
let $1a0d0c254c7e05ef$var$globalVersion = 0;
class $1a0d0c254c7e05ef$var$Link {
    constructor(sub, dep){
        this.sub = sub;
        this.dep = dep;
        this.version = dep.version;
        this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
    }
}
class $1a0d0c254c7e05ef$var$Dep {
    constructor(computed){
        this.computed = computed;
        this.version = 0;
        /**
     * Link between this dep and the current active effect
     */ this.activeLink = void 0;
        /**
     * Doubly linked list representing the subscribing effects (tail)
     */ this.subs = void 0;
        /**
     * For object property deps cleanup
     */ this.map = void 0;
        this.key = void 0;
        /**
     * Subscriber counter
     */ this.sc = 0;
    }
    track(debugInfo) {
        if (!$1a0d0c254c7e05ef$var$activeSub || !$1a0d0c254c7e05ef$var$shouldTrack || $1a0d0c254c7e05ef$var$activeSub === this.computed) return;
        let link = this.activeLink;
        if (link === void 0 || link.sub !== $1a0d0c254c7e05ef$var$activeSub) {
            link = this.activeLink = new $1a0d0c254c7e05ef$var$Link($1a0d0c254c7e05ef$var$activeSub, this);
            if (!$1a0d0c254c7e05ef$var$activeSub.deps) $1a0d0c254c7e05ef$var$activeSub.deps = $1a0d0c254c7e05ef$var$activeSub.depsTail = link;
            else {
                link.prevDep = $1a0d0c254c7e05ef$var$activeSub.depsTail;
                $1a0d0c254c7e05ef$var$activeSub.depsTail.nextDep = link;
                $1a0d0c254c7e05ef$var$activeSub.depsTail = link;
            }
            $1a0d0c254c7e05ef$var$addSub(link);
        } else if (link.version === -1) {
            link.version = this.version;
            if (link.nextDep) {
                const next = link.nextDep;
                next.prevDep = link.prevDep;
                if (link.prevDep) link.prevDep.nextDep = next;
                link.prevDep = $1a0d0c254c7e05ef$var$activeSub.depsTail;
                link.nextDep = void 0;
                $1a0d0c254c7e05ef$var$activeSub.depsTail.nextDep = link;
                $1a0d0c254c7e05ef$var$activeSub.depsTail = link;
                if ($1a0d0c254c7e05ef$var$activeSub.deps === link) $1a0d0c254c7e05ef$var$activeSub.deps = next;
            }
        }
        return link;
    }
    trigger(debugInfo) {
        this.version++;
        $1a0d0c254c7e05ef$var$globalVersion++;
        this.notify(debugInfo);
    }
    notify(debugInfo) {
        $1a0d0c254c7e05ef$var$startBatch();
        try {
            for(let link = this.subs; link; link = link.prevSub)if (link.sub.notify()) link.sub.dep.notify();
        } finally{
            $1a0d0c254c7e05ef$var$endBatch();
        }
    }
}
function $1a0d0c254c7e05ef$var$addSub(link) {
    link.dep.sc++;
    if (link.sub.flags & 4) {
        const computed = link.dep.computed;
        if (computed && !link.dep.subs) {
            computed.flags |= 20;
            for(let l = computed.deps; l; l = l.nextDep)$1a0d0c254c7e05ef$var$addSub(l);
        }
        const currentTail = link.dep.subs;
        if (currentTail !== link) {
            link.prevSub = currentTail;
            if (currentTail) currentTail.nextSub = link;
        }
        link.dep.subs = link;
    }
}
const $1a0d0c254c7e05ef$var$targetMap = /* @__PURE__ */ new WeakMap();
const $1a0d0c254c7e05ef$export$3c41b1a4e06acc14 = Symbol("");
const $1a0d0c254c7e05ef$export$49093fa1cddcb78d = Symbol("");
const $1a0d0c254c7e05ef$export$4f926f0baab682cd = Symbol("");
function $1a0d0c254c7e05ef$export$6b2a7d5132615086(target, type, key) {
    if ($1a0d0c254c7e05ef$var$shouldTrack && $1a0d0c254c7e05ef$var$activeSub) {
        let depsMap = $1a0d0c254c7e05ef$var$targetMap.get(target);
        if (!depsMap) $1a0d0c254c7e05ef$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
        let dep = depsMap.get(key);
        if (!dep) {
            depsMap.set(key, dep = new $1a0d0c254c7e05ef$var$Dep());
            dep.map = depsMap;
            dep.key = key;
        }
        dep.track();
    }
}
function $1a0d0c254c7e05ef$export$e614dc9140f7ae71(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $1a0d0c254c7e05ef$var$targetMap.get(target);
    if (!depsMap) {
        $1a0d0c254c7e05ef$var$globalVersion++;
        return;
    }
    const run = (dep)=>{
        if (dep) dep.trigger();
    };
    $1a0d0c254c7e05ef$var$startBatch();
    if (type === "clear") depsMap.forEach(run);
    else {
        const targetIsArray = (0, $Cr6yt.isArray)(target);
        const isArrayIndex = targetIsArray && (0, $Cr6yt.isIntegerKey)(key);
        if (targetIsArray && key === "length") {
            const newLength = Number(newValue);
            depsMap.forEach((dep, key2)=>{
                if (key2 === "length" || key2 === $1a0d0c254c7e05ef$export$4f926f0baab682cd || !(0, $Cr6yt.isSymbol)(key2) && key2 >= newLength) run(dep);
            });
        } else {
            if (key !== void 0 || depsMap.has(void 0)) run(depsMap.get(key));
            if (isArrayIndex) run(depsMap.get($1a0d0c254c7e05ef$export$4f926f0baab682cd));
            switch(type){
                case "add":
                    if (!targetIsArray) {
                        run(depsMap.get($1a0d0c254c7e05ef$export$3c41b1a4e06acc14));
                        if ((0, $Cr6yt.isMap)(target)) run(depsMap.get($1a0d0c254c7e05ef$export$49093fa1cddcb78d));
                    } else if (isArrayIndex) run(depsMap.get("length"));
                    break;
                case "delete":
                    if (!targetIsArray) {
                        run(depsMap.get($1a0d0c254c7e05ef$export$3c41b1a4e06acc14));
                        if ((0, $Cr6yt.isMap)(target)) run(depsMap.get($1a0d0c254c7e05ef$export$49093fa1cddcb78d));
                    }
                    break;
                case "set":
                    if ((0, $Cr6yt.isMap)(target)) run(depsMap.get($1a0d0c254c7e05ef$export$3c41b1a4e06acc14));
                    break;
            }
        }
    }
    $1a0d0c254c7e05ef$var$endBatch();
}
function $1a0d0c254c7e05ef$var$getDepFromReactive(object, key) {
    const depMap = $1a0d0c254c7e05ef$var$targetMap.get(object);
    return depMap && depMap.get(key);
}
function $1a0d0c254c7e05ef$export$1544eab4943788e4(array) {
    const raw = $1a0d0c254c7e05ef$export$ab18938b9fc5f28e(array);
    if (raw === array) return raw;
    $1a0d0c254c7e05ef$export$6b2a7d5132615086(raw, "iterate", $1a0d0c254c7e05ef$export$4f926f0baab682cd);
    return $1a0d0c254c7e05ef$export$7f3fe6025abfa26e(array) ? raw : raw.map($1a0d0c254c7e05ef$export$45c769cf449a508c);
}
function $1a0d0c254c7e05ef$export$5eb48af14254449e(arr) {
    $1a0d0c254c7e05ef$export$6b2a7d5132615086(arr = $1a0d0c254c7e05ef$export$ab18938b9fc5f28e(arr), "iterate", $1a0d0c254c7e05ef$export$4f926f0baab682cd);
    return arr;
}
const $1a0d0c254c7e05ef$var$arrayInstrumentations = {
    __proto__: null,
    [Symbol.iterator] () {
        return $1a0d0c254c7e05ef$var$iterator(this, Symbol.iterator, $1a0d0c254c7e05ef$export$45c769cf449a508c);
    },
    concat (...args) {
        return $1a0d0c254c7e05ef$export$1544eab4943788e4(this).concat(...args.map((x)=>(0, $Cr6yt.isArray)(x) ? $1a0d0c254c7e05ef$export$1544eab4943788e4(x) : x));
    },
    entries () {
        return $1a0d0c254c7e05ef$var$iterator(this, "entries", (value)=>{
            value[1] = $1a0d0c254c7e05ef$export$45c769cf449a508c(value[1]);
            return value;
        });
    },
    every (fn, thisArg) {
        return $1a0d0c254c7e05ef$var$apply(this, "every", fn, thisArg, void 0, arguments);
    },
    filter (fn, thisArg) {
        return $1a0d0c254c7e05ef$var$apply(this, "filter", fn, thisArg, (v)=>v.map($1a0d0c254c7e05ef$export$45c769cf449a508c), arguments);
    },
    find (fn, thisArg) {
        return $1a0d0c254c7e05ef$var$apply(this, "find", fn, thisArg, $1a0d0c254c7e05ef$export$45c769cf449a508c, arguments);
    },
    findIndex (fn, thisArg) {
        return $1a0d0c254c7e05ef$var$apply(this, "findIndex", fn, thisArg, void 0, arguments);
    },
    findLast (fn, thisArg) {
        return $1a0d0c254c7e05ef$var$apply(this, "findLast", fn, thisArg, $1a0d0c254c7e05ef$export$45c769cf449a508c, arguments);
    },
    findLastIndex (fn, thisArg) {
        return $1a0d0c254c7e05ef$var$apply(this, "findLastIndex", fn, thisArg, void 0, arguments);
    },
    // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
    forEach (fn, thisArg) {
        return $1a0d0c254c7e05ef$var$apply(this, "forEach", fn, thisArg, void 0, arguments);
    },
    includes (...args) {
        return $1a0d0c254c7e05ef$var$searchProxy(this, "includes", args);
    },
    indexOf (...args) {
        return $1a0d0c254c7e05ef$var$searchProxy(this, "indexOf", args);
    },
    join (separator) {
        return $1a0d0c254c7e05ef$export$1544eab4943788e4(this).join(separator);
    },
    // keys() iterator only reads `length`, no optimisation required
    lastIndexOf (...args) {
        return $1a0d0c254c7e05ef$var$searchProxy(this, "lastIndexOf", args);
    },
    map (fn, thisArg) {
        return $1a0d0c254c7e05ef$var$apply(this, "map", fn, thisArg, void 0, arguments);
    },
    pop () {
        return $1a0d0c254c7e05ef$var$noTracking(this, "pop");
    },
    push (...args) {
        return $1a0d0c254c7e05ef$var$noTracking(this, "push", args);
    },
    reduce (fn, ...args) {
        return $1a0d0c254c7e05ef$var$reduce(this, "reduce", fn, args);
    },
    reduceRight (fn, ...args) {
        return $1a0d0c254c7e05ef$var$reduce(this, "reduceRight", fn, args);
    },
    shift () {
        return $1a0d0c254c7e05ef$var$noTracking(this, "shift");
    },
    // slice could use ARRAY_ITERATE but also seems to beg for range tracking
    some (fn, thisArg) {
        return $1a0d0c254c7e05ef$var$apply(this, "some", fn, thisArg, void 0, arguments);
    },
    splice (...args) {
        return $1a0d0c254c7e05ef$var$noTracking(this, "splice", args);
    },
    toReversed () {
        return $1a0d0c254c7e05ef$export$1544eab4943788e4(this).toReversed();
    },
    toSorted (comparer) {
        return $1a0d0c254c7e05ef$export$1544eab4943788e4(this).toSorted(comparer);
    },
    toSpliced (...args) {
        return $1a0d0c254c7e05ef$export$1544eab4943788e4(this).toSpliced(...args);
    },
    unshift (...args) {
        return $1a0d0c254c7e05ef$var$noTracking(this, "unshift", args);
    },
    values () {
        return $1a0d0c254c7e05ef$var$iterator(this, "values", $1a0d0c254c7e05ef$export$45c769cf449a508c);
    }
};
function $1a0d0c254c7e05ef$var$iterator(self, method, wrapValue) {
    const arr = $1a0d0c254c7e05ef$export$5eb48af14254449e(self);
    const iter = arr[method]();
    if (arr !== self && !$1a0d0c254c7e05ef$export$7f3fe6025abfa26e(self)) {
        iter._next = iter.next;
        iter.next = ()=>{
            const result = iter._next();
            if (result.value) result.value = wrapValue(result.value);
            return result;
        };
    }
    return iter;
}
const $1a0d0c254c7e05ef$var$arrayProto = Array.prototype;
function $1a0d0c254c7e05ef$var$apply(self, method, fn, thisArg, wrappedRetFn, args) {
    const arr = $1a0d0c254c7e05ef$export$5eb48af14254449e(self);
    const needsWrap = arr !== self && !$1a0d0c254c7e05ef$export$7f3fe6025abfa26e(self);
    const methodFn = arr[method];
    if (methodFn !== $1a0d0c254c7e05ef$var$arrayProto[method]) {
        const result2 = methodFn.apply(self, args);
        return needsWrap ? $1a0d0c254c7e05ef$export$45c769cf449a508c(result2) : result2;
    }
    let wrappedFn = fn;
    if (arr !== self) {
        if (needsWrap) wrappedFn = function(item, index) {
            return fn.call(this, $1a0d0c254c7e05ef$export$45c769cf449a508c(item), index, self);
        };
        else if (fn.length > 2) wrappedFn = function(item, index) {
            return fn.call(this, item, index, self);
        };
    }
    const result = methodFn.call(arr, wrappedFn, thisArg);
    return needsWrap && wrappedRetFn ? wrappedRetFn(result) : result;
}
function $1a0d0c254c7e05ef$var$reduce(self, method, fn, args) {
    const arr = $1a0d0c254c7e05ef$export$5eb48af14254449e(self);
    let wrappedFn = fn;
    if (arr !== self) {
        if (!$1a0d0c254c7e05ef$export$7f3fe6025abfa26e(self)) wrappedFn = function(acc, item, index) {
            return fn.call(this, acc, $1a0d0c254c7e05ef$export$45c769cf449a508c(item), index, self);
        };
        else if (fn.length > 3) wrappedFn = function(acc, item, index) {
            return fn.call(this, acc, item, index, self);
        };
    }
    return arr[method](wrappedFn, ...args);
}
function $1a0d0c254c7e05ef$var$searchProxy(self, method, args) {
    const arr = $1a0d0c254c7e05ef$export$ab18938b9fc5f28e(self);
    $1a0d0c254c7e05ef$export$6b2a7d5132615086(arr, "iterate", $1a0d0c254c7e05ef$export$4f926f0baab682cd);
    const res = arr[method](...args);
    if ((res === -1 || res === false) && $1a0d0c254c7e05ef$export$5f3ca29d057519b3(args[0])) {
        args[0] = $1a0d0c254c7e05ef$export$ab18938b9fc5f28e(args[0]);
        return arr[method](...args);
    }
    return res;
}
function $1a0d0c254c7e05ef$var$noTracking(self, method, args = []) {
    $1a0d0c254c7e05ef$export$938a971395fef855();
    $1a0d0c254c7e05ef$var$startBatch();
    const res = $1a0d0c254c7e05ef$export$ab18938b9fc5f28e(self)[method].apply(self, args);
    $1a0d0c254c7e05ef$var$endBatch();
    $1a0d0c254c7e05ef$export$c39176b1babaa8b8();
    return res;
}
const $1a0d0c254c7e05ef$var$isNonTrackableKeys = /* @__PURE__ */ (0, $Cr6yt.makeMap)(`__proto__,__v_isRef,__isVue`);
const $1a0d0c254c7e05ef$var$builtInSymbols = new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((key)=>key !== "arguments" && key !== "caller").map((key)=>Symbol[key]).filter((0, $Cr6yt.isSymbol)));
function $1a0d0c254c7e05ef$var$hasOwnProperty(key) {
    if (!(0, $Cr6yt.isSymbol)(key)) key = String(key);
    const obj = $1a0d0c254c7e05ef$export$ab18938b9fc5f28e(this);
    $1a0d0c254c7e05ef$export$6b2a7d5132615086(obj, "has", key);
    return obj.hasOwnProperty(key);
}
class $1a0d0c254c7e05ef$var$BaseReactiveHandler {
    constructor(_isReadonly = false, _isShallow = false){
        this._isReadonly = _isReadonly;
        this._isShallow = _isShallow;
    }
    get(target, key, receiver) {
        if (key === "__v_skip") return target["__v_skip"];
        const isReadonly2 = this._isReadonly, isShallow2 = this._isShallow;
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_isShallow") return isShallow2;
        else if (key === "__v_raw") {
            if (receiver === (isReadonly2 ? isShallow2 ? $1a0d0c254c7e05ef$var$shallowReadonlyMap : $1a0d0c254c7e05ef$var$readonlyMap : isShallow2 ? $1a0d0c254c7e05ef$var$shallowReactiveMap : $1a0d0c254c7e05ef$var$reactiveMap).get(target) || // receiver is not the reactive proxy, but has the same prototype
            // this means the receiver is a user proxy of the reactive proxy
            Object.getPrototypeOf(target) === Object.getPrototypeOf(receiver)) return target;
            return;
        }
        const targetIsArray = (0, $Cr6yt.isArray)(target);
        if (!isReadonly2) {
            let fn;
            if (targetIsArray && (fn = $1a0d0c254c7e05ef$var$arrayInstrumentations[key])) return fn;
            if (key === "hasOwnProperty") return $1a0d0c254c7e05ef$var$hasOwnProperty;
        }
        const res = Reflect.get(target, key, // if this is a proxy wrapping a ref, return methods using the raw ref
        // as receiver so that we don't have to call `toRaw` on the ref in all
        // its class methods
        $1a0d0c254c7e05ef$export$4f9f5282de18fc69(target) ? target : receiver);
        if ((0, $Cr6yt.isSymbol)(key) ? $1a0d0c254c7e05ef$var$builtInSymbols.has(key) : $1a0d0c254c7e05ef$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly2) $1a0d0c254c7e05ef$export$6b2a7d5132615086(target, "get", key);
        if (isShallow2) return res;
        if ($1a0d0c254c7e05ef$export$4f9f5282de18fc69(res)) return targetIsArray && (0, $Cr6yt.isIntegerKey)(key) ? res : res.value;
        if ((0, $Cr6yt.isObject)(res)) return isReadonly2 ? $1a0d0c254c7e05ef$export$6ec456bd5b7b3c51(res) : $1a0d0c254c7e05ef$export$90a44edba14e47be(res);
        return res;
    }
}
class $1a0d0c254c7e05ef$var$MutableReactiveHandler extends $1a0d0c254c7e05ef$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(false, isShallow2);
    }
    set(target, key, value, receiver) {
        let oldValue = target[key];
        if (!this._isShallow) {
            const isOldValueReadonly = $1a0d0c254c7e05ef$export$92d09b48637741e7(oldValue);
            if (!$1a0d0c254c7e05ef$export$7f3fe6025abfa26e(value) && !$1a0d0c254c7e05ef$export$92d09b48637741e7(value)) {
                oldValue = $1a0d0c254c7e05ef$export$ab18938b9fc5f28e(oldValue);
                value = $1a0d0c254c7e05ef$export$ab18938b9fc5f28e(value);
            }
            if (!(0, $Cr6yt.isArray)(target) && $1a0d0c254c7e05ef$export$4f9f5282de18fc69(oldValue) && !$1a0d0c254c7e05ef$export$4f9f5282de18fc69(value)) {
                if (isOldValueReadonly) return false;
                else {
                    oldValue.value = value;
                    return true;
                }
            }
        }
        const hadKey = (0, $Cr6yt.isArray)(target) && (0, $Cr6yt.isIntegerKey)(key) ? Number(key) < target.length : (0, $Cr6yt.hasOwn)(target, key);
        const result = Reflect.set(target, key, value, $1a0d0c254c7e05ef$export$4f9f5282de18fc69(target) ? target : receiver);
        if (target === $1a0d0c254c7e05ef$export$ab18938b9fc5f28e(receiver)) {
            if (!hadKey) $1a0d0c254c7e05ef$export$e614dc9140f7ae71(target, "add", key, value);
            else if ((0, $Cr6yt.hasChanged)(value, oldValue)) $1a0d0c254c7e05ef$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
        }
        return result;
    }
    deleteProperty(target, key) {
        const hadKey = (0, $Cr6yt.hasOwn)(target, key);
        const oldValue = target[key];
        const result = Reflect.deleteProperty(target, key);
        if (result && hadKey) $1a0d0c254c7e05ef$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
        return result;
    }
    has(target, key) {
        const result = Reflect.has(target, key);
        if (!(0, $Cr6yt.isSymbol)(key) || !$1a0d0c254c7e05ef$var$builtInSymbols.has(key)) $1a0d0c254c7e05ef$export$6b2a7d5132615086(target, "has", key);
        return result;
    }
    ownKeys(target) {
        $1a0d0c254c7e05ef$export$6b2a7d5132615086(target, "iterate", (0, $Cr6yt.isArray)(target) ? "length" : $1a0d0c254c7e05ef$export$3c41b1a4e06acc14);
        return Reflect.ownKeys(target);
    }
}
class $1a0d0c254c7e05ef$var$ReadonlyReactiveHandler extends $1a0d0c254c7e05ef$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(true, isShallow2);
    }
    set(target, key) {
        return true;
    }
    deleteProperty(target, key) {
        return true;
    }
}
const $1a0d0c254c7e05ef$var$mutableHandlers = /* @__PURE__ */ new $1a0d0c254c7e05ef$var$MutableReactiveHandler();
const $1a0d0c254c7e05ef$var$readonlyHandlers = /* @__PURE__ */ new $1a0d0c254c7e05ef$var$ReadonlyReactiveHandler();
const $1a0d0c254c7e05ef$var$shallowReactiveHandlers = /* @__PURE__ */ new $1a0d0c254c7e05ef$var$MutableReactiveHandler(true);
const $1a0d0c254c7e05ef$var$shallowReadonlyHandlers = /* @__PURE__ */ new $1a0d0c254c7e05ef$var$ReadonlyReactiveHandler(true);
const $1a0d0c254c7e05ef$var$toShallow = (value)=>value;
const $1a0d0c254c7e05ef$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $1a0d0c254c7e05ef$var$createIterableMethod(method, isReadonly2, isShallow2) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $1a0d0c254c7e05ef$export$ab18938b9fc5f28e(target);
        const targetIsMap = (0, $Cr6yt.isMap)(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow2 ? $1a0d0c254c7e05ef$var$toShallow : isReadonly2 ? $1a0d0c254c7e05ef$export$4a78e7a2a4fb689f : $1a0d0c254c7e05ef$export$45c769cf449a508c;
        !isReadonly2 && $1a0d0c254c7e05ef$export$6b2a7d5132615086(rawTarget, "iterate", isKeyOnly ? $1a0d0c254c7e05ef$export$49093fa1cddcb78d : $1a0d0c254c7e05ef$export$3c41b1a4e06acc14);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $1a0d0c254c7e05ef$var$createReadonlyMethod(type) {
    return function(...args) {
        return type === "delete" ? false : type === "clear" ? void 0 : this;
    };
}
function $1a0d0c254c7e05ef$var$createInstrumentations(readonly, shallow) {
    const instrumentations = {
        get (key) {
            const target = this["__v_raw"];
            const rawTarget = $1a0d0c254c7e05ef$export$ab18938b9fc5f28e(target);
            const rawKey = $1a0d0c254c7e05ef$export$ab18938b9fc5f28e(key);
            if (!readonly) {
                if ((0, $Cr6yt.hasChanged)(key, rawKey)) $1a0d0c254c7e05ef$export$6b2a7d5132615086(rawTarget, "get", key);
                $1a0d0c254c7e05ef$export$6b2a7d5132615086(rawTarget, "get", rawKey);
            }
            const { has: has } = $1a0d0c254c7e05ef$var$getProto(rawTarget);
            const wrap = shallow ? $1a0d0c254c7e05ef$var$toShallow : readonly ? $1a0d0c254c7e05ef$export$4a78e7a2a4fb689f : $1a0d0c254c7e05ef$export$45c769cf449a508c;
            if (has.call(rawTarget, key)) return wrap(target.get(key));
            else if (has.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
            else if (target !== rawTarget) target.get(key);
        },
        get size () {
            const target = this["__v_raw"];
            !readonly && $1a0d0c254c7e05ef$export$6b2a7d5132615086($1a0d0c254c7e05ef$export$ab18938b9fc5f28e(target), "iterate", $1a0d0c254c7e05ef$export$3c41b1a4e06acc14);
            return Reflect.get(target, "size", target);
        },
        has (key) {
            const target = this["__v_raw"];
            const rawTarget = $1a0d0c254c7e05ef$export$ab18938b9fc5f28e(target);
            const rawKey = $1a0d0c254c7e05ef$export$ab18938b9fc5f28e(key);
            if (!readonly) {
                if ((0, $Cr6yt.hasChanged)(key, rawKey)) $1a0d0c254c7e05ef$export$6b2a7d5132615086(rawTarget, "has", key);
                $1a0d0c254c7e05ef$export$6b2a7d5132615086(rawTarget, "has", rawKey);
            }
            return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
        },
        forEach (callback, thisArg) {
            const observed = this;
            const target = observed["__v_raw"];
            const rawTarget = $1a0d0c254c7e05ef$export$ab18938b9fc5f28e(target);
            const wrap = shallow ? $1a0d0c254c7e05ef$var$toShallow : readonly ? $1a0d0c254c7e05ef$export$4a78e7a2a4fb689f : $1a0d0c254c7e05ef$export$45c769cf449a508c;
            !readonly && $1a0d0c254c7e05ef$export$6b2a7d5132615086(rawTarget, "iterate", $1a0d0c254c7e05ef$export$3c41b1a4e06acc14);
            return target.forEach((value, key)=>{
                return callback.call(thisArg, wrap(value), wrap(key), observed);
            });
        }
    };
    (0, $Cr6yt.extend)(instrumentations, readonly ? {
        add: $1a0d0c254c7e05ef$var$createReadonlyMethod("add"),
        set: $1a0d0c254c7e05ef$var$createReadonlyMethod("set"),
        delete: $1a0d0c254c7e05ef$var$createReadonlyMethod("delete"),
        clear: $1a0d0c254c7e05ef$var$createReadonlyMethod("clear")
    } : {
        add (value) {
            if (!shallow && !$1a0d0c254c7e05ef$export$7f3fe6025abfa26e(value) && !$1a0d0c254c7e05ef$export$92d09b48637741e7(value)) value = $1a0d0c254c7e05ef$export$ab18938b9fc5f28e(value);
            const target = $1a0d0c254c7e05ef$export$ab18938b9fc5f28e(this);
            const proto = $1a0d0c254c7e05ef$var$getProto(target);
            const hadKey = proto.has.call(target, value);
            if (!hadKey) {
                target.add(value);
                $1a0d0c254c7e05ef$export$e614dc9140f7ae71(target, "add", value, value);
            }
            return this;
        },
        set (key, value) {
            if (!shallow && !$1a0d0c254c7e05ef$export$7f3fe6025abfa26e(value) && !$1a0d0c254c7e05ef$export$92d09b48637741e7(value)) value = $1a0d0c254c7e05ef$export$ab18938b9fc5f28e(value);
            const target = $1a0d0c254c7e05ef$export$ab18938b9fc5f28e(this);
            const { has: has, get: get } = $1a0d0c254c7e05ef$var$getProto(target);
            let hadKey = has.call(target, key);
            if (!hadKey) {
                key = $1a0d0c254c7e05ef$export$ab18938b9fc5f28e(key);
                hadKey = has.call(target, key);
            }
            const oldValue = get.call(target, key);
            target.set(key, value);
            if (!hadKey) $1a0d0c254c7e05ef$export$e614dc9140f7ae71(target, "add", key, value);
            else if ((0, $Cr6yt.hasChanged)(value, oldValue)) $1a0d0c254c7e05ef$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
            return this;
        },
        delete (key) {
            const target = $1a0d0c254c7e05ef$export$ab18938b9fc5f28e(this);
            const { has: has, get: get } = $1a0d0c254c7e05ef$var$getProto(target);
            let hadKey = has.call(target, key);
            if (!hadKey) {
                key = $1a0d0c254c7e05ef$export$ab18938b9fc5f28e(key);
                hadKey = has.call(target, key);
            }
            const oldValue = get ? get.call(target, key) : void 0;
            const result = target.delete(key);
            if (hadKey) $1a0d0c254c7e05ef$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
            return result;
        },
        clear () {
            const target = $1a0d0c254c7e05ef$export$ab18938b9fc5f28e(this);
            const hadItems = target.size !== 0;
            const oldTarget = void 0;
            const result = target.clear();
            if (hadItems) $1a0d0c254c7e05ef$export$e614dc9140f7ae71(target, "clear", void 0, void 0, oldTarget);
            return result;
        }
    });
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        instrumentations[method] = $1a0d0c254c7e05ef$var$createIterableMethod(method, readonly, shallow);
    });
    return instrumentations;
}
function $1a0d0c254c7e05ef$var$createInstrumentationGetter(isReadonly2, shallow) {
    const instrumentations = $1a0d0c254c7e05ef$var$createInstrumentations(isReadonly2, shallow);
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_raw") return target;
        return Reflect.get((0, $Cr6yt.hasOwn)(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
const $1a0d0c254c7e05ef$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $1a0d0c254c7e05ef$var$createInstrumentationGetter(false, false)
};
const $1a0d0c254c7e05ef$var$shallowCollectionHandlers = {
    get: /* @__PURE__ */ $1a0d0c254c7e05ef$var$createInstrumentationGetter(false, true)
};
const $1a0d0c254c7e05ef$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $1a0d0c254c7e05ef$var$createInstrumentationGetter(true, false)
};
const $1a0d0c254c7e05ef$var$shallowReadonlyCollectionHandlers = {
    get: /* @__PURE__ */ $1a0d0c254c7e05ef$var$createInstrumentationGetter(true, true)
};
function $1a0d0c254c7e05ef$var$checkIdentityKeys(target, has, key) {
    const rawKey = $1a0d0c254c7e05ef$export$ab18938b9fc5f28e(key);
    if (rawKey !== key && has.call(target, rawKey)) {
        const type = (0, $Cr6yt.toRawType)(target);
        $1a0d0c254c7e05ef$var$warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
const $1a0d0c254c7e05ef$var$reactiveMap = /* @__PURE__ */ new WeakMap();
const $1a0d0c254c7e05ef$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
const $1a0d0c254c7e05ef$var$readonlyMap = /* @__PURE__ */ new WeakMap();
const $1a0d0c254c7e05ef$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $1a0d0c254c7e05ef$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1 /* COMMON */ ;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2 /* COLLECTION */ ;
        default:
            return 0 /* INVALID */ ;
    }
}
function $1a0d0c254c7e05ef$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 /* INVALID */  : $1a0d0c254c7e05ef$var$targetTypeMap((0, $Cr6yt.toRawType)(value));
}
function $1a0d0c254c7e05ef$export$90a44edba14e47be(target) {
    if ($1a0d0c254c7e05ef$export$92d09b48637741e7(target)) return target;
    return $1a0d0c254c7e05ef$var$createReactiveObject(target, false, $1a0d0c254c7e05ef$var$mutableHandlers, $1a0d0c254c7e05ef$var$mutableCollectionHandlers, $1a0d0c254c7e05ef$var$reactiveMap);
}
function $1a0d0c254c7e05ef$export$8d81cefd22d22260(target) {
    return $1a0d0c254c7e05ef$var$createReactiveObject(target, false, $1a0d0c254c7e05ef$var$shallowReactiveHandlers, $1a0d0c254c7e05ef$var$shallowCollectionHandlers, $1a0d0c254c7e05ef$var$shallowReactiveMap);
}
function $1a0d0c254c7e05ef$export$6ec456bd5b7b3c51(target) {
    return $1a0d0c254c7e05ef$var$createReactiveObject(target, true, $1a0d0c254c7e05ef$var$readonlyHandlers, $1a0d0c254c7e05ef$var$readonlyCollectionHandlers, $1a0d0c254c7e05ef$var$readonlyMap);
}
function $1a0d0c254c7e05ef$export$7c4b5f2b50f09f6b(target) {
    return $1a0d0c254c7e05ef$var$createReactiveObject(target, true, $1a0d0c254c7e05ef$var$shallowReadonlyHandlers, $1a0d0c254c7e05ef$var$shallowReadonlyCollectionHandlers, $1a0d0c254c7e05ef$var$shallowReadonlyMap);
}
function $1a0d0c254c7e05ef$var$createReactiveObject(target, isReadonly2, baseHandlers, collectionHandlers, proxyMap) {
    if (!(0, $Cr6yt.isObject)(target)) return target;
    if (target["__v_raw"] && !(isReadonly2 && target["__v_isReactive"])) return target;
    const targetType = $1a0d0c254c7e05ef$var$getTargetType(target);
    if (targetType === 0 /* INVALID */ ) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const proxy = new Proxy(target, targetType === 2 /* COLLECTION */  ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $1a0d0c254c7e05ef$export$352205f445242f02(value) {
    if ($1a0d0c254c7e05ef$export$92d09b48637741e7(value)) return $1a0d0c254c7e05ef$export$352205f445242f02(value["__v_raw"]);
    return !!(value && value["__v_isReactive"]);
}
function $1a0d0c254c7e05ef$export$92d09b48637741e7(value) {
    return !!(value && value["__v_isReadonly"]);
}
function $1a0d0c254c7e05ef$export$7f3fe6025abfa26e(value) {
    return !!(value && value["__v_isShallow"]);
}
function $1a0d0c254c7e05ef$export$5f3ca29d057519b3(value) {
    return value ? !!value["__v_raw"] : false;
}
function $1a0d0c254c7e05ef$export$ab18938b9fc5f28e(observed) {
    const raw = observed && observed["__v_raw"];
    return raw ? $1a0d0c254c7e05ef$export$ab18938b9fc5f28e(raw) : observed;
}
function $1a0d0c254c7e05ef$export$995ab8b13ad7a9d0(value) {
    if (!(0, $Cr6yt.hasOwn)(value, "__v_skip") && Object.isExtensible(value)) (0, $Cr6yt.def)(value, "__v_skip", true);
    return value;
}
const $1a0d0c254c7e05ef$export$45c769cf449a508c = (value)=>(0, $Cr6yt.isObject)(value) ? $1a0d0c254c7e05ef$export$90a44edba14e47be(value) : value;
const $1a0d0c254c7e05ef$export$4a78e7a2a4fb689f = (value)=>(0, $Cr6yt.isObject)(value) ? $1a0d0c254c7e05ef$export$6ec456bd5b7b3c51(value) : value;
function $1a0d0c254c7e05ef$export$4f9f5282de18fc69(r) {
    return r ? r["__v_isRef"] === true : false;
}
function $1a0d0c254c7e05ef$export$eff4d24c3ff7876e(value) {
    return $1a0d0c254c7e05ef$var$createRef(value, false);
}
function $1a0d0c254c7e05ef$export$9b7bc5fe3b17c8b3(value) {
    return $1a0d0c254c7e05ef$var$createRef(value, true);
}
function $1a0d0c254c7e05ef$var$createRef(rawValue, shallow) {
    if ($1a0d0c254c7e05ef$export$4f9f5282de18fc69(rawValue)) return rawValue;
    return new $1a0d0c254c7e05ef$var$RefImpl(rawValue, shallow);
}
class $1a0d0c254c7e05ef$var$RefImpl {
    constructor(value, isShallow2){
        this.dep = new $1a0d0c254c7e05ef$var$Dep();
        this["__v_isRef"] = true;
        this["__v_isShallow"] = false;
        this._rawValue = isShallow2 ? value : $1a0d0c254c7e05ef$export$ab18938b9fc5f28e(value);
        this._value = isShallow2 ? value : $1a0d0c254c7e05ef$export$45c769cf449a508c(value);
        this["__v_isShallow"] = isShallow2;
    }
    get value() {
        this.dep.track();
        return this._value;
    }
    set value(newValue) {
        const oldValue = this._rawValue;
        const useDirectValue = this["__v_isShallow"] || $1a0d0c254c7e05ef$export$7f3fe6025abfa26e(newValue) || $1a0d0c254c7e05ef$export$92d09b48637741e7(newValue);
        newValue = useDirectValue ? newValue : $1a0d0c254c7e05ef$export$ab18938b9fc5f28e(newValue);
        if ((0, $Cr6yt.hasChanged)(newValue, oldValue)) {
            this._rawValue = newValue;
            this._value = useDirectValue ? newValue : $1a0d0c254c7e05ef$export$45c769cf449a508c(newValue);
            this.dep.trigger();
        }
    }
}
function $1a0d0c254c7e05ef$export$f402f86588575ccc(ref2) {
    if (ref2.dep) ref2.dep.trigger();
}
function $1a0d0c254c7e05ef$export$a239a76781616204(ref2) {
    return $1a0d0c254c7e05ef$export$4f9f5282de18fc69(ref2) ? ref2.value : ref2;
}
function $1a0d0c254c7e05ef$export$30bdcc2218aa9458(source) {
    return (0, $Cr6yt.isFunction)(source) ? source() : $1a0d0c254c7e05ef$export$a239a76781616204(source);
}
const $1a0d0c254c7e05ef$var$shallowUnwrapHandlers = {
    get: (target, key, receiver)=>key === "__v_raw" ? target : $1a0d0c254c7e05ef$export$a239a76781616204(Reflect.get(target, key, receiver)),
    set: (target, key, value, receiver)=>{
        const oldValue = target[key];
        if ($1a0d0c254c7e05ef$export$4f9f5282de18fc69(oldValue) && !$1a0d0c254c7e05ef$export$4f9f5282de18fc69(value)) {
            oldValue.value = value;
            return true;
        } else return Reflect.set(target, key, value, receiver);
    }
};
function $1a0d0c254c7e05ef$export$f353fd1b97db3fa0(objectWithRefs) {
    return $1a0d0c254c7e05ef$export$352205f445242f02(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, $1a0d0c254c7e05ef$var$shallowUnwrapHandlers);
}
class $1a0d0c254c7e05ef$var$CustomRefImpl {
    constructor(factory){
        this["__v_isRef"] = true;
        this._value = void 0;
        const dep = this.dep = new $1a0d0c254c7e05ef$var$Dep();
        const { get: get, set: set } = factory(dep.track.bind(dep), dep.trigger.bind(dep));
        this._get = get;
        this._set = set;
    }
    get value() {
        return this._value = this._get();
    }
    set value(newVal) {
        this._set(newVal);
    }
}
function $1a0d0c254c7e05ef$export$a20c2dd6199824cb(factory) {
    return new $1a0d0c254c7e05ef$var$CustomRefImpl(factory);
}
function $1a0d0c254c7e05ef$export$2e9533675e5e70e0(object) {
    const ret = (0, $Cr6yt.isArray)(object) ? new Array(object.length) : {};
    for(const key in object)ret[key] = $1a0d0c254c7e05ef$var$propertyToRef(object, key);
    return ret;
}
class $1a0d0c254c7e05ef$var$ObjectRefImpl {
    constructor(_object, _key, _defaultValue){
        this._object = _object;
        this._key = _key;
        this._defaultValue = _defaultValue;
        this["__v_isRef"] = true;
        this._value = void 0;
    }
    get value() {
        const val = this._object[this._key];
        return this._value = val === void 0 ? this._defaultValue : val;
    }
    set value(newVal) {
        this._object[this._key] = newVal;
    }
    get dep() {
        return $1a0d0c254c7e05ef$var$getDepFromReactive($1a0d0c254c7e05ef$export$ab18938b9fc5f28e(this._object), this._key);
    }
}
class $1a0d0c254c7e05ef$var$GetterRefImpl {
    constructor(_getter){
        this._getter = _getter;
        this["__v_isRef"] = true;
        this["__v_isReadonly"] = true;
        this._value = void 0;
    }
    get value() {
        return this._value = this._getter();
    }
}
function $1a0d0c254c7e05ef$export$1f60508e4f47b4b7(source, key, defaultValue) {
    if ($1a0d0c254c7e05ef$export$4f9f5282de18fc69(source)) return source;
    else if ((0, $Cr6yt.isFunction)(source)) return new $1a0d0c254c7e05ef$var$GetterRefImpl(source);
    else if ((0, $Cr6yt.isObject)(source) && arguments.length > 1) return $1a0d0c254c7e05ef$var$propertyToRef(source, key, defaultValue);
    else return $1a0d0c254c7e05ef$export$eff4d24c3ff7876e(source);
}
function $1a0d0c254c7e05ef$var$propertyToRef(source, key, defaultValue) {
    const val = source[key];
    return $1a0d0c254c7e05ef$export$4f9f5282de18fc69(val) ? val : new $1a0d0c254c7e05ef$var$ObjectRefImpl(source, key, defaultValue);
}
class $1a0d0c254c7e05ef$var$ComputedRefImpl {
    constructor(fn, setter, isSSR){
        this.fn = fn;
        this.setter = setter;
        /**
     * @internal
     */ this._value = void 0;
        /**
     * @internal
     */ this.dep = new $1a0d0c254c7e05ef$var$Dep(this);
        /**
     * @internal
     */ this.__v_isRef = true;
        // TODO isolatedDeclarations "__v_isReadonly"
        // A computed is also a subscriber that tracks other deps
        /**
     * @internal
     */ this.deps = void 0;
        /**
     * @internal
     */ this.depsTail = void 0;
        /**
     * @internal
     */ this.flags = 16;
        /**
     * @internal
     */ this.globalVersion = $1a0d0c254c7e05ef$var$globalVersion - 1;
        /**
     * @internal
     */ this.next = void 0;
        // for backwards compat
        this.effect = this;
        this["__v_isReadonly"] = !setter;
        this.isSSR = isSSR;
    }
    /**
   * @internal
   */ notify() {
        this.flags |= 16;
        if (!(this.flags & 8) && // avoid infinite self recursion
        $1a0d0c254c7e05ef$var$activeSub !== this) {
            $1a0d0c254c7e05ef$var$batch(this, true);
            return true;
        }
    }
    get value() {
        const link = this.dep.track();
        $1a0d0c254c7e05ef$var$refreshComputed(this);
        if (link) link.version = this.dep.version;
        return this._value;
    }
    set value(newValue) {
        if (this.setter) this.setter(newValue);
    }
}
function $1a0d0c254c7e05ef$export$2983e091f1a1e8e2(getterOrOptions, debugOptions, isSSR = false) {
    let getter;
    let setter;
    if ((0, $Cr6yt.isFunction)(getterOrOptions)) getter = getterOrOptions;
    else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    const cRef = new $1a0d0c254c7e05ef$var$ComputedRefImpl(getter, setter, isSSR);
    return cRef;
}
const $1a0d0c254c7e05ef$export$2ac2bd0a56e04551 = {
    "GET": "get",
    "HAS": "has",
    "ITERATE": "iterate"
};
const $1a0d0c254c7e05ef$export$1e8941c92696a26 = {
    "SET": "set",
    "ADD": "add",
    "DELETE": "delete",
    "CLEAR": "clear"
};
const $1a0d0c254c7e05ef$export$e738ba173768902d = {
    "SKIP": "__v_skip",
    "IS_REACTIVE": "__v_isReactive",
    "IS_READONLY": "__v_isReadonly",
    "IS_SHALLOW": "__v_isShallow",
    "RAW": "__v_raw",
    "IS_REF": "__v_isRef"
};
const $1a0d0c254c7e05ef$export$c54ef203cb79e75f = {
    "WATCH_GETTER": 2,
    "2": "WATCH_GETTER",
    "WATCH_CALLBACK": 3,
    "3": "WATCH_CALLBACK",
    "WATCH_CLEANUP": 4,
    "4": "WATCH_CLEANUP"
};
const $1a0d0c254c7e05ef$var$INITIAL_WATCHER_VALUE = {};
const $1a0d0c254c7e05ef$var$cleanupMap = /* @__PURE__ */ new WeakMap();
let $1a0d0c254c7e05ef$var$activeWatcher = void 0;
function $1a0d0c254c7e05ef$export$2532f7acfca7c82d() {
    return $1a0d0c254c7e05ef$var$activeWatcher;
}
function $1a0d0c254c7e05ef$export$8ddeeb083684a9d0(cleanupFn, failSilently = false, owner = $1a0d0c254c7e05ef$var$activeWatcher) {
    if (owner) {
        let cleanups = $1a0d0c254c7e05ef$var$cleanupMap.get(owner);
        if (!cleanups) $1a0d0c254c7e05ef$var$cleanupMap.set(owner, cleanups = []);
        cleanups.push(cleanupFn);
    }
}
function $1a0d0c254c7e05ef$export$3db5d71bdb2d5499(source, cb, options = (0, $Cr6yt.EMPTY_OBJ)) {
    const { immediate: immediate, deep: deep, once: once, scheduler: scheduler, augmentJob: augmentJob, call: call } = options;
    const warnInvalidSource = (s)=>{
        (options.onWarn || $1a0d0c254c7e05ef$var$warn)(`Invalid watch source: `, s, `A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.`);
    };
    const reactiveGetter = (source2)=>{
        if (deep) return source2;
        if ($1a0d0c254c7e05ef$export$7f3fe6025abfa26e(source2) || deep === false || deep === 0) return $1a0d0c254c7e05ef$export$df3f009e3d155b20(source2, 1);
        return $1a0d0c254c7e05ef$export$df3f009e3d155b20(source2);
    };
    let effect;
    let getter;
    let cleanup;
    let boundCleanup;
    let forceTrigger = false;
    let isMultiSource = false;
    if ($1a0d0c254c7e05ef$export$4f9f5282de18fc69(source)) {
        getter = ()=>source.value;
        forceTrigger = $1a0d0c254c7e05ef$export$7f3fe6025abfa26e(source);
    } else if ($1a0d0c254c7e05ef$export$352205f445242f02(source)) {
        getter = ()=>reactiveGetter(source);
        forceTrigger = true;
    } else if ((0, $Cr6yt.isArray)(source)) {
        isMultiSource = true;
        forceTrigger = source.some((s)=>$1a0d0c254c7e05ef$export$352205f445242f02(s) || $1a0d0c254c7e05ef$export$7f3fe6025abfa26e(s));
        getter = ()=>source.map((s)=>{
                if ($1a0d0c254c7e05ef$export$4f9f5282de18fc69(s)) return s.value;
                else if ($1a0d0c254c7e05ef$export$352205f445242f02(s)) return reactiveGetter(s);
                else if ((0, $Cr6yt.isFunction)(s)) return call ? call(s, 2) : s();
            });
    } else if ((0, $Cr6yt.isFunction)(source)) {
        if (cb) getter = call ? ()=>call(source, 2) : source;
        else getter = ()=>{
            if (cleanup) {
                $1a0d0c254c7e05ef$export$938a971395fef855();
                try {
                    cleanup();
                } finally{
                    $1a0d0c254c7e05ef$export$c39176b1babaa8b8();
                }
            }
            const currentEffect = $1a0d0c254c7e05ef$var$activeWatcher;
            $1a0d0c254c7e05ef$var$activeWatcher = effect;
            try {
                return call ? call(source, 3, [
                    boundCleanup
                ]) : source(boundCleanup);
            } finally{
                $1a0d0c254c7e05ef$var$activeWatcher = currentEffect;
            }
        };
    } else getter = (0, $Cr6yt.NOOP);
    if (cb && deep) {
        const baseGetter = getter;
        const depth = deep === true ? Infinity : deep;
        getter = ()=>$1a0d0c254c7e05ef$export$df3f009e3d155b20(baseGetter(), depth);
    }
    const scope = $1a0d0c254c7e05ef$export$c7be4b0125a10cba();
    const watchHandle = ()=>{
        effect.stop();
        if (scope && scope.active) (0, $Cr6yt.remove)(scope.effects, effect);
    };
    if (once && cb) {
        const _cb = cb;
        cb = (...args)=>{
            _cb(...args);
            watchHandle();
        };
    }
    let oldValue = isMultiSource ? new Array(source.length).fill($1a0d0c254c7e05ef$var$INITIAL_WATCHER_VALUE) : $1a0d0c254c7e05ef$var$INITIAL_WATCHER_VALUE;
    const job = (immediateFirstRun)=>{
        if (!(effect.flags & 1) || !effect.dirty && !immediateFirstRun) return;
        if (cb) {
            const newValue = effect.run();
            if (deep || forceTrigger || (isMultiSource ? newValue.some((v, i)=>(0, $Cr6yt.hasChanged)(v, oldValue[i])) : (0, $Cr6yt.hasChanged)(newValue, oldValue))) {
                if (cleanup) cleanup();
                const currentWatcher = $1a0d0c254c7e05ef$var$activeWatcher;
                $1a0d0c254c7e05ef$var$activeWatcher = effect;
                try {
                    const args = [
                        newValue,
                        // pass undefined as the old value when it's changed for the first time
                        oldValue === $1a0d0c254c7e05ef$var$INITIAL_WATCHER_VALUE ? void 0 : isMultiSource && oldValue[0] === $1a0d0c254c7e05ef$var$INITIAL_WATCHER_VALUE ? [] : oldValue,
                        boundCleanup
                    ];
                    call ? call(cb, 3, args) : // @ts-expect-error
                    cb(...args);
                    oldValue = newValue;
                } finally{
                    $1a0d0c254c7e05ef$var$activeWatcher = currentWatcher;
                }
            }
        } else effect.run();
    };
    if (augmentJob) augmentJob(job);
    effect = new $1a0d0c254c7e05ef$export$28352bb4dd362521(getter);
    effect.scheduler = scheduler ? ()=>scheduler(job, false) : job;
    boundCleanup = (fn)=>$1a0d0c254c7e05ef$export$8ddeeb083684a9d0(fn, false, effect);
    cleanup = effect.onStop = ()=>{
        const cleanups = $1a0d0c254c7e05ef$var$cleanupMap.get(effect);
        if (cleanups) {
            if (call) call(cleanups, 4);
            else for (const cleanup2 of cleanups)cleanup2();
            $1a0d0c254c7e05ef$var$cleanupMap.delete(effect);
        }
    };
    if (cb) {
        if (immediate) job(true);
        else oldValue = effect.run();
    } else if (scheduler) scheduler(job.bind(null, true), true);
    else effect.run();
    watchHandle.pause = effect.pause.bind(effect);
    watchHandle.resume = effect.resume.bind(effect);
    watchHandle.stop = watchHandle;
    return watchHandle;
}
function $1a0d0c254c7e05ef$export$df3f009e3d155b20(value, depth = Infinity, seen) {
    if (depth <= 0 || !(0, $Cr6yt.isObject)(value) || value["__v_skip"]) return value;
    seen = seen || /* @__PURE__ */ new Set();
    if (seen.has(value)) return value;
    seen.add(value);
    depth--;
    if ($1a0d0c254c7e05ef$export$4f9f5282de18fc69(value)) $1a0d0c254c7e05ef$export$df3f009e3d155b20(value.value, depth, seen);
    else if ((0, $Cr6yt.isArray)(value)) for(let i = 0; i < value.length; i++)$1a0d0c254c7e05ef$export$df3f009e3d155b20(value[i], depth, seen);
    else if ((0, $Cr6yt.isSet)(value) || (0, $Cr6yt.isMap)(value)) value.forEach((v)=>{
        $1a0d0c254c7e05ef$export$df3f009e3d155b20(v, depth, seen);
    });
    else if ((0, $Cr6yt.isPlainObject)(value)) {
        for(const key in value)$1a0d0c254c7e05ef$export$df3f009e3d155b20(value[key], depth, seen);
        for (const key of Object.getOwnPropertySymbols(value))if (Object.prototype.propertyIsEnumerable.call(value, key)) $1a0d0c254c7e05ef$export$df3f009e3d155b20(value[key], depth, seen);
    }
    return value;
}

});
parcelRegister("Cr6yt", function(module, exports) {

$parcel$export(module.exports, "makeMap", () => $073893289f699ee8$export$b41394a5437791c8);
$parcel$export(module.exports, "EMPTY_OBJ", () => $073893289f699ee8$export$cf583d23ab39677c);
$parcel$export(module.exports, "EMPTY_ARR", () => $073893289f699ee8$export$6bd8558f433f1cc1);
$parcel$export(module.exports, "NOOP", () => $073893289f699ee8$export$5702a91a6f42969f);
$parcel$export(module.exports, "NO", () => $073893289f699ee8$export$c01351c0af048e39);
$parcel$export(module.exports, "isOn", () => $073893289f699ee8$export$1a2d97de39ecbb75);
$parcel$export(module.exports, "isModelListener", () => $073893289f699ee8$export$793aa5469768d691);
$parcel$export(module.exports, "extend", () => $073893289f699ee8$export$8b58be045bf06082);
$parcel$export(module.exports, "remove", () => $073893289f699ee8$export$cd7f480d6b8286c3);
$parcel$export(module.exports, "hasOwn", () => $073893289f699ee8$export$b5a638e9b3fff9f3);
$parcel$export(module.exports, "isArray", () => $073893289f699ee8$export$43bee75e5e14138e);
$parcel$export(module.exports, "isMap", () => $073893289f699ee8$export$5c90113a285f2241);
$parcel$export(module.exports, "isSet", () => $073893289f699ee8$export$6750766a7c7ec627);
$parcel$export(module.exports, "isRegExp", () => $073893289f699ee8$export$49841c62b9eff15);
$parcel$export(module.exports, "isFunction", () => $073893289f699ee8$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isString", () => $073893289f699ee8$export$844ec244b1367d54);
$parcel$export(module.exports, "isSymbol", () => $073893289f699ee8$export$a244864fd9645c7f);
$parcel$export(module.exports, "isObject", () => $073893289f699ee8$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isPromise", () => $073893289f699ee8$export$4369c812aac99591);
$parcel$export(module.exports, "toRawType", () => $073893289f699ee8$export$5ad0a3c360b8fbb5);
$parcel$export(module.exports, "isPlainObject", () => $073893289f699ee8$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isIntegerKey", () => $073893289f699ee8$export$e2a2b93446ec9fe);
$parcel$export(module.exports, "isReservedProp", () => $073893289f699ee8$export$bf7d3c0236f0aa85);
$parcel$export(module.exports, "isBuiltInDirective", () => $073893289f699ee8$export$a9c1fdb3030c2a6b);
$parcel$export(module.exports, "camelize", () => $073893289f699ee8$export$161d051f5dd25de7);
$parcel$export(module.exports, "hyphenate", () => $073893289f699ee8$export$6e6a0a3676c4b8bb);
$parcel$export(module.exports, "capitalize", () => $073893289f699ee8$export$9a00dee1beb8f576);
$parcel$export(module.exports, "toHandlerKey", () => $073893289f699ee8$export$8c022799eeaaefcd);
$parcel$export(module.exports, "hasChanged", () => $073893289f699ee8$export$f619eb8b89076d23);
$parcel$export(module.exports, "invokeArrayFns", () => $073893289f699ee8$export$39951422d618a9d3);
$parcel$export(module.exports, "def", () => $073893289f699ee8$export$8afb76124cf08683);
$parcel$export(module.exports, "looseToNumber", () => $073893289f699ee8$export$d3be7195bcc2f31b);
$parcel$export(module.exports, "toNumber", () => $073893289f699ee8$export$a0a81dc3380ce7d3);
$parcel$export(module.exports, "getGlobalThis", () => $073893289f699ee8$export$ff5f2eeb11fc7e14);
$parcel$export(module.exports, "isGloballyAllowed", () => $073893289f699ee8$export$f73b8c13b7f97ebf);
$parcel$export(module.exports, "normalizeStyle", () => $073893289f699ee8$export$8756898546458274);
$parcel$export(module.exports, "stringifyStyle", () => $073893289f699ee8$export$9466a5a0ee6f1479);
$parcel$export(module.exports, "normalizeClass", () => $073893289f699ee8$export$4f7022d2d68e2c5a);
$parcel$export(module.exports, "isHTMLTag", () => $073893289f699ee8$export$1ccf854a0984f890);
$parcel$export(module.exports, "isSVGTag", () => $073893289f699ee8$export$6328ce7565ea1049);
$parcel$export(module.exports, "isMathMLTag", () => $073893289f699ee8$export$4a46ca4c5be17b20);
$parcel$export(module.exports, "isSpecialBooleanAttr", () => $073893289f699ee8$export$d186f5eb2e810715);
$parcel$export(module.exports, "isBooleanAttr", () => $073893289f699ee8$export$f763ba3b84e9cd8c);
$parcel$export(module.exports, "includeBooleanAttr", () => $073893289f699ee8$export$e3f3cdb1390d56ce);
$parcel$export(module.exports, "isKnownHtmlAttr", () => $073893289f699ee8$export$f7e7a1cc7da8d5e9);
$parcel$export(module.exports, "isKnownSvgAttr", () => $073893289f699ee8$export$80da416f43933831);
$parcel$export(module.exports, "isRenderableAttrValue", () => $073893289f699ee8$export$921dd2acf0d386a3);
$parcel$export(module.exports, "getEscapedCssVarName", () => $073893289f699ee8$export$ad9a320bfb7ba440);
$parcel$export(module.exports, "looseEqual", () => $073893289f699ee8$export$ae8015769846262c);
$parcel$export(module.exports, "looseIndexOf", () => $073893289f699ee8$export$42912a80cedb8bd4);
$parcel$export(module.exports, "toDisplayString", () => $073893289f699ee8$export$b5b1545233b45293);
/**
* @vue/shared v3.5.14
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ /*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $073893289f699ee8$export$b41394a5437791c8(str) {
    const map = /* @__PURE__ */ Object.create(null);
    for (const key of str.split(","))map[key] = 1;
    return (val)=>val in map;
}
const $073893289f699ee8$export$cf583d23ab39677c = {};
const $073893289f699ee8$export$6bd8558f433f1cc1 = [];
const $073893289f699ee8$export$5702a91a6f42969f = ()=>{};
const $073893289f699ee8$export$c01351c0af048e39 = ()=>false;
const $073893289f699ee8$export$1a2d97de39ecbb75 = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // uppercase letter
    (key.charCodeAt(2) > 122 || key.charCodeAt(2) < 97);
const $073893289f699ee8$export$793aa5469768d691 = (key)=>key.startsWith("onUpdate:");
const $073893289f699ee8$export$8b58be045bf06082 = Object.assign;
const $073893289f699ee8$export$cd7f480d6b8286c3 = (arr, el)=>{
    const i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
const $073893289f699ee8$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $073893289f699ee8$export$b5a638e9b3fff9f3 = (val, key)=>$073893289f699ee8$var$hasOwnProperty.call(val, key);
const $073893289f699ee8$export$43bee75e5e14138e = Array.isArray;
const $073893289f699ee8$export$5c90113a285f2241 = (val)=>$073893289f699ee8$export$1dccc787cc36538b(val) === "[object Map]";
const $073893289f699ee8$export$6750766a7c7ec627 = (val)=>$073893289f699ee8$export$1dccc787cc36538b(val) === "[object Set]";
const $073893289f699ee8$export$871608497c498473 = (val)=>$073893289f699ee8$export$1dccc787cc36538b(val) === "[object Date]";
const $073893289f699ee8$export$49841c62b9eff15 = (val)=>$073893289f699ee8$export$1dccc787cc36538b(val) === "[object RegExp]";
const $073893289f699ee8$export$f6e2535fb5126e54 = (val)=>typeof val === "function";
const $073893289f699ee8$export$844ec244b1367d54 = (val)=>typeof val === "string";
const $073893289f699ee8$export$a244864fd9645c7f = (val)=>typeof val === "symbol";
const $073893289f699ee8$export$a6cdc56e425d0d0a = (val)=>val !== null && typeof val === "object";
const $073893289f699ee8$export$4369c812aac99591 = (val)=>{
    return ($073893289f699ee8$export$a6cdc56e425d0d0a(val) || $073893289f699ee8$export$f6e2535fb5126e54(val)) && $073893289f699ee8$export$f6e2535fb5126e54(val.then) && $073893289f699ee8$export$f6e2535fb5126e54(val.catch);
};
const $073893289f699ee8$export$830c053460e5ddf6 = Object.prototype.toString;
const $073893289f699ee8$export$1dccc787cc36538b = (value)=>$073893289f699ee8$export$830c053460e5ddf6.call(value);
const $073893289f699ee8$export$5ad0a3c360b8fbb5 = (value)=>{
    return $073893289f699ee8$export$1dccc787cc36538b(value).slice(8, -1);
};
const $073893289f699ee8$export$53b83ca8eaab0383 = (val)=>$073893289f699ee8$export$1dccc787cc36538b(val) === "[object Object]";
const $073893289f699ee8$export$e2a2b93446ec9fe = (key)=>$073893289f699ee8$export$844ec244b1367d54(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
const $073893289f699ee8$export$bf7d3c0236f0aa85 = /* @__PURE__ */ $073893289f699ee8$export$b41394a5437791c8(// the leading comma is intentional so empty string "" is also included
",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
const $073893289f699ee8$export$a9c1fdb3030c2a6b = /* @__PURE__ */ $073893289f699ee8$export$b41394a5437791c8("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
const $073893289f699ee8$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
const $073893289f699ee8$var$camelizeRE = /-(\w)/g;
const $073893289f699ee8$export$161d051f5dd25de7 = $073893289f699ee8$var$cacheStringFunction((str)=>{
    return str.replace($073893289f699ee8$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
const $073893289f699ee8$var$hyphenateRE = /\B([A-Z])/g;
const $073893289f699ee8$export$6e6a0a3676c4b8bb = $073893289f699ee8$var$cacheStringFunction((str)=>str.replace($073893289f699ee8$var$hyphenateRE, "-$1").toLowerCase());
const $073893289f699ee8$export$9a00dee1beb8f576 = $073893289f699ee8$var$cacheStringFunction((str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
});
const $073893289f699ee8$export$8c022799eeaaefcd = $073893289f699ee8$var$cacheStringFunction((str)=>{
    const s = str ? `on${$073893289f699ee8$export$9a00dee1beb8f576(str)}` : ``;
    return s;
});
const $073893289f699ee8$export$f619eb8b89076d23 = (value, oldValue)=>!Object.is(value, oldValue);
const $073893289f699ee8$export$39951422d618a9d3 = (fns, ...arg)=>{
    for(let i = 0; i < fns.length; i++)fns[i](...arg);
};
const $073893289f699ee8$export$8afb76124cf08683 = (obj, key, value, writable = false)=>{
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        writable: writable,
        value: value
    });
};
const $073893289f699ee8$export$d3be7195bcc2f31b = (val)=>{
    const n = parseFloat(val);
    return isNaN(n) ? val : n;
};
const $073893289f699ee8$export$a0a81dc3380ce7d3 = (val)=>{
    const n = $073893289f699ee8$export$844ec244b1367d54(val) ? Number(val) : NaN;
    return isNaN(n) ? val : n;
};
let $073893289f699ee8$var$_globalThis;
const $073893289f699ee8$export$ff5f2eeb11fc7e14 = ()=>{
    return $073893289f699ee8$var$_globalThis || ($073893289f699ee8$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};
const $073893289f699ee8$var$identRE = /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/;
function $073893289f699ee8$export$53d5e12f9a1d3cde(name) {
    return $073893289f699ee8$var$identRE.test(name) ? `__props.${name}` : `__props[${JSON.stringify(name)}]`;
}
function $073893289f699ee8$export$abc5374c10a73a04(source, options) {
    return source + JSON.stringify(options, (_, val)=>typeof val === "function" ? val.toString() : val);
}
const $073893289f699ee8$export$4bcc674e2ac54ab0 = {
    "TEXT": 1,
    "1": "TEXT",
    "CLASS": 2,
    "2": "CLASS",
    "STYLE": 4,
    "4": "STYLE",
    "PROPS": 8,
    "8": "PROPS",
    "FULL_PROPS": 16,
    "16": "FULL_PROPS",
    "NEED_HYDRATION": 32,
    "32": "NEED_HYDRATION",
    "STABLE_FRAGMENT": 64,
    "64": "STABLE_FRAGMENT",
    "KEYED_FRAGMENT": 128,
    "128": "KEYED_FRAGMENT",
    "UNKEYED_FRAGMENT": 256,
    "256": "UNKEYED_FRAGMENT",
    "NEED_PATCH": 512,
    "512": "NEED_PATCH",
    "DYNAMIC_SLOTS": 1024,
    "1024": "DYNAMIC_SLOTS",
    "DEV_ROOT_FRAGMENT": 2048,
    "2048": "DEV_ROOT_FRAGMENT",
    "CACHED": -1,
    "-1": "CACHED",
    "BAIL": -2,
    "-2": "BAIL"
};
const $073893289f699ee8$export$def7dc2c2e95a08a = {
    [1]: `TEXT`,
    [2]: `CLASS`,
    [4]: `STYLE`,
    [8]: `PROPS`,
    [16]: `FULL_PROPS`,
    [32]: `NEED_HYDRATION`,
    [64]: `STABLE_FRAGMENT`,
    [128]: `KEYED_FRAGMENT`,
    [256]: `UNKEYED_FRAGMENT`,
    [512]: `NEED_PATCH`,
    [1024]: `DYNAMIC_SLOTS`,
    [2048]: `DEV_ROOT_FRAGMENT`,
    [-1]: `HOISTED`,
    [-2]: `BAIL`
};
const $073893289f699ee8$export$ff27c1ebf2311072 = {
    "ELEMENT": 1,
    "1": "ELEMENT",
    "FUNCTIONAL_COMPONENT": 2,
    "2": "FUNCTIONAL_COMPONENT",
    "STATEFUL_COMPONENT": 4,
    "4": "STATEFUL_COMPONENT",
    "TEXT_CHILDREN": 8,
    "8": "TEXT_CHILDREN",
    "ARRAY_CHILDREN": 16,
    "16": "ARRAY_CHILDREN",
    "SLOTS_CHILDREN": 32,
    "32": "SLOTS_CHILDREN",
    "TELEPORT": 64,
    "64": "TELEPORT",
    "SUSPENSE": 128,
    "128": "SUSPENSE",
    "COMPONENT_SHOULD_KEEP_ALIVE": 256,
    "256": "COMPONENT_SHOULD_KEEP_ALIVE",
    "COMPONENT_KEPT_ALIVE": 512,
    "512": "COMPONENT_KEPT_ALIVE",
    "COMPONENT": 6,
    "6": "COMPONENT"
};
const $073893289f699ee8$export$b1e6fe37bcdef5be = {
    "STABLE": 1,
    "1": "STABLE",
    "DYNAMIC": 2,
    "2": "DYNAMIC",
    "FORWARDED": 3,
    "3": "FORWARDED"
};
const $073893289f699ee8$export$624972196ed3745f = {
    [1]: "STABLE",
    [2]: "DYNAMIC",
    [3]: "FORWARDED"
};
const $073893289f699ee8$var$GLOBALS_ALLOWED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console,Error,Symbol";
const $073893289f699ee8$export$f73b8c13b7f97ebf = /* @__PURE__ */ $073893289f699ee8$export$b41394a5437791c8($073893289f699ee8$var$GLOBALS_ALLOWED);
const $073893289f699ee8$export$d6571a1911e4f27e = $073893289f699ee8$export$f73b8c13b7f97ebf;
const $073893289f699ee8$var$range = 2;
function $073893289f699ee8$export$f9c0d8b6684a279b(source, start = 0, end = source.length) {
    start = Math.max(0, Math.min(start, source.length));
    end = Math.max(0, Math.min(end, source.length));
    if (start > end) return "";
    let lines = source.split(/(\r?\n)/);
    const newlineSequences = lines.filter((_, idx)=>idx % 2 === 1);
    lines = lines.filter((_, idx)=>idx % 2 === 0);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(let j = i - $073893289f699ee8$var$range; j <= i + $073893289f699ee8$var$range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${" ".repeat(Math.max(3 - String(line).length, 0))}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                const newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    const pad = start - (count - (lineLength + newLineSeqLength));
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + "^".repeat(length));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
function $073893289f699ee8$export$8756898546458274(value) {
    if ($073893289f699ee8$export$43bee75e5e14138e(value)) {
        const res = {};
        for(let i = 0; i < value.length; i++){
            const item = value[i];
            const normalized = $073893289f699ee8$export$844ec244b1367d54(item) ? $073893289f699ee8$export$76a205ce979d066a(item) : $073893289f699ee8$export$8756898546458274(item);
            if (normalized) for(const key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if ($073893289f699ee8$export$844ec244b1367d54(value) || $073893289f699ee8$export$a6cdc56e425d0d0a(value)) return value;
}
const $073893289f699ee8$var$listDelimiterRE = /;(?![^(]*\))/g;
const $073893289f699ee8$var$propertyDelimiterRE = /:([^]+)/;
const $073893289f699ee8$var$styleCommentRE = /\/\*[^]*?\*\//g;
function $073893289f699ee8$export$76a205ce979d066a(cssText) {
    const ret = {};
    cssText.replace($073893289f699ee8$var$styleCommentRE, "").split($073893289f699ee8$var$listDelimiterRE).forEach((item)=>{
        if (item) {
            const tmp = item.split($073893289f699ee8$var$propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function $073893289f699ee8$export$9466a5a0ee6f1479(styles) {
    if (!styles) return "";
    if ($073893289f699ee8$export$844ec244b1367d54(styles)) return styles;
    let ret = "";
    for(const key in styles){
        const value = styles[key];
        if ($073893289f699ee8$export$844ec244b1367d54(value) || typeof value === "number") {
            const normalizedKey = key.startsWith(`--`) ? key : $073893289f699ee8$export$6e6a0a3676c4b8bb(key);
            ret += `${normalizedKey}:${value};`;
        }
    }
    return ret;
}
function $073893289f699ee8$export$4f7022d2d68e2c5a(value) {
    let res = "";
    if ($073893289f699ee8$export$844ec244b1367d54(value)) res = value;
    else if ($073893289f699ee8$export$43bee75e5e14138e(value)) for(let i = 0; i < value.length; i++){
        const normalized = $073893289f699ee8$export$4f7022d2d68e2c5a(value[i]);
        if (normalized) res += normalized + " ";
    }
    else if ($073893289f699ee8$export$a6cdc56e425d0d0a(value)) {
        for(const name in value)if (value[name]) res += name + " ";
    }
    return res.trim();
}
function $073893289f699ee8$export$601abcd8103db5e4(props) {
    if (!props) return null;
    let { class: klass, style: style } = props;
    if (klass && !$073893289f699ee8$export$844ec244b1367d54(klass)) props.class = $073893289f699ee8$export$4f7022d2d68e2c5a(klass);
    if (style) props.style = $073893289f699ee8$export$8756898546458274(style);
    return props;
}
const $073893289f699ee8$var$HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
const $073893289f699ee8$var$SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
const $073893289f699ee8$var$MATH_TAGS = "annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics";
const $073893289f699ee8$var$VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
const $073893289f699ee8$export$1ccf854a0984f890 = /* @__PURE__ */ $073893289f699ee8$export$b41394a5437791c8($073893289f699ee8$var$HTML_TAGS);
const $073893289f699ee8$export$6328ce7565ea1049 = /* @__PURE__ */ $073893289f699ee8$export$b41394a5437791c8($073893289f699ee8$var$SVG_TAGS);
const $073893289f699ee8$export$4a46ca4c5be17b20 = /* @__PURE__ */ $073893289f699ee8$export$b41394a5437791c8($073893289f699ee8$var$MATH_TAGS);
const $073893289f699ee8$export$e5f2d3d97d9367a4 = /* @__PURE__ */ $073893289f699ee8$export$b41394a5437791c8($073893289f699ee8$var$VOID_TAGS);
const $073893289f699ee8$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
const $073893289f699ee8$export$d186f5eb2e810715 = /* @__PURE__ */ $073893289f699ee8$export$b41394a5437791c8($073893289f699ee8$var$specialBooleanAttrs);
const $073893289f699ee8$export$f763ba3b84e9cd8c = /* @__PURE__ */ $073893289f699ee8$export$b41394a5437791c8($073893289f699ee8$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,inert,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
function $073893289f699ee8$export$e3f3cdb1390d56ce(value) {
    return !!value || value === "";
}
const $073893289f699ee8$var$unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u0020]/;
const $073893289f699ee8$var$attrValidationCache = {};
function $073893289f699ee8$export$d55ef77660f30d12(name) {
    if ($073893289f699ee8$var$attrValidationCache.hasOwnProperty(name)) return $073893289f699ee8$var$attrValidationCache[name];
    const isUnsafe = $073893289f699ee8$var$unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error(`unsafe attribute name: ${name}`);
    return $073893289f699ee8$var$attrValidationCache[name] = !isUnsafe;
}
const $073893289f699ee8$export$b66fd0cae8dec3c8 = {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
};
const $073893289f699ee8$export$f7e7a1cc7da8d5e9 = /* @__PURE__ */ $073893289f699ee8$export$b41394a5437791c8(`accept,accept-charset,accesskey,action,align,allow,alt,async,autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,border,buffered,capture,challenge,charset,checked,cite,class,code,codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,formaction,formenctype,formmethod,formnovalidate,formtarget,headers,height,hidden,high,href,hreflang,http-equiv,icon,id,importance,inert,integrity,ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,target,title,translate,type,usemap,value,width,wrap`);
const $073893289f699ee8$export$80da416f43933831 = /* @__PURE__ */ $073893289f699ee8$export$b41394a5437791c8(`xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,color-interpolation-filters,color-profile,color-rendering,contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,font-family,font-size,font-size-adjust,font-stretch,font-style,font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,overflow,overline-position,overline-thickness,panose-1,paint-order,path,pathLength,patternContentUnits,patternTransform,patternUnits,ping,pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,specularConstant,specularExponent,speed,spreadMethod,startOffset,stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,string,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,text-decoration,text-rendering,textLength,to,transform,transform-origin,type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xmlns:xlink,xml:base,xml:lang,xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan`);
const $073893289f699ee8$export$fc0748a8e0014066 = /* @__PURE__ */ $073893289f699ee8$export$b41394a5437791c8(`accent,accentunder,actiontype,align,alignmentscope,altimg,altimg-height,altimg-valign,altimg-width,alttext,bevelled,close,columnsalign,columnlines,columnspan,denomalign,depth,dir,display,displaystyle,encoding,equalcolumns,equalrows,fence,fontstyle,fontweight,form,frame,framespacing,groupalign,height,href,id,indentalign,indentalignfirst,indentalignlast,indentshift,indentshiftfirst,indentshiftlast,indextype,justify,largetop,largeop,lquote,lspace,mathbackground,mathcolor,mathsize,mathvariant,maxsize,minlabelspacing,mode,other,overflow,position,rowalign,rowlines,rowspan,rquote,rspace,scriptlevel,scriptminsize,scriptsizemultiplier,selection,separator,separators,shift,side,src,stackalign,stretchy,subscriptshift,superscriptshift,symmetric,voffset,width,widths,xlink:href,xlink:show,xlink:type,xmlns`);
function $073893289f699ee8$export$921dd2acf0d386a3(value) {
    if (value == null) return false;
    const type = typeof value;
    return type === "string" || type === "number" || type === "boolean";
}
const $073893289f699ee8$var$escapeRE = /["'&<>]/;
function $073893289f699ee8$export$4cf11838cdc2a8a8(string) {
    const str = "" + string;
    const match = $073893289f699ee8$var$escapeRE.exec(str);
    if (!match) return str;
    let html = "";
    let escaped;
    let index;
    let lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = "&quot;";
                break;
            case 38:
                escaped = "&amp;";
                break;
            case 39:
                escaped = "&#39;";
                break;
            case 60:
                escaped = "&lt;";
                break;
            case 62:
                escaped = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
const $073893289f699ee8$var$commentStripRE = /^-?>|<!--|-->|--!>|<!-$/g;
function $073893289f699ee8$export$7b105034a53bde5f(src) {
    return src.replace($073893289f699ee8$var$commentStripRE, "");
}
const $073893289f699ee8$export$9320a7246b331080 = /[ !"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g;
function $073893289f699ee8$export$ad9a320bfb7ba440(key, doubleEscape) {
    return key.replace($073893289f699ee8$export$9320a7246b331080, (s)=>doubleEscape ? s === '"' ? '\\\\\\"' : `\\\\${s}` : `\\${s}`);
}
function $073893289f699ee8$var$looseCompareArrays(a, b) {
    if (a.length !== b.length) return false;
    let equal = true;
    for(let i = 0; equal && i < a.length; i++)equal = $073893289f699ee8$export$ae8015769846262c(a[i], b[i]);
    return equal;
}
function $073893289f699ee8$export$ae8015769846262c(a, b) {
    if (a === b) return true;
    let aValidType = $073893289f699ee8$export$871608497c498473(a);
    let bValidType = $073893289f699ee8$export$871608497c498473(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = $073893289f699ee8$export$a244864fd9645c7f(a);
    bValidType = $073893289f699ee8$export$a244864fd9645c7f(b);
    if (aValidType || bValidType) return a === b;
    aValidType = $073893289f699ee8$export$43bee75e5e14138e(a);
    bValidType = $073893289f699ee8$export$43bee75e5e14138e(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $073893289f699ee8$var$looseCompareArrays(a, b) : false;
    aValidType = $073893289f699ee8$export$a6cdc56e425d0d0a(a);
    bValidType = $073893289f699ee8$export$a6cdc56e425d0d0a(b);
    if (aValidType || bValidType) {
        if (!aValidType || !bValidType) return false;
        const aKeysCount = Object.keys(a).length;
        const bKeysCount = Object.keys(b).length;
        if (aKeysCount !== bKeysCount) return false;
        for(const key in a){
            const aHasKey = a.hasOwnProperty(key);
            const bHasKey = b.hasOwnProperty(key);
            if (aHasKey && !bHasKey || !aHasKey && bHasKey || !$073893289f699ee8$export$ae8015769846262c(a[key], b[key])) return false;
        }
    }
    return String(a) === String(b);
}
function $073893289f699ee8$export$42912a80cedb8bd4(arr, val) {
    return arr.findIndex((item)=>$073893289f699ee8$export$ae8015769846262c(item, val));
}
const $073893289f699ee8$var$isRef = (val)=>{
    return !!(val && val["__v_isRef"] === true);
};
const $073893289f699ee8$export$b5b1545233b45293 = (val)=>{
    return $073893289f699ee8$export$844ec244b1367d54(val) ? val : val == null ? "" : $073893289f699ee8$export$43bee75e5e14138e(val) || $073893289f699ee8$export$a6cdc56e425d0d0a(val) && (val.toString === $073893289f699ee8$export$830c053460e5ddf6 || !$073893289f699ee8$export$f6e2535fb5126e54(val.toString)) ? $073893289f699ee8$var$isRef(val) ? $073893289f699ee8$export$b5b1545233b45293(val.value) : JSON.stringify(val, $073893289f699ee8$var$replacer, 2) : String(val);
};
const $073893289f699ee8$var$replacer = (_key, val)=>{
    if ($073893289f699ee8$var$isRef(val)) return $073893289f699ee8$var$replacer(_key, val.value);
    else if ($073893289f699ee8$export$5c90113a285f2241(val)) return {
        [`Map(${val.size})`]: [
            ...val.entries()
        ].reduce((entries, [key, val2], i)=>{
            entries[$073893289f699ee8$var$stringifySymbol(key, i) + " =>"] = val2;
            return entries;
        }, {})
    };
    else if ($073893289f699ee8$export$6750766a7c7ec627(val)) return {
        [`Set(${val.size})`]: [
            ...val.values()
        ].map((v)=>$073893289f699ee8$var$stringifySymbol(v))
    };
    else if ($073893289f699ee8$export$a244864fd9645c7f(val)) return $073893289f699ee8$var$stringifySymbol(val);
    else if ($073893289f699ee8$export$a6cdc56e425d0d0a(val) && !$073893289f699ee8$export$43bee75e5e14138e(val) && !$073893289f699ee8$export$53b83ca8eaab0383(val)) return String(val);
    return val;
};
const $073893289f699ee8$var$stringifySymbol = (v, i = "")=>{
    var _a;
    return(// Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    $073893289f699ee8$export$a244864fd9645c7f(v) ? `Symbol(${(_a = v.description) != null ? _a : i})` : v);
};

});



parcelRegister("dIm2H", function(module, exports) {
$parcel$export(module.exports, "BaseTransition", () => (parcelRequire("58rTl")).BaseTransition);
$parcel$export(module.exports, "BaseTransitionPropsValidators", () => (parcelRequire("58rTl")).BaseTransitionPropsValidators);
$parcel$export(module.exports, "callWithAsyncErrorHandling", () => (parcelRequire("58rTl")).callWithAsyncErrorHandling);
$parcel$export(module.exports, "camelize", () => (parcelRequire("Cr6yt")).camelize);
$parcel$export(module.exports, "computed", () => (parcelRequire("58rTl")).computed);
$parcel$export(module.exports, "createElementBlock", () => (parcelRequire("58rTl")).createElementBlock);
$parcel$export(module.exports, "createElementVNode", () => (parcelRequire("58rTl")).createElementVNode);
$parcel$export(module.exports, "createHydrationRenderer", () => (parcelRequire("58rTl")).createHydrationRenderer);
$parcel$export(module.exports, "createRenderer", () => (parcelRequire("58rTl")).createRenderer);
$parcel$export(module.exports, "createVNode", () => (parcelRequire("58rTl")).createVNode);
$parcel$export(module.exports, "defineComponent", () => (parcelRequire("58rTl")).defineComponent);
$parcel$export(module.exports, "Fragment", () => (parcelRequire("58rTl")).Fragment);
$parcel$export(module.exports, "getCurrentInstance", () => (parcelRequire("58rTl")).getCurrentInstance);
$parcel$export(module.exports, "getTransitionRawChildren", () => (parcelRequire("58rTl")).getTransitionRawChildren);
$parcel$export(module.exports, "h", () => (parcelRequire("58rTl")).h);
$parcel$export(module.exports, "initCustomFormatter", () => (parcelRequire("58rTl")).initCustomFormatter);
$parcel$export(module.exports, "isRuntimeOnly", () => (parcelRequire("58rTl")).isRuntimeOnly);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("58rTl")).nextTick);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("Cr6yt")).normalizeClass);
$parcel$export(module.exports, "normalizeStyle", () => (parcelRequire("Cr6yt")).normalizeStyle);
$parcel$export(module.exports, "onBeforeUpdate", () => (parcelRequire("58rTl")).onBeforeUpdate);
$parcel$export(module.exports, "onMounted", () => (parcelRequire("58rTl")).onMounted);
$parcel$export(module.exports, "onUnmounted", () => (parcelRequire("58rTl")).onUnmounted);
$parcel$export(module.exports, "onUpdated", () => (parcelRequire("58rTl")).onUpdated);
$parcel$export(module.exports, "openBlock", () => (parcelRequire("58rTl")).openBlock);
$parcel$export(module.exports, "queuePostFlushCb", () => (parcelRequire("58rTl")).queuePostFlushCb);
$parcel$export(module.exports, "ref", () => (parcelRequire("2eFsq")).ref);
$parcel$export(module.exports, "renderList", () => (parcelRequire("58rTl")).renderList);
$parcel$export(module.exports, "resolveTransitionHooks", () => (parcelRequire("58rTl")).resolveTransitionHooks);
$parcel$export(module.exports, "setTransitionHooks", () => (parcelRequire("58rTl")).setTransitionHooks);
$parcel$export(module.exports, "Static", () => (parcelRequire("58rTl")).Static);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("2eFsq")).toRaw);
$parcel$export(module.exports, "useTemplateRef", () => (parcelRequire("58rTl")).useTemplateRef);
$parcel$export(module.exports, "useTransitionState", () => (parcelRequire("58rTl")).useTransitionState);
$parcel$export(module.exports, "warn", () => (parcelRequire("58rTl")).warn);
$parcel$export(module.exports, "watch", () => (parcelRequire("58rTl")).watch);
$parcel$export(module.exports, "toDisplayString", () => (parcelRequire("Cr6yt")).toDisplayString);

$parcel$export(module.exports, "createApp", () => $9fc07b9c70ec4a60$export$4e373c34abfa8c68);
$parcel$export(module.exports, "withModifiers", () => $9fc07b9c70ec4a60$export$26bd3b8e29e6f273);
$parcel$export(module.exports, "withKeys", () => $9fc07b9c70ec4a60$export$f691a8759658f782);
/**
* @vue/runtime-dom v3.5.14
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $58rTl = parcelRequire("58rTl");
var $Cr6yt = parcelRequire("Cr6yt");
var $2eFsq = parcelRequire("2eFsq");parcelRequire("Cr6yt");
var $2eFsq = parcelRequire("2eFsq");

var $Cr6yt = parcelRequire("Cr6yt");
let $9fc07b9c70ec4a60$var$policy = void 0;
const $9fc07b9c70ec4a60$var$tt = typeof window !== "undefined" && window.trustedTypes;
if ($9fc07b9c70ec4a60$var$tt) try {
    $9fc07b9c70ec4a60$var$policy = /* @__PURE__ */ $9fc07b9c70ec4a60$var$tt.createPolicy("vue", {
        createHTML: (val)=>val
    });
} catch (e) {}
const $9fc07b9c70ec4a60$var$unsafeToTrustedHTML = $9fc07b9c70ec4a60$var$policy ? (val)=>$9fc07b9c70ec4a60$var$policy.createHTML(val) : (val)=>val;
const $9fc07b9c70ec4a60$var$svgNS = "http://www.w3.org/2000/svg";
const $9fc07b9c70ec4a60$var$mathmlNS = "http://www.w3.org/1998/Math/MathML";
const $9fc07b9c70ec4a60$var$doc = typeof document !== "undefined" ? document : null;
const $9fc07b9c70ec4a60$var$templateContainer = $9fc07b9c70ec4a60$var$doc && /* @__PURE__ */ $9fc07b9c70ec4a60$var$doc.createElement("template");
const $9fc07b9c70ec4a60$var$nodeOps = {
    insert: (child, parent, anchor)=>{
        parent.insertBefore(child, anchor || null);
    },
    remove: (child)=>{
        const parent = child.parentNode;
        if (parent) parent.removeChild(child);
    },
    createElement: (tag, namespace, is, props)=>{
        const el = namespace === "svg" ? $9fc07b9c70ec4a60$var$doc.createElementNS($9fc07b9c70ec4a60$var$svgNS, tag) : namespace === "mathml" ? $9fc07b9c70ec4a60$var$doc.createElementNS($9fc07b9c70ec4a60$var$mathmlNS, tag) : is ? $9fc07b9c70ec4a60$var$doc.createElement(tag, {
            is: is
        }) : $9fc07b9c70ec4a60$var$doc.createElement(tag);
        if (tag === "select" && props && props.multiple != null) el.setAttribute("multiple", props.multiple);
        return el;
    },
    createText: (text)=>$9fc07b9c70ec4a60$var$doc.createTextNode(text),
    createComment: (text)=>$9fc07b9c70ec4a60$var$doc.createComment(text),
    setText: (node, text)=>{
        node.nodeValue = text;
    },
    setElementText: (el, text)=>{
        el.textContent = text;
    },
    parentNode: (node)=>node.parentNode,
    nextSibling: (node)=>node.nextSibling,
    querySelector: (selector)=>$9fc07b9c70ec4a60$var$doc.querySelector(selector),
    setScopeId (el, id) {
        el.setAttribute(id, "");
    },
    // __UNSAFE__
    // Reason: innerHTML.
    // Static content here can only come from compiled templates.
    // As long as the user only uses trusted templates, this is safe.
    insertStaticContent (content, parent, anchor, namespace, start, end) {
        const before = anchor ? anchor.previousSibling : parent.lastChild;
        if (start && (start === end || start.nextSibling)) while(true){
            parent.insertBefore(start.cloneNode(true), anchor);
            if (start === end || !(start = start.nextSibling)) break;
        }
        else {
            $9fc07b9c70ec4a60$var$templateContainer.innerHTML = $9fc07b9c70ec4a60$var$unsafeToTrustedHTML(namespace === "svg" ? `<svg>${content}</svg>` : namespace === "mathml" ? `<math>${content}</math>` : content);
            const template = $9fc07b9c70ec4a60$var$templateContainer.content;
            if (namespace === "svg" || namespace === "mathml") {
                const wrapper = template.firstChild;
                while(wrapper.firstChild)template.appendChild(wrapper.firstChild);
                template.removeChild(wrapper);
            }
            parent.insertBefore(template, anchor);
        }
        return [
            // first
            before ? before.nextSibling : parent.firstChild,
            // last
            anchor ? anchor.previousSibling : parent.lastChild
        ];
    }
};
const $9fc07b9c70ec4a60$var$TRANSITION = "transition";
const $9fc07b9c70ec4a60$var$ANIMATION = "animation";
const $9fc07b9c70ec4a60$var$vtcKey = Symbol("_vtc");
const $9fc07b9c70ec4a60$var$DOMTransitionPropsValidators = {
    name: String,
    type: String,
    css: {
        type: Boolean,
        default: true
    },
    duration: [
        String,
        Number,
        Object
    ],
    enterFromClass: String,
    enterActiveClass: String,
    enterToClass: String,
    appearFromClass: String,
    appearActiveClass: String,
    appearToClass: String,
    leaveFromClass: String,
    leaveActiveClass: String,
    leaveToClass: String
};
const $9fc07b9c70ec4a60$var$TransitionPropsValidators = /* @__PURE__ */ (0, $Cr6yt.extend)({}, (0, $58rTl.BaseTransitionPropsValidators), $9fc07b9c70ec4a60$var$DOMTransitionPropsValidators);
const $9fc07b9c70ec4a60$var$decorate$1 = (t)=>{
    t.displayName = "Transition";
    t.props = $9fc07b9c70ec4a60$var$TransitionPropsValidators;
    return t;
};
const $9fc07b9c70ec4a60$export$be58926105124dd4 = /* @__PURE__ */ $9fc07b9c70ec4a60$var$decorate$1((props, { slots: slots })=>(0, $58rTl.h)((0, $58rTl.BaseTransition), $9fc07b9c70ec4a60$var$resolveTransitionProps(props), slots));
const $9fc07b9c70ec4a60$var$callHook = (hook, args = [])=>{
    if ((0, $Cr6yt.isArray)(hook)) hook.forEach((h2)=>h2(...args));
    else if (hook) hook(...args);
};
const $9fc07b9c70ec4a60$var$hasExplicitCallback = (hook)=>{
    return hook ? (0, $Cr6yt.isArray)(hook) ? hook.some((h2)=>h2.length > 1) : hook.length > 1 : false;
};
function $9fc07b9c70ec4a60$var$resolveTransitionProps(rawProps) {
    const baseProps = {};
    for(const key in rawProps)if (!(key in $9fc07b9c70ec4a60$var$DOMTransitionPropsValidators)) baseProps[key] = rawProps[key];
    if (rawProps.css === false) return baseProps;
    const { name: name = "v", type: type, duration: duration, enterFromClass: enterFromClass = `${name}-enter-from`, enterActiveClass: enterActiveClass = `${name}-enter-active`, enterToClass: enterToClass = `${name}-enter-to`, appearFromClass: appearFromClass = enterFromClass, appearActiveClass: appearActiveClass = enterActiveClass, appearToClass: appearToClass = enterToClass, leaveFromClass: leaveFromClass = `${name}-leave-from`, leaveActiveClass: leaveActiveClass = `${name}-leave-active`, leaveToClass: leaveToClass = `${name}-leave-to` } = rawProps;
    const durations = $9fc07b9c70ec4a60$var$normalizeDuration(duration);
    const enterDuration = durations && durations[0];
    const leaveDuration = durations && durations[1];
    const { onBeforeEnter: onBeforeEnter, onEnter: onEnter, onEnterCancelled: onEnterCancelled, onLeave: onLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear = onBeforeEnter, onAppear: onAppear = onEnter, onAppearCancelled: onAppearCancelled = onEnterCancelled } = baseProps;
    const finishEnter = (el, isAppear, done, isCancelled)=>{
        el._enterCancelled = isCancelled;
        $9fc07b9c70ec4a60$var$removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
        $9fc07b9c70ec4a60$var$removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
        done && done();
    };
    const finishLeave = (el, done)=>{
        el._isLeaving = false;
        $9fc07b9c70ec4a60$var$removeTransitionClass(el, leaveFromClass);
        $9fc07b9c70ec4a60$var$removeTransitionClass(el, leaveToClass);
        $9fc07b9c70ec4a60$var$removeTransitionClass(el, leaveActiveClass);
        done && done();
    };
    const makeEnterHook = (isAppear)=>{
        return (el, done)=>{
            const hook = isAppear ? onAppear : onEnter;
            const resolve = ()=>finishEnter(el, isAppear, done);
            $9fc07b9c70ec4a60$var$callHook(hook, [
                el,
                resolve
            ]);
            $9fc07b9c70ec4a60$var$nextFrame(()=>{
                $9fc07b9c70ec4a60$var$removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
                $9fc07b9c70ec4a60$var$addTransitionClass(el, isAppear ? appearToClass : enterToClass);
                if (!$9fc07b9c70ec4a60$var$hasExplicitCallback(hook)) $9fc07b9c70ec4a60$var$whenTransitionEnds(el, type, enterDuration, resolve);
            });
        };
    };
    return (0, $Cr6yt.extend)(baseProps, {
        onBeforeEnter (el) {
            $9fc07b9c70ec4a60$var$callHook(onBeforeEnter, [
                el
            ]);
            $9fc07b9c70ec4a60$var$addTransitionClass(el, enterFromClass);
            $9fc07b9c70ec4a60$var$addTransitionClass(el, enterActiveClass);
        },
        onBeforeAppear (el) {
            $9fc07b9c70ec4a60$var$callHook(onBeforeAppear, [
                el
            ]);
            $9fc07b9c70ec4a60$var$addTransitionClass(el, appearFromClass);
            $9fc07b9c70ec4a60$var$addTransitionClass(el, appearActiveClass);
        },
        onEnter: makeEnterHook(false),
        onAppear: makeEnterHook(true),
        onLeave (el, done) {
            el._isLeaving = true;
            const resolve = ()=>finishLeave(el, done);
            $9fc07b9c70ec4a60$var$addTransitionClass(el, leaveFromClass);
            if (!el._enterCancelled) {
                $9fc07b9c70ec4a60$var$forceReflow();
                $9fc07b9c70ec4a60$var$addTransitionClass(el, leaveActiveClass);
            } else {
                $9fc07b9c70ec4a60$var$addTransitionClass(el, leaveActiveClass);
                $9fc07b9c70ec4a60$var$forceReflow();
            }
            $9fc07b9c70ec4a60$var$nextFrame(()=>{
                if (!el._isLeaving) return;
                $9fc07b9c70ec4a60$var$removeTransitionClass(el, leaveFromClass);
                $9fc07b9c70ec4a60$var$addTransitionClass(el, leaveToClass);
                if (!$9fc07b9c70ec4a60$var$hasExplicitCallback(onLeave)) $9fc07b9c70ec4a60$var$whenTransitionEnds(el, type, leaveDuration, resolve);
            });
            $9fc07b9c70ec4a60$var$callHook(onLeave, [
                el,
                resolve
            ]);
        },
        onEnterCancelled (el) {
            finishEnter(el, false, void 0, true);
            $9fc07b9c70ec4a60$var$callHook(onEnterCancelled, [
                el
            ]);
        },
        onAppearCancelled (el) {
            finishEnter(el, true, void 0, true);
            $9fc07b9c70ec4a60$var$callHook(onAppearCancelled, [
                el
            ]);
        },
        onLeaveCancelled (el) {
            finishLeave(el);
            $9fc07b9c70ec4a60$var$callHook(onLeaveCancelled, [
                el
            ]);
        }
    });
}
function $9fc07b9c70ec4a60$var$normalizeDuration(duration) {
    if (duration == null) return null;
    else if ((0, $Cr6yt.isObject)(duration)) return [
        $9fc07b9c70ec4a60$var$NumberOf(duration.enter),
        $9fc07b9c70ec4a60$var$NumberOf(duration.leave)
    ];
    else {
        const n = $9fc07b9c70ec4a60$var$NumberOf(duration);
        return [
            n,
            n
        ];
    }
}
function $9fc07b9c70ec4a60$var$NumberOf(val) {
    const res = (0, $Cr6yt.toNumber)(val);
    return res;
}
function $9fc07b9c70ec4a60$var$addTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.add(c));
    (el[$9fc07b9c70ec4a60$var$vtcKey] || (el[$9fc07b9c70ec4a60$var$vtcKey] = /* @__PURE__ */ new Set())).add(cls);
}
function $9fc07b9c70ec4a60$var$removeTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.remove(c));
    const _vtc = el[$9fc07b9c70ec4a60$var$vtcKey];
    if (_vtc) {
        _vtc.delete(cls);
        if (!_vtc.size) el[$9fc07b9c70ec4a60$var$vtcKey] = void 0;
    }
}
function $9fc07b9c70ec4a60$var$nextFrame(cb) {
    requestAnimationFrame(()=>{
        requestAnimationFrame(cb);
    });
}
let $9fc07b9c70ec4a60$var$endId = 0;
function $9fc07b9c70ec4a60$var$whenTransitionEnds(el, expectedType, explicitTimeout, resolve) {
    const id = el._endId = ++$9fc07b9c70ec4a60$var$endId;
    const resolveIfNotStale = ()=>{
        if (id === el._endId) resolve();
    };
    if (explicitTimeout != null) return setTimeout(resolveIfNotStale, explicitTimeout);
    const { type: type, timeout: timeout, propCount: propCount } = $9fc07b9c70ec4a60$var$getTransitionInfo(el, expectedType);
    if (!type) return resolve();
    const endEvent = type + "end";
    let ended = 0;
    const end = ()=>{
        el.removeEventListener(endEvent, onEnd);
        resolveIfNotStale();
    };
    const onEnd = (e)=>{
        if (e.target === el && ++ended >= propCount) end();
    };
    setTimeout(()=>{
        if (ended < propCount) end();
    }, timeout + 1);
    el.addEventListener(endEvent, onEnd);
}
function $9fc07b9c70ec4a60$var$getTransitionInfo(el, expectedType) {
    const styles = window.getComputedStyle(el);
    const getStyleProperties = (key)=>(styles[key] || "").split(", ");
    const transitionDelays = getStyleProperties(`${$9fc07b9c70ec4a60$var$TRANSITION}Delay`);
    const transitionDurations = getStyleProperties(`${$9fc07b9c70ec4a60$var$TRANSITION}Duration`);
    const transitionTimeout = $9fc07b9c70ec4a60$var$getTimeout(transitionDelays, transitionDurations);
    const animationDelays = getStyleProperties(`${$9fc07b9c70ec4a60$var$ANIMATION}Delay`);
    const animationDurations = getStyleProperties(`${$9fc07b9c70ec4a60$var$ANIMATION}Duration`);
    const animationTimeout = $9fc07b9c70ec4a60$var$getTimeout(animationDelays, animationDurations);
    let type = null;
    let timeout = 0;
    let propCount = 0;
    if (expectedType === $9fc07b9c70ec4a60$var$TRANSITION) {
        if (transitionTimeout > 0) {
            type = $9fc07b9c70ec4a60$var$TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    } else if (expectedType === $9fc07b9c70ec4a60$var$ANIMATION) {
        if (animationTimeout > 0) {
            type = $9fc07b9c70ec4a60$var$ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    } else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type = timeout > 0 ? transitionTimeout > animationTimeout ? $9fc07b9c70ec4a60$var$TRANSITION : $9fc07b9c70ec4a60$var$ANIMATION : null;
        propCount = type ? type === $9fc07b9c70ec4a60$var$TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }
    const hasTransform = type === $9fc07b9c70ec4a60$var$TRANSITION && /\b(transform|all)(,|$)/.test(getStyleProperties(`${$9fc07b9c70ec4a60$var$TRANSITION}Property`).toString());
    return {
        type: type,
        timeout: timeout,
        propCount: propCount,
        hasTransform: hasTransform
    };
}
function $9fc07b9c70ec4a60$var$getTimeout(delays, durations) {
    while(delays.length < durations.length)delays = delays.concat(delays);
    return Math.max(...durations.map((d, i)=>$9fc07b9c70ec4a60$var$toMs(d) + $9fc07b9c70ec4a60$var$toMs(delays[i])));
}
function $9fc07b9c70ec4a60$var$toMs(s) {
    if (s === "auto") return 0;
    return Number(s.slice(0, -1).replace(",", ".")) * 1e3;
}
function $9fc07b9c70ec4a60$var$forceReflow() {
    return document.body.offsetHeight;
}
function $9fc07b9c70ec4a60$var$patchClass(el, value, isSVG) {
    const transitionClasses = el[$9fc07b9c70ec4a60$var$vtcKey];
    if (transitionClasses) value = (value ? [
        value,
        ...transitionClasses
    ] : [
        ...transitionClasses
    ]).join(" ");
    if (value == null) el.removeAttribute("class");
    else if (isSVG) el.setAttribute("class", value);
    else el.className = value;
}
const $9fc07b9c70ec4a60$var$vShowOriginalDisplay = Symbol("_vod");
const $9fc07b9c70ec4a60$var$vShowHidden = Symbol("_vsh");
const $9fc07b9c70ec4a60$export$5cb4fcdc6937d7e1 = {
    beforeMount (el, { value: value }, { transition: transition }) {
        el[$9fc07b9c70ec4a60$var$vShowOriginalDisplay] = el.style.display === "none" ? "" : el.style.display;
        if (transition && value) transition.beforeEnter(el);
        else $9fc07b9c70ec4a60$var$setDisplay(el, value);
    },
    mounted (el, { value: value }, { transition: transition }) {
        if (transition && value) transition.enter(el);
    },
    updated (el, { value: value, oldValue: oldValue }, { transition: transition }) {
        if (!value === !oldValue) return;
        if (transition) {
            if (value) {
                transition.beforeEnter(el);
                $9fc07b9c70ec4a60$var$setDisplay(el, true);
                transition.enter(el);
            } else transition.leave(el, ()=>{
                $9fc07b9c70ec4a60$var$setDisplay(el, false);
            });
        } else $9fc07b9c70ec4a60$var$setDisplay(el, value);
    },
    beforeUnmount (el, { value: value }) {
        $9fc07b9c70ec4a60$var$setDisplay(el, value);
    }
};
function $9fc07b9c70ec4a60$var$setDisplay(el, value) {
    el.style.display = value ? el[$9fc07b9c70ec4a60$var$vShowOriginalDisplay] : "none";
    el[$9fc07b9c70ec4a60$var$vShowHidden] = !value;
}
function $9fc07b9c70ec4a60$var$initVShowForSSR() {
    $9fc07b9c70ec4a60$export$5cb4fcdc6937d7e1.getSSRProps = ({ value: value })=>{
        if (!value) return {
            style: {
                display: "none"
            }
        };
    };
}
const $9fc07b9c70ec4a60$var$CSS_VAR_TEXT = Symbol("");
function $9fc07b9c70ec4a60$export$ef28b76f07940108(getter) {
    const instance = (0, $58rTl.getCurrentInstance)();
    if (!instance) return;
    const updateTeleports = instance.ut = (vars = getter(instance.proxy))=>{
        Array.from(document.querySelectorAll(`[data-v-owner="${instance.uid}"]`)).forEach((node)=>$9fc07b9c70ec4a60$var$setVarsOnNode(node, vars));
    };
    const setVars = ()=>{
        const vars = getter(instance.proxy);
        if (instance.ce) $9fc07b9c70ec4a60$var$setVarsOnNode(instance.ce, vars);
        else $9fc07b9c70ec4a60$var$setVarsOnVNode(instance.subTree, vars);
        updateTeleports(vars);
    };
    (0, $58rTl.onBeforeUpdate)(()=>{
        (0, $58rTl.queuePostFlushCb)(setVars);
    });
    (0, $58rTl.onMounted)(()=>{
        (0, $58rTl.watch)(setVars, (0, $Cr6yt.NOOP), {
            flush: "post"
        });
        const ob = new MutationObserver(setVars);
        ob.observe(instance.subTree.el.parentNode, {
            childList: true
        });
        (0, $58rTl.onUnmounted)(()=>ob.disconnect());
    });
}
function $9fc07b9c70ec4a60$var$setVarsOnVNode(vnode, vars) {
    if (vnode.shapeFlag & 128) {
        const suspense = vnode.suspense;
        vnode = suspense.activeBranch;
        if (suspense.pendingBranch && !suspense.isHydrating) suspense.effects.push(()=>{
            $9fc07b9c70ec4a60$var$setVarsOnVNode(suspense.activeBranch, vars);
        });
    }
    while(vnode.component)vnode = vnode.component.subTree;
    if (vnode.shapeFlag & 1 && vnode.el) $9fc07b9c70ec4a60$var$setVarsOnNode(vnode.el, vars);
    else if (vnode.type === (0, $58rTl.Fragment)) vnode.children.forEach((c)=>$9fc07b9c70ec4a60$var$setVarsOnVNode(c, vars));
    else if (vnode.type === (0, $58rTl.Static)) {
        let { el: el, anchor: anchor } = vnode;
        while(el){
            $9fc07b9c70ec4a60$var$setVarsOnNode(el, vars);
            if (el === anchor) break;
            el = el.nextSibling;
        }
    }
}
function $9fc07b9c70ec4a60$var$setVarsOnNode(el, vars) {
    if (el.nodeType === 1) {
        const style = el.style;
        let cssText = "";
        for(const key in vars){
            style.setProperty(`--${key}`, vars[key]);
            cssText += `--${key}: ${vars[key]};`;
        }
        style[$9fc07b9c70ec4a60$var$CSS_VAR_TEXT] = cssText;
    }
}
const $9fc07b9c70ec4a60$var$displayRE = /(^|;)\s*display\s*:/;
function $9fc07b9c70ec4a60$var$patchStyle(el, prev, next) {
    const style = el.style;
    const isCssString = (0, $Cr6yt.isString)(next);
    let hasControlledDisplay = false;
    if (next && !isCssString) {
        if (prev) {
            if (!(0, $Cr6yt.isString)(prev)) {
                for(const key in prev)if (next[key] == null) $9fc07b9c70ec4a60$var$setStyle(style, key, "");
            } else for (const prevStyle of prev.split(";")){
                const key = prevStyle.slice(0, prevStyle.indexOf(":")).trim();
                if (next[key] == null) $9fc07b9c70ec4a60$var$setStyle(style, key, "");
            }
        }
        for(const key in next){
            if (key === "display") hasControlledDisplay = true;
            $9fc07b9c70ec4a60$var$setStyle(style, key, next[key]);
        }
    } else {
        if (isCssString) {
            if (prev !== next) {
                const cssVarText = style[$9fc07b9c70ec4a60$var$CSS_VAR_TEXT];
                if (cssVarText) next += ";" + cssVarText;
                style.cssText = next;
                hasControlledDisplay = $9fc07b9c70ec4a60$var$displayRE.test(next);
            }
        } else if (prev) el.removeAttribute("style");
    }
    if ($9fc07b9c70ec4a60$var$vShowOriginalDisplay in el) {
        el[$9fc07b9c70ec4a60$var$vShowOriginalDisplay] = hasControlledDisplay ? style.display : "";
        if (el[$9fc07b9c70ec4a60$var$vShowHidden]) style.display = "none";
    }
}
const $9fc07b9c70ec4a60$var$semicolonRE = /[^\\];\s*$/;
const $9fc07b9c70ec4a60$var$importantRE = /\s*!important$/;
function $9fc07b9c70ec4a60$var$setStyle(style, name, val) {
    if ((0, $Cr6yt.isArray)(val)) val.forEach((v)=>$9fc07b9c70ec4a60$var$setStyle(style, name, v));
    else {
        if (val == null) val = "";
        if (name.startsWith("--")) style.setProperty(name, val);
        else {
            const prefixed = $9fc07b9c70ec4a60$var$autoPrefix(style, name);
            if ($9fc07b9c70ec4a60$var$importantRE.test(val)) style.setProperty((0, $Cr6yt.hyphenate)(prefixed), val.replace($9fc07b9c70ec4a60$var$importantRE, ""), "important");
            else style[prefixed] = val;
        }
    }
}
const $9fc07b9c70ec4a60$var$prefixes = [
    "Webkit",
    "Moz",
    "ms"
];
const $9fc07b9c70ec4a60$var$prefixCache = {};
function $9fc07b9c70ec4a60$var$autoPrefix(style, rawName) {
    const cached = $9fc07b9c70ec4a60$var$prefixCache[rawName];
    if (cached) return cached;
    let name = (0, $Cr6yt.camelize)(rawName);
    if (name !== "filter" && name in style) return $9fc07b9c70ec4a60$var$prefixCache[rawName] = name;
    name = (0, $Cr6yt.capitalize)(name);
    for(let i = 0; i < $9fc07b9c70ec4a60$var$prefixes.length; i++){
        const prefixed = $9fc07b9c70ec4a60$var$prefixes[i] + name;
        if (prefixed in style) return $9fc07b9c70ec4a60$var$prefixCache[rawName] = prefixed;
    }
    return rawName;
}
const $9fc07b9c70ec4a60$var$xlinkNS = "http://www.w3.org/1999/xlink";
function $9fc07b9c70ec4a60$var$patchAttr(el, key, value, isSVG, instance, isBoolean = (0, $Cr6yt.isSpecialBooleanAttr)(key)) {
    if (isSVG && key.startsWith("xlink:")) {
        if (value == null) el.removeAttributeNS($9fc07b9c70ec4a60$var$xlinkNS, key.slice(6, key.length));
        else el.setAttributeNS($9fc07b9c70ec4a60$var$xlinkNS, key, value);
    } else if (value == null || isBoolean && !(0, $Cr6yt.includeBooleanAttr)(value)) el.removeAttribute(key);
    else el.setAttribute(key, isBoolean ? "" : (0, $Cr6yt.isSymbol)(value) ? String(value) : value);
}
function $9fc07b9c70ec4a60$var$patchDOMProp(el, key, value, parentComponent, attrName) {
    if (key === "innerHTML" || key === "textContent") {
        if (value != null) el[key] = key === "innerHTML" ? $9fc07b9c70ec4a60$var$unsafeToTrustedHTML(value) : value;
        return;
    }
    const tag = el.tagName;
    if (key === "value" && tag !== "PROGRESS" && // custom elements may use _value internally
    !tag.includes("-")) {
        const oldValue = tag === "OPTION" ? el.getAttribute("value") || "" : el.value;
        const newValue = value == null ? // #11647: value should be set as empty string for null and undefined,
        // but <input type="checkbox"> should be set as 'on'.
        el.type === "checkbox" ? "on" : "" : String(value);
        if (oldValue !== newValue || !("_value" in el)) el.value = newValue;
        if (value == null) el.removeAttribute(key);
        el._value = value;
        return;
    }
    let needRemove = false;
    if (value === "" || value == null) {
        const type = typeof el[key];
        if (type === "boolean") value = (0, $Cr6yt.includeBooleanAttr)(value);
        else if (value == null && type === "string") {
            value = "";
            needRemove = true;
        } else if (type === "number") {
            value = 0;
            needRemove = true;
        }
    }
    try {
        el[key] = value;
    } catch (e) {}
    needRemove && el.removeAttribute(attrName || key);
}
function $9fc07b9c70ec4a60$var$addEventListener(el, event, handler, options) {
    el.addEventListener(event, handler, options);
}
function $9fc07b9c70ec4a60$var$removeEventListener(el, event, handler, options) {
    el.removeEventListener(event, handler, options);
}
const $9fc07b9c70ec4a60$var$veiKey = Symbol("_vei");
function $9fc07b9c70ec4a60$var$patchEvent(el, rawName, prevValue, nextValue, instance = null) {
    const invokers = el[$9fc07b9c70ec4a60$var$veiKey] || (el[$9fc07b9c70ec4a60$var$veiKey] = {});
    const existingInvoker = invokers[rawName];
    if (nextValue && existingInvoker) existingInvoker.value = nextValue;
    else {
        const [name, options] = $9fc07b9c70ec4a60$var$parseName(rawName);
        if (nextValue) {
            const invoker = invokers[rawName] = $9fc07b9c70ec4a60$var$createInvoker(nextValue, instance);
            $9fc07b9c70ec4a60$var$addEventListener(el, name, invoker, options);
        } else if (existingInvoker) {
            $9fc07b9c70ec4a60$var$removeEventListener(el, name, existingInvoker, options);
            invokers[rawName] = void 0;
        }
    }
}
const $9fc07b9c70ec4a60$var$optionsModifierRE = /(?:Once|Passive|Capture)$/;
function $9fc07b9c70ec4a60$var$parseName(name) {
    let options;
    if ($9fc07b9c70ec4a60$var$optionsModifierRE.test(name)) {
        options = {};
        let m;
        while(m = name.match($9fc07b9c70ec4a60$var$optionsModifierRE)){
            name = name.slice(0, name.length - m[0].length);
            options[m[0].toLowerCase()] = true;
        }
    }
    const event = name[2] === ":" ? name.slice(3) : (0, $Cr6yt.hyphenate)(name.slice(2));
    return [
        event,
        options
    ];
}
let $9fc07b9c70ec4a60$var$cachedNow = 0;
const $9fc07b9c70ec4a60$var$p = /* @__PURE__ */ Promise.resolve();
const $9fc07b9c70ec4a60$var$getNow = ()=>$9fc07b9c70ec4a60$var$cachedNow || ($9fc07b9c70ec4a60$var$p.then(()=>$9fc07b9c70ec4a60$var$cachedNow = 0), $9fc07b9c70ec4a60$var$cachedNow = Date.now());
function $9fc07b9c70ec4a60$var$createInvoker(initialValue, instance) {
    const invoker = (e)=>{
        if (!e._vts) e._vts = Date.now();
        else if (e._vts <= invoker.attached) return;
        (0, $58rTl.callWithAsyncErrorHandling)($9fc07b9c70ec4a60$var$patchStopImmediatePropagation(e, invoker.value), instance, 5, [
            e
        ]);
    };
    invoker.value = initialValue;
    invoker.attached = $9fc07b9c70ec4a60$var$getNow();
    return invoker;
}
function $9fc07b9c70ec4a60$var$sanitizeEventValue(value, propName) {
    if ((0, $Cr6yt.isFunction)(value) || (0, $Cr6yt.isArray)(value)) return value;
    (0, $58rTl.warn)(`Wrong type passed as event handler to ${propName} - did you forget @ or : in front of your prop?
Expected function or array of functions, received type ${typeof value}.`);
    return 0, $Cr6yt.NOOP;
}
function $9fc07b9c70ec4a60$var$patchStopImmediatePropagation(e, value) {
    if ((0, $Cr6yt.isArray)(value)) {
        const originalStop = e.stopImmediatePropagation;
        e.stopImmediatePropagation = ()=>{
            originalStop.call(e);
            e._stopped = true;
        };
        return value.map((fn)=>(e2)=>!e2._stopped && fn && fn(e2));
    } else return value;
}
const $9fc07b9c70ec4a60$var$isNativeOn = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // lowercase letter
    key.charCodeAt(2) > 96 && key.charCodeAt(2) < 123;
const $9fc07b9c70ec4a60$var$patchProp = (el, key, prevValue, nextValue, namespace, parentComponent)=>{
    const isSVG = namespace === "svg";
    if (key === "class") $9fc07b9c70ec4a60$var$patchClass(el, nextValue, isSVG);
    else if (key === "style") $9fc07b9c70ec4a60$var$patchStyle(el, prevValue, nextValue);
    else if ((0, $Cr6yt.isOn)(key)) {
        if (!(0, $Cr6yt.isModelListener)(key)) $9fc07b9c70ec4a60$var$patchEvent(el, key, prevValue, nextValue, parentComponent);
    } else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : $9fc07b9c70ec4a60$var$shouldSetAsProp(el, key, nextValue, isSVG)) {
        $9fc07b9c70ec4a60$var$patchDOMProp(el, key, nextValue);
        if (!el.tagName.includes("-") && (key === "value" || key === "checked" || key === "selected")) $9fc07b9c70ec4a60$var$patchAttr(el, key, nextValue, isSVG, parentComponent, key !== "value");
    } else if (// #11081 force set props for possible async custom element
    el._isVueCE && (/[A-Z]/.test(key) || !(0, $Cr6yt.isString)(nextValue))) $9fc07b9c70ec4a60$var$patchDOMProp(el, (0, $Cr6yt.camelize)(key), nextValue, parentComponent, key);
    else {
        if (key === "true-value") el._trueValue = nextValue;
        else if (key === "false-value") el._falseValue = nextValue;
        $9fc07b9c70ec4a60$var$patchAttr(el, key, nextValue, isSVG);
    }
};
function $9fc07b9c70ec4a60$var$shouldSetAsProp(el, key, value, isSVG) {
    if (isSVG) {
        if (key === "innerHTML" || key === "textContent") return true;
        if (key in el && $9fc07b9c70ec4a60$var$isNativeOn(key) && (0, $Cr6yt.isFunction)(value)) return true;
        return false;
    }
    if (key === "spellcheck" || key === "draggable" || key === "translate" || key === "autocorrect") return false;
    if (key === "form") return false;
    if (key === "list" && el.tagName === "INPUT") return false;
    if (key === "type" && el.tagName === "TEXTAREA") return false;
    if (key === "width" || key === "height") {
        const tag = el.tagName;
        if (tag === "IMG" || tag === "VIDEO" || tag === "CANVAS" || tag === "SOURCE") return false;
    }
    if ($9fc07b9c70ec4a60$var$isNativeOn(key) && (0, $Cr6yt.isString)(value)) return false;
    return key in el;
}
const $9fc07b9c70ec4a60$var$REMOVAL = {};
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $9fc07b9c70ec4a60$export$a00e2346eabbdbef(options, extraOptions, _createApp) {
    const Comp = (0, $58rTl.defineComponent)(options, extraOptions);
    if ((0, $Cr6yt.isPlainObject)(Comp)) (0, $Cr6yt.extend)(Comp, extraOptions);
    class VueCustomElement extends $9fc07b9c70ec4a60$export$b337c1a55163dbe3 {
        constructor(initialProps){
            super(Comp, initialProps, _createApp);
        }
    }
    VueCustomElement.def = Comp;
    return VueCustomElement;
}
/*! #__NO_SIDE_EFFECTS__ */ const $9fc07b9c70ec4a60$export$6debb2e68f212638 = /* @__NO_SIDE_EFFECTS__ */ (options, extraOptions)=>{
    return /* @__PURE__ */ $9fc07b9c70ec4a60$export$a00e2346eabbdbef(options, extraOptions, $9fc07b9c70ec4a60$export$35800275c0037383);
};
const $9fc07b9c70ec4a60$var$BaseClass = typeof HTMLElement !== "undefined" ? HTMLElement : class {
};
class $9fc07b9c70ec4a60$export$b337c1a55163dbe3 extends $9fc07b9c70ec4a60$var$BaseClass {
    constructor(_def, _props = {}, _createApp = $9fc07b9c70ec4a60$export$4e373c34abfa8c68){
        super();
        this._def = _def;
        this._props = _props;
        this._createApp = _createApp;
        this._isVueCE = true;
        /**
     * @internal
     */ this._instance = null;
        /**
     * @internal
     */ this._app = null;
        /**
     * @internal
     */ this._nonce = this._def.nonce;
        this._connected = false;
        this._resolved = false;
        this._numberProps = null;
        this._styleChildren = /* @__PURE__ */ new WeakSet();
        this._ob = null;
        if (this.shadowRoot && _createApp !== $9fc07b9c70ec4a60$export$4e373c34abfa8c68) this._root = this.shadowRoot;
        else if (_def.shadowRoot !== false) {
            this.attachShadow({
                mode: "open"
            });
            this._root = this.shadowRoot;
        } else this._root = this;
        if (!this._def.__asyncLoader) this._resolveProps(this._def);
    }
    connectedCallback() {
        if (!this.isConnected) return;
        if (!this.shadowRoot) this._parseSlots();
        this._connected = true;
        let parent = this;
        while(parent = parent && (parent.parentNode || parent.host))if (parent instanceof $9fc07b9c70ec4a60$export$b337c1a55163dbe3) {
            this._parent = parent;
            break;
        }
        if (!this._instance) {
            if (this._resolved) {
                this._setParent();
                this._update();
            } else if (parent && parent._pendingResolve) this._pendingResolve = parent._pendingResolve.then(()=>{
                this._pendingResolve = void 0;
                this._resolveDef();
            });
            else this._resolveDef();
        }
    }
    _setParent(parent = this._parent) {
        if (parent) {
            this._instance.parent = parent._instance;
            this._instance.provides = parent._instance.provides;
        }
    }
    disconnectedCallback() {
        this._connected = false;
        (0, $58rTl.nextTick)(()=>{
            if (!this._connected) {
                if (this._ob) {
                    this._ob.disconnect();
                    this._ob = null;
                }
                this._app && this._app.unmount();
                if (this._instance) this._instance.ce = void 0;
                this._app = this._instance = null;
            }
        });
    }
    /**
   * resolve inner component definition (handle possible async component)
   */ _resolveDef() {
        if (this._pendingResolve) return;
        for(let i = 0; i < this.attributes.length; i++)this._setAttr(this.attributes[i].name);
        this._ob = new MutationObserver((mutations)=>{
            for (const m of mutations)this._setAttr(m.attributeName);
        });
        this._ob.observe(this, {
            attributes: true
        });
        const resolve = (def, isAsync = false)=>{
            this._resolved = true;
            this._pendingResolve = void 0;
            const { props: props, styles: styles } = def;
            let numberProps;
            if (props && !(0, $Cr6yt.isArray)(props)) for(const key in props){
                const opt = props[key];
                if (opt === Number || opt && opt.type === Number) {
                    if (key in this._props) this._props[key] = (0, $Cr6yt.toNumber)(this._props[key]);
                    (numberProps || (numberProps = /* @__PURE__ */ Object.create(null)))[(0, $Cr6yt.camelize)(key)] = true;
                }
            }
            this._numberProps = numberProps;
            if (isAsync) this._resolveProps(def);
            if (this.shadowRoot) this._applyStyles(styles);
            this._mount(def);
        };
        const asyncDef = this._def.__asyncLoader;
        if (asyncDef) this._pendingResolve = asyncDef().then((def)=>resolve(this._def = def, true));
        else resolve(this._def);
    }
    _mount(def) {
        if (__VUE_PROD_DEVTOOLS__ && !def.name) def.name = "VueElement";
        this._app = this._createApp(def);
        if (def.configureApp) def.configureApp(this._app);
        this._app._ceVNode = this._createVNode();
        this._app.mount(this._root);
        const exposed = this._instance && this._instance.exposed;
        if (!exposed) return;
        for(const key in exposed)if (!(0, $Cr6yt.hasOwn)(this, key)) Object.defineProperty(this, key, {
            // unwrap ref to be consistent with public instance behavior
            get: ()=>(0, $2eFsq.unref)(exposed[key])
        });
    }
    _resolveProps(def) {
        const { props: props } = def;
        const declaredPropKeys = (0, $Cr6yt.isArray)(props) ? props : Object.keys(props || {});
        for (const key of Object.keys(this))if (key[0] !== "_" && declaredPropKeys.includes(key)) this._setProp(key, this[key]);
        for (const key of declaredPropKeys.map((0, $Cr6yt.camelize)))Object.defineProperty(this, key, {
            get () {
                return this._getProp(key);
            },
            set (val) {
                this._setProp(key, val, true, true);
            }
        });
    }
    _setAttr(key) {
        if (key.startsWith("data-v-")) return;
        const has = this.hasAttribute(key);
        let value = has ? this.getAttribute(key) : $9fc07b9c70ec4a60$var$REMOVAL;
        const camelKey = (0, $Cr6yt.camelize)(key);
        if (has && this._numberProps && this._numberProps[camelKey]) value = (0, $Cr6yt.toNumber)(value);
        this._setProp(camelKey, value, false, true);
    }
    /**
   * @internal
   */ _getProp(key) {
        return this._props[key];
    }
    /**
   * @internal
   */ _setProp(key, val, shouldReflect = true, shouldUpdate = false) {
        if (val !== this._props[key]) {
            if (val === $9fc07b9c70ec4a60$var$REMOVAL) delete this._props[key];
            else {
                this._props[key] = val;
                if (key === "key" && this._app) this._app._ceVNode.key = val;
            }
            if (shouldUpdate && this._instance) this._update();
            if (shouldReflect) {
                const ob = this._ob;
                ob && ob.disconnect();
                if (val === true) this.setAttribute((0, $Cr6yt.hyphenate)(key), "");
                else if (typeof val === "string" || typeof val === "number") this.setAttribute((0, $Cr6yt.hyphenate)(key), val + "");
                else if (!val) this.removeAttribute((0, $Cr6yt.hyphenate)(key));
                ob && ob.observe(this, {
                    attributes: true
                });
            }
        }
    }
    _update() {
        $9fc07b9c70ec4a60$export$b3890eb0ae9dca99(this._createVNode(), this._root);
    }
    _createVNode() {
        const baseProps = {};
        if (!this.shadowRoot) baseProps.onVnodeMounted = baseProps.onVnodeUpdated = this._renderSlots.bind(this);
        const vnode = (0, $58rTl.createVNode)(this._def, (0, $Cr6yt.extend)(baseProps, this._props));
        if (!this._instance) vnode.ce = (instance)=>{
            this._instance = instance;
            instance.ce = this;
            instance.isCE = true;
            var newStyles, s;
            const dispatch = (event, args)=>{
                this.dispatchEvent(new CustomEvent(event, (0, $Cr6yt.isPlainObject)(args[0]) ? (0, $Cr6yt.extend)({
                    detail: args
                }, args[0]) : {
                    detail: args
                }));
            };
            instance.emit = (event, ...args)=>{
                dispatch(event, args);
                if ((0, $Cr6yt.hyphenate)(event) !== event) dispatch((0, $Cr6yt.hyphenate)(event), args);
            };
            this._setParent();
        };
        return vnode;
    }
    _applyStyles(styles, owner) {
        if (!styles) return;
        if (owner) {
            if (owner === this._def || this._styleChildren.has(owner)) return;
            this._styleChildren.add(owner);
        }
        const nonce = this._nonce;
        for(let i = styles.length - 1; i >= 0; i--){
            const s = document.createElement("style");
            if (nonce) s.setAttribute("nonce", nonce);
            s.textContent = styles[i];
            this.shadowRoot.prepend(s);
        }
    }
    /**
   * Only called when shadowRoot is false
   */ _parseSlots() {
        const slots = this._slots = {};
        let n;
        while(n = this.firstChild){
            const slotName = n.nodeType === 1 && n.getAttribute("slot") || "default";
            (slots[slotName] || (slots[slotName] = [])).push(n);
            this.removeChild(n);
        }
    }
    /**
   * Only called when shadowRoot is false
   */ _renderSlots() {
        const outlets = (this._teleportTarget || this).querySelectorAll("slot");
        const scopeId = this._instance.type.__scopeId;
        for(let i = 0; i < outlets.length; i++){
            const o = outlets[i];
            const slotName = o.getAttribute("name") || "default";
            const content = this._slots[slotName];
            const parent = o.parentNode;
            if (content) for (const n of content){
                if (scopeId && n.nodeType === 1) {
                    const id = scopeId + "-s";
                    const walker = document.createTreeWalker(n, 1);
                    n.setAttribute(id, "");
                    let child;
                    while(child = walker.nextNode())child.setAttribute(id, "");
                }
                parent.insertBefore(n, o);
            }
            else while(o.firstChild)parent.insertBefore(o.firstChild, o);
            parent.removeChild(o);
        }
    }
    /**
   * @internal
   */ _injectChildStyle(comp) {
        this._applyStyles(comp.styles, comp);
    }
    /**
   * @internal
   */ _removeChildStyle(comp) {
        var s;
    }
}
function $9fc07b9c70ec4a60$export$da5acfe93a94e37d(caller) {
    const instance = (0, $58rTl.getCurrentInstance)();
    const el = instance && instance.ce;
    if (el) return el;
    else if (false) {
        if (!instance) (0, $58rTl.warn)(`${caller || "useHost"} called without an active component instance.`);
        else (0, $58rTl.warn)(`${caller || "useHost"} can only be used in components defined via defineCustomElement.`);
    }
    return null;
}
function $9fc07b9c70ec4a60$export$64d45095031fa749() {
    const el = $9fc07b9c70ec4a60$export$da5acfe93a94e37d();
    return el && el.shadowRoot;
}
function $9fc07b9c70ec4a60$export$9300d5b90d56e3d1(name = "$style") {
    {
        const instance = (0, $58rTl.getCurrentInstance)();
        if (!instance) return 0, $Cr6yt.EMPTY_OBJ;
        const modules = instance.type.__cssModules;
        if (!modules) return 0, $Cr6yt.EMPTY_OBJ;
        const mod = modules[name];
        if (!mod) return 0, $Cr6yt.EMPTY_OBJ;
        return mod;
    }
}
const $9fc07b9c70ec4a60$var$positionMap = /* @__PURE__ */ new WeakMap();
const $9fc07b9c70ec4a60$var$newPositionMap = /* @__PURE__ */ new WeakMap();
const $9fc07b9c70ec4a60$var$moveCbKey = Symbol("_moveCb");
const $9fc07b9c70ec4a60$var$enterCbKey = Symbol("_enterCb");
const $9fc07b9c70ec4a60$var$decorate = (t)=>{
    delete t.props.mode;
    return t;
};
const $9fc07b9c70ec4a60$var$TransitionGroupImpl = /* @__PURE__ */ $9fc07b9c70ec4a60$var$decorate({
    name: "TransitionGroup",
    props: /* @__PURE__ */ (0, $Cr6yt.extend)({}, $9fc07b9c70ec4a60$var$TransitionPropsValidators, {
        tag: String,
        moveClass: String
    }),
    setup (props, { slots: slots }) {
        const instance = (0, $58rTl.getCurrentInstance)();
        const state = (0, $58rTl.useTransitionState)();
        let prevChildren;
        let children;
        (0, $58rTl.onUpdated)(()=>{
            if (!prevChildren.length) return;
            const moveClass = props.moveClass || `${props.name || "v"}-move`;
            if (!$9fc07b9c70ec4a60$var$hasCSSTransform(prevChildren[0].el, instance.vnode.el, moveClass)) {
                prevChildren = [];
                return;
            }
            prevChildren.forEach($9fc07b9c70ec4a60$var$callPendingCbs);
            prevChildren.forEach($9fc07b9c70ec4a60$var$recordPosition);
            const movedChildren = prevChildren.filter($9fc07b9c70ec4a60$var$applyTranslation);
            $9fc07b9c70ec4a60$var$forceReflow();
            movedChildren.forEach((c)=>{
                const el = c.el;
                const style = el.style;
                $9fc07b9c70ec4a60$var$addTransitionClass(el, moveClass);
                style.transform = style.webkitTransform = style.transitionDuration = "";
                const cb = el[$9fc07b9c70ec4a60$var$moveCbKey] = (e)=>{
                    if (e && e.target !== el) return;
                    if (!e || /transform$/.test(e.propertyName)) {
                        el.removeEventListener("transitionend", cb);
                        el[$9fc07b9c70ec4a60$var$moveCbKey] = null;
                        $9fc07b9c70ec4a60$var$removeTransitionClass(el, moveClass);
                    }
                };
                el.addEventListener("transitionend", cb);
            });
            prevChildren = [];
        });
        return ()=>{
            const rawProps = (0, $2eFsq.toRaw)(props);
            const cssTransitionProps = $9fc07b9c70ec4a60$var$resolveTransitionProps(rawProps);
            let tag = rawProps.tag || (0, $58rTl.Fragment);
            prevChildren = [];
            if (children) for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.el && child.el instanceof Element) {
                    prevChildren.push(child);
                    (0, $58rTl.setTransitionHooks)(child, (0, $58rTl.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
                    $9fc07b9c70ec4a60$var$positionMap.set(child, child.el.getBoundingClientRect());
                }
            }
            children = slots.default ? (0, $58rTl.getTransitionRawChildren)(slots.default()) : [];
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.key != null) (0, $58rTl.setTransitionHooks)(child, (0, $58rTl.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
            }
            return (0, $58rTl.createVNode)(tag, null, children);
        };
    }
});
const $9fc07b9c70ec4a60$export$19ffa8f511f7bc2e = $9fc07b9c70ec4a60$var$TransitionGroupImpl;
function $9fc07b9c70ec4a60$var$callPendingCbs(c) {
    const el = c.el;
    if (el[$9fc07b9c70ec4a60$var$moveCbKey]) el[$9fc07b9c70ec4a60$var$moveCbKey]();
    if (el[$9fc07b9c70ec4a60$var$enterCbKey]) el[$9fc07b9c70ec4a60$var$enterCbKey]();
}
function $9fc07b9c70ec4a60$var$recordPosition(c) {
    $9fc07b9c70ec4a60$var$newPositionMap.set(c, c.el.getBoundingClientRect());
}
function $9fc07b9c70ec4a60$var$applyTranslation(c) {
    const oldPos = $9fc07b9c70ec4a60$var$positionMap.get(c);
    const newPos = $9fc07b9c70ec4a60$var$newPositionMap.get(c);
    const dx = oldPos.left - newPos.left;
    const dy = oldPos.top - newPos.top;
    if (dx || dy) {
        const s = c.el.style;
        s.transform = s.webkitTransform = `translate(${dx}px,${dy}px)`;
        s.transitionDuration = "0s";
        return c;
    }
}
function $9fc07b9c70ec4a60$var$hasCSSTransform(el, root, moveClass) {
    const clone = el.cloneNode();
    const _vtc = el[$9fc07b9c70ec4a60$var$vtcKey];
    if (_vtc) _vtc.forEach((cls)=>{
        cls.split(/\s+/).forEach((c)=>c && clone.classList.remove(c));
    });
    moveClass.split(/\s+/).forEach((c)=>c && clone.classList.add(c));
    clone.style.display = "none";
    const container = root.nodeType === 1 ? root : root.parentNode;
    container.appendChild(clone);
    const { hasTransform: hasTransform } = $9fc07b9c70ec4a60$var$getTransitionInfo(clone);
    container.removeChild(clone);
    return hasTransform;
}
const $9fc07b9c70ec4a60$var$getModelAssigner = (vnode)=>{
    const fn = vnode.props["onUpdate:modelValue"] || false;
    return (0, $Cr6yt.isArray)(fn) ? (value)=>(0, $Cr6yt.invokeArrayFns)(fn, value) : fn;
};
function $9fc07b9c70ec4a60$var$onCompositionStart(e) {
    e.target.composing = true;
}
function $9fc07b9c70ec4a60$var$onCompositionEnd(e) {
    const target = e.target;
    if (target.composing) {
        target.composing = false;
        target.dispatchEvent(new Event("input"));
    }
}
const $9fc07b9c70ec4a60$var$assignKey = Symbol("_assign");
const $9fc07b9c70ec4a60$export$f1f88689f5728478 = {
    created (el, { modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el[$9fc07b9c70ec4a60$var$assignKey] = $9fc07b9c70ec4a60$var$getModelAssigner(vnode);
        const castToNumber = number || vnode.props && vnode.props.type === "number";
        $9fc07b9c70ec4a60$var$addEventListener(el, lazy ? "change" : "input", (e)=>{
            if (e.target.composing) return;
            let domValue = el.value;
            if (trim) domValue = domValue.trim();
            if (castToNumber) domValue = (0, $Cr6yt.looseToNumber)(domValue);
            el[$9fc07b9c70ec4a60$var$assignKey](domValue);
        });
        if (trim) $9fc07b9c70ec4a60$var$addEventListener(el, "change", ()=>{
            el.value = el.value.trim();
        });
        if (!lazy) {
            $9fc07b9c70ec4a60$var$addEventListener(el, "compositionstart", $9fc07b9c70ec4a60$var$onCompositionStart);
            $9fc07b9c70ec4a60$var$addEventListener(el, "compositionend", $9fc07b9c70ec4a60$var$onCompositionEnd);
            $9fc07b9c70ec4a60$var$addEventListener(el, "change", $9fc07b9c70ec4a60$var$onCompositionEnd);
        }
    },
    // set value on mounted so it's after min/max for type="range"
    mounted (el, { value: value }) {
        el.value = value == null ? "" : value;
    },
    beforeUpdate (el, { value: value, oldValue: oldValue, modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el[$9fc07b9c70ec4a60$var$assignKey] = $9fc07b9c70ec4a60$var$getModelAssigner(vnode);
        if (el.composing) return;
        const elValue = (number || el.type === "number") && !/^0\d/.test(el.value) ? (0, $Cr6yt.looseToNumber)(el.value) : el.value;
        const newValue = value == null ? "" : value;
        if (elValue === newValue) return;
        if (document.activeElement === el && el.type !== "range") {
            if (lazy && value === oldValue) return;
            if (trim && el.value.trim() === newValue) return;
        }
        el.value = newValue;
    }
};
const $9fc07b9c70ec4a60$export$8847c2e532b35714 = {
    // #4096 array checkboxes need to be deep traversed
    deep: true,
    created (el, _, vnode) {
        el[$9fc07b9c70ec4a60$var$assignKey] = $9fc07b9c70ec4a60$var$getModelAssigner(vnode);
        $9fc07b9c70ec4a60$var$addEventListener(el, "change", ()=>{
            const modelValue = el._modelValue;
            const elementValue = $9fc07b9c70ec4a60$var$getValue(el);
            const checked = el.checked;
            const assign = el[$9fc07b9c70ec4a60$var$assignKey];
            if ((0, $Cr6yt.isArray)(modelValue)) {
                const index = (0, $Cr6yt.looseIndexOf)(modelValue, elementValue);
                const found = index !== -1;
                if (checked && !found) assign(modelValue.concat(elementValue));
                else if (!checked && found) {
                    const filtered = [
                        ...modelValue
                    ];
                    filtered.splice(index, 1);
                    assign(filtered);
                }
            } else if ((0, $Cr6yt.isSet)(modelValue)) {
                const cloned = new Set(modelValue);
                if (checked) cloned.add(elementValue);
                else cloned.delete(elementValue);
                assign(cloned);
            } else assign($9fc07b9c70ec4a60$var$getCheckboxValue(el, checked));
        });
    },
    // set initial checked on mount to wait for true-value/false-value
    mounted: $9fc07b9c70ec4a60$var$setChecked,
    beforeUpdate (el, binding, vnode) {
        el[$9fc07b9c70ec4a60$var$assignKey] = $9fc07b9c70ec4a60$var$getModelAssigner(vnode);
        $9fc07b9c70ec4a60$var$setChecked(el, binding, vnode);
    }
};
function $9fc07b9c70ec4a60$var$setChecked(el, { value: value, oldValue: oldValue }, vnode) {
    el._modelValue = value;
    let checked;
    if ((0, $Cr6yt.isArray)(value)) checked = (0, $Cr6yt.looseIndexOf)(value, vnode.props.value) > -1;
    else if ((0, $Cr6yt.isSet)(value)) checked = value.has(vnode.props.value);
    else {
        if (value === oldValue) return;
        checked = (0, $Cr6yt.looseEqual)(value, $9fc07b9c70ec4a60$var$getCheckboxValue(el, true));
    }
    if (el.checked !== checked) el.checked = checked;
}
const $9fc07b9c70ec4a60$export$b4356c59b38b7aa9 = {
    created (el, { value: value }, vnode) {
        el.checked = (0, $Cr6yt.looseEqual)(value, vnode.props.value);
        el[$9fc07b9c70ec4a60$var$assignKey] = $9fc07b9c70ec4a60$var$getModelAssigner(vnode);
        $9fc07b9c70ec4a60$var$addEventListener(el, "change", ()=>{
            el[$9fc07b9c70ec4a60$var$assignKey]($9fc07b9c70ec4a60$var$getValue(el));
        });
    },
    beforeUpdate (el, { value: value, oldValue: oldValue }, vnode) {
        el[$9fc07b9c70ec4a60$var$assignKey] = $9fc07b9c70ec4a60$var$getModelAssigner(vnode);
        if (value !== oldValue) el.checked = (0, $Cr6yt.looseEqual)(value, vnode.props.value);
    }
};
const $9fc07b9c70ec4a60$export$87d227567b51ca39 = {
    // <select multiple> value need to be deep traversed
    deep: true,
    created (el, { value: value, modifiers: { number: number } }, vnode) {
        const isSetModel = (0, $Cr6yt.isSet)(value);
        $9fc07b9c70ec4a60$var$addEventListener(el, "change", ()=>{
            const selectedVal = Array.prototype.filter.call(el.options, (o)=>o.selected).map((o)=>number ? (0, $Cr6yt.looseToNumber)($9fc07b9c70ec4a60$var$getValue(o)) : $9fc07b9c70ec4a60$var$getValue(o));
            el[$9fc07b9c70ec4a60$var$assignKey](el.multiple ? isSetModel ? new Set(selectedVal) : selectedVal : selectedVal[0]);
            el._assigning = true;
            (0, $58rTl.nextTick)(()=>{
                el._assigning = false;
            });
        });
        el[$9fc07b9c70ec4a60$var$assignKey] = $9fc07b9c70ec4a60$var$getModelAssigner(vnode);
    },
    // set value in mounted & updated because <select> relies on its children
    // <option>s.
    mounted (el, { value: value }) {
        $9fc07b9c70ec4a60$var$setSelected(el, value);
    },
    beforeUpdate (el, _binding, vnode) {
        el[$9fc07b9c70ec4a60$var$assignKey] = $9fc07b9c70ec4a60$var$getModelAssigner(vnode);
    },
    updated (el, { value: value }) {
        if (!el._assigning) $9fc07b9c70ec4a60$var$setSelected(el, value);
    }
};
function $9fc07b9c70ec4a60$var$setSelected(el, value) {
    const isMultiple = el.multiple;
    const isArrayValue = (0, $Cr6yt.isArray)(value);
    if (isMultiple && !isArrayValue && !(0, $Cr6yt.isSet)(value)) return;
    for(let i = 0, l = el.options.length; i < l; i++){
        const option = el.options[i];
        const optionValue = $9fc07b9c70ec4a60$var$getValue(option);
        if (isMultiple) {
            if (isArrayValue) {
                const optionType = typeof optionValue;
                if (optionType === "string" || optionType === "number") option.selected = value.some((v)=>String(v) === String(optionValue));
                else option.selected = (0, $Cr6yt.looseIndexOf)(value, optionValue) > -1;
            } else option.selected = value.has(optionValue);
        } else if ((0, $Cr6yt.looseEqual)($9fc07b9c70ec4a60$var$getValue(option), value)) {
            if (el.selectedIndex !== i) el.selectedIndex = i;
            return;
        }
    }
    if (!isMultiple && el.selectedIndex !== -1) el.selectedIndex = -1;
}
function $9fc07b9c70ec4a60$var$getValue(el) {
    return "_value" in el ? el._value : el.value;
}
function $9fc07b9c70ec4a60$var$getCheckboxValue(el, checked) {
    const key = checked ? "_trueValue" : "_falseValue";
    return key in el ? el[key] : checked;
}
const $9fc07b9c70ec4a60$export$5ad5c0e01ff62c5 = {
    created (el, binding, vnode) {
        $9fc07b9c70ec4a60$var$callModelHook(el, binding, vnode, null, "created");
    },
    mounted (el, binding, vnode) {
        $9fc07b9c70ec4a60$var$callModelHook(el, binding, vnode, null, "mounted");
    },
    beforeUpdate (el, binding, vnode, prevVNode) {
        $9fc07b9c70ec4a60$var$callModelHook(el, binding, vnode, prevVNode, "beforeUpdate");
    },
    updated (el, binding, vnode, prevVNode) {
        $9fc07b9c70ec4a60$var$callModelHook(el, binding, vnode, prevVNode, "updated");
    }
};
function $9fc07b9c70ec4a60$var$resolveDynamicModel(tagName, type) {
    switch(tagName){
        case "SELECT":
            return $9fc07b9c70ec4a60$export$87d227567b51ca39;
        case "TEXTAREA":
            return $9fc07b9c70ec4a60$export$f1f88689f5728478;
        default:
            switch(type){
                case "checkbox":
                    return $9fc07b9c70ec4a60$export$8847c2e532b35714;
                case "radio":
                    return $9fc07b9c70ec4a60$export$b4356c59b38b7aa9;
                default:
                    return $9fc07b9c70ec4a60$export$f1f88689f5728478;
            }
    }
}
function $9fc07b9c70ec4a60$var$callModelHook(el, binding, vnode, prevVNode, hook) {
    const modelToUse = $9fc07b9c70ec4a60$var$resolveDynamicModel(el.tagName, vnode.props && vnode.props.type);
    const fn = modelToUse[hook];
    fn && fn(el, binding, vnode, prevVNode);
}
function $9fc07b9c70ec4a60$var$initVModelForSSR() {
    $9fc07b9c70ec4a60$export$f1f88689f5728478.getSSRProps = ({ value: value })=>({
            value: value
        });
    $9fc07b9c70ec4a60$export$b4356c59b38b7aa9.getSSRProps = ({ value: value }, vnode)=>{
        if (vnode.props && (0, $Cr6yt.looseEqual)(vnode.props.value, value)) return {
            checked: true
        };
    };
    $9fc07b9c70ec4a60$export$8847c2e532b35714.getSSRProps = ({ value: value }, vnode)=>{
        if ((0, $Cr6yt.isArray)(value)) {
            if (vnode.props && (0, $Cr6yt.looseIndexOf)(value, vnode.props.value) > -1) return {
                checked: true
            };
        } else if ((0, $Cr6yt.isSet)(value)) {
            if (vnode.props && value.has(vnode.props.value)) return {
                checked: true
            };
        } else if (value) return {
            checked: true
        };
    };
    $9fc07b9c70ec4a60$export$5ad5c0e01ff62c5.getSSRProps = (binding, vnode)=>{
        if (typeof vnode.type !== "string") return;
        const modelToUse = $9fc07b9c70ec4a60$var$resolveDynamicModel(// resolveDynamicModel expects an uppercase tag name, but vnode.type is lowercase
        vnode.type.toUpperCase(), vnode.props && vnode.props.type);
        if (modelToUse.getSSRProps) return modelToUse.getSSRProps(binding, vnode);
    };
}
const $9fc07b9c70ec4a60$var$systemModifiers = [
    "ctrl",
    "shift",
    "alt",
    "meta"
];
const $9fc07b9c70ec4a60$var$modifierGuards = {
    stop: (e)=>e.stopPropagation(),
    prevent: (e)=>e.preventDefault(),
    self: (e)=>e.target !== e.currentTarget,
    ctrl: (e)=>!e.ctrlKey,
    shift: (e)=>!e.shiftKey,
    alt: (e)=>!e.altKey,
    meta: (e)=>!e.metaKey,
    left: (e)=>"button" in e && e.button !== 0,
    middle: (e)=>"button" in e && e.button !== 1,
    right: (e)=>"button" in e && e.button !== 2,
    exact: (e, modifiers)=>$9fc07b9c70ec4a60$var$systemModifiers.some((m)=>e[`${m}Key`] && !modifiers.includes(m))
};
const $9fc07b9c70ec4a60$export$26bd3b8e29e6f273 = (fn, modifiers)=>{
    const cache = fn._withMods || (fn._withMods = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event, ...args)=>{
        for(let i = 0; i < modifiers.length; i++){
            const guard = $9fc07b9c70ec4a60$var$modifierGuards[modifiers[i]];
            if (guard && guard(event, modifiers)) return;
        }
        return fn(event, ...args);
    });
};
const $9fc07b9c70ec4a60$var$keyNames = {
    esc: "escape",
    space: " ",
    up: "arrow-up",
    left: "arrow-left",
    right: "arrow-right",
    down: "arrow-down",
    delete: "backspace"
};
const $9fc07b9c70ec4a60$export$f691a8759658f782 = (fn, modifiers)=>{
    const cache = fn._withKeys || (fn._withKeys = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event)=>{
        if (!("key" in event)) return;
        const eventKey = (0, $Cr6yt.hyphenate)(event.key);
        if (modifiers.some((k)=>k === eventKey || $9fc07b9c70ec4a60$var$keyNames[k] === eventKey)) return fn(event);
    });
};
const $9fc07b9c70ec4a60$var$rendererOptions = /* @__PURE__ */ (0, $Cr6yt.extend)({
    patchProp: $9fc07b9c70ec4a60$var$patchProp
}, $9fc07b9c70ec4a60$var$nodeOps);
let $9fc07b9c70ec4a60$var$renderer;
let $9fc07b9c70ec4a60$var$enabledHydration = false;
function $9fc07b9c70ec4a60$var$ensureRenderer() {
    return $9fc07b9c70ec4a60$var$renderer || ($9fc07b9c70ec4a60$var$renderer = (0, $58rTl.createRenderer)($9fc07b9c70ec4a60$var$rendererOptions));
}
function $9fc07b9c70ec4a60$var$ensureHydrationRenderer() {
    $9fc07b9c70ec4a60$var$renderer = $9fc07b9c70ec4a60$var$enabledHydration ? $9fc07b9c70ec4a60$var$renderer : (0, $58rTl.createHydrationRenderer)($9fc07b9c70ec4a60$var$rendererOptions);
    $9fc07b9c70ec4a60$var$enabledHydration = true;
    return $9fc07b9c70ec4a60$var$renderer;
}
const $9fc07b9c70ec4a60$export$b3890eb0ae9dca99 = (...args)=>{
    $9fc07b9c70ec4a60$var$ensureRenderer().render(...args);
};
const $9fc07b9c70ec4a60$export$fa8d919ba61d84db = (...args)=>{
    $9fc07b9c70ec4a60$var$ensureHydrationRenderer().hydrate(...args);
};
const $9fc07b9c70ec4a60$export$4e373c34abfa8c68 = (...args)=>{
    const app = $9fc07b9c70ec4a60$var$ensureRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $9fc07b9c70ec4a60$var$normalizeContainer(containerOrSelector);
        if (!container) return;
        const component = app._component;
        if (!(0, $Cr6yt.isFunction)(component) && !component.render && !component.template) component.template = container.innerHTML;
        if (container.nodeType === 1) container.textContent = "";
        const proxy = mount(container, false, $9fc07b9c70ec4a60$var$resolveRootNamespace(container));
        if (container instanceof Element) {
            container.removeAttribute("v-cloak");
            container.setAttribute("data-v-app", "");
        }
        return proxy;
    };
    return app;
};
const $9fc07b9c70ec4a60$export$35800275c0037383 = (...args)=>{
    const app = $9fc07b9c70ec4a60$var$ensureHydrationRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $9fc07b9c70ec4a60$var$normalizeContainer(containerOrSelector);
        if (container) return mount(container, true, $9fc07b9c70ec4a60$var$resolveRootNamespace(container));
    };
    return app;
};
function $9fc07b9c70ec4a60$var$resolveRootNamespace(container) {
    if (container instanceof SVGElement) return "svg";
    if (typeof MathMLElement === "function" && container instanceof MathMLElement) return "mathml";
}
function $9fc07b9c70ec4a60$var$injectNativeTagCheck(app) {
    Object.defineProperty(app.config, "isNativeTag", {
        value: (tag)=>(0, $Cr6yt.isHTMLTag)(tag) || (0, $Cr6yt.isSVGTag)(tag) || (0, $Cr6yt.isMathMLTag)(tag),
        writable: false
    });
}
function $9fc07b9c70ec4a60$var$injectCompilerOptionsCheck(app) {
    if ((0, $58rTl.isRuntimeOnly)()) {
        const isCustomElement = app.config.isCustomElement;
        Object.defineProperty(app.config, "isCustomElement", {
            get () {
                return isCustomElement;
            },
            set () {
                (0, $58rTl.warn)(`The \`isCustomElement\` config option is deprecated. Use \`compilerOptions.isCustomElement\` instead.`);
            }
        });
        const compilerOptions = app.config.compilerOptions;
        const msg = `The \`compilerOptions\` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, \`compilerOptions\` must be passed to \`@vue/compiler-dom\` in the build setup instead.
- For vue-loader: pass it via vue-loader's \`compilerOptions\` loader option.
- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader
- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc`;
        Object.defineProperty(app.config, "compilerOptions", {
            get () {
                (0, $58rTl.warn)(msg);
                return compilerOptions;
            },
            set () {
                (0, $58rTl.warn)(msg);
            }
        });
    }
}
function $9fc07b9c70ec4a60$var$normalizeContainer(container) {
    if ((0, $Cr6yt.isString)(container)) {
        const res = document.querySelector(container);
        return res;
    }
    return container;
}
let $9fc07b9c70ec4a60$var$ssrDirectiveInitialized = false;
const $9fc07b9c70ec4a60$export$800b28255aa678d9 = ()=>{
    if (!$9fc07b9c70ec4a60$var$ssrDirectiveInitialized) {
        $9fc07b9c70ec4a60$var$ssrDirectiveInitialized = true;
        $9fc07b9c70ec4a60$var$initVModelForSSR();
        $9fc07b9c70ec4a60$var$initVShowForSSR();
    }
};

});



parcelRegister("3NNX1", function(module, exports) {

$parcel$export(module.exports, "render", () => $2c4cb1eb429dee56$export$b3890eb0ae9dca99);
parcelRequire("9uXBG");
var $58rTl = parcelRequire("58rTl");
var $Cr6yt = parcelRequire("Cr6yt");
var $dIm2H = parcelRequire("dIm2H");
const $2c4cb1eb429dee56$var$_hoisted_1 = [
    "onKeydown"
];
const $2c4cb1eb429dee56$var$_hoisted_2 = {
    class: "app__main main"
};
const $2c4cb1eb429dee56$var$_hoisted_3 = {
    class: "main__chapter-list chapter-list"
};
const $2c4cb1eb429dee56$var$_hoisted_4 = [
    "onClick"
];
const $2c4cb1eb429dee56$var$_hoisted_5 = {
    ref: "audioElement"
};
const $2c4cb1eb429dee56$var$_hoisted_6 = {
    class: "main__audio-player audio-player"
};
const $2c4cb1eb429dee56$var$_hoisted_7 = {
    key: 0
};
const $2c4cb1eb429dee56$var$_hoisted_8 = {
    key: 1
};
const $2c4cb1eb429dee56$var$_hoisted_9 = {
    class: "progress-bar__time"
};
function $2c4cb1eb429dee56$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $58rTl.openBlock)(), (0, $58rTl.createElementBlock)("div", {
        class: "app",
        onKeydown: (0, $dIm2H.withKeys)((0, $dIm2H.withModifiers)($setup.togglePlaying, [
            "prevent"
        ]), [
            "space"
        ])
    }, [
        _cache[0] || (_cache[0] = (0, $58rTl.createElementVNode)("header", {
            class: "app__header header"
        }, [
            (0, $58rTl.createElementVNode)("img", {
                class: "header__image",
                src: "/background.png",
                alt: ""
            })
        ], -1)),
        (0, $58rTl.createElementVNode)("main", $2c4cb1eb429dee56$var$_hoisted_2, [
            (0, $58rTl.createElementVNode)("ul", $2c4cb1eb429dee56$var$_hoisted_3, [
                ((0, $58rTl.openBlock)(), (0, $58rTl.createElementBlock)((0, $58rTl.Fragment), null, (0, $58rTl.renderList)($setup.CHAPTER_LIST, (chapter, index)=>{
                    return (0, $58rTl.createElementVNode)("li", {
                        class: (0, $Cr6yt.normalizeClass)([
                            "chapter-list__item",
                            {
                                'chapter-list__item--active': $setup.currentChapter === index
                            }
                        ]),
                        key: chapter.file
                    }, [
                        (0, $58rTl.createElementVNode)("button", {
                            class: "chapter-list__button",
                            type: "button",
                            onClick: ($event)=>$setup.switchTrack(index)
                        }, [
                            (0, $58rTl.createElementVNode)("span", null, "Track " + (0, $Cr6yt.toDisplayString)(index + 1) + " - ", 1),
                            (0, $58rTl.createElementVNode)("span", null, (0, $Cr6yt.toDisplayString)(chapter.name), 1)
                        ], 8, $2c4cb1eb429dee56$var$_hoisted_4)
                    ], 2);
                }), 64))
            ]),
            (0, $58rTl.createElementVNode)("audio", $2c4cb1eb429dee56$var$_hoisted_5, null, 512),
            (0, $58rTl.createElementVNode)("div", $2c4cb1eb429dee56$var$_hoisted_6, [
                (0, $58rTl.createElementVNode)("button", {
                    class: "audio-player__button",
                    onClick: $setup.togglePlaying,
                    type: "button"
                }, [
                    $setup.playing ? ((0, $58rTl.openBlock)(), (0, $58rTl.createElementBlock)("span", $2c4cb1eb429dee56$var$_hoisted_7, "\u23F8\uFE0E")) : ((0, $58rTl.openBlock)(), (0, $58rTl.createElementBlock)("span", $2c4cb1eb429dee56$var$_hoisted_8, "\u23F5\uFE0E"))
                ]),
                (0, $58rTl.createElementVNode)("div", {
                    class: "audio-player__progress progress-bar",
                    onClick: $setup.onClick
                }, [
                    (0, $58rTl.createElementVNode)("div", {
                        class: "progress-bar__filled",
                        style: (0, $Cr6yt.normalizeStyle)({
                            width: `${$setup.currentTime / $setup.duration * 100}%`
                        })
                    }, null, 4),
                    (0, $58rTl.createElementVNode)("span", $2c4cb1eb429dee56$var$_hoisted_9, [
                        (0, $58rTl.createElementVNode)("span", null, (0, $Cr6yt.toDisplayString)($setup.formattedCurrentTime), 1),
                        (0, $58rTl.createElementVNode)("span", null, (0, $Cr6yt.toDisplayString)($setup.formattedDuration), 1)
                    ])
                ])
            ])
        ])
    ], 40, $2c4cb1eb429dee56$var$_hoisted_1);
}

});

parcelRegister("1rrBo", function(module, exports) {

$parcel$export(module.exports, "default", () => $10cdb945e864b702$export$2e2bcd8739ae039);
let $10cdb945e864b702$var$NOOP = ()=>{};
var $10cdb945e864b702$export$2e2bcd8739ae039 = (script)=>{};

});







parcelRequire("9uXBG");
var $dIm2H = parcelRequire("dIm2H");
let $ae3de8900c09c2f9$var$script;




let $ae3de8900c09c2f9$var$initialize = ()=>{
    $ae3de8900c09c2f9$var$script = (parcelRequire("boZNq"));
    if ($ae3de8900c09c2f9$var$script.__esModule) $ae3de8900c09c2f9$var$script = $ae3de8900c09c2f9$var$script.default;
    $ae3de8900c09c2f9$var$script.render = (parcelRequire("3NNX1")).render;
    $ae3de8900c09c2f9$var$script.__cssModules = {};
    (parcelRequire("1rrBo")).default($ae3de8900c09c2f9$var$script);
    $ae3de8900c09c2f9$var$script.__scopeId = 'data-v-5dcc92';
    $ae3de8900c09c2f9$var$script.__file = "App.vue";
};
$ae3de8900c09c2f9$var$initialize();
var $ae3de8900c09c2f9$export$2e2bcd8739ae039 = $ae3de8900c09c2f9$var$script;


const $35da740d59af89ba$var$app = (0, $dIm2H.createApp)((0, $ae3de8900c09c2f9$export$2e2bcd8739ae039));
$35da740d59af89ba$var$app.mount("#app");


//# sourceMappingURL=jessi.66d7b5d4.js.map
